/*!
 * Flower Sugar Chat Widget
 * v1.0.0  -  https://flowersugar.com
 *
 * Embed:
 *   <script
 *     src="https://YOUR-CDN/flowersugar-widget.js"
 *     data-endpoint="https://YOUR-CLOUD-RUN-URL"
 *     data-widget-key="flower_sugar_public_widget"
 *     defer
 *   ></script>
 *
 * Single-file vanilla JS, no dependencies. Mounts a Shadow-DOM-isolated
 * floating chat widget in the bottom-right of any page on flowersugar.com.
 */
(function () {
  "use strict";

  if (window.__FLOWER_SUGAR_CHAT__) return;
  window.__FLOWER_SUGAR_CHAT__ = true;

  // ---------------------------------------------------------------------
  // Console suppression (v2.55.24)
  // ---------------------------------------------------------------------
  // Silence ALL of the widget's console.* output. This is a LOCAL shadow:
  // `console` here is a function-scoped variable that overrides the global
  // `console` for every reference inside this IIFE (including the nested
  // FS_FIRESTORE / FS_TYPING / FS_PHONE / FS_SHOPIFY_CART modules, which
  // are lexically nested below). The host page's window.console is NOT
  // touched — other scripts on the storefront keep logging normally.
  //
  // Opt-in restore: add data-debug="true" (or "1") to the widget <script>
  // tag to pass through to the real console for diagnostics, without
  // editing this file. Default: fully suppressed.
  var _fsDebug = (function () {
    try {
      var s = document.currentScript ||
        (function () {
          var all = document.getElementsByTagName("script");
          return all[all.length - 1];
        })();
      var v = s && s.getAttribute("data-debug");
      return v === "true" || v === "1";
    } catch (_) {
      return false;
    }
  })();

  var console = (function (real) {
    if (_fsDebug && real) return real;          // pass-through when debugging
    var noop = function () {};
    // Cover every method the widget uses plus the common rest, so any
    // console.<method>(...) call inside this scope is a safe no-op.
    return {
      log: noop, info: noop, warn: noop, error: noop, debug: noop,
      trace: noop, group: noop, groupCollapsed: noop, groupEnd: noop,
      table: noop, dir: noop, dirxml: noop, assert: noop, count: noop,
      countReset: noop, time: noop, timeEnd: noop, timeLog: noop,
      clear: noop, profile: noop, profileEnd: noop,
    };
  })((typeof window !== "undefined" && window.console) || null);

  // ---------------------------------------------------------------------
  // Config from <script> data attributes
  // ---------------------------------------------------------------------
  var script = document.currentScript ||
    (function () {
      var s = document.getElementsByTagName("script");
      return s[s.length - 1];
    })();

  // Read attributes. Note: getAttribute returns null when the attribute is
  // absent, but the empty string "" when explicitly set as data-endpoint="".
  // The two cases mean different things:
  //   - absent / null  → fall through to the production default
  //   - empty string   → use same-origin (good for local dev)

  var rawEndpoint = (script && script.getAttribute("data-endpoint"));
  var ENDPOINT;
  if (rawEndpoint === "") {
    ENDPOINT = location.origin;
  } else {
    ENDPOINT = rawEndpoint ||
      "https://flowersugar-chatbot-541962859153.asia-southeast1.run.app";
  }

  var WIDGET_KEY = (script && script.getAttribute("data-widget-key")) ||
    "flower_sugar_public_widget";

  // v2.55.19 hotfix7 — single source of truth for the widget version
  // string. Used in EVERY [FS/shopify_cart] / [FS/boot] log line so that
  // ANY log paste (truncated or not) reveals which build is running.
  // Bump on every visible behavior change so cached-stale-script
  // problems are immediately diagnosable.
  var FS_WIDGET_VERSION = "v2.55.180";

  // ───────────────────────────────────────────────────────────────────
  // Cart-sync tracing (added on request)
  //
  // Dedicated logging channel for the two cart-synchronisation
  // pathways, kept SEPARATE from console.log (which is commented out
  // wholesale) so this tracing stays active:
  //
  //   Pathway 1 — Shopify cart → widget cart → Firestore
  //     cart:updated / ajaxProduct:added  →  _adoptShopifyCart()
  //       →  _syncToServer()  →  POST /cart/shopify_sync  →  Firestore
  //
  //   Pathway 2 — widget cart → Shopify cart
  //     pushToShopify()  →  _shopifyAdd() / _shopifyChange()
  //       →  POST /cart/add.js / /cart/change.js  →  re-fetch /cart.js
  //
  // Every log line is prefixed "[FS/cart_trace]" + the pathway tag so a
  // single console filter (`FS/cart_trace`) surfaces the entire flow in
  // order. Uses console.info (NOT console.log) on purpose. Flip
  // FS_CART_TRACE to false to silence without removing the call sites.
  // ───────────────────────────────────────────────────────────────────
  var FS_CART_TRACE = true;
  function _cartTrace(tag /*, ...args */) {
    if (!FS_CART_TRACE) return;
    var args = Array.prototype.slice.call(arguments, 1);
    try {
      console.info.apply(console,
        ["[FS/cart_trace]" + tag, FS_WIDGET_VERSION].concat(args));
    } catch (e) { /* never let tracing break the widget */ }
  }

  // v2.55.20+hotfix6 — one-shot deploy verification log. Fires once
  // at script load with the exact version + a manifest of new features
  // so any browser console paste immediately reveals whether the new
  // build is in effect or a cached-stale-script is being served.
  // console.info("[FS/boot] widget loaded", FS_WIDGET_VERSION,
    // "features=", {
      // explicit_date_param: true,
      // align_target_date_with_cart: true,
      // collapse_remove_add_pairs: true,
      // preview_gate_removed: true,
      // every_skip_path_logged: true,
      // drawer_open_suppression: true,
      // empty_quote_bubble_suppression: true,
      // foreign_add_propagation: true,
    // });

  // If the configured endpoint is still a known placeholder AND we're served
  // from an http(s) origin, fall back to same-origin too.
  if (/XXXX|YOUR-CLOUD-RUN-URL|YOUR-CDN/i.test(ENDPOINT) && /^https?:/.test(location.origin)) {
    console.warn(
      "[FlowerSugar] data-endpoint looks like a placeholder (" + ENDPOINT +
      "). Falling back to same-origin: " + location.origin
    );
    ENDPOINT = location.origin;
  }

  // Hardening: if we're being served from localhost/127.0.0.1/0.0.0.0 but
  // the resolved ENDPOINT is the production Cloud Run URL, that's almost
  // certainly a misconfiguration (data-endpoint attribute missing or wrong).
  // Auto-switch to same-origin so local dev "just works".
  if (/^(?:localhost|127\.0\.0\.1|0\.0\.0\.0)(?::\d+)?$/i.test(location.host) &&
      /run\.app|cloudfunctions|cloudrun/i.test(ENDPOINT)) {
    console.warn(
      "[FlowerSugar] Served from localhost but endpoint is production (" + ENDPOINT +
      "). Auto-switching to same-origin: " + location.origin
    );
    ENDPOINT = location.origin;
  }

  // console.info("[FlowerSugar] endpoint:", ENDPOINT, "widget_key:", WIDGET_KEY.slice(0, 12) + "...");

  // ---------------------------------------------------------------------
  // Feature flags
  // ---------------------------------------------------------------------
  // RENDER_HISTORICAL_STRUCTURED — controls whether structured bot
  // responses (delivery-fee rate tables, product cards) are re-rendered
  // when chat history is reloaded on widget open.
  //   true  → history shows the full rate table / product cards, exactly
  //           as they appeared live.
  //   false → history shows only the bot's text for those turns; the
  //           structured block is omitted.
  // Flip this single constant to turn the behaviour on or off.
  var RENDER_HISTORICAL_STRUCTURED = true;

  // ---------------------------------------------------------------------
  // Session id - cookie-backed, ~1 year
  // ---------------------------------------------------------------------
  var COOKIE_NAME = "fs_chat_session";

  // data-live-endpoint → the live-agent server origin (mints customer tokens
  // for the live-agent Firestore module). Read here; the bridge that exposes
  // it to the module is built near the END of the IIFE (after addBubble,
  // $messages, SESSION_ID etc. all exist — search "FS LIVE-AGENT bridge").
  var LIVE_ENDPOINT = (script && script.getAttribute("data-live-endpoint")) || "";

  // ---------------------------------------------------------------------
  // Address autocomplete (Google Places) — script-tag configuration
  // ---------------------------------------------------------------------
  // data-maps-key            → Google Maps JavaScript API key. The key is
  //                            domain-restricted (HTTP-referrer) to
  //                            flowersugar.com, so embedding it in the page
  //                            is expected and safe. When ABSENT, the
  //                            search-while-type feature is OFF and the
  //                            address line stays a plain text input.
  // data-address-autocomplete → "true"/"false" master switch for the
  //                            search-while-type feature. Defaults to ON
  //                            when a maps key is present, OFF otherwise.
  //                            Set data-address-autocomplete="false" to ship
  //                            the key but keep the feature dark.
  var MAPS_API_KEY = (script && script.getAttribute("data-maps-key")) || "";
  var _rawAutocompleteFlag = (script && script.getAttribute("data-address-autocomplete"));
  // null (absent) → default to enabled iff a key exists; "false"/"0"/"off"/"no"
  // → disabled; anything else → enabled.
  var ADDRESS_AUTOCOMPLETE_ENABLED;
  if (_rawAutocompleteFlag === null || _rawAutocompleteFlag === undefined) {
    ADDRESS_AUTOCOMPLETE_ENABLED = !!MAPS_API_KEY;
  } else {
    ADDRESS_AUTOCOMPLETE_ENABLED =
      !/^(false|0|off|no)$/i.test(String(_rawAutocompleteFlag).trim());
  }
  // Effective feature gate: needs BOTH the switch on AND a key present.
  var ADDR_AC_ON = ADDRESS_AUTOCOMPLETE_ENABLED && !!MAPS_API_KEY;

  function getCookie(name) {
    var m = document.cookie.match(new RegExp("(?:^|;\\s*)" + name + "=([^;]+)"));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 3600 * 1000);
    document.cookie =
      name + "=" + encodeURIComponent(value) +
      ";expires=" + d.toUTCString() +
      ";path=/;samesite=lax;secure";
  }

  function getSessionId() {
    var sid = getCookie(COOKIE_NAME);
    if (!sid) {
      sid = "fs_chat_" +
        Math.random().toString(36).slice(2, 10) +
        Date.now().toString(36);
      setCookie(COOKIE_NAME, sid, 365);
    }
    return sid;
  }

  var SESSION_ID = getSessionId();

  // ---------------------------------------------------------------------
  // v2.53.0 — Tab id (per-browser-tab UUID)
  // ---------------------------------------------------------------------
  // Used by the cross-tab typing-signal lockout (v2.53.1) and stored in
  // every outgoing message's `meta.tab_id` for provenance. Persisted in
  // sessionStorage so the same id survives reloads of the SAME tab but
  // a fresh tab gets a fresh id (which is what we want — sessionStorage
  // is per-tab by definition).
  //
  // Soft-fail: if sessionStorage is blocked (Safari Private Browsing,
  // strict cookie policies), fall back to a per-page-load uuid so other
  // tab-based features still work for the lifetime of the page.
  // ---------------------------------------------------------------------
  var TAB_STORAGE_KEY = "fs_chat_tab_id";
  var TAB_ID = (function () {
    try {
      var t = sessionStorage.getItem(TAB_STORAGE_KEY);
      if (!t) {
        t = "tab_" +
            Math.random().toString(36).slice(2, 10) +
            Date.now().toString(36);
        sessionStorage.setItem(TAB_STORAGE_KEY, t);
      }
      return t;
    } catch (_) {
      return "tab_" +
             Math.random().toString(36).slice(2, 10) +
             Date.now().toString(36);
    }
  })();
  // console.info("[FlowerSugar] tab_id:", TAB_ID);

  // ---------------------------------------------------------------------
  // v2.36.0 — WhatsApp escape hatch (footer link)
  // ---------------------------------------------------------------------
  // Persistent low-key WhatsApp affordance in the footer slot. NOT the
  // same as the existing in-bubble WhatsApp buttons (refund flow, error
  // fallback) — those use a different message template ("Hi Flower
  // Sugar, I need help. My reference: ...") because they fire in
  // problem moments. The footer is exploratory and uses the
  // "products & services" phrasing — the production team's WhatsApp
  // inbox sees the template and immediately knows which entry point
  // the customer came from.
  //
  // Keep these two templates distinct. If a future version wants to
  // unify, do it deliberately and update the production team's triage.
  var WA_FOOTER_PHONE = "60196800751";
  var WA_FOOTER_MESSAGE_TEMPLATE =
    "Hi Flower Sugar! I would like to know more about your products & services [ref: <SESSION>]";

  function _isWithinBusinessHours() {
    // v2.36.0 stub — always true (24/7).
    //
    // When this needs tightening (e.g. 9am-6pm MYT), this is the
    // single edit point: compute the current Asia/Kuala_Lumpur hour
    // and return whether it's within the window. Callers (footer
    // render + click handler) already gate on this function, so a
    // single edit here makes the footer hide / disable correctly
    // across midnight boundaries (panel-open path re-evaluates).
    return true;
  }

  function _buildFooterWhatsAppUrl(sessionId) {
    // Build the wa.me URL with the agreed message template. Defensive
    // against missing/empty/non-string sessionId — produces "[ref: ]"
    // rather than crashing. The production team will see the empty
    // reference and can ask the customer for their chat URL.
    var safeId = (typeof sessionId === "string") ? sessionId : "";
    var message = WA_FOOTER_MESSAGE_TEMPLATE.replace("<SESSION>", safeId);
    return "https://wa.me/" + WA_FOOTER_PHONE +
           "?text=" + encodeURIComponent(message);
  }

  // ---------------------------------------------------------------------
  // CSS — mounted into the host element's light DOM (see "Mount"
  // section below). The host page's stylesheet can reach in, so EVERY
  // class used by the widget is prefixed `fs-chatbot-` for isolation.
  // The host element itself is targeted by id (#flower-sugar-chat-host).
  // jQuery UI's own classes (`.ui-datepicker`, `.hasDatepicker`) are
  // left as-is since the library owns them.
  // ---------------------------------------------------------------------
  var CSS = `
    /* Re-isolate the host element itself from inherited page styles.
       Was a :host rule under shadow DOM (v2.27.11 and earlier); now
       targets the actual id since :host doesn't apply in light DOM. */
    #flower-sugar-chat-host { all: initial; }
    /* Scoped to the widget — was unscoped under shadow DOM but
       would now apply globally in light DOM and override host page
       box-sizing on every element. */
    #flower-sugar-chat-host *,
    #flower-sugar-chat-host *::before,
    #flower-sugar-chat-host *::after { box-sizing: border-box; }
    .fs-chatbot-root {
      --fs-pink-50:  #FFF5F8;
      --fs-pink-100: #FCE4EC;
      --fs-pink-200: #F8BBD0;
      --fs-pink-400: #EC8AAB;
      --fs-pink-500: #D6608A;
      --fs-pink-600: #B84773;
      --fs-ink:      #2A1820;
      --fs-ink-soft: #5A4853;
      --fs-cream:    #FBF7F4;
      --fs-line:     rgba(184, 71, 115, 0.12);
      --fs-shadow-lg: 0 24px 60px -16px rgba(184, 71, 115, 0.28),
                      0 8px 24px -6px rgba(42, 24, 32, 0.08);
      --fs-shadow-md: 0 8px 28px -6px rgba(184, 71, 115, 0.22);

      font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
      color: var(--fs-ink);
      line-height: 1.5;
    }
    .fs-chatbot-root .fs-chatbot-display {
      font-family: 'Cormorant Garamond', 'Playfair Display', Georgia, serif;
      letter-spacing: -0.01em;
    }

    /* ---------- Floating launcher button ---------- */
    .fs-chatbot-launcher {
      position: fixed;
      right: 24px;
      bottom: 24px;
      width: 64px;
      height: 64px;
      border-radius: 50%;
      border: none;
      cursor: pointer;
      background: linear-gradient(135deg, var(--fs-pink-500), var(--fs-pink-600));
      color: white;
      box-shadow: var(--fs-shadow-lg);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2147483646;
      transition: transform 220ms cubic-bezier(.2,.8,.2,1), box-shadow 220ms;
    }
    .fs-chatbot-launcher:hover {
      transform: translateY(-2px) scale(1.04);
      box-shadow: 0 28px 70px -16px rgba(184, 71, 115, 0.36),
                  0 10px 28px -6px rgba(42, 24, 32, 0.12);
    }
    .fs-chatbot-launcher::after {
      content: "";
      position: absolute;
      inset: -6px;
      border-radius: 50%;
      border: 1px solid var(--fs-pink-200);
      opacity: 0.7;
      animation: ring 2.6s ease-out infinite;
    }
    @keyframes ring {
      0%   { transform: scale(0.95); opacity: 0.7; }
      80%  { transform: scale(1.18); opacity: 0; }
      100% { transform: scale(1.18); opacity: 0; }
    }
    .fs-chatbot-launcher svg { width: 28px; height: 28px; }
    .fs-chatbot-launcher.fs-chatbot-hidden { display: none; }

    /* ---------- v2.55.45 — Unread indicator on the launcher ---------- */
    /* A count badge (1, 2, 3+) pinned to the top-right edge of the
       launcher. Sits ABOVE the pulsing ::after ring (higher z-index).
       In dot mode (.fs-chatbot-unread-dot) it shrinks to an empty dot. */
    .fs-chatbot-unread {
      position: absolute;
      top: -3px;
      right: -3px;
      min-width: 20px;
      height: 20px;
      padding: 0 5px;
      box-sizing: border-box;
      border-radius: 10px;
      background: #e8344e;             /* high-contrast unread red */
      color: #fff;
      font-size: 12px;
      font-weight: 700;
      line-height: 20px;
      text-align: center;
      letter-spacing: -0.02em;
      box-shadow: 0 0 0 2px #fff;      /* ring to lift it off the launcher */
      z-index: 1;                      /* above the ::after pulse ring */
      pointer-events: none;            /* clicks pass through to the launcher */
      animation: fs-unread-pop 240ms cubic-bezier(.2,.8,.2,1);
    }
    /* Dot mode: no number, smaller solid dot. */
    .fs-chatbot-unread.fs-chatbot-unread-dot {
      min-width: 12px;
      width: 12px;
      height: 12px;
      padding: 0;
      border-radius: 50%;
      font-size: 0;                    /* hide any text content */
    }
    .fs-chatbot-unread.fs-chatbot-hidden { display: none; }
    @keyframes fs-unread-pop {
      0%   { transform: scale(0); }
      70%  { transform: scale(1.18); }
      100% { transform: scale(1); }
    }
    @media (prefers-reduced-motion: reduce) {
      .fs-chatbot-unread { animation: none; }
    }

    /* ---------- Chat panel ---------- */
    .fs-chatbot-panel {
      position: fixed;
      right: 24px;
      bottom: 24px;
      width: 392px;
      height: min(640px, calc(100vh - 48px));
      background: var(--fs-cream);
      border-radius: 22px;
      box-shadow: var(--fs-shadow-lg);
      display: none;
      flex-direction: column;
      overflow: hidden;
      z-index: 2147483647;
      border: 1px solid var(--fs-line);
      animation: rise 280ms cubic-bezier(.2,.8,.2,1);
    }
    .fs-chatbot-panel.fs-chatbot-open { display: flex; }
    @keyframes rise {
      from { opacity: 0; transform: translateY(12px) scale(.98); }
      to   { opacity: 1; transform: translateY(0)    scale(1); }
    }

    /* ---------- Header ---------- */
    .fs-chatbot-header {
      position: relative;
      padding: 22px 22px 18px;
      background:
        radial-gradient(120% 140% at 100% 0%, rgba(248, 187, 208, 0.55) 0%, rgba(248, 187, 208, 0) 60%),
        linear-gradient(180deg, #FFFFFF 0%, var(--fs-cream) 100%);
      border-bottom: 1px solid var(--fs-line);
    }
    .fs-chatbot-header-row {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .fs-chatbot-badge {
      width: 42px; height: 42px;
      border-radius: 50%;
      background: linear-gradient(135deg, var(--fs-pink-100), var(--fs-pink-200));
      display: flex; align-items: center; justify-content: center;
      box-shadow: inset 0 0 0 1px rgba(255,255,255,0.6), var(--fs-shadow-md);
      flex-shrink: 0;
    }
    .fs-chatbot-badge svg { width: 22px; height: 22px; color: var(--fs-pink-600); }
    .fs-chatbot-header-title {
      font-size: 20px;
      font-weight: 500;
      color: var(--fs-ink);
      margin: 0;
      line-height: 1.1;
    }
    .fs-chatbot-header-sub {
      font-size: 12px;
      color: var(--fs-ink-soft);
      margin-top: 3px;
      display: flex;
      align-items: center;
      gap: 6px;
    }
    .fs-chatbot-pulse {
      display: inline-block;
      width: 6px; height: 6px;
      border-radius: 50%;
      background: #4CAF50;
      box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.5);
      animation: pulse 1.8s infinite;
    }
    @keyframes pulse {
      0%   { box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.5); }
      100% { box-shadow: 0 0 0 8px rgba(76, 175, 80, 0); }
    }
    .fs-chatbot-close-btn {
      position: absolute;
      top: 16px; right: 14px;
      background: transparent;
      border: none;
      width: 32px; height: 32px;
      border-radius: 50%;
      cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      color: var(--fs-ink-soft);
      transition: background 160ms;
    }
    .fs-chatbot-close-btn:hover { background: rgba(184, 71, 115, 0.08); }
    .fs-chatbot-close-btn svg { width: 16px; height: 16px; }

    /* ---------- v2.55.0 — Settings (gear) button + drawer ---------- */
    /* Gear button sits to the LEFT of the close button. Same visual
       footprint as close so the header reads as a balanced two-icon
       cluster. */
    .fs-chatbot-menu-btn {
      position: absolute;
      top: 16px; right: 54px;   /* 54 = close.right(14) + close.width(32) + gap(8) */
      background: transparent;
      border: none;
      width: 32px; height: 32px;
      border-radius: 50%;
      cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      color: var(--fs-ink-soft);
      transition: background 160ms;
    }
    .fs-chatbot-menu-btn:hover { background: rgba(184, 71, 115, 0.08); }
    .fs-chatbot-menu-btn svg { width: 18px; height: 18px; }

    /* Settings drawer — anchored under the gear button. Floats over
       the message area. */
    .fs-chatbot-settings-drawer {
      position: absolute;
      top: 56px;        /* below the header */
      right: 14px;
      background: #fff;
      border: 1px solid var(--fs-border, rgba(20, 20, 24, 0.08));
      border-radius: 12px;
      box-shadow: 0 8px 28px rgba(20, 20, 24, 0.12);
      min-width: 220px;
      padding: 6px;
      z-index: 5;
      display: none;
    }
    .fs-chatbot-settings-drawer.fs-chatbot-settings-open { display: block; }

    .fs-chatbot-settings-item {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      padding: 10px 12px;
      background: transparent;
      border: none;
      cursor: pointer;
      font-size: 13px;
      color: var(--fs-ink, #14141a);
      text-align: left;
      border-radius: 8px;
      transition: background 120ms;
    }
    .fs-chatbot-settings-item:hover {
      background: rgba(184, 71, 115, 0.06);
    }
    .fs-chatbot-settings-item-icon {
      width: 16px; height: 16px;
      color: var(--fs-ink-soft);
      flex-shrink: 0;
    }
    .fs-chatbot-settings-divider {
      height: 1px;
      background: var(--fs-border, rgba(20, 20, 24, 0.06));
      margin: 4px 6px;
    }

    /* ---------- v2.55.0 — Inline soft prompt (chat-stream bubble) ---------- */
    .fs-chatbot-phone-prompt {
      align-self: stretch;
      background: linear-gradient(135deg,
        rgba(184, 71, 115, 0.06),
        rgba(184, 71, 115, 0.02));
      border: 1px solid rgba(184, 71, 115, 0.15);
      border-radius: 16px;
      padding: 14px 16px;
      margin: 8px 0;
      font-size: 13px;
      color: var(--fs-ink, #14141a);
    }
    .fs-chatbot-phone-prompt-title {
      font-weight: 600;
      margin-bottom: 6px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .fs-chatbot-phone-prompt-title svg {
      width: 16px; height: 16px;
      color: var(--fs-accent, #b84773);
    }
    .fs-chatbot-phone-prompt-body {
      color: var(--fs-ink-soft);
      margin-bottom: 12px;
      line-height: 1.45;
    }
    .fs-chatbot-phone-prompt-actions {
      display: flex;
      gap: 8px;
    }
    .fs-chatbot-phone-prompt-btn {
      flex: 1;
      padding: 8px 12px;
      border-radius: 8px;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
      border: 1px solid transparent;
      transition: opacity 120ms, transform 120ms;
    }
    .fs-chatbot-phone-prompt-btn:hover { opacity: 0.85; }
    .fs-chatbot-phone-prompt-btn:active { transform: scale(0.98); }
    .fs-chatbot-phone-prompt-btn-primary {
      background: var(--fs-accent, #b84773);
      color: #fff;
    }
    .fs-chatbot-phone-prompt-btn-secondary {
      background: rgba(184, 71, 115, 0.06);
      color: var(--fs-ink, #14141a);
    }

    /* ---------- v2.55.0 — Phone entry overlay ---------- */
    .fs-chatbot-phone-modal {
      position: absolute;
      inset: 0;
      background: rgba(255, 255, 255, 0.92);
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
      display: none;
      align-items: center;
      justify-content: center;
      z-index: 10;
      padding: 16px;
    }
    .fs-chatbot-phone-modal.fs-chatbot-phone-modal-open {
      display: flex;
    }
    .fs-chatbot-phone-modal-card {
      width: 100%;
      max-width: 320px;
      background: #fff;
      border: 1px solid var(--fs-border, rgba(20, 20, 24, 0.08));
      border-radius: 16px;
      box-shadow: 0 12px 32px rgba(20, 20, 24, 0.14);
      padding: 20px;
    }
    .fs-chatbot-phone-modal-title {
      font-weight: 600;
      font-size: 15px;
      margin-bottom: 4px;
    }
    .fs-chatbot-phone-modal-subtitle {
      font-size: 12px;
      color: var(--fs-ink-soft);
      margin-bottom: 14px;
      line-height: 1.4;
    }
    .fs-chatbot-phone-input {
      width: 100%;
      padding: 10px 12px;
      font-size: 16px;  /* 16px to prevent iOS auto-zoom */
      border: 1px solid var(--fs-border, rgba(20, 20, 24, 0.12));
      border-radius: 10px;
      outline: none;
      transition: border-color 120ms;
      box-sizing: border-box;
    }
    .fs-chatbot-phone-input:focus {
      border-color: var(--fs-accent, #b84773);
    }
    .fs-chatbot-phone-input.fs-chatbot-phone-input-error {
      border-color: #d94a4a;
    }
    .fs-chatbot-phone-error {
      font-size: 11px;
      color: #d94a4a;
      margin-top: 6px;
      min-height: 14px;
    }
    .fs-chatbot-phone-modal-actions {
      display: flex;
      gap: 8px;
      margin-top: 14px;
    }
    .fs-chatbot-phone-modal-btn {
      flex: 1;
      padding: 10px 14px;
      border-radius: 10px;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      border: 1px solid transparent;
      transition: opacity 120ms;
    }
    .fs-chatbot-phone-modal-btn:hover { opacity: 0.88; }
    .fs-chatbot-phone-modal-btn:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
    .fs-chatbot-phone-modal-btn-primary {
      background: var(--fs-accent, #b84773);
      color: #fff;
    }
    .fs-chatbot-phone-modal-btn-secondary {
      background: rgba(20, 20, 24, 0.06);
      color: var(--fs-ink, #14141a);
    }
    .fs-chatbot-phone-modal-privacy {
      font-size: 10px;
      color: var(--fs-ink-soft);
      margin-top: 10px;
      line-height: 1.4;
    }

    /* Linked-phone indicator — shows masked phone in the header
       subtitle when session is linked. */
    .fs-chatbot-linked-phone {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 11px;
      color: var(--fs-ink-soft);
    }
    .fs-chatbot-linked-phone svg { width: 11px; height: 11px; }

    /* ---------- Messages area ---------- */
    .fs-chatbot-messages {
      flex: 1;
      overflow-y: auto;
      padding: 20px 18px 8px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      scroll-behavior: smooth;
    }
    .fs-chatbot-messages::-webkit-scrollbar { width: 6px; }
    .fs-chatbot-messages::-webkit-scrollbar-thumb {
      background: var(--fs-pink-200);
      border-radius: 3px;
    }

    /* ── Cart panel (v2.29.1, read-only) ─────────────────────────────
       Compact summary bar that appears above the messages list when
       the customer has items in their cart. The bar shows a one-line
       summary: "N items · DD MMM · RMxx.xx". v2.29.1 is read-only —
       no chevron, no actions. The wizard arrives in v2.29.2.
    */
    .fs-chatbot-cart-bar {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      padding: 10px 16px;
      background: var(--fs-pink-50);
      border-bottom: 1px solid var(--fs-line);
      font-size: 13px;
      color: var(--fs-ink);
      gap: 8px;
      line-height: 1.3;
    }
    .fs-chatbot-cart-bar.fs-chatbot-cart-hidden {
      display: none;
    }
    .fs-chatbot-cart-icon {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      color: var(--fs-pink-500);
    }
    .fs-chatbot-cart-summary {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .fs-chatbot-cart-summary .fs-chatbot-cart-sep {
      color: var(--fs-ink-soft);
      margin: 0 6px;
    }
    .fs-chatbot-cart-summary .fs-chatbot-cart-total {
      font-weight: 600;
      color: var(--fs-pink-600);
    }
    .fs-chatbot-cart-summary .fs-chatbot-cart-pending {
      color: var(--fs-ink-soft);
      font-style: italic;
    }

    /* ── Cart bar chevron (v2.29.2) — taps to open wizard ─────────── */
    .fs-chatbot-cart-bar.fs-chatbot-cart-interactive {
      cursor: pointer;
      user-select: none;
    }
    .fs-chatbot-cart-bar.fs-chatbot-cart-interactive:hover {
      background: var(--fs-pink-100);
    }
    .fs-chatbot-cart-chev {
      flex-shrink: 0;
      width: 14px;
      height: 14px;
      color: var(--fs-ink-soft);
      transition: transform 0.18s ease;
    }
    .fs-chatbot-cart-bar.fs-chatbot-cart-hidden .fs-chatbot-cart-chev {
      display: none;
    }

    /* ── Wizard modal (v2.29.2) ──────────────────────────────────────
       Modal overlay covering the entire chat panel interior. Hosts
       the three-page wizard; v2.29.2 ships only page 1.
    */
    .fs-chatbot-wizard {
      position: absolute;
      /* Long-form top/right/bottom/left rather than 'inset: 0' shorthand.
         The shorthand was only added to Safari in iOS 14.5; on earlier
         iOS it is a no-op, leaving the wizard at position: static even
         though position: absolute is set — observed as the wizard
         flowing as a normal flex child of the panel rather than
         overlaying it. */
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      /* height/width 100% is redundant when top+bottom+left+right are
         all 0 — modern browsers compute size from the four offsets. But
         in iOS Safari < 13 with flex parent the size calc can be
         inconsistent. Setting explicit 100% removes the ambiguity. */
      height: 100%;
      width: 100%;
      background: var(--fs-cream);
      z-index: 10;
      display: none;
      flex-direction: column;
      /* overflow: hidden here is belt-and-braces: prevents content
         from growing the wizard's box past the panel boundary in any
         flex-layout edge case. */
      overflow: hidden;
      animation: fs-wiz-rise 200ms cubic-bezier(.2,.8,.2,1);
    }
    .fs-chatbot-wizard.fs-chatbot-wizard-open {
      display: flex;
    }
    @keyframes fs-wiz-rise {
      from { opacity: 0; transform: translateY(8px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .fs-chatbot-wizard-header {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 14px 18px;
      border-bottom: 1px solid var(--fs-line);
      background: var(--fs-pink-50);
    }
    .fs-chatbot-wizard-title {
      flex: 1;
      font-family: "Cormorant Garamond", serif;
      font-size: 20px;
      font-weight: 600;
      color: var(--fs-pink-600);
      margin: 0;
    }
    .fs-chatbot-wizard-cancel {
      flex-shrink: 0;
      background: transparent;
      border: 1px solid var(--fs-pink-200);
      color: var(--fs-pink-600);
      border-radius: 8px;
      padding: 5px 12px;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      font-family: inherit;
    }
    .fs-chatbot-wizard-cancel:hover {
      background: var(--fs-pink-100);
    }
    .fs-chatbot-wizard-body {
      flex: 1;
      /* Without min-height: 0, the body's min-height defaults to 'auto'
         (= content height), which overrides flex: 1 when content is
         taller than available space — the body grows to fit content
         instead of scrolling. This is the classic flexbox + scroll gotcha. */
      min-height: 0;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      padding: 16px 18px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .fs-chatbot-wizard-footer {
      flex-shrink: 0;
      padding: 14px 18px;
      border-top: 1px solid var(--fs-line);
      display: flex;
      gap: 10px;
      align-items: center;
    }
    .fs-chatbot-wizard-proceed {
      flex: 1;
      background: var(--fs-pink-500);
      color: white;
      border: 0;
      border-radius: 10px;
      padding: 12px 16px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      font-family: inherit;
    }
    .fs-chatbot-wizard-proceed:hover {
      background: var(--fs-pink-600);
    }
    .fs-chatbot-wizard-proceed:disabled {
      background: var(--fs-pink-200);
      color: white;
      cursor: not-allowed;
    }
    .fs-chatbot-wizard-status {
      flex-shrink: 0;
      font-size: 12px;
      color: var(--fs-ink-soft);
      font-style: italic;
    }

    /* Accordion sections within the wizard */
    .fs-chatbot-wiz-section {
      border: 1px solid var(--fs-line);
      border-radius: 10px;
      background: white;
      /* overflow: visible (not hidden) — when the section expands, its
         body's children (address inputs, datepicker, etc.) must be
         allowed to lay out at full natural height. overflow: hidden on
         the section clips fields that sit past the section's computed
         box height, which manifests as "address fields below the first
         couple are invisible and unreachable." The wizard body
         (.fs-chatbot-wizard-body) is the actual scroll container; let
         it own that responsibility. The slight cosmetic cost is that
         the rounded corners don't clip inner content — invisible in
         practice because the body's background is white and the only
         visible boundary is the section's own border. */
      overflow: visible;
    }
    .fs-chatbot-wiz-section-head {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 14px;
      cursor: pointer;
      user-select: none;
      background: white;
      border: 0;
      width: 100%;
      text-align: left;
      font-family: inherit;
      font-size: 14px;
      font-weight: 600;
      color: var(--fs-ink);
    }
    .fs-chatbot-wiz-section-head:hover {
      background: var(--fs-pink-50);
    }
    .fs-chatbot-wiz-section-title {
      flex: 1;
    }
    .fs-chatbot-wiz-section-summary {
      font-weight: 400;
      font-size: 12px;
      color: var(--fs-ink-soft);
      margin-right: 6px;
    }
    .fs-chatbot-wiz-section-chev {
      width: 14px;
      height: 14px;
      color: var(--fs-ink-soft);
      transition: transform 0.18s ease;
    }
    .fs-chatbot-wiz-section.fs-chatbot-wiz-expanded .fs-chatbot-wiz-section-chev {
      transform: rotate(180deg);
    }
    .fs-chatbot-wiz-section-body {
      padding: 0 14px 14px;
      display: none;
    }
    .fs-chatbot-wiz-section.fs-chatbot-wiz-expanded .fs-chatbot-wiz-section-body {
      display: block;
    }

    /* Items list inside the items section */
    .fs-chatbot-wiz-item {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 0;
      border-bottom: 1px dashed var(--fs-line);
    }
    .fs-chatbot-wiz-item:last-child {
      border-bottom: 0;
    }
    .fs-chatbot-wiz-item.fs-chatbot-wiz-item-zero {
      opacity: 0.45;
    }
    .fs-chatbot-wiz-item-name {
      flex: 1;
      font-size: 13px;
      color: var(--fs-ink);
      min-width: 0;
    }
    .fs-chatbot-wiz-item-variant {
      font-size: 11px;
      color: var(--fs-ink-soft);
      display: block;
      margin-top: 2px;
    }
    .fs-chatbot-wiz-item-price {
      font-size: 12px;
      color: var(--fs-ink-soft);
      flex-shrink: 0;
      min-width: 70px;
      text-align: right;
    }

    /* Quantity stepper (+/- buttons) */
    .fs-chatbot-wiz-qty {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      border: 1px solid var(--fs-line);
      border-radius: 8px;
      overflow: hidden;
    }
    .fs-chatbot-wiz-qty-btn {
      width: 30px;
      height: 30px;
      background: white;
      border: 0;
      color: var(--fs-pink-500);
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      font-family: inherit;
      line-height: 1;
    }
    .fs-chatbot-wiz-qty-btn:hover {
      background: var(--fs-pink-50);
    }
    .fs-chatbot-wiz-qty-btn:disabled {
      color: var(--fs-pink-200);
      cursor: not-allowed;
    }
    .fs-chatbot-wiz-qty-value {
      min-width: 28px;
      text-align: center;
      font-size: 13px;
      font-weight: 600;
      color: var(--fs-ink);
    }

    /* Date + address fields */
    .fs-chatbot-wiz-field {
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-bottom: 10px;
    }
    .fs-chatbot-wiz-field label {
      font-size: 12px;
      color: var(--fs-ink-soft);
      font-weight: 500;
    }
    .fs-chatbot-wiz-field input,
    .fs-chatbot-wiz-field select {
      padding: 9px 11px;
      border: 1px solid var(--fs-line);
      border-radius: 8px;
      /* v2.55.1: 16px to prevent iOS Safari auto-zoom on focus.
         Same rationale as .fs-chatbot-composer textarea. The wizard
         is the highest-stakes UI in the widget — customers enter
         their delivery address, name, and phone here. Pre-fix iOS
         zoom on focus made these fields almost unusable on iPhone. */
      font-size: 16px;
      font-family: inherit;
      color: var(--fs-ink);
      background: white;
    }
    .fs-chatbot-wiz-field input:focus,
    .fs-chatbot-wiz-field select:focus {
      outline: none;
      border-color: var(--fs-pink-400);
    }
    .fs-chatbot-wiz-field.fs-chatbot-wiz-field-error input,
    .fs-chatbot-wiz-field.fs-chatbot-wiz-field-error select {
      border-color: #c53030;
      background: #fff5f5;
    }
    .fs-chatbot-wiz-field-error-msg {
      font-size: 11px;
      color: #c53030;
      margin-top: 2px;
    }
    /* v2.31.9: field-level hint shown below an input as informational
       guidance (NOT an error). Distinct from .fs-chatbot-wiz-field-error-msg
       which is red — this is a quieter muted-ink colour so the
       customer reads it as "info" not "you did something wrong."
       Currently used by the balloon-wording field to show the
       allowed-charset rule before the customer makes a mistake. */
    .fs-chatbot-wiz-field-hint {
      font-size: 11px;
      color: var(--fs-ink-soft);
      margin-top: 3px;
      line-height: 1.4;
    }
    /* v2.31.0: disabled fields (pickup-mode recipient name/phone).
       Greyed background, lighter text, placeholder shown. The label
       is also muted so the customer reads the whole row as "this
       won't ask for input." */
    .fs-chatbot-wiz-field-disabled label {
      color: var(--fs-ink-muted, #999);
    }
    .fs-chatbot-wiz-field-disabled input {
      background: #f4f4f4;
      color: var(--fs-ink-muted, #999);
      cursor: not-allowed;
    }
    .fs-chatbot-wiz-field-disabled input::placeholder {
      color: var(--fs-ink-muted, #999);
      font-style: italic;
    }
    .fs-chatbot-wiz-pickup-note {
      background: var(--fs-pink-50);
      border: 1px solid var(--fs-line);
      border-radius: 8px;
      padding: 10px 12px;
      font-size: 12px;
      color: var(--fs-ink-soft);
      margin-top: 8px;
    }

    /* ── Fulfilment mode toggle (v2.29.5) ─────────────────────────────
       Two-button pill at the very top of wizard page 1. Switches the
       cart between delivery (default) and pickup. */
    .fs-chatbot-wiz-fulfilment {
      display: flex;
      gap: 0;
      margin-bottom: 12px;
      border: 1px solid var(--fs-line);
      border-radius: 10px;
      overflow: visible;
      background: white;
    }
    .fs-chatbot-wiz-fulfilment-btn {
      flex: 1;
      padding: 10px 14px;
      background: white;
      border: 0;
      color: var(--fs-ink-soft);
      font-size: 13px;
      font-weight: 600;
      font-family: inherit;
      cursor: pointer;
      transition: background 0.12s, color 0.12s;
    }
    .fs-chatbot-wiz-fulfilment-btn:hover {
      background: var(--fs-pink-50);
      color: var(--fs-ink);
    }
    .fs-chatbot-wiz-fulfilment-btn.fs-chatbot-wiz-fulfilment-active {
      background: var(--fs-pink-500);
      color: white;
    }
    .fs-chatbot-wiz-fulfilment-btn.fs-chatbot-wiz-fulfilment-active:hover {
      background: var(--fs-pink-600);
    }

    /* Pickup info block — replaces the address form when pickup is
       selected. Read-only display of the canned store address. */
    .fs-chatbot-wiz-pickup-info {
      background: var(--fs-pink-50);
      border: 1px solid var(--fs-line);
      border-radius: 8px;
      padding: 12px 14px;
    }
    .fs-chatbot-wiz-pickup-line {
      font-size: 13px;
      color: var(--fs-ink);
      line-height: 1.5;
    }
    .fs-chatbot-wiz-pickup-line:first-child {
      color: var(--fs-pink-600);
      margin-bottom: 4px;
    }

    /* ── Wizard page 2: delivery options (v2.29.3) ─────────────────── */
    .fs-chatbot-wiz-options-list {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .fs-chatbot-wiz-options-list[data-has-error="1"] {
      /* Error-state outline on the radio group when service_code
         comes back invalid. Subtle — the per-field error message
         carries the specifics. */
      padding: 4px;
      border: 1px solid #c53030;
      border-radius: 10px;
      background: #fff5f5;
    }
    .fs-chatbot-wiz-option {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 12px 14px;
      border: 1px solid var(--fs-line);
      border-radius: 10px;
      background: white;
      cursor: pointer;
      transition: border-color 0.12s, background 0.12s;
    }
    .fs-chatbot-wiz-option:hover {
      background: var(--fs-pink-50);
      border-color: var(--fs-pink-200);
    }
    .fs-chatbot-wiz-option input[type="radio"] {
      flex-shrink: 0;
      margin: 0;
      accent-color: var(--fs-pink-500);
    }
    .fs-chatbot-wiz-option input[type="radio"]:checked + .fs-chatbot-wiz-option-body {
      color: var(--fs-pink-600);
    }
    /* Checked-row visual treatment via :has() — modern browsers only.
       Falls back to the input's own checked indicator on older
       browsers. */
    .fs-chatbot-wiz-option:has(input[type="radio"]:checked) {
      border-color: var(--fs-pink-400);
      background: var(--fs-pink-50);
    }
    .fs-chatbot-wiz-option-body {
      flex: 1;
      min-width: 0;
    }
    .fs-chatbot-wiz-option-name {
      font-size: 14px;
      font-weight: 600;
      color: var(--fs-ink);
    }
    .fs-chatbot-wiz-option-desc {
      font-size: 12px;
      color: var(--fs-ink-soft);
      margin-top: 2px;
    }
    .fs-chatbot-wiz-option-price {
      flex-shrink: 0;
      font-size: 13px;
      font-weight: 600;
      color: var(--fs-pink-600);
    }
    .fs-chatbot-wiz-options-loading,
    .fs-chatbot-wiz-options-empty {
      padding: 20px 16px;
      text-align: center;
      font-size: 13px;
      color: var(--fs-ink-soft);
      font-style: italic;
    }
    .fs-chatbot-wiz-form-error {
      padding: 10px 14px;
      margin-bottom: 10px;
      background: #fff5f5;
      border: 1px solid #fed7d7;
      border-radius: 8px;
      color: #c53030;
      font-size: 13px;
    }

    /* v2.33.10: pickup-time statement on Page 3.
       Shown when fulfilment_mode=pickup AND pickup_date is today/tomorrow.
       Visually distinct from error (positive tone, blue background) — this
       is REASSURANCE, not a warning. */
    .fs-chatbot-wiz-pickup-statement {
      padding: 10px 14px;
      margin-bottom: 12px;
      background: #f0f7ff;
      border: 1px solid #c5dbf0;
      border-radius: 8px;
      color: #1e3a5f;
      font-size: 13px;
      line-height: 1.5;
    }

    /* v2.55.110: read-only customisation summary on Page 3.
       Shows cart.product_remark (the bot's accumulated summary of every
       accepted customisation). GREYED + never editable — the only
       affordance is the "x" which clears the whole field. */
    .fs-chatbot-wiz-product-remark {
      position: relative;
      padding: 10px 36px 10px 14px;
      margin-bottom: 12px;
      background: var(--fs-pink-50, #fdf2f8);
      border: 1px solid var(--fs-line, #e7e1e4);
      border-radius: 8px;
      color: var(--fs-ink-soft, #6b6168);
      font-size: 13px;
      line-height: 1.5;
    }
    .fs-chatbot-wiz-product-remark-label {
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      color: var(--fs-ink-soft, #6b6168);
      opacity: 0.75;
      margin-bottom: 4px;
    }
    .fs-chatbot-wiz-product-remark-text {
      color: var(--fs-ink-soft, #6b6168);
      white-space: pre-wrap;
      word-break: break-word;
    }
    .fs-chatbot-wiz-product-remark-x {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 22px;
      height: 22px;
      line-height: 1;
      border: none;
      border-radius: 50%;
      background: transparent;
      color: var(--fs-ink-soft, #6b6168);
      font-size: 17px;
      cursor: pointer;
      font-family: inherit;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
    }
    .fs-chatbot-wiz-product-remark-x:hover {
      background: var(--fs-pink-100, #fce4ee);
      color: var(--fs-ink, #2b2228);
    }
    .fs-chatbot-wiz-product-remark-x:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    /* v2.33.10: inactivity warning (yellow, transient). Shown 5min
       before the 1-hour cutoff. Disappears on any interaction. */
    .fs-chatbot-wiz-inactivity-warn {
      padding: 10px 14px;
      margin-bottom: 10px;
      background: #fffaf0;
      border: 1px solid #f6e05e;
      border-radius: 8px;
      color: #744210;
      font-size: 13px;
    }

    /* Back button on page 2 footer — quieter than Proceed. */
    .fs-chatbot-wizard-back {
      flex-shrink: 0;
      background: transparent;
      border: 1px solid var(--fs-line);
      color: var(--fs-ink-soft);
      border-radius: 10px;
      padding: 12px 16px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      font-family: inherit;
    }
    .fs-chatbot-wizard-back:hover {
      background: var(--fs-pink-50);
      color: var(--fs-ink);
    }
    .fs-chatbot-wizard-back:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    /* ── Wizard page 3: order details form (v2.29.4) ────────────────
       Vertical form grouped into sections (buyer block, recipient
       block, per-item message card blocks). Reuses the existing
       .fs-chatbot-wiz-field input styling from page 1. */
    .fs-chatbot-wiz-details-section {
      border: 1px solid var(--fs-line);
      border-radius: 10px;
      background: white;
      padding: 14px;
      margin-bottom: 12px;
    }
    .fs-chatbot-wiz-details-section:last-child {
      margin-bottom: 0;
    }
    .fs-chatbot-wiz-details-heading {
      font-size: 14px;
      font-weight: 600;
      color: var(--fs-ink);
      margin-bottom: 10px;
    }
    /* The textarea in the message-card section gets a slightly
       different treatment vs single-line inputs — taller, monospaced
       isn't a fit (it's prose), but use a softer focus ring. v2.29.8
       bumped min-height to fit ~4 rows of the 550-char message. */
    .fs-chatbot-wiz-details-section textarea {
      width: 100%;
      padding: 9px 11px;
      border: 1px solid var(--fs-line);
      border-radius: 8px;
      /* v2.55.1: 16px to prevent iOS Safari auto-zoom on focus.
         This is the wizard's "additional notes" textarea (e.g. card
         message, special instructions). Customer-facing → same iOS
         rationale as the other inputs. */
      font-size: 16px;
      font-family: inherit;
      color: var(--fs-ink);
      background: white;
      resize: vertical;
      min-height: 90px;
      line-height: 1.4;
    }
    .fs-chatbot-wiz-details-section textarea:focus {
      outline: none;
      border-color: var(--fs-pink-400);
    }
    .fs-chatbot-wiz-field.fs-chatbot-wiz-field-error textarea {
      border-color: #c53030;
      background: #fff5f5;
    }

    /* v2.29.8 help note below all per-item card sections. One note
       per form (not per item) — visually quieter than repeating it. */
    .fs-chatbot-wiz-card-help {
      font-size: 12px;
      color: var(--fs-ink-soft);
      line-height: 1.45;
      padding: 8px 14px 4px;
      margin-bottom: 12px;
      font-style: italic;
    }

    /* v2.31.0 page-bottom hint. Used on wizard pages 1 and 2 to tell
       the customer what to expect on the next page. Visually similar
       to .fs-chatbot-wiz-card-help (muted, italic, smaller) but
       distinct class so the two can be tuned independently — the
       card-help note is per-form-section while the page-hint is
       per-page. */
    .fs-chatbot-wiz-page-hint {
      font-size: 12px;
      color: var(--fs-ink-soft);
      line-height: 1.45;
      padding: 10px 14px 6px;
      margin-top: 4px;
      font-style: italic;
      border-top: 1px dashed var(--fs-line);
    }

    .fs-chatbot-msg { max-width: 86%; display: flex; flex-direction: column; gap: 6px; }
    .fs-chatbot-msg.fs-chatbot-user { align-self: flex-end; align-items: flex-end; }
    .fs-chatbot-msg.fs-chatbot-bot  { align-self: flex-start; }

    .fs-chatbot-bubble {
      padding: 11px 15px;
      font-size: 14.5px;
      line-height: 1.5;
      border-radius: 18px;
      word-wrap: break-word;
      white-space: pre-wrap;
    }
    .fs-chatbot-msg.fs-chatbot-user .fs-chatbot-bubble {
      background: linear-gradient(135deg, var(--fs-pink-500), var(--fs-pink-600));
      color: #fff;
      border-bottom-right-radius: 6px;
      box-shadow: 0 4px 14px -4px rgba(184, 71, 115, 0.4);
    }
    .fs-chatbot-msg.fs-chatbot-bot .fs-chatbot-bubble {
      background: #fff;
      color: var(--fs-ink);
      border: 1px solid var(--fs-line);
      border-bottom-left-radius: 6px;
      box-shadow: 0 2px 8px -2px rgba(42, 24, 32, 0.04);
    }
    .fs-chatbot-bubble a {
      color: var(--fs-pink-600);
      text-decoration: underline;
      text-underline-offset: 2px;
    }
    .fs-chatbot-msg.fs-chatbot-user .fs-chatbot-bubble a { color: #fff; }

    /* ---------- Per-message timestamp ----------
       Small dim text under each bubble. Aligns with the bubble's edge
       (right for user, left for bot) so it visually belongs to the
       message above it. Won't appear on transient nodes like the
       typing indicator (those skip the timestamp helper). */
    .fs-chatbot-msg-ts {
      font-size: 11px;
      color: var(--fs-ink-soft);
      opacity: 0.7;
      padding: 0 4px;
      line-height: 1;
      user-select: none;
    }
    .fs-chatbot-msg.fs-chatbot-user .fs-chatbot-msg-ts { text-align: right; }
    .fs-chatbot-msg.fs-chatbot-bot  .fs-chatbot-msg-ts { text-align: left;  }

    /* ---------- Welcome card ---------- */
    .fs-chatbot-welcome {
      background: linear-gradient(135deg, #fff 0%, var(--fs-pink-50) 100%);
      border: 1px solid var(--fs-line);
      border-radius: 16px;
      padding: 18px 18px 16px;
      box-shadow: 0 4px 16px -6px rgba(184, 71, 115, 0.12);
    }
    .fs-chatbot-welcome h3 {
      margin: 0 0 6px;
      font-size: 22px;
      font-weight: 500;
      letter-spacing: -0.01em;
      color: var(--fs-ink);
    }
    .fs-chatbot-welcome p {
      margin: 0;
      font-size: 13.5px;
      color: var(--fs-ink-soft);
    }
    .fs-chatbot-welcome p.fs-chatbot-welcome-langs {
      margin-top: 8px;
      font-size: 12.5px;
      color: var(--fs-ink-soft);
      opacity: 0.85;
    }

    /* ---------- Quick action chips ---------- */
    /* STAGE 1: chips hidden — remove display:none to re-enable */
    .fs-chatbot-quick-actions {
      display: none;
      flex-wrap: wrap;
      gap: 8px;
      padding: 0 18px 14px;
    }
    .fs-chatbot-chip {
      flex: 1 1 calc(50% - 4px);
      min-width: 0;
      padding: 10px 12px;
      font-size: 13px;
      font-weight: 500;
      border: 1px solid var(--fs-pink-200);
      background: #fff;
      color: var(--fs-pink-600);
      border-radius: 12px;
      cursor: pointer;
      transition: all 160ms;
      display: flex;
      align-items: center;
      gap: 6px;
      justify-content: center;
      font-family: inherit;
    }
    .fs-chatbot-chip:hover {
      background: var(--fs-pink-50);
      border-color: var(--fs-pink-400);
      transform: translateY(-1px);
    }
    .fs-chatbot-chip svg { width: 14px; height: 14px; flex-shrink: 0; }

    /* ---------- Product cards ---------- */
    .fs-chatbot-products {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-top: 6px;
      width: 100%;
    }
    /* v2.55.93 — photo-display channel: image + title tiles, distinct from
       product cards (no price, no Place Order; a photo enquiry shows photos,
       not an orderable card). Same visual language as product cards. */
    .fs-chatbot-photos {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-top: 6px;
      width: 100%;
    }
    .fs-chatbot-photo {
      background: #fff;
      border: 1px solid var(--fs-line);
      border-radius: 14px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      text-decoration: none;
      transition: transform 200ms, box-shadow 200ms;
    }
    a.fs-chatbot-photo:hover {
      transform: translateY(-2px);
      box-shadow: var(--fs-shadow-md);
    }
    .fs-chatbot-photo-img {
      width: 100%;
      aspect-ratio: 1 / 1;
      object-fit: cover;
      background: var(--fs-pink-50);
      display: block;
    }
    .fs-chatbot-photo-title {
      padding: 8px 10px 10px;
      font-size: 12.5px;
      font-weight: 500;
      color: var(--fs-ink);
      line-height: 1.3;
    }
    .fs-chatbot-product {
      background: #fff;
      border: 1px solid var(--fs-line);
      border-radius: 14px;
      overflow: hidden;
      transition: transform 200ms, box-shadow 200ms;
      cursor: pointer;
      display: flex;
      flex-direction: column;
    }
    .fs-chatbot-product:hover {
      transform: translateY(-2px);
      box-shadow: var(--fs-shadow-md);
    }
    .fs-chatbot-product-img {
      width: 100%;
      aspect-ratio: 1 / 1;
      object-fit: cover;
      background: var(--fs-pink-50);
      display: block;
    }
    .fs-chatbot-product-body {
      padding: 9px 10px 11px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      flex: 1;
    }
    .fs-chatbot-product-title {
      font-size: 12.5px;
      font-weight: 500;
      color: var(--fs-ink);
      line-height: 1.3;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .fs-chatbot-product-price {
      font-size: 13px;
      font-weight: 600;
      color: var(--fs-pink-600);
      margin-top: auto;
    }
    .fs-chatbot-product-cta {
      margin-top: 6px;
      padding: 6px 10px;
      border: 1px solid var(--fs-pink-200);
      border-radius: 8px;
      font-size: 11.5px;
      font-weight: 500;
      color: var(--fs-pink-600);
      background: var(--fs-pink-50);
      text-align: center;
      text-decoration: none;
      transition: all 160ms;
    }
    .fs-chatbot-product-cta:hover {
      background: var(--fs-pink-500);
      color: #fff;
      border-color: var(--fs-pink-500);
    }
    /* New (post-restructure): card body is an inner anchor so the body
       click opens the product page in a new tab; the Place Order CTA is
       a sibling button so its click does NOT navigate. */
    .fs-chatbot-product-link {
      display: block;
      color: inherit;
      text-decoration: none;
    }
    .fs-chatbot-product-cta-btn {
      display: block;
      width: calc(100% - 20px);
      margin: 0 10px 11px;
      padding: 7px 10px;
      border: 1px solid var(--fs-pink-200);
      border-radius: 8px;
      font-family: inherit;
      font-size: 11.5px;
      font-weight: 600;
      color: var(--fs-pink-600);
      background: var(--fs-pink-50);
      text-align: center;
      cursor: pointer;
      transition: all 160ms;
    }
    .fs-chatbot-product-cta-btn:hover:not(.fs-chatbot-disabled) {
      background: var(--fs-pink-500);
      color: #fff;
      border-color: var(--fs-pink-500);
    }
    .fs-chatbot-product-cta-btn.fs-chatbot-disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }
    /* Variant + Date form rendered when Place Order is clicked. Lives
       inside a normal bot bubble (.fs-chatbot-msg.fs-chatbot-bot) so it appears in the chat
       stream, not inside the product-card grid. The bubble it lives in
       opts out of .fs-chatbot-msg's 86% max-width cap (see .fs-chatbot-msg.fs-chatbot-variant-date-bubble
       below) so the form fills the row — the calendar widget needs
       horizontal space. */
    .fs-chatbot-variant-date-form {
      padding: 10px;
      border: 1px solid var(--fs-pink-200);
      border-radius: 12px;
      background: #fff;
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;
      box-sizing: border-box;
    }
    /* The bubble that contains a Variant+Date form: full width inside its
       parent (.fs-chatbot-msgs handles the row's own padding), overriding .fs-chatbot-msg's
       default 86% cap. */
    .fs-chatbot-msg.fs-chatbot-variant-date-bubble {
      max-width: 100%;
      width: 100%;
      align-self: stretch;
    }
    .fs-chatbot-variant-date-form .fs-chatbot-vdf-header {
      font-size: 12.5px;
      font-weight: 600;
      color: var(--fs-pink-600);
      padding-bottom: 4px;
      border-bottom: 1px solid var(--fs-line);
    }
    .fs-chatbot-variant-date-form .fs-chatbot-vdf-field {
      display: flex;
      flex-direction: column;
      gap: 3px;
    }
    .fs-chatbot-variant-date-form .fs-chatbot-vdf-label {
      font-size: 11.5px;
      font-weight: 500;
      color: var(--fs-ink);
    }
    .fs-chatbot-variant-date-form select,
    .fs-chatbot-variant-date-form input[type="date"],
    .fs-chatbot-variant-date-form input[type="text"] {
      font-family: inherit;
      /* v2.55.1: 16px to prevent iOS Safari auto-zoom on focus.
         The VDF is the flow customers go through after clicking
         Place Order on a product card — date picker + variant
         dropdown. Pre-fix on iOS the page zoomed in when they
         tapped either field, breaking the layout. */
      font-size: 16px;
      padding: 6px 8px;
      border: 1px solid var(--fs-line);
      border-radius: 6px;
      background: #fff;
      color: var(--fs-ink);
    }
    /* jQuery UI datepicker pops up as a fixed-position .ui-datepicker
       element in document body. The chat widget runs at a high z-index
       (it's a floating panel), so the calendar needs to outrank it. */
    .ui-datepicker {
      z-index: 2147483647 !important;
    }
    .fs-chatbot-variant-date-form .fs-chatbot-vdf-error {
      font-size: 11px;
      color: #c0392b;
      min-height: 14px;
    }
    .fs-chatbot-variant-date-form .fs-chatbot-vdf-actions {
      display: flex;
      gap: 6px;
      margin-top: 2px;
    }
    .fs-chatbot-variant-date-form .fs-chatbot-vdf-submit,
    .fs-chatbot-variant-date-form .fs-chatbot-vdf-cancel {
      flex: 1;
      padding: 7px 10px;
      border-radius: 8px;
      font-family: inherit;
      font-size: 11.5px;
      font-weight: 600;
      cursor: pointer;
      transition: all 160ms;
    }
    .fs-chatbot-variant-date-form .fs-chatbot-vdf-submit {
      border: 1px solid var(--fs-pink-500);
      background: var(--fs-pink-500);
      color: #fff;
    }
    .fs-chatbot-variant-date-form .fs-chatbot-vdf-submit:hover { filter: brightness(0.95); }
    .fs-chatbot-variant-date-form .fs-chatbot-vdf-cancel {
      border: 1px solid var(--fs-line);
      background: #fff;
      color: var(--fs-ink-soft);
    }
    .fs-chatbot-variant-date-form .fs-chatbot-vdf-cancel:hover { background: var(--fs-pink-50); }

    /* ---------- Delivery quote block (handler pre-built reply) ---------- */
    .fs-chatbot-delivery-quote {
      margin-top: 8px;
      background: #fff;
      border: 1px solid var(--fs-line);
      border-radius: 14px;
      padding: 12px 14px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    /* v2.55.59 — authenticated order-details bubble */
    .fs-chatbot-order-details {
      margin-top: 8px;
      background: #fff;
      border: 1px solid var(--fs-line);
      border-radius: 14px;
      padding: 12px 14px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .fs-chatbot-od-header {
      font-size: 14px;
      font-weight: 700;
      color: var(--fs-ink, #222);
      padding-bottom: 6px;
      border-bottom: 1px solid var(--fs-line);
    }
    .fs-chatbot-od-row {
      display: flex;
      flex-direction: column;
      gap: 1px;
    }
    .fs-chatbot-od-label {
      font-size: 11px;
      font-weight: 600;
      color: var(--fs-muted, #888);
      text-transform: uppercase;
      letter-spacing: 0.02em;
    }
    .fs-chatbot-od-value {
      font-size: 14px;
      font-weight: 500;
      color: var(--fs-ink, #222);
      white-space: pre-wrap;
      word-break: break-word;
    }
    .fs-chatbot-od-remark {
      font-size: 11px;
      color: var(--fs-muted, #999);
      line-height: 1.3;
    }
    .fs-chatbot-od-documents {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-top: 4px;
      padding-top: 10px;
      border-top: 1px solid var(--fs-line);
    }
    .fs-chatbot-od-doc-btn {
      display: inline-block;
      align-self: flex-start;
      font-size: 13px;
      font-weight: 600;
      color: #fff;
      background: var(--fs-accent, #c2557a);
      text-decoration: none;
      padding: 8px 14px;
      border-radius: 10px;
    }
    .fs-chatbot-od-doc-btn:hover { opacity: 0.92; }
    .fs-chatbot-od-doc-note {
      font-size: 11px;
      color: var(--fs-muted, #888);
      line-height: 1.4;
    }
    .fs-chatbot-delivery-quote-item {
      font-size: 13px;
      font-weight: 600;
      color: var(--fs-ink);
      padding-bottom: 6px;
      border-bottom: 1px solid var(--fs-line);
    }
    .fs-chatbot-delivery-quote-tier {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    .fs-chatbot-delivery-quote-tier-label {
      font-size: 11.5px;
      font-weight: 600;
      color: var(--fs-pink-600);
      text-transform: uppercase;
      letter-spacing: 0.4px;
      margin-bottom: 2px;
    }
    /* Table-style two-column grid. Rows visually separated by faint dividers. */
    .fs-chatbot-delivery-rates {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 0;
      border-top: 1px solid var(--fs-line);
    }
    .fs-chatbot-delivery-rate-row {
      display: contents;
    }
    .fs-chatbot-delivery-rate-row > * {
      padding: 7px 0;
      border-bottom: 1px solid var(--fs-line);
      font-size: 13px;
      line-height: 1.35;
    }
    .fs-chatbot-delivery-rate-row:last-child > * {
      border-bottom: none;
    }
    .fs-chatbot-delivery-rate-name {
      color: var(--fs-ink);
      padding-right: 12px;
    }
    .fs-chatbot-delivery-rate-price {
      font-weight: 600;
      color: var(--fs-ink);
      text-align: right;
      white-space: nowrap;
    }
    .fs-chatbot-delivery-rate-free {
      color: #1f9d55;
    }
    .fs-chatbot-delivery-quote-disclaimers {
      list-style: disc outside;
      margin: 0;
      padding: 6px 0 0 18px;
      border-top: 1px dashed var(--fs-line);
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    .fs-chatbot-delivery-quote-disclaimers li {
      font-size: 11px;
      line-height: 1.4;
      color: var(--fs-muted, #888);
    }
    .fs-chatbot-delivery-quote-expiry {
      font-size: 11.5px;
      color: var(--fs-muted, #888);
      font-style: italic;
      padding-top: 6px;
      border-top: 1px dashed var(--fs-line);
    }
    .fs-chatbot-delivery-quote-empty {
      font-size: 24px;
      color: var(--fs-muted, #888);
      text-align: center;
      padding: 8px 0;
    }

    /* ---------- Inline buttons (whatsapp, track) ---------- */
    .fs-chatbot-btn-row {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-top: 4px;
    }
    .fs-chatbot-btn {
      padding: 11px 14px;
      border: none;
      border-radius: 12px;
      font-size: 13.5px;
      font-weight: 500;
      cursor: pointer;
      text-align: center;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      transition: all 180ms;
      font-family: inherit;
    }
    .fs-chatbot-btn-primary {
      background: linear-gradient(135deg, var(--fs-pink-500), var(--fs-pink-600));
      color: #fff;
      box-shadow: 0 6px 16px -6px rgba(184, 71, 115, 0.5);
    }
    .fs-chatbot-btn-primary:hover {
      transform: translateY(-1px);
      box-shadow: 0 10px 22px -8px rgba(184, 71, 115, 0.6);
    }
    .fs-chatbot-btn-whatsapp {
      background: #25D366;
      color: #fff;
      box-shadow: 0 6px 16px -6px rgba(37, 211, 102, 0.5);
    }
    .fs-chatbot-btn-whatsapp:hover { background: #1eba59; }
    .fs-chatbot-btn svg { width: 16px; height: 16px; }

    /* ---------- Session ID reference (shown below WhatsApp button) ---------- */
    .fs-chatbot-session-ref {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      margin-top: 2px;
      padding: 6px 10px;
      border: 1px dashed var(--fs-pink-200);
      border-radius: 8px;
      background: var(--fs-pink-50);
      cursor: pointer;
      font-size: 11px;
      color: var(--fs-ink-soft);
      transition: all 160ms;
      user-select: none;
    }
    .fs-chatbot-session-ref:hover {
      background: var(--fs-pink-100);
      border-color: var(--fs-pink-400);
      color: var(--fs-ink);
    }
    .fs-chatbot-session-ref .fs-chatbot-ref-id {
      font-family: 'Courier New', Courier, monospace;
      font-size: 10.5px;
      font-weight: 600;
      color: var(--fs-pink-600);
      letter-spacing: 0.04em;
    }
    .fs-chatbot-session-ref .fs-chatbot-ref-copy {
      font-size: 10px;
      color: var(--fs-ink-soft);
      opacity: 0.7;
    }
    .fs-chatbot-session-ref.fs-chatbot-copied {
      border-color: #4CAF50;
      background: #f0faf0;
      color: #2e7d32;
    }
    .fs-chatbot-session-ref.fs-chatbot-copied .fs-chatbot-ref-id { color: #2e7d32; }
    .fs-chatbot-session-ref.fs-chatbot-copied .fs-chatbot-ref-copy { color: #2e7d32; opacity: 1; }

    /* ─── v2.32.0: Bank-transfer details block ─────────────────────
       Rendered inside the order-success bubble below the summary.
       Mirrors the structure of the session-ref pattern above (the
       tap-to-copy account number row uses the same green flash on
       copy) but with explicit per-row layout for readability. */
    .fs-chatbot-bank-details {
      margin-top: 8px;
      padding: 12px 14px;
      border: 1px solid var(--fs-line);
      border-radius: 12px;
      background: var(--fs-pink-50);
      font-size: 13px;
      color: var(--fs-ink);
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    .fs-chatbot-bank-row {
      display: flex;
      align-items: center;
      gap: 6px;
      line-height: 1.4;
    }
    .fs-chatbot-bank-label {
      color: var(--fs-ink-soft);
      font-weight: 500;
      min-width: 56px;   /* aligns the three labels in a vertical column */
    }
    .fs-chatbot-bank-account {
      font-family: 'Courier New', Courier, monospace;
      font-weight: 600;
      color: var(--fs-pink-600);
      letter-spacing: 0.04em;
    }
    .fs-chatbot-bank-account-row {
      padding: 4px 6px;
      margin: 2px -6px 0;
      border-radius: 6px;
      transition: background 160ms;
    }
    .fs-chatbot-bank-account-row:hover {
      background: rgba(184, 71, 115, 0.06);
    }
    .fs-chatbot-bank-copy-hint {
      margin-left: auto;
      font-size: 10.5px;
      color: var(--fs-ink-soft);
      opacity: 0.7;
    }
    .fs-chatbot-bank-account-row.fs-chatbot-bank-copied {
      background: #f0faf0;
    }
    .fs-chatbot-bank-account-row.fs-chatbot-bank-copied .fs-chatbot-bank-account {
      color: #2e7d32;
    }
    .fs-chatbot-bank-account-row.fs-chatbot-bank-copied .fs-chatbot-bank-copy-hint {
      color: #2e7d32;
      opacity: 1;
    }
    .fs-chatbot-bank-note {
      margin-top: 6px;
      padding-top: 6px;
      border-top: 1px dashed var(--fs-line);
      font-size: 11.5px;
      color: var(--fs-ink-soft);
      font-style: italic;
      line-height: 1.45;
    }
    .fs-chatbot-bank-slip-note {
      margin-top: 4px;
      font-size: 11.5px;
      color: var(--fs-ink-soft);
      line-height: 1.45;
    }

    /* Payment-link expiry hint shown below the Pay Online button. */
    .fs-chatbot-payment-expiry {
      margin-top: 4px;
      font-size: 11px;
      color: var(--fs-ink-soft);
      font-style: italic;
      text-align: center;
      opacity: 0.8;
    }

    /* ---------- Typing indicator ---------- */
    .fs-chatbot-typing { display: flex; gap: 4px; padding: 12px 16px; }
    .fs-chatbot-typing span {
      width: 7px; height: 7px;
      border-radius: 50%;
      background: var(--fs-pink-400);
      opacity: 0.6;
      animation: bounce 1.2s infinite ease-in-out;
    }
    .fs-chatbot-typing span:nth-child(2) { animation-delay: 0.15s; }
    .fs-chatbot-typing span:nth-child(3) { animation-delay: 0.3s; }
    @keyframes bounce {
      0%,80%,100% { transform: translateY(0);    opacity: 0.4; }
      40%         { transform: translateY(-5px); opacity: 1;   }
    }

    /* ---------- Composer ---------- */
    .fs-chatbot-composer {
      border-top: 1px solid var(--fs-line);
      padding: 12px 14px;
      background: #fff;
      display: flex;
      align-items: flex-end;
      gap: 8px;
    }
    .fs-chatbot-composer textarea {
      flex: 1;
      border: 1px solid var(--fs-line);
      border-radius: 14px;
      padding: 10px 14px;
      /* v2.55.1: 16px (not 14px) to prevent iOS Safari auto-zoom.
         iOS Safari auto-zooms any form input with font-size < 16px
         when the customer taps to focus, which on the chat widget
         meant the page suddenly jumped and the input was barely
         readable. 16px is the threshold; at 16px iOS leaves the
         zoom alone. This matches the v2.55.0 phone-modal input
         which uses 16px for the same reason.

         Cosmetic side effect: input text is now slightly larger
         than the bot bubbles (which are 14px). Major messaging
         apps (iMessage, WhatsApp, Slack) all use ≥16px input fonts
         for the same iOS reason, so this is the established
         convention. The visual harmony is preserved by the larger
         input feeling like a more substantial / inviting writing
         surface. */
      font-size: 16px;
      font-family: inherit;
      color: var(--fs-ink);
      resize: none;
      max-height: 120px;
      min-height: 42px;
      line-height: 1.4;
      background: var(--fs-cream);
      transition: border-color 160ms, background 160ms;
    }
    .fs-chatbot-composer textarea:focus {
      outline: none;
      border-color: var(--fs-pink-400);
      background: #fff;
    }
    .fs-chatbot-send {
      width: 42px; height: 42px;
      border-radius: 50%;
      border: none;
      background: linear-gradient(135deg, var(--fs-pink-500), var(--fs-pink-600));
      color: #fff;
      cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      flex-shrink: 0;
      transition: transform 160ms, box-shadow 160ms, opacity 160ms;
      box-shadow: 0 4px 12px -4px rgba(184, 71, 115, 0.5);
    }
    .fs-chatbot-send:hover:not(:disabled) { transform: scale(1.06); }
    .fs-chatbot-send:disabled { opacity: 0.4; cursor: not-allowed; }
    .fs-chatbot-send svg { width: 16px; height: 16px; }

    /* ---------- Scroll-to-bottom button ----------
       A small circular button that floats just above the composer's
       top edge. Visible only when the customer has scrolled up from
       the latest message — auto-hides when at the bottom so it doesn't
       cover anything during normal use. Clicking scrolls smoothly back
       down. Anchored to the panel (which is position: fixed), so the
       coordinates resolve against the chat panel, not the page.
       --
       The bottom offset is roughly the composer's height (54-58px,
       depending on whether the textarea has grown) + a 10px gap so
       the button sits visually above the input row. */
    .fs-chatbot-scroll-bottom {
      position: absolute;
      right: 18px;
      bottom: 78px;
      width: 36px; height: 36px;
      border-radius: 50%;
      border: 1px solid var(--fs-line);
      background: #fff;
      color: var(--fs-pink-600);
      cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      box-shadow: 0 4px 12px -4px rgba(42, 24, 32, 0.18);
      transition: opacity 180ms, transform 180ms, background 160ms;
      opacity: 1;
      transform: translateY(0);
      z-index: 10;
    }
    .fs-chatbot-scroll-bottom:hover { background: var(--fs-pink-50); }
    .fs-chatbot-scroll-bottom svg { width: 16px; height: 16px; }
    /* Hidden state: faded out + nudged down so the show/hide reads as
       motion, not a sudden pop. pointer-events:none prevents stale
       clicks during the fade-out. */
    .fs-chatbot-scroll-bottom.fs-chatbot-hidden {
      opacity: 0;
      transform: translateY(6px);
      pointer-events: none;
    }

    .fs-chatbot-footer-note {
      text-align: center;
      font-size: 10.5px;
      color: var(--fs-ink-soft);
      padding: 0 0 8px;
      background: #fff;
      letter-spacing: 0.02em;
    }
    .fs-chatbot-footer-note .fs-chatbot-heart { color: var(--fs-pink-500); }

    /* v2.36.0 — WhatsApp escape hatch in the footer.
       Persistent, low-key affordance to reach customer service via
       WhatsApp at any time. Visible 24/7 (hours stub returns true),
       visible in all modes including live-agent (the customer may
       still want out-of-band channels like photo/voice).

       Visual rules:
         - NO WhatsApp green (--fs-ink-soft / --fs-ink only). The bright
           brand green is reserved for in-bubble action buttons
           (.fs-chatbot-btn-whatsapp) where "act now" is the message.
           The footer's role is "always there, never urgent."
         - Brand text on the left stays at 10.5px (matches original
           footer aesthetic, inherits the parent .fs-chatbot-footer-note size).
         - Link portion bumped to 12px for a slightly bigger touch
           target on mobile, still visually quiet.
         - Underline ONLY on hover/focus; no resting underline to keep
           the link from out-competing the bot's primary CTAs. */
    .fs-chatbot-footer-note .fs-chatbot-footer-brand { color: var(--fs-ink-soft); }
    .fs-chatbot-footer-note .fs-chatbot-footer-sep   { color: var(--fs-ink-soft); margin: 0 4px; }
    .fs-chatbot-footer-note .fs-chatbot-wa-link {
      color: var(--fs-ink-soft);
      text-decoration: none;
      font-size: 12px;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.15s ease;
    }
    .fs-chatbot-footer-note .fs-chatbot-wa-link:hover,
    .fs-chatbot-footer-note .fs-chatbot-wa-link:focus-visible {
      color: var(--fs-ink);
      text-decoration: underline;
    }
    .fs-chatbot-footer-note .fs-chatbot-wa-link:focus-visible {
      outline: 2px solid var(--fs-ink-soft);
      outline-offset: 2px;
      border-radius: 2px;
    }
    .fs-chatbot-footer-note .fs-chatbot-wa-link svg {
      width: 12px;
      height: 12px;
      fill: currentColor; /* inherits the muted tone, NOT green */
      flex-shrink: 0;
    }

    /* ---------- Mobile ---------- */
    @media (max-width: 480px) {
      .fs-chatbot-panel {
        /* v2.55.2: iOS Safari's URL bar takes ~75-90px when expanded
           (default on page load) and shrinks to ~50px after scroll.
           100vh reports the FULL viewport including the URL bar's
           collapse space, so a (bottom: 0; height: 100vh) element gets
           its TOP edge pushed off-screen behind the URL bar -- that's
           the "top of widget hidden" bug.

           Fix: use 100dvh (dynamic viewport height). dvh tracks the
           current visible area, so the panel always fits exactly the
           space the user can actually see and tap.

           Browser support: iOS Safari 15.4+ (March 2022), Chrome 108+,
           Firefox 101+. Order matters in the declaration -- older
           browsers ignore the dvh line and use vh (incorrect on
           iOS but not catastrophic; pre-15.4 iOS users see the
           pre-v2.55.2 behaviour). Modern browsers use the dvh line.

           Using inset: 0 instead of separately positioning right/
           bottom + width/height is more robust on iOS -- fewer separate
           constraints for Safari to mis-compute against the wrong
           viewport reference. */
        inset: 0;
        right: 0; bottom: 0;          /* fallback for clients without inset */
        width: 100vw;
        height: 100vh;                 /* fallback */
        height: 100dvh;
        max-height: 100vh;             /* fallback */
        max-height: 100dvh;
        border-radius: 0;
      }
      .fs-chatbot-launcher { right: 16px; bottom: 16px; }
    }

    /* ---------- Forms (Stage F) ---------- */
    /* Form bubble — sits below text bubble in the same .fs-chatbot-msg wrapper. */
    .fs-chatbot-form-bubble {
      margin-top: 8px;
      padding: 16px;
      background: var(--fs-cream);
      border: 1px solid var(--fs-line);
      border-radius: 16px;
      max-width: 100%;
    }
    .fs-chatbot-form-title {
      font-size: 14px;
      line-height: 1.45;
      color: var(--fs-ink);
      margin: 0 0 12px;
    }
    .fs-chatbot-form-field {
      margin-bottom: 14px;
      display: flex;
      flex-direction: column;
      gap: 6px;
    }
    .fs-chatbot-form-field.fs-chatbot-hidden { display: none; }
    .fs-chatbot-form-field label {
      font-size: 13px;
      font-weight: 600;
      color: var(--fs-ink);
    }
    .fs-chatbot-form-field .fs-chatbot-field-required {
      color: var(--fs-pink-500);
      margin-left: 2px;
    }
    /* Checkbox toggle row — box + inline label, tappable as one unit */
    .fs-chatbot-checkbox-row {
      display: flex;
      align-items: center;
      gap: 9px;
      cursor: pointer;
      padding: 4px 0;
    }
    .fs-chatbot-checkbox-input {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
      accent-color: var(--fs-pink-500);
      cursor: pointer;
    }
    .fs-chatbot-checkbox-label {
      font-size: 13px;
      color: var(--fs-ink);
      line-height: 1.35;
      user-select: none;
    }
    .fs-chatbot-form-field input[type="text"],
    .fs-chatbot-form-field input[type="date"],
    .fs-chatbot-form-field input[type="email"],
    .fs-chatbot-form-field input[type="tel"],
    .fs-chatbot-form-field textarea,
    .fs-chatbot-form-field select {
      width: 100%;
      padding: 10px 12px;
      font-family: inherit;
      /* v2.55.1: 16px to prevent iOS Safari auto-zoom on focus.
         Inline bot-spawned forms (variant picker, generic data
         capture) live inside the chat stream. Same iOS reason as
         the composer textarea and wizard fields. */
      font-size: 16px;
      color: var(--fs-ink);
      background: white;
      border: 1px solid var(--fs-line);
      border-radius: 10px;
      outline: none;
      transition: border-color 0.15s, box-shadow 0.15s;
    }
    .fs-chatbot-form-field input:focus,
    .fs-chatbot-form-field textarea:focus,
    .fs-chatbot-form-field select:focus {
      border-color: var(--fs-pink-400);
      box-shadow: 0 0 0 3px rgba(236, 138, 171, 0.18);
    }
    .fs-chatbot-form-field textarea {
      min-height: 80px;
      resize: vertical;
    }
    .fs-chatbot-form-field .fs-chatbot-field-helper {
      font-size: 12px;
      color: var(--fs-ink-soft);
      margin-top: 2px;
    }
    .fs-chatbot-form-field .fs-chatbot-field-error {
      font-size: 12px;
      color: #C02050;
      margin-top: 2px;
      display: none;
    }
    .fs-chatbot-form-field.fs-chatbot-has-error .fs-chatbot-field-error { display: block; }
    .fs-chatbot-form-field.fs-chatbot-has-error input,
    .fs-chatbot-form-field.fs-chatbot-has-error textarea,
    .fs-chatbot-form-field.fs-chatbot-has-error select {
      border-color: #C02050;
    }

    /* Radio-style select: when options ≤ 4 we render as radio cards */
    .fs-chatbot-form-field .fs-chatbot-radio-group {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .fs-chatbot-form-field .fs-chatbot-radio-card {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      padding: 12px;
      border: 1px solid var(--fs-line);
      background: white;
      border-radius: 10px;
      cursor: pointer;
      transition: border-color 0.12s, background 0.12s;
    }
    .fs-chatbot-form-field .fs-chatbot-radio-card:hover { background: var(--fs-pink-50); }
    .fs-chatbot-form-field .fs-chatbot-radio-card.fs-chatbot-selected {
      border-color: var(--fs-pink-500);
      background: var(--fs-pink-50);
    }
    .fs-chatbot-form-field .fs-chatbot-radio-card input[type="radio"] {
      margin-top: 3px;
      accent-color: var(--fs-pink-500);
      flex-shrink: 0;
    }
    .fs-chatbot-form-field .fs-chatbot-radio-card .fs-chatbot-radio-body { flex: 1; }
    .fs-chatbot-form-field .fs-chatbot-radio-card .fs-chatbot-radio-label {
      font-size: 14px; font-weight: 600; color: var(--fs-ink);
    }
    .fs-chatbot-form-field .fs-chatbot-radio-card .fs-chatbot-radio-sublabel {
      font-size: 12px; color: var(--fs-ink-soft); margin-top: 2px;
    }

    /* Form action row */
    .fs-chatbot-form-actions {
      display: flex; gap: 10px; margin-top: 4px;
    }
    .fs-chatbot-form-actions button {
      flex: 1;
      padding: 11px 14px;
      font-family: inherit;
      font-size: 14px;
      font-weight: 600;
      border-radius: 12px;
      border: 1px solid transparent;
      cursor: pointer;
      transition: opacity 0.12s, transform 0.06s;
    }
    .fs-chatbot-form-actions button:disabled { opacity: 0.6; cursor: not-allowed; }
    .fs-chatbot-form-actions button:active { transform: translateY(1px); }
    .fs-chatbot-form-actions .fs-chatbot-btn-submit {
      background: var(--fs-pink-500); color: white;
    }
    .fs-chatbot-form-actions .fs-chatbot-btn-submit:hover:not(:disabled) { background: var(--fs-pink-600); }
    .fs-chatbot-form-actions .fs-chatbot-btn-cancel {
      background: transparent; color: var(--fs-ink-soft);
      border-color: var(--fs-line);
    }
    .fs-chatbot-form-actions .fs-chatbot-btn-cancel:hover { background: var(--fs-pink-50); }

    /* Quick-action buttons (different from URL buttons — send a server action) */
    .fs-chatbot-btn-row .fs-chatbot-btn-quick {
      background: white;
      color: var(--fs-ink);
      border: 1px solid var(--fs-pink-200);
      cursor: pointer;
      font-family: inherit;
    }
    .fs-chatbot-btn-row .fs-chatbot-btn-quick:hover { background: var(--fs-pink-50); border-color: var(--fs-pink-400); }

    /* Disabled dates notice for date fields */
    .fs-chatbot-form-field .fs-chatbot-disabled-dates {
      display: block;
      font-size: 11px;
      color: var(--fs-ink-soft);
      margin-top: 4px;
      line-height: 1.4;
    }
    .fs-chatbot-form-field .fs-chatbot-disabled-dates strong { color: var(--fs-pink-600); }
  `;

  // ---------------------------------------------------------------------
  // Mount
  // ---------------------------------------------------------------------
  // Originally this widget used a closed shadow DOM for CSS isolation
  // (so the host page's theme couldn't bleed in). But jQuery UI's
  // datepicker — and any library using document-scoped selectors —
  // can't see elements inside a shadow tree:
  //   - `$(id)` (jQuery's selector engine) queries `document`, not
  //     shadow roots.
  //   - `document.getElementById`, `document.querySelector*`, same.
  //   - jQuery UI's click handlers do `$(id)` to recover the input
  //     from a day-cell click → empty wrapper → `_getInst(undefined)`
  //     → "Missing instance data for this datepicker".
  //
  // The Variant + Date form's datepicker (v2.27.4+) needs to behave
  // identically to the page's own datepicker, which requires those
  // selector lookups to work. So we mount into the host element
  // directly (light DOM) and accept the trade-off: the host page's
  // CSS can now reach in. The widget's own stylesheet has high enough
  // specificity to win in practice, and the visual diff is small.
  //
  // The rest of this file does its DOM lookups via `root.querySelector`
  // and `document.querySelector` — neither needs a `shadow` reference,
  // so we don't define one. (The original implementation had `var
  // shadow = host.attachShadow(...)`, but no downstream code actually
  // used it.)
  var host = document.createElement("div");
  host.id = "flower-sugar-chat-host";
  host.style.cssText = "all: initial;";
  document.body.appendChild(host);

  var fontLink = document.createElement("link");
  fontLink.rel = "stylesheet";
  fontLink.href =
    "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600&family=Inter:wght@400;500;600&display=swap";
  host.appendChild(fontLink);

  var styleEl = document.createElement("style");
  styleEl.textContent = CSS;
  host.appendChild(styleEl);

  var root = document.createElement("div");
  root.className = "fs-chatbot-root";

  if (!display_chatbot){
    root.style.display = "none";
  }
  host.appendChild(root);

  // ---------------------------------------------------------------------
  // Markup
  // ---------------------------------------------------------------------
  root.innerHTML = `
    <button class="fs-chatbot-launcher" id="fs-launcher" aria-label="Open chat with Flower Sugar">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
      </svg>
      <!-- v2.55.45 — unread indicator. Hidden at count 0. Shows a low-capped
           count (1, 2, 3+) or, in dot mode, an empty solid dot. -->
      <span class="fs-chatbot-unread fs-chatbot-hidden" id="fs-unread"
            aria-live="polite" role="status"></span>
    </button>

    <div class="fs-chatbot-panel" id="fs-panel" role="dialog" aria-label="Flower Sugar chat">
      <div class="fs-chatbot-header">
        <div class="fs-chatbot-header-row">
          <div class="fs-chatbot-badge">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C9.5 2 7.5 4 7.5 6.5c0 1 .3 1.9.8 2.6C6.7 9.5 5 11 5 13c0 2.5 2 4.5 4.5 4.5.6 0 1.1-.1 1.6-.3v2.3c0 .8.6 1.5 1.4 1.5h.6c.8 0 1.4-.7 1.4-1.5v-2.3c.5.2 1 .3 1.6.3 2.5 0 4.5-2 4.5-4.5 0-2-1.7-3.5-3.3-3.9.5-.7.8-1.6.8-2.6C16.5 4 14.5 2 12 2zm0 3c.8 0 1.5.7 1.5 1.5S12.8 8 12 8s-1.5-.7-1.5-1.5S11.2 5 12 5zm-2.5 6.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5S8 13.8 8 13s.7-1.5 1.5-1.5zm5 0c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5S13 13.8 13 13s.7-1.5 1.5-1.5z"/>
            </svg>
          </div>
          <div>
            <h2 class="fs-chatbot-header-title fs-chatbot-display">Flower Sugar</h2>
            <div class="fs-chatbot-header-sub" id="fs-header-sub"><span class="fs-chatbot-pulse"></span> Usually replies instantly</div>
          </div>
        </div>
        <!-- v2.55.0: gear (settings) button → opens drawer with phone capture controls -->
        <button class="fs-chatbot-menu-btn" id="fs-menu" aria-label="Settings menu">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="1.5"/>
            <circle cx="12" cy="5"  r="1.5"/>
            <circle cx="12" cy="19" r="1.5"/>
          </svg>
        </button>
        <button class="fs-chatbot-close-btn" id="fs-close" aria-label="Close chat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
               stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
        </button>
        <!-- v2.55.0: settings drawer — anchored under the gear -->
        <div class="fs-chatbot-settings-drawer" id="fs-settings-drawer" role="menu">
          <button class="fs-chatbot-settings-item" id="fs-settings-save-phone" role="menuitem">
            <svg class="fs-chatbot-settings-item-icon" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
            </svg>
            <span id="fs-settings-save-phone-label">Save my number</span>
          </button>
          <!-- v2.55.3: Continue previous chat (recovery) — visible only when
               session is NOT linked (a linked session already has its
               history; recovery is for fresh devices). -->
          <button class="fs-chatbot-settings-item" id="fs-settings-recover-phone"
                  role="menuitem">
            <svg class="fs-chatbot-settings-item-icon" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 12a9 9 0 1 0 9-9"/>
              <polyline points="3 4 3 12 11 12"/>
            </svg>
            <span>Continue previous chat</span>
          </button>
          <!-- v2.55.6: Clear History — supersedes "Update phone" and
               "Unlink phone from device". Archives the session on the
               server (preserving the data for audit) and reloads the
               widget with a fresh session_id. Visible regardless of
               linked state. The confirmation dialog warns the customer
               that history AND cart will be wiped from this device. -->
          <button class="fs-chatbot-settings-item" id="fs-settings-clear-history"
                  role="menuitem">
            <svg class="fs-chatbot-settings-item-icon" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="3 6 5 6 21 6"/>
              <path d="M19 6l-2 14a2 2 0 01-2 2H9a2 2 0 01-2-2L5 6"/>
              <path d="M10 11v6M14 11v6"/>
              <path d="M9 6V4a2 2 0 012-2h2a2 2 0 012 2v2"/>
            </svg>
            <span>Clear History</span>
          </button>
        </div>
      </div>

      <!-- v2.55.0: phone entry overlay — modal-style inside the widget -->
      <div class="fs-chatbot-phone-modal" id="fs-phone-modal" role="dialog" aria-modal="true">
        <div class="fs-chatbot-phone-modal-card">
          <!-- v2.55.0 — Capture view (Save my number flow) -->
          <div class="fs-chatbot-phone-view" id="fs-phone-view-capture">
            <div class="fs-chatbot-phone-modal-title" id="fs-phone-modal-title">Save your chat across devices</div>
            <div class="fs-chatbot-phone-modal-subtitle">
              Enter your phone number and you can pick up this conversation on any device.
            </div>
            <input type="tel" class="fs-chatbot-phone-input" id="fs-phone-input"
                   placeholder="e.g. 012-345 6789" autocomplete="tel"
                   inputmode="tel" />
            <div class="fs-chatbot-phone-error" id="fs-phone-error"></div>
            <div class="fs-chatbot-phone-modal-actions">
              <button class="fs-chatbot-phone-modal-btn fs-chatbot-phone-modal-btn-secondary"
                      id="fs-phone-modal-cancel">Cancel</button>
              <button class="fs-chatbot-phone-modal-btn fs-chatbot-phone-modal-btn-primary"
                      id="fs-phone-modal-save">Save</button>
            </div>
            <div class="fs-chatbot-phone-modal-privacy">
              We save your number to link your chat history to your phone.
              Used only for chat continuity and order updates. Reply STOP anytime.
            </div>
          </div>

          <!-- v2.55.3 — Recover-phone view (enter your number to recover chat) -->
          <div class="fs-chatbot-phone-view" id="fs-phone-view-recover-phone" style="display:none">
            <div class="fs-chatbot-phone-modal-title">Continue your previous chat</div>
            <div class="fs-chatbot-phone-modal-subtitle">
              Enter the phone number you saved your chat with. We'll send you a verification code.
            </div>
            <input type="tel" class="fs-chatbot-phone-input" id="fs-phone-recover-input"
                   placeholder="e.g. 012-345 6789" autocomplete="tel"
                   inputmode="tel" />
            <div class="fs-chatbot-phone-error" id="fs-phone-recover-error"></div>
            <div class="fs-chatbot-phone-modal-actions">
              <button class="fs-chatbot-phone-modal-btn fs-chatbot-phone-modal-btn-secondary"
                      id="fs-phone-recover-cancel">Cancel</button>
              <button class="fs-chatbot-phone-modal-btn fs-chatbot-phone-modal-btn-primary"
                      id="fs-phone-recover-request">Request code</button>
            </div>
          </div>

          <!-- v2.55.3 — Recover-code view (WhatsApp deep-link + code input) -->
          <div class="fs-chatbot-phone-view" id="fs-phone-view-recover-code" style="display:none">
            <div class="fs-chatbot-phone-modal-title">Get your code via WhatsApp</div>
            <div class="fs-chatbot-phone-modal-subtitle" id="fs-phone-recover-wa-subtitle">
              Tap the button below to message us on WhatsApp. An agent will reply with your 6-digit code.
            </div>
            <a class="fs-chatbot-phone-modal-btn fs-chatbot-phone-modal-btn-primary fs-chatbot-phone-wa-link"
               id="fs-phone-recover-wa-link" href="#" target="_blank" rel="noopener noreferrer"
               style="display:flex; align-items:center; justify-content:center; gap:8px; text-decoration:none; margin-bottom:14px">
              <svg viewBox="0 0 24 24" fill="currentColor" style="width:18px; height:18px">
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654z"/>
              </svg>
              <span>Open WhatsApp</span>
            </a>
            <div class="fs-chatbot-phone-modal-subtitle" style="margin-top:6px">
              Once you've received the code, enter it here:
            </div>
            <input type="text" class="fs-chatbot-phone-input" id="fs-phone-code-input"
                   placeholder="6-digit code" inputmode="numeric"
                   maxlength="6" autocomplete="one-time-code" />
            <div class="fs-chatbot-phone-error" id="fs-phone-code-error"></div>
            <div class="fs-chatbot-phone-modal-actions">
              <button class="fs-chatbot-phone-modal-btn fs-chatbot-phone-modal-btn-secondary"
                      id="fs-phone-code-cancel">Cancel</button>
              <button class="fs-chatbot-phone-modal-btn fs-chatbot-phone-modal-btn-primary"
                      id="fs-phone-code-verify">Verify</button>
            </div>
          </div>
        </div>
      </div>

      <div class="fs-chatbot-cart-bar fs-chatbot-cart-hidden" id="fs-cart-bar" aria-live="polite">
        <svg class="fs-chatbot-cart-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 3h2l.4 2M7 13h10l3-8H6.4M7 13L5.4 5M7 13l-2 4h13"/>
          <circle cx="9" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/>
        </svg>
        <div class="fs-chatbot-cart-summary" id="fs-cart-summary"></div>
        <svg class="fs-chatbot-cart-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </div>

      <div class="fs-chatbot-messages" id="fs-messages"></div>

      <div class="fs-chatbot-wizard" id="fs-wizard" role="dialog" aria-labelledby="fs-wizard-title">
        <div class="fs-chatbot-wizard-header">
          <h3 class="fs-chatbot-wizard-title" id="fs-wizard-title">Review your order</h3>
          <button class="fs-chatbot-wizard-cancel" id="fs-wizard-cancel" type="button">Cancel</button>
        </div>
        <div class="fs-chatbot-wizard-body" id="fs-wizard-body"></div>
        <div class="fs-chatbot-wizard-footer" id="fs-wizard-footer">
          <span class="fs-chatbot-wizard-status" id="fs-wizard-status"></span>
          <button class="fs-chatbot-wizard-proceed" id="fs-wizard-proceed" type="button">Proceed</button>
        </div>
      </div>

      <div class="fs-chatbot-quick-actions" id="fs-quick">
        <button class="fs-chatbot-chip" data-action="recommend_bouquet">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="3"/><path d="M12 11v9M8 14h8"/></svg>
          Recommend Bouquet
        </button>
        <button class="fs-chatbot-chip" data-action="track_order">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h13l3 4v6h-2"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg>
          Track Order
        </button>
        <button class="fs-chatbot-chip" data-action="delivery_fee">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
          Delivery Fee
        </button>
        <button class="fs-chatbot-chip" data-action="place_order">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
          Place Order
        </button>
      </div>

      <div class="fs-chatbot-composer">
        <textarea id="fs-input" placeholder="Type a message..." rows="1"></textarea>
        <button class="fs-chatbot-send" id="fs-send" aria-label="Send">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>
        </button>
      </div>
      <!-- Scroll-to-bottom button — hidden by default; revealed by
           scroll handler when not at bottom. Sits above the composer,
           anchored to the panel. -->
      <button class="fs-chatbot-scroll-bottom fs-chatbot-hidden" id="fs-scroll-bottom"
              aria-label="Scroll to latest message" type="button">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
             stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <div class="fs-chatbot-footer-note">
        <span class="fs-chatbot-footer-brand">Flower Sugar</span><span class="fs-chatbot-footer-sep">·</span><a class="fs-chatbot-wa-link" id="fs-wa-footer" href="${_buildFooterWhatsAppUrl(SESSION_ID)}" target="_blank" rel="noopener noreferrer" aria-label="Chat with us on WhatsApp"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.4.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5 0 1.5 1.1 2.9 1.2 3.1.1.2 2.1 3.2 5.1 4.5 1.8.7 2.4.8 3.3.7.5-.1 1.7-.7 2-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.4zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.3 5L2 22l5.1-1.3c1.4.8 3.1 1.3 4.9 1.3 5.5 0 10-4.5 10-10S17.5 2 12 2z"/></svg>Chat on WhatsApp</a>
      </div>
    </div>
  `;

  // ---------------------------------------------------------------------
  // Refs
  // ---------------------------------------------------------------------
  var $launcher = root.querySelector("#fs-launcher");
  var $panel    = root.querySelector("#fs-panel");
  var $unread   = root.querySelector("#fs-unread");   // v2.55.45 unread badge
  var $close    = root.querySelector("#fs-close");
  var $messages = root.querySelector("#fs-messages");
  var $input    = root.querySelector("#fs-input");
  var $send     = root.querySelector("#fs-send");
  var $quick    = root.querySelector("#fs-quick");
  var $scrollBottom = root.querySelector("#fs-scroll-bottom");
  var $waFooter = root.querySelector("#fs-wa-footer");
  // v2.55.0 — phone capture UI elements
  var $menu              = root.querySelector("#fs-menu");
  var $settingsDrawer    = root.querySelector("#fs-settings-drawer");
  var $settingsSavePhone = root.querySelector("#fs-settings-save-phone");
  var $settingsSavePhoneLabel = root.querySelector("#fs-settings-save-phone-label");
  // v2.55.6: $settingsUnlink removed from the UI. Server endpoint
  // /customer/phone/unlink kept for legacy/internal use only.
  var $settingsClearHistory = root.querySelector("#fs-settings-clear-history");
  var $phoneModal        = root.querySelector("#fs-phone-modal");
  var $phoneInput        = root.querySelector("#fs-phone-input");
  var $phoneError        = root.querySelector("#fs-phone-error");
  var $phoneSave         = root.querySelector("#fs-phone-modal-save");
  var $phoneCancel       = root.querySelector("#fs-phone-modal-cancel");
  var $phoneModalTitle   = root.querySelector("#fs-phone-modal-title");
  var $headerSub         = root.querySelector("#fs-header-sub");
  // v2.55.3 — recovery flow elements
  var $settingsRecover     = root.querySelector("#fs-settings-recover-phone");
  var $phoneViewCapture    = root.querySelector("#fs-phone-view-capture");
  var $phoneViewRecPhone   = root.querySelector("#fs-phone-view-recover-phone");
  var $phoneViewRecCode    = root.querySelector("#fs-phone-view-recover-code");
  var $phoneRecoverInput   = root.querySelector("#fs-phone-recover-input");
  var $phoneRecoverError   = root.querySelector("#fs-phone-recover-error");
  var $phoneRecoverRequest = root.querySelector("#fs-phone-recover-request");
  var $phoneRecoverCancel  = root.querySelector("#fs-phone-recover-cancel");
  var $phoneRecoverWaLink  = root.querySelector("#fs-phone-recover-wa-link");
  var $phoneRecoverWaSub   = root.querySelector("#fs-phone-recover-wa-subtitle");
  var $phoneCodeInput      = root.querySelector("#fs-phone-code-input");
  var $phoneCodeError      = root.querySelector("#fs-phone-code-error");
  var $phoneCodeVerify     = root.querySelector("#fs-phone-code-verify");
  var $phoneCodeCancel     = root.querySelector("#fs-phone-code-cancel");

  // v2.55.45 — restore the per-session unread count (persists across page
  // navigation while the panel is closed) and render the badge. If the
  // widget happens to boot with the panel already open, clear it instead.
  _loadUnread();
  _renderUnreadBadge();

  // v2.36.0 — WhatsApp footer link wiring.
  //
  // The link's href is set at template-render time (so middle-click /
  // ctrl-click "open in new tab" works without JS), but we also attach
  // a click handler that REBUILDS the URL fresh before navigating.
  // This is defensive against:
  //   - SESSION_ID changing during the widget's lifetime (doesn't today,
  //     but no contract says it can't);
  //   - the template string ever being modified at runtime by another
  //     handler.
  //
  // Plus a visibility refresh that ties to _isWithinBusinessHours().
  // The stub returns true today; when hours tighten later, this is
  // where the link hides automatically across midnight boundaries
  // (called on every panel open via openPanel()).
  function _refreshWhatsAppFooter() {
    if (!$waFooter) return;
    if (_isWithinBusinessHours()) {
      $waFooter.style.display = "";
      $waFooter.href = _buildFooterWhatsAppUrl(SESSION_ID);
    } else {
      $waFooter.style.display = "none";
    }
  }
  _refreshWhatsAppFooter();
  if ($waFooter) {
    $waFooter.addEventListener("click", function () {
      // Rebuild before navigation. The browser's native click navigation
      // reads `href` AFTER this handler runs (modulo any preventDefault),
      // so setting the attribute here ensures the freshest URL is used.
      $waFooter.href = _buildFooterWhatsAppUrl(SESSION_ID);
    });
  }

  // ---------------------------------------------------------------------
  // Scroll-to-bottom visibility — show the floating button only when
  // the messages container has scrolled UP from the latest message.
  // Threshold is generous (40px) so the button doesn't flicker on tiny
  // scroll deltas at the bottom edge. The button auto-hides as the
  // customer approaches the bottom either by scrolling manually or by
  // clicking the button itself.
  //
  // The scroll event fires frequently on natural scroll; we read
  // scrollTop/scrollHeight directly which is cheap (no layout thrash).
  // ---------------------------------------------------------------------
  var SCROLL_BOTTOM_THRESHOLD = 40;

  function _isAtBottom() {
    // scrollHeight - scrollTop - clientHeight = distance from bottom
    var distance = $messages.scrollHeight - $messages.scrollTop - $messages.clientHeight;
    return distance <= SCROLL_BOTTOM_THRESHOLD;
  }
  function _updateScrollBottomVisibility() {
    // Don't show when there's nothing to scroll past — empty chat or
    // single message.
    if ($messages.scrollHeight <= $messages.clientHeight + SCROLL_BOTTOM_THRESHOLD) {
      $scrollBottom.classList.add("fs-chatbot-hidden");
      return;
    }
    if (_isAtBottom()) {
      $scrollBottom.classList.add("fs-chatbot-hidden");
    } else {
      $scrollBottom.classList.remove("fs-chatbot-hidden");
    }
  }
  $messages.addEventListener("scroll", _updateScrollBottomVisibility, { passive: true });
  $scrollBottom.addEventListener("click", function () {
    // Force-snap to bottom on explicit click — the customer wants to
    // catch up, regardless of where they currently are. (scrollToBottom
    // without the flag only snaps when already near the bottom; that
    // would no-op here.) The CSS scroll-behavior: smooth animates this.
    scrollToBottom(true);
    // Optimistically hide; the scroll handler will reconcile when the
    // animation completes.
    $scrollBottom.classList.add("fs-chatbot-hidden");
  });

  var hasShownWelcome = false;
  var isSending = false;

  // ---------------------------------------------------------------------
  // Input lock — disables the message box (#fs-input) and the Send
  // button while EITHER a request is in-flight OR a form is active
  // (variant-date bubble OR server-side form). The customer should
  // resolve the open form (submit or cancel) before typing a fresh
  // message — both because the server keeps form state on its side
  // and because letting them race a typed reply against a half-filled
  // form leads to confusing UX.
  //
  // The registry uses a Set of DOM nodes so a form's lifetime is
  // exactly the time its node is in the document. On any open/remove,
  // call _updateInputLockState() to re-derive the locked state from
  // (isSending OR activeForms.size > 0).
  // ---------------------------------------------------------------------
  var activeForms = new Set();

  function _registerActiveForm(formNode) {
    activeForms.add(formNode);
    _updateInputLockState();
  }
  function _unregisterActiveForm(formNode) {
    activeForms.delete(formNode);
    _updateInputLockState();
  }
  function _updateInputLockState() {
    // Lock when sending OR when any form is active OR (v2.53.3) when
    // another tab of the same session is typing. The placeholder
    // gives the customer a hint about why typing isn't accepted —
    // otherwise the disabled state looks like a bug.
    var foreignTyping = false;
    try {
      foreignTyping = typeof FS_TYPING !== "undefined"
        && FS_TYPING.isForeignTypingActive();
    } catch (_) {}
    var locked = isSending || activeForms.size > 0 || foreignTyping;
    $input.disabled = locked;
    $send.disabled  = locked;
    if (locked) {
      if (isSending) {
        $input.placeholder = "Waiting for reply…";
      } else if (activeForms.size > 0) {
        $input.placeholder = "Please complete or cancel the form above…";
      } else if (foreignTyping) {
        // v2.53.3
        $input.placeholder = "Another tab is typing…";
      }
    } else {
      $input.placeholder = "Type a message...";
    }
  }

  // v2.55.171 — single active-form rule. A registered form locks the
  // composer (see _updateInputLockState). Forms used to stack: tapping
  // Place Order opens a client-built variant-date form WHILE a server form
  // (e.g. delivery_fee) is still open, so both stayed registered and, after
  // the variant-date form was answered, the composer remained disabled
  // waiting on the abandoned delivery_fee form. The rule: before ANY new
  // form is displayed, cancel every form currently locking the composer.
  function _quietCancelServerForm(formId, bubbleEl) {
    // Supersede a still-open SERVER form because a new form is replacing it.
    // pending_forms are per-form_id docs that are NOT auto-superseded, so a
    // dangling one risks an auto-resume — mark it cancelled server-side. But
    // suppress ALL reply rendering: the new form already reflects the current
    // state, so a "Cancelled" bubble + ack reply would be noise. Register the
    // returned ids as seen so the Firestore listener also skips them.
    if (formId) {
      try {
        FS_FIRESTORE.beginInFlight();
        api("/chat/form_cancel", {
          widget_key: WIDGET_KEY,
          session_id: SESSION_ID,
          tab_id:     TAB_ID,
          page_url:   location.href,
          form_id:    formId,
        }).then(function (res) {
          if (res && res.body) {
            FS_FIRESTORE.registerSeenId(res.body.user_message_id);
            FS_FIRESTORE.registerSeenId(res.body.assistant_message_id);
          }
        }).catch(function () {}).finally(function () {
          FS_FIRESTORE.endInFlight();
        });
      } catch (_) {}
    }
    // Remove from DOM + unregister immediately so the composer unlocks now,
    // independent of the background cancel round-trip.
    removeFormBubble(bubbleEl);
  }

  function _supersedeActiveForms(newFormId) {
    // Cancel every currently-active (composer-locking) form before a new one
    // is shown. Iterate a COPY — the teardown callbacks mutate activeForms.
    // Non-blocking forms (e.g. escalation_contact) are never registered, so
    // they are not in activeForms and correctly survive.
    Array.from(activeForms).forEach(function (openForm) {
      if (openForm._ownerCard) {
        // Client-built variant-date form — no server pending_form to cancel.
        if (openForm._teardownScrollClose) openForm._teardownScrollClose();
        _unregisterActiveForm(openForm);
        openForm._ownerCard._variantDateBubble = null;
        openForm.remove();
        return;
      }
      // Server-emitted form (renderForm output) — keyed by data-form-id.
      var fid = (openForm.getAttribute
        && openForm.getAttribute("data-form-id")) || "";
      if (newFormId && fid && fid === String(newFormId)) {
        // Re-render of the SAME form_id — just replace the old bubble; do
        // NOT server-cancel the form we are about to show again.
        removeFormBubble(openForm);
        return;
      }
      _quietCancelServerForm(fid, openForm);
    });
  }

  // ---------------------------------------------------------------------
  // cart_state — a small mirror of the server-side cart, updated from
  // every reply where the place_order handler ran. Used to pre-fill
  // subsequent forms (e.g. delivery_date on the Variant+Date form when
  // the customer clicks "Place Order" on a product card).
  //
  // Shape: { delivery_date, delivery_address, stage, item_count } | null
  // ---------------------------------------------------------------------
  var cartState = null;

  function updateCartStateFromReply(reply) {
    if (reply && reply.cart_state && typeof reply.cart_state === "object") {
      cartState = reply.cart_state;
    }
  }

  // ---------------------------------------------------------------------
  // fullCart — v2.29.1 cart panel mirror
  //
  // Separate from cartState above (which is a 4-field summary used for
  // variant-date pre-fill, kept for back-compat). fullCart holds the
  // structured cart shape that landed on every response in v2.29.0:
  //   { items: [...], delivery_date, delivery_address, delivery_options,
  //     delivery_option_selected, form_data, stage, ... }
  //
  // Sources (in order of when they fire during a session):
  //   1. Boot: GET /cart/state — cold-start population.
  //   2. Every /chat, /chat/form_submit, /chat/form_cancel response —
  //      response.cart (top-level, not reply.cart). Kept in sync turn-
  //      by-turn so the panel updates without polling.
  //
  // Render: renderCartPanel() is called on every fullCart mutation.
  // Hides the bar when cart is empty (items=[] or null).
  // ---------------------------------------------------------------------
  var fullCart = null;

  // v2.55.140 — order-flow button labels, localised to the conversation
  // language (en | ms | zh). The backend sends the resolved language on every
  // reply (reply.language); we remember the latest and use it for the
  // "Place Order" button labels. Unknown codes fall back to English.
  var convoLanguage = "en";
  var BUTTON_LABELS = {
    place_order: { en: "Place Order", ms: "Buat Pesanan", zh: "下单" },
    placing:     { en: "Placing…",    ms: "Memproses…",   zh: "处理中…" },
  };
  function btnLabel(key) {
    var row = BUTTON_LABELS[key] || {};
    return row[convoLanguage] || row.en || "";
  }
  function applyStaticButtonLabels() {
    // The composer "Place Order" chip is baked into the static DOM; the
    // dynamic render points (product-card CTA, wizard submit, variant header)
    // read btnLabel() at render time, so only the chip needs updating here.
    try {
      var chip = document.querySelector('.fs-chatbot-chip[data-action="place_order"]');
      if (chip && chip.lastChild && chip.lastChild.nodeType === 3) {
        chip.lastChild.textContent = " " + btnLabel("place_order");
      }
    } catch (e) { /* never let a label update break the reply */ }
  }

  // v2.31.7 diagnostic: log the per-item has_balloon_wording flags
  // every time fullCart is updated. Tells us whether the backend is
  // sending the flag at all and what its value is. If the widget
  // never shows the "Text On Balloon" field, this is the FIRST log
  // to check: every cart line should have a has_balloon_wording bool.
  // Missing key entirely → backend's _cart_for_wire is stripping it
  // (shouldn't, but possible). False where true expected → upstream
  // tools.py / fuzzy_search didn't include the flag for this SKU.
  function _logBalloonFlagsOnCartSync(source, cart) {
    if (!cart || !Array.isArray(cart.items)) {
      // console.log("[fs-widget][balloon/cart_sync]", source,
      //             "no cart or empty items");
      return;
    }
    var rows = cart.items.map(function (it) {
      return {
        product_name:        it.product_name,
        variant_id:          it.variant_id,
        has_balloon_wording: it.has_balloon_wording,
        // Compare against the sibling flag for context — if has_card is
        // set correctly but has_balloon_wording is missing on the same
        // item, the propagation path is selective (problem at one
        // boundary). If BOTH are missing, the whole variant record is
        // empty or the cart-line write path skipped both.
        includes_message_card: it.includes_message_card,
      };
    });
    // console.log("[fs-widget][balloon/cart_sync]", source,
    //             "items=", rows,
    //             "cart.balloon_wording=", cart.balloon_wording);
  }

  function updateFullCartFromResponse(body) {
    // Response shape (v2.29.0): { status, session_id, reply, cart, ... }
    // Accept null/missing cart as "no change" rather than blanking the
    // panel — some endpoints (notably the _fallback_reply path) emit
    // cart: null when session isn't loaded. Clearing on null would make
    // the panel flicker during transient backend errors.
    if (!body || !body.cart) return;

    // v2.55.19 hotfix2 — respect Shopify cart authority for the items
    // field. The bot's response can include cart.items that differ
    // from Shopify (e.g., bot just added a chat-driven item server-
    // side that hasn't been pushed to Shopify yet). Per spec, Shopify
    // is the source of truth — preserve Shopify's items. Other cart-
    // level fields (balloon_wording, message_card, etc.) come from
    // the server.
    var serverCart = body.cart;
    var prevN = (fullCart && fullCart.items) ? fullCart.items.length : 0;
    var serverN = (serverCart.items) ? serverCart.items.length : 0;
    try {
      if (typeof FS_SHOPIFY_CART !== "undefined" &&
          FS_SHOPIFY_CART.hasAdoptedItems &&
          FS_SHOPIFY_CART.hasAdoptedItems()) {
        var shopifyItems = FS_SHOPIFY_CART.getAdoptedItems() || [];
        var shopifyDate  = FS_SHOPIFY_CART.getAdoptedDeliveryDate
          ? FS_SHOPIFY_CART.getAdoptedDeliveryDate()
          : null;
        var shopifyOwned = { items: shopifyItems };
        if (shopifyDate) {
          shopifyOwned.delivery_date         = shopifyDate;
          shopifyOwned.current_delivery_date = shopifyDate;
        }
        // v2.55.20 — detect divergence: if server's items differ from
        // Shopify's adopted state, that means something (bot, agent,
        // wizard via /cart/edit) drove a cart change server-side that
        // hasn't reached Shopify yet. Push it.
        //
        // Note: this is fire-and-forget. The fullCart we're about to
        // assign still has Shopify's items (Shopify-authority); the
        // push will eventually update both Shopify AND adoptedItems,
        // at which point a re-render will show the new state.
        //
        // v2.55.20+hotfix6 — REMOVED the divergence-preview gate. The
        // preview used _computeDiff against raw items, missing
        // cart-level date changes. Now we always call pushToShopify
        // with serverCart.items AND serverCart.delivery_date — push
        // handles alignment + no-op internally. Every skip path logs
        // explicitly to avoid silent failure modes.
        try {
          if (!Array.isArray(serverCart.items)) {
            console.warn("[FS/cart_state] updateFullCartFromResponse " +
                         "SKIP push — serverCart.items not array",
                         FS_WIDGET_VERSION,
                         "items_type=" + (typeof serverCart.items));
          } else {
            // console.info("[FS/cart_state] updateFullCartFromResponse — " +
                         // "triggering pushToShopify (let it diff internally)",
                         // FS_WIDGET_VERSION,
                         // "items_n=" + serverCart.items.length,
                         // "serverCart_delivery_date=" +
                           // (serverCart.delivery_date || "(none)"),
                         // "adoptedDeliveryDate=" + (shopifyDate || "(none)"));
            FS_SHOPIFY_CART.pushToShopify(
              serverCart.items,
              serverCart.delivery_date
            );
          }
        } catch (e) {
          console.warn("[FS/cart_state] updateFullCartFromResponse " +
                       "divergence check FAILED",
                       FS_WIDGET_VERSION,
                       "error=", e && e.message,
                       "stack=", e && e.stack);
        }
        // console.info("[FS/cart_state] updateFullCartFromResponse",
          // "prev_items_n=" + prevN,
          // "server_items_n=" + serverN,
          // "shopify_items_n=" + shopifyItems.length,
          // "shopify_delivery_date=" + (shopifyDate || "null"),
          // "respected_shopify_authority=true");
        fullCart = Object.assign({}, serverCart, shopifyOwned);
      } else {
        // console.info("[FS/cart_state] updateFullCartFromResponse",
          // "prev_items_n=" + prevN,
          // "server_items_n=" + serverN,
          // "respected_shopify_authority=false_(no_adoption_yet)");
        fullCart = serverCart;
      }
    } catch (_) {
      // Defensive: if FS_SHOPIFY_CART throws or doesn't exist, fall
      // back to server-driven behavior (the original v2.29.0 path).
      fullCart = serverCart;
    }
    _logBalloonFlagsOnCartSync("updateFullCartFromResponse", fullCart);
    renderCartPanel();
  }

  // Direct setter for the /cart/state cold-start response. That endpoint
  // returns cart at top level, not inside body — but the function above
  // already handles both (body.cart === top-level cart).
  //
  // v2.55.19 hotfix: log every call. If Shopify has already adopted and
  // setFullCart runs afterward, the Shopify cart gets wiped. The chained
  // boot sequence (loadCartState → FS_SHOPIFY_CART.boot) should prevent
  // this, but the log here is the diagnostic if it happens anyway.
  //
  // v2.55.19 hotfix2: respect Shopify adoption authoritatively. Even
  // when called AFTER FS_SHOPIFY_CART has adopted (race or otherwise),
  // setFullCart MUST NOT replace the items array with the server's
  // view — Shopify is the source of truth for items. We do still
  // accept the other cart-level fields (balloon_wording, message
  // card, etc.) from the server because those aren't synced to
  // Shopify in this phase.
  function setFullCart(cart, source) {
    source = source || "cold-start";
    var prevN = (fullCart && fullCart.items) ? fullCart.items.length : 0;
    var newN  = (cart && Array.isArray(cart.items)) ? cart.items.length : 0;
    var shopifyAuthoritative = false;
    var shopifyItems = null;
    var shopifyDate  = null;
    try {
      if (typeof FS_SHOPIFY_CART !== "undefined" &&
          FS_SHOPIFY_CART.hasAdoptedItems &&
          FS_SHOPIFY_CART.hasAdoptedItems()) {
        shopifyAuthoritative = true;
        shopifyItems = FS_SHOPIFY_CART.getAdoptedItems() || [];
        // v2.55.19 hotfix4 — also pick up the delivery date if
        // FS_SHOPIFY_CART has authority. Without this, an empty
        // server cart's null delivery_date would overwrite the
        // Shopify-derived date after every /cart/state or /chat
        // response.
        if (FS_SHOPIFY_CART.getAdoptedDeliveryDate) {
          shopifyDate = FS_SHOPIFY_CART.getAdoptedDeliveryDate();
        }
      }
    } catch (_) { /* defensive — FS_SHOPIFY_CART may not exist on
                     non-Shopify pages or if module init failed */ }

    var finalCart;
    if (shopifyAuthoritative) {
      // Preserve Shopify-owned fields (items + delivery_date + current_delivery_date).
      // Accept server's view for everything else (balloon_wording, message_card,
      // recipient/sender, address, delivery_option_selected, etc.).
      var shopifyOwned = { items: shopifyItems };
      if (shopifyDate) {
        shopifyOwned.delivery_date         = shopifyDate;
        shopifyOwned.current_delivery_date = shopifyDate;
      }
      if (cart) {
        finalCart = Object.assign({}, cart, shopifyOwned);
      } else {
        finalCart = shopifyOwned;
      }
      // console.info("[FS/cart_state] setFullCart",
        // "source=" + source,
        // "prev_items_n=" + prevN,
        // "server_items_n=" + newN,
        // "shopify_items_n=" + shopifyItems.length,
        // "shopify_delivery_date=" + (shopifyDate || "null"),
        // "respected_shopify_authority=true");
    } else {
      finalCart = cart;
      // console.info("[FS/cart_state] setFullCart",
        // "source=" + source,
        // "prev_items_n=" + prevN,
        // "new_items_n=" + newN,
        // "had_items_before=" + (prevN > 0),
        // "respected_shopify_authority=false_(no_adoption_yet)");
    }
    fullCart = finalCart;
    _logBalloonFlagsOnCartSync("setFullCart (" + source + ")", fullCart);
    renderCartPanel();
  }

  // ── Formatting helpers ──────────────────────────────────────────────
  // Match backend's _format_price_cents: "RMxxx.xx" with a comma every
  // 3 digits in the integer part. The cart bar uses this for the total.
  function _formatPriceCents(cents) {
    if (typeof cents !== "number") {
      cents = parseInt(cents, 10);
      if (isNaN(cents)) return "RM0.00";
    }
    var sign = cents < 0 ? "-" : "";
    var abs = Math.abs(cents);
    var ringgit = Math.floor(abs / 100);
    var cents2 = (abs % 100).toString().padStart(2, "0");
    // Thousands separator for the ringgit part.
    var rs = ringgit.toString();
    var withCommas = rs.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return sign + "RM" + withCommas + "." + cents2;
  }

  function _pluralItems(n) {
    return n === 1 ? "1 item" : (n + " items");
  }

  // Compute cart subtotal (items only, NOT including delivery) in cents.
  // Caller adds delivery_option_selected.total_price_cents if present.
  function _cartItemsSubtotalCents(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var total = 0;
    // v2.55.19 hotfix7 — log every item's price contribution so we can
    // see exactly what the UI is summing. If subtotal shows 0 despite
    // Shopify items having prices, this log reveals where the chain
    // broke (e.g., items had price_cents=undefined or NaN).
    var perItem = [];
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var qty = typeof it.quantity === "number" ? it.quantity : parseInt(it.quantity, 10);
      var px = typeof it.price_cents === "number" ? it.price_cents : parseInt(it.price_cents, 10);
      var add = (!isNaN(qty) && !isNaN(px)) ? qty * px : 0;
      total += add;
      perItem.push({
        variant_id:  it.variant_id,
        qty:         qty,
        qty_type:    typeof it.quantity,
        price_cents: px,
        price_type:  typeof it.price_cents,
        contributes: add,
      });
    }
    try {
      // console.debug("[FS/cart_panel/subtotal]",
        // (typeof FS_WIDGET_VERSION !== "undefined" ? FS_WIDGET_VERSION : "?"),
        // "total_cents=" + total,
        // "per_item=", perItem);
    } catch (_) { /* defensive */ }
    return total;
  }

  // ── Render ─────────────────────────────────────────────────────────
  function renderCartPanel() {
    var $bar = document.getElementById("fs-cart-bar");
    var $sum = document.getElementById("fs-cart-summary");
    if (!$bar || !$sum) return;

    // Hide the bar when the cart is empty or null. The chevron + wizard
    // arrive in v2.29.2; for v2.29.1 the bar is information-only.
    if (!fullCart || !Array.isArray(fullCart.items) || fullCart.items.length === 0) {
      $bar.classList.add("fs-chatbot-cart-hidden");
      $sum.textContent = "";
      return;
    }

    // Build the summary line. Three slots:
    //   1. item count ("4 items")
    //   2. delivery date if set ("· 27 May") or omitted
    //   3. total — items subtotal + delivery fee if selected, else
    //      "subtotal + delivery TBD"
    var parts = [];
    var itemCount = 0;
    for (var i = 0; i < fullCart.items.length; i++) {
      var qty = fullCart.items[i].quantity;
      itemCount += (typeof qty === "number" ? qty : parseInt(qty, 10) || 1);
    }
    parts.push('<span>' + _pluralItems(itemCount) + '</span>');

    if (fullCart.delivery_date) {
      var dateStr = formatDateShort(fullCart.delivery_date);
      // formatDateShort returns the original string if it doesn't parse —
      // hide the slot in that case rather than render garbage.
      if (dateStr && dateStr !== fullCart.delivery_date) {
        parts.push('<span class="fs-chatbot-cart-sep">·</span>');
        parts.push('<span>' + escapeHtml(dateStr) + '</span>');
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(fullCart.delivery_date)) {
        // Date parsed by formatDateShort but came back unchanged
        // (shouldn't happen with our shape, but defensive).
        parts.push('<span class="fs-chatbot-cart-sep">·</span>');
        parts.push('<span>' + escapeHtml(fullCart.delivery_date) + '</span>');
      }
    }

    var subtotal = _cartItemsSubtotalCents(fullCart);
    var sel = fullCart.delivery_option_selected;
    if (sel && typeof sel.total_price_cents === "number") {
      var grandTotal = subtotal + sel.total_price_cents;
      parts.push('<span class="fs-chatbot-cart-sep">·</span>');
      parts.push('<span class="fs-chatbot-cart-total">' + _formatPriceCents(grandTotal) + '</span>');
    } else {
      // No delivery option chosen yet — show subtotal with a "pending"
      // marker so customer knows there's more to come.
      parts.push('<span class="fs-chatbot-cart-sep">·</span>');
      parts.push('<span class="fs-chatbot-cart-total">' + _formatPriceCents(subtotal) + '</span>');
      parts.push(' <span class="fs-chatbot-cart-pending">+ delivery</span>');
    }

    $sum.innerHTML = parts.join("");
    $bar.classList.remove("fs-chatbot-cart-hidden");
    // v2.29.2: bar is interactive whenever it's visible — taps open
    // the wizard. The class toggles the cursor + hover style.
    $bar.classList.add("fs-chatbot-cart-interactive");
  }


  // ====================================================================
  // Cart edit wizard (v2.29.2)
  //
  // Modal overlay on top of the chat panel. Hosts the 3-page form
  // for editing cart state; v2.29.2 ships page 1 only (items + date +
  // address). Pages 2 and 3 land in v2.29.3+.
  //
  // State model:
  //   wizardOpen  — bool, mirrors the .fs-chatbot-wizard-open class
  //   wizardDraft — snapshot of fullCart at modal open + pending edits
  //                 the customer has made client-side. On Cancel,
  //                 discarded. On Proceed, submitted as a single batch.
  //   wizardErrors — error rows from the most recent failed Proceed,
  //                  used to highlight fields. Cleared on next Proceed.
  //   wizardBusy  — true while POST /cart/edit is in flight; disables
  //                 the Proceed button and shows the "validating
  //                 changes…" spinner-equivalent.
  //   wizardCollapsed — which accordion sections are collapsed. Default:
  //                     items expanded, date/address collapsed.
  //
  // The wizard's "Always re-render on open" semantic is implemented by
  // discarding wizardDraft on open and re-snapshotting from fullCart.
  // Customer edits made before opening are NOT preserved.
  // ====================================================================
  var wizardOpen = false;
  var wizardDraft = null;
  var wizardErrors = [];
  var wizardBusy = false;
  // v2.55.110: true while the product_remark "x" POST is in flight, so the
  // button can disable itself and avoid double-submits.
  var productRemarkBusy = false;
  var wizardCollapsed = { items: false, date: true, address: true };
  // v2.29.3: wizardPage tracks which step the customer is on.
  //   "items"   — page 1 (items + date + address). Default.
  //   "options" — page 2 (delivery option selection).
  //   "details" — page 3 (sender/recipient form). v2.29.4.
  // Page transitions are driven by the endpoint's next_page response.
  var wizardPage = "items";
  // wizardSelectedServiceCode holds the customer's pre-selection on
  // page 2 before they hit Confirm. Independent from cart's
  // delivery_option_selected, which only updates after a successful
  // submission.
  var wizardSelectedServiceCode = null;
  // v2.29.4: wizardDetailsDraft holds in-flight form values on page 3.
  // Initialised from cart.form_data | cart.partial_form_data | {} when
  // the customer arrives on the page. Survives Back-to-page-1 so the
  // customer doesn't lose their typed values during a round trip.
  var wizardDetailsDraft = null;

  // v2.33.10: inactivity-timer state for the wizard.
  //
  // After 1 hour of no interaction with the open wizard, the wizard
  // auto-closes. A 5-minute warning fires at the 55-min mark. On
  // re-open after expiry, a one-time notice surfaces explaining what
  // happened.
  //
  // The timer's purpose: snapshots on cart lines (especially
  // earliest_pickup_datetime, earliest_pickup_datetime_made_to_order,
  // ready_made_quantity_at_add_time) can go stale. After 1 hour, the
  // safe default is to drop the wizard state and re-validate on next
  // interaction.
  //
  // Implementation:
  //   wizardActivityTimerId  — setTimeout handle for the 60-min cutoff
  //   wizardActivityWarnId   — setTimeout handle for the 55-min warning
  //   wizardExpiredNotice    — flag read once by openWizard to surface
  //                            the "previous session expired" notice
  var WIZARD_INACTIVITY_MS    = 60 * 60 * 1000;   // 1 hour
  var WIZARD_WARN_MS          = 55 * 60 * 1000;   // 5 min before cutoff
  var wizardActivityTimerId   = null;
  var wizardActivityWarnId    = null;
  var wizardExpiredNotice     = false;

  // v2.31.9: balloon-wording charset constraint.
  //
  // Flower Sugar's balloon-printing equipment only renders Roman
  // (Latin) letters, digits, and a common ASCII punctuation/symbol
  // set reliably. Anything outside that — emoji, accented letters,
  // CJK, curly quotes from iOS autocorrect, em-dashes — either fails
  // to print or produces garbled output. The widget enforces the
  // constraint at TWO points:
  //
  //   1. Keystroke (oninput): the value is normalised + filtered
  //      before it lands in wizardDetailsDraft. Smart quotes from
  //      iOS/macOS autocorrect are silently mapped to their ASCII
  //      equivalents first, so a customer typing `"Sweet 16!"`
  //      doesn't get rejected for the curly variant.
  //   2. Submit: the value is re-checked. If anything bad slipped
  //      through (browser quirks, paste with invisible chars,
  //      programmatic insertion), submission shows a field-level
  //      error instead of sending the bad data.
  //
  // Per product decision (v2.31.9): backend doesn't re-validate.
  // Frontend control is sufficient — the bad-actor case (someone
  // bypassing the widget) is out of scope.
  //
  // Allowed set (lenient ASCII):
  //   A-Z a-z 0-9 space . , ! ? ' " - & ( ) : @ # $ % * + / = _ ~ ;
  var _BALLOON_WORDING_ALLOWED_RE =
        /^[A-Za-z0-9 .,!?'"\-&():@#$%*+\/=_~;]*$/;
  // Character-by-character version used in the filter step (matches
  // a SINGLE allowed char). Mirrors the above without the anchors.
  var _BALLOON_WORDING_CHAR_RE =
        /[A-Za-z0-9 .,!?'"\-&():@#$%*+\/=_~;]/;

  function _normaliseBalloonWording(s) {
    // Map common Unicode look-alikes to their ASCII equivalents
    // BEFORE filtering. Without this step, customers typing on iOS
    // or macOS with smart quotes enabled would see their input
    // silently rejected as the platform auto-converts ' → ' or
    // " → " mid-keystroke.
    //
    // Mappings:
    //   U+2018 ' / U+2019 '       → '
    //   U+201C " / U+201D "       → "
    //   U+2013 –  / U+2014 —       → -
    //   U+2026 …                  → ...
    //   no-break-space U+00A0     → regular space
    if (typeof s !== "string") return "";
    return s
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/[\u2013\u2014]/g, "-")
      .replace(/\u2026/g, "...")
      .replace(/\u00A0/g, " ");
  }

  function _filterBalloonWording(s) {
    // Drop any character not in the allowed set. Operates on a
    // normalised string (call _normaliseBalloonWording first or pass
    // already-clean input). Returns the cleaned string.
    if (typeof s !== "string") return "";
    var out = "";
    for (var i = 0; i < s.length; i++) {
      var ch = s.charAt(i);
      if (_BALLOON_WORDING_CHAR_RE.test(ch)) out += ch;
    }
    return out;
  }

  function _isBalloonWordingValid(s) {
    // Cheap submit-time check. The anchored regex requires every
    // char in the string be in the allowed set (or empty string).
    if (typeof s !== "string") return true;   // null/undefined → treat as empty (valid)
    return _BALLOON_WORDING_ALLOWED_RE.test(s);
  }


  function openWizard() {
    // v2.41.0 — idempotency guard. Prevents a second tap on "Proceed
    // to order" (while the wizard is already open) from re-snapshotting
    // from fullCart and discarding any in-progress wizard edits. Also
    // protects against rapid double-taps now that the chat button is
    // no longer disabled after the first click (see v2.41.0 reorder
    // in the click handler).
    if (wizardOpen) return;
    if (!fullCart || !Array.isArray(fullCart.items) || fullCart.items.length === 0) {
      // No cart → nothing to edit. Don't open.
      return;
    }
    // Always re-render: snapshot fresh from fullCart, discard any prior
    // in-flight edits. Per design (parallel conversational + wizard
    // paths), the conversational thread may have moved the cart since
    // the wizard was last open. Customer must re-state intent.
    wizardDraft = _wizardSnapshotFromCart(fullCart);
    wizardErrors = [];
    wizardBusy = false;
    // v2.55.72 — address starts EXPANDED for delivery (the customer must
    // fill it before proceeding, so show it up front), COLLAPSED for
    // pickup (read-only canned address, kept compact). The fulfilment
    // toggle handler keeps this in sync when the customer switches modes.
    wizardCollapsed = {
      items:   false,
      date:    true,
      address: (wizardDraft.pending_fulfilment === "delivery") ? false : true,
    };
    wizardPage = "items";
    wizardSelectedServiceCode = (fullCart.delivery_option_selected || {}).service_code || null;
    wizardDetailsDraft = null;
    wizardOpen = true;
    var $wiz = document.getElementById("fs-wizard");
    if ($wiz) $wiz.classList.add("fs-chatbot-wizard-open");

    // v2.33.10: start the 1-hour inactivity timer (with 55-min warning).
    _wizardActivityTimerStart();

    // v2.33.10: if the previous session expired, surface a one-time
    // notice. The expired flag is set by _wizardExpire below; reading
    // it here also clears it.
    if (wizardExpiredNotice) {
      wizardExpiredNotice = false;
      // Banner shows above the first-page heading; reused
      // wizardFormError-style div for now (could become its own
      // class — keeping minimal for the v2.33.10 launch).
      wizardErrors.push({
        field:   "_form",
        message: "Your previous session expired after an hour of inactivity. "
               + "Please review your cart and proceed."
      });
    }

    renderWizard();
  }

  function closeWizard() {
    wizardOpen = false;
    wizardDraft = null;
    wizardErrors = [];
    wizardBusy = false;
    wizardPage = "items";
    wizardSelectedServiceCode = null;
    wizardDetailsDraft = null;
    var $wiz = document.getElementById("fs-wizard");
    if ($wiz) $wiz.classList.remove("fs-chatbot-wizard-open");

    // v2.33.10: stop any pending inactivity timers when manually closing
    // (don't fire a warning after the customer's already gone).
    _wizardActivityTimerStop();
  }

  // v2.55.36 — transient "Cart refreshed" notification. Shown when the
  // widget receives a cart change from Firestore that this tab did NOT
  // originate (a foreign source_action — another tab's webpage action,
  // an agent edit, etc.) while the wizard is open. The wizard's editable
  // snapshot is taken at open and never live-refreshed, so an external
  // change makes it stale; we close the wizard and surface this notice so
  // the customer knows why it closed and that the cart now reflects the
  // latest state. Auto-dismisses after a few seconds; tapping dismisses
  // early. Self-contained inline styles so it shows without host CSS.
  function _showCartRefreshedNotice(messageText) {
    try {
      var existing = document.getElementById("fs-cart-refreshed-notice");
      if (existing && existing.parentNode) {
        existing.parentNode.removeChild(existing);
      }
      var el = document.createElement("div");
      el.id = "fs-cart-refreshed-notice";
      el.className = "fs-chatbot-cart-refreshed-notice";
      el.setAttribute("role", "status");
      el.setAttribute("aria-live", "polite");
      el.textContent = messageText || "Cart refreshed";
      el.style.cssText =
        "position: absolute; top: 12px; left: 12px; right: 12px;" +
        "padding: 10px 14px; background: #1f2937; color: #fff;" +
        "font-size: 13px; line-height: 1.3; border-radius: 8px;" +
        "text-align: center; z-index: 200; cursor: pointer;" +
        "box-shadow: 0 2px 8px rgba(0,0,0,0.18);" +
        "opacity: 0; transition: opacity 160ms ease;";
      var panel = document.querySelector(".fs-chatbot-panel") || document.body;
      panel.appendChild(el);
      // Force reflow so the opacity transition runs.
      void el.offsetWidth;
      el.style.opacity = "1";

      var _dismiss = function () {
        if (!el) return;
        el.style.opacity = "0";
        var _node = el;
        el = null;
        setTimeout(function () {
          if (_node && _node.parentNode) _node.parentNode.removeChild(_node);
        }, 200);
      };
      el.addEventListener("click", _dismiss);
      setTimeout(_dismiss, 4000);
    } catch (e) {
      // Notice is best-effort; never let it break the listener.
      console.warn("[FS/cart_refreshed_notice] failed:", e && e.message);
    }
  }

  // Snapshot turns the structured cart into the wizard's editable model.
  // Items become a draft list keyed by product_id+variant_id with a
  // pending_quantity field; the rest are flat values the customer can
  // edit (date, address).
  function _wizardSnapshotFromCart(cart) {

    var items = (cart.items || []).map(function (it) {
      return {
        product_id:    String(it.product_id || ""),
        variant_id:    String(it.variant_id || ""),
        product_name:  it.product_name || "",
        variant_name:  it.variant_name || "",
        price_cents:   typeof it.price_cents === "number" ? it.price_cents : parseInt(it.price_cents, 10) || 0,
        original_qty:  it.quantity,
        pending_qty:   it.quantity,
        disabled_dates: Array.isArray(it.disabled_dates) ? it.disabled_dates.slice() : [],
        earliest_availability: it.earliest_availability || null,
      };
    });

    var addr = cart.delivery_address;
    var addr_form = addr ? {
      address_line: addr.address1 || "",
      postal_code:  addr.postal_code || "",
      city:         addr.city || "",
      state:        addr.province_code || "",   // ISO code in the form field
    } : { address_line: "", postal_code: "", city: "", state: "" };

    return {
      items:           items,
      original_date:   cart.delivery_date || null,
      pending_date:    cart.delivery_date || null,
      address:         addr_form,
      // v2.29.5: fulfilment_mode reads from cart (default delivery).
      // The pickup toggle on page 1 mutates this; payload picks it up.
      original_fulfilment: cart.fulfilment_mode || "delivery",
      pending_fulfilment:  cart.fulfilment_mode || "delivery",
    };
  }

  // ── Body render ─────────────────────────────────────────────────────
  // v2.29.3: top-level render dispatcher. Routes to page-specific
  // renderers + updates the header/footer affordances for the page.
  function renderWizard() {
    var $title = document.getElementById("fs-wizard-title");
    if ($title) {
      if (wizardPage === "options") {
        $title.textContent = "Choose delivery option";
      } else if (wizardPage === "details") {
        $title.textContent = "Confirm order details";
      } else {
        $title.textContent = "Review your order";
      }
    }
    if (wizardPage === "options") {
      renderWizardOptions();
    } else if (wizardPage === "details") {
      renderWizardDetails();
    } else {
      renderWizardBody();   // page=items (default)
    }

    // v2.33.10: install activity listeners on the wizard panel so any
    // interaction (click, input, keydown) resets the inactivity timer.
    // Each renderWizard call replaces page content; we use a flag on
    // the panel element to install listeners ONCE per wizard session.
    var $wiz = document.getElementById("fs-wizard");
    if ($wiz && !$wiz._fs_activity_listeners_installed) {
      var resetFn = _wizardActivityTimerReset;
      $wiz.addEventListener("click",   resetFn, true);
      $wiz.addEventListener("input",   resetFn, true);
      $wiz.addEventListener("keydown", resetFn, true);
      $wiz._fs_activity_listeners_installed = true;
    }
  }

  function renderWizardBody() {
    var $body = document.getElementById("fs-wizard-body");
    if (!$body || !wizardDraft) return;

    // v2.33.4: auto-expand any section with errors so the customer
    // sees the validation messages without having to hunt. Pre-
    // v2.33.4 the date section was collapsed by default and stayed
    // collapsed even after a failed Proceed — its error-state CSS
    // applied but the body (including the error message) was
    // display:none. The fix is unconditional: any section that has
    // errors targeting one of its fields gets expanded.
    //
    // The map is deliberately verbose (rather than scanning every
    // field id with the section prefix) because the field naming
    // conventions differ per section:
    //   - items section: `item:{pid}:{vid}:quantity`
    //   - date section:  `delivery_date`
    //   - address sec.:  `delivery_address.{field}`
    // Adding a new error-emitting field requires adding it here.
    _autoExpandSectionsWithErrors();

    var html = "";
    // v2.33.10: inactivity warning (5 min before auto-close). Yellow
    // tone — informational, not an error. Customer can click anywhere
    // in the wizard to reset.
    var inactWarn = _wizardFieldError("_inactivity_warn");
    if (inactWarn) {
      html += '<div class="fs-chatbot-wiz-inactivity-warn">'
            +   escapeHtml(inactWarn)
            + '</div>';
    }
    // v2.30.1: section order is items → date → fulfilment toggle →
    // address. Putting the fulfilment toggle BELOW the date keeps
    // the natural checkout reading order ("what / when / how / where")
    // and lets the date section's "Delivery or pick up date" wording
    // (v2.42.0) signpost the toggle that follows. The address section
    // still branches on pending_fulfilment, so its render order vs
    // the toggle stays the same.
    // v2.55.72 — surface page-level prerequisite errors at the top so the
    // customer sees WHY Proceed didn't advance. The server returns bare
    // `delivery_date` / `delivery_address` errors for unmet prerequisites
    // (and `_form` for general issues); the per-section renderers only
    // show dotted `delivery_address.*` sub-field errors, so without this a
    // bare server error would expand the section (via _autoExpand) but
    // display no message. Collect any such top-level messages here.
    var topMsgs = [];
    var formErrP1 = _wizardFieldError("_form");
    if (formErrP1) topMsgs.push(formErrP1);
    var dateErrTop = _wizardFieldError("delivery_date");
    if (dateErrTop) topMsgs.push(dateErrTop);
    var addrErrTop = _wizardFieldError("delivery_address");  // bare (server)
    if (addrErrTop) topMsgs.push(addrErrTop);
    if (topMsgs.length > 0) {
      html += '<div class="fs-chatbot-wiz-form-error">'
            +   topMsgs.map(escapeHtml).join("<br>")
            + '</div>';
    }
    html += _renderItemsSection();
    html += _renderDateSection();
    html += _renderFulfilmentToggle();
    html += _renderAddressSection();
    // v2.31.0 page-1 hint: tells the customer what to expect after
    // they hit Proceed. Text differs by fulfilment mode — delivery
    // flows through page 2 (carrier rates) before details; pickup
    // skips straight to page 3.
    var isPickup = (wizardDraft.pending_fulfilment === "pickup");
    var page1Hint = isPickup
      ? "Submit contact details &amp; message card content on next page"
      : "Delivery fees to be calculated on next page";
    html += '<div class="fs-chatbot-wiz-page-hint">' + page1Hint + '</div>';
    $body.innerHTML = html;

    // Wire up event handlers post-render. Using delegation on the body
    // is cleaner than per-button listeners since renderWizardBody()
    // re-runs on every state change.
    _wireWizardBody($body);
    _updateFooterForItemsPage();
  }

  // v2.33.4: inspect wizardErrors and force-expand any section that
  // owns a field with an error. Mutates wizardCollapsed in place
  // (matches the existing toggle-button pattern at _wireWizardBody).
  // Idempotent — re-running with the same errors produces the same
  // expansion state.
  //
  // The customer can still manually collapse a section AFTER seeing
  // its error (the toggle button works normally), but we always
  // expand at render-time when errors are present. This is the
  // right policy for validation: the customer's intent in clicking
  // "Proceed" was to move forward; the wizard's job is to show
  // them WHY they can't.
  function _autoExpandSectionsWithErrors() {
    if (!wizardErrors || wizardErrors.length === 0) return;
    for (var i = 0; i < wizardErrors.length; i++) {
      var field = wizardErrors[i].field || "";
      if (field === "delivery_date") {
        wizardCollapsed.date = false;
      } else if (field.indexOf("item:") === 0) {
        wizardCollapsed.items = false;
      } else if (field === "delivery_address"
                 || field.indexOf("delivery_address.") === 0) {
        // v2.55.72 — the server returns a bare `delivery_address` error
        // for the missing-address prerequisite; the client validator and
        // per-field address validation use the dotted `delivery_address.*`
        // form. Expand the address section for either.
        wizardCollapsed.address = false;
      }
      // `_form` errors render at the top via the existing footer
      // path — no section to expand.
    }
  }

  // v2.29.5: fulfilment mode toggle. Two-button pill — Delivery vs
  // Pickup. Switching changes wizardDraft.pending_fulfilment and
  // re-renders so the address section can hide/show accordingly.
  // v2.30.1: moved from above items to below the date section so the
  // checkout reading order is items → date → mode → address.
  function _renderFulfilmentToggle() {
    var mode = wizardDraft.pending_fulfilment || "delivery";
    return ''
      + '<div class="fs-chatbot-wiz-fulfilment">'
      + '  <button type="button" class="fs-chatbot-wiz-fulfilment-btn'
      +     (mode === "delivery" ? " fs-chatbot-wiz-fulfilment-active" : "") + '"'
      +     ' data-fulfilment="delivery">Delivery</button>'
      + '  <button type="button" class="fs-chatbot-wiz-fulfilment-btn'
      +     (mode === "pickup" ? " fs-chatbot-wiz-fulfilment-active" : "") + '"'
      +     ' data-fulfilment="pickup">Pickup</button>'
      + '</div>';
  }

  // v2.29.3: page-2 (options) renderer. Radio list of delivery
  // options from fullCart.delivery_options, with Back / Confirm
  // footer.
  function renderWizardOptions() {
    var $body = document.getElementById("fs-wizard-body");
    if (!$body) return;

    var formErr = _wizardFieldError("_form");
    var svcErr = _wizardFieldError("service_code");
    var options = (fullCart && fullCart.delivery_options) || [];

    var html = "";
    if (formErr) {
      html += '<div class="fs-chatbot-wiz-form-error">'
            +   escapeHtml(formErr)
            + '</div>';
    }
    if (wizardBusy && options.length === 0) {
      // Initial load — no options yet, spinner placeholder.
      html += '<div class="fs-chatbot-wiz-options-loading">Fetching delivery options…</div>';
    } else if (options.length === 0) {
      html += '<div class="fs-chatbot-wiz-options-empty">'
            +   'No delivery options available. Go back and check your date and address.'
            + '</div>';
    } else {
      html += '<div class="fs-chatbot-wiz-options-list"'
            +    (svcErr ? ' data-has-error="1"' : '') + '>';
      options.forEach(function (opt, idx) {
        var code = String(opt.service_code || "");
        var name = opt.service_name || "Delivery";
        var priceCents = typeof opt.total_price === "number"
          ? opt.total_price
          : parseInt(opt.total_price, 10) || 0;
        var desc = opt.description || "";
        var checked = code === wizardSelectedServiceCode ? " checked" : "";
        html += ''
          + '<label class="fs-chatbot-wiz-option" data-code="' + escapeHtml(code) + '">'
          + '  <input type="radio" name="fs-wiz-service" value="' + escapeHtml(code) + '"' + checked + '>'
          + '  <div class="fs-chatbot-wiz-option-body">'
          + '    <div class="fs-chatbot-wiz-option-name">' + escapeHtml(name) + '</div>'
          + (desc
              ? '    <div class="fs-chatbot-wiz-option-desc">' + escapeHtml(desc) + '</div>'
              : '')
          + '  </div>'
          + '  <div class="fs-chatbot-wiz-option-price">' + _formatPriceCents(priceCents) + '</div>'
          + '</label>';
      });
      html += '</div>';
      if (svcErr) {
        html += '<div class="fs-chatbot-wiz-field-error-msg">' + escapeHtml(svcErr) + '</div>';
      }
      // v2.31.0 page-2 hint. Shown only when options are available
      // (selecting one is what advances to page 3). Suppressed in
      // the loading and empty states to avoid promising a next page
      // that isn't reachable.
      html += '<div class="fs-chatbot-wiz-page-hint">'
            +   'Submit contact details &amp; message card content on next page'
            + '</div>';
    }

    $body.innerHTML = html;

    // Wire radio change handlers.
    $body.querySelectorAll('input[name="fs-wiz-service"]').forEach(function (r) {
      r.addEventListener("change", function () {
        wizardSelectedServiceCode = r.value || null;
        // Don't re-render the whole body — that'd lose focus. Just
        // update the proceed-enabled state.
        _updateFooterForOptionsPage();
      });
    });

    _updateFooterForOptionsPage();
  }

  // v2.29.4: page-3 (details) renderer. Sender/recipient form, plus
  // per-item message card fields. Validates client-side on Confirm
  // but trusts the server for the authoritative error list.
  // v2.55.110: clear the customer-facing customisation summary
  // (cart.product_remark) via /cart/edit page=clear_product_remark, then
  // re-render Page 3 from the fresh cart. Delete-only; there is no edit.
  function _clearProductRemark() {
    if (productRemarkBusy) return;
    productRemarkBusy = true;
    var $x = document.getElementById("fs-product-remark-x");
    if ($x) $x.disabled = true;
    api("/cart/edit", {
      widget_key: WIDGET_KEY,
      session_id: SESSION_ID,
      page:       "clear_product_remark",
      payload:    {},
      tab_id:     TAB_ID,
    }).then(function (res) {
      productRemarkBusy = false;
      if (res && res.status === 200 && res.body && res.body.cart) {
        fullCart = res.body.cart;
        renderCartPanel();
      }
      // Re-render either way: on success the block is gone; on failure the
      // button re-enables so the customer can retry.
      renderWizardDetails();
    }).catch(function () {
      productRemarkBusy = false;
      renderWizardDetails();
    });
  }

  function renderWizardDetails() {
    var $body = document.getElementById("fs-wizard-body");
    if (!$body) return;

    // Initialise the in-flight draft from the cart. Priority:
    // partial_form_data (in-flight from server side) > form_data
    // (previously submitted) > empty. Customer's typed values then
    // mutate wizardDetailsDraft directly via input handlers; survives
    // Back-to-page-1 round trips.
    if (wizardDetailsDraft === null) {
      var seed = (fullCart && fullCart.partial_form_data)
              || (fullCart && fullCart.form_data)
              || {};
      wizardDetailsDraft = {};
      Object.keys(seed).forEach(function (k) {
        wizardDetailsDraft[k] = seed[k];
      });
      // v2.31.7: pull balloon_wording from its dedicated cart field as
      // a tertiary fallback. card_messages uses an analogous pattern —
      // values live in cart.card_messages, not form_data, until the
      // first submit writes them through. balloon_wording also has
      // its own cart field (cart.balloon_wording), so on a fresh
      // re-render before submission, seed from there too. The seed
      // above wins when balloon_wording is also in form_data (the
      // typical case after a re-edit).
      if (wizardDetailsDraft.balloon_wording === undefined
          && fullCart && fullCart.balloon_wording) {
        wizardDetailsDraft.balloon_wording = fullCart.balloon_wording;
      }
    }

    var formErr = _wizardFieldError("_form");
    var html = "";
    if (formErr) {
      html += '<div class="fs-chatbot-wiz-form-error">'
            +   escapeHtml(formErr)
            + '</div>';
    }

    // v2.33.10: inactivity warning on Page 3 too
    var inactWarnP3 = _wizardFieldError("_inactivity_warn");
    if (inactWarnP3) {
      html += '<div class="fs-chatbot-wiz-inactivity-warn">'
            +   escapeHtml(inactWarnP3)
            + '</div>';
    }

    // v2.33.10: pickup-time-aware statement.
    // Shown ONLY when:
    //   (i)   fulfilment_mode == "pickup"
    //   (ii)  pickup_date is today OR tomorrow (Malaysia time)
    // Two sentence variants:
    //   - "All item(s) in your cart are ready made. Pick up is available
    //      from {datetime} onwards."  (every line: quantity ≤ ready_made_quantity_at_add_time)
    //   - "Some of all item(s) in your cart are not ready made. Pick up is
    //      available from {datetime} onwards."  (any line: quantity > rmq snapshot)
    // {datetime} is max() of each line's chosen EPD (optimistic vs
    // made-to-order, see v2.53.7 in _buildPickupTimeStatement), formatted
    // as "10:15 AM, Friday 30 May 2026" (matches v2.33.7 BUSINESS STATUS).
    var pickupStatement = _buildPickupTimeStatement();
    if (pickupStatement) {
      html += '<div class="fs-chatbot-wiz-pickup-statement">'
            +   escapeHtml(pickupStatement)
            + '</div>';
    }

    // v2.55.110: read-only customisation summary. The bot accumulates
    // every ACCEPTED customisation into cart.product_remark; show it here
    // greyed/non-editable with an "x" that clears it (delete-only). Hidden
    // when empty.
    var productRemark = (fullCart && fullCart.product_remark) || "";
    if (productRemark && String(productRemark).trim()) {
      html += '<div class="fs-chatbot-wiz-product-remark">'
            +   '<button type="button" class="fs-chatbot-wiz-product-remark-x"'
            +          ' id="fs-product-remark-x" aria-label="Remove customisations"'
            +          (productRemarkBusy ? ' disabled' : '') + '>\u00d7</button>'
            +   '<div class="fs-chatbot-wiz-product-remark-label">Customisations</div>'
            +   '<div class="fs-chatbot-wiz-product-remark-text">'
            +     escapeHtml(String(productRemark).trim())
            +   '</div>'
            + '</div>';
    }

    // Buyer block
    html += '<div class="fs-chatbot-wiz-details-section">'
          + '  <div class="fs-chatbot-wiz-details-heading">Your details</div>'
          +    _detailsField("buyer_name",  "Your name",            "text", null)
          +    _detailsField("buyer_phone", "Your WhatsApp number", "tel",  null)
          +    _detailsField("buyer_email", "Your email",           "email", null)
          + '</div>';

    // Recipient block — v2.31.0: in pickup mode, the customer IS the
    // recipient. Recipient inputs are disabled with a "Same as sender"
    // placeholder; the backend mirrors buyer fields into recipient
    // fields at submission time. In delivery mode, fields work as
    // they always have.
    var isPickupP3 = (fullCart && fullCart.fulfilment_mode === "pickup");
    var recipientOpts = isPickupP3
      ? { disabled: true, placeholder: "Same as sender" }
      : null;
    html += '<div class="fs-chatbot-wiz-details-section">'
          + '  <div class="fs-chatbot-wiz-details-heading">Recipient</div>'
          +    _detailsField("recipient_name",  "Recipient\u2019s name",  "text", null, recipientOpts)
          +    _detailsField("recipient_phone", "Recipient\u2019s phone", "tel",  null, recipientOpts)
          + '</div>';

    // v2.31.7: order-level "Text On Balloon" field. Rendered ONCE
    // per order whenever any cart item has has_balloon_wording=True.
    // Matches the backend's _build_order_details_fields gate
    // (_cart_has_balloon_wording_items). Single 35-char input — the
    // customer types one phrase that the shop prints on all balloons
    // in the order, mirroring Flower Sugar's fulfilment workflow.
    //
    // Field positioned between the recipient block (order-level
    // contact info) and the per-unit card-message fanout (per-unit
    // content). The hierarchy: buyer → recipient → balloon wording →
    // per-unit cards. Same ordering as the backend's field list, so
    // submission validation and visual layout match.
    var hasBalloonItem = ((fullCart && fullCart.items) || []).some(function (it) {
      return !!it.has_balloon_wording;
    });
    // v2.31.7 diagnostic: log the page-3 gate decision. Fires every
    // time renderWizardDetails runs. If hasBalloonItem=false but the
    // customer expects to see the field:
    //   1. Inspect the items below: does any have has_balloon_wording=true?
    //   2. If yes → bug in the .some() predicate above (shouldn't be).
    //   3. If no → check [fs-widget][balloon/cart_sync] log above to
    //      see what the server sent in the last cart payload.
    //   4. If the SERVER also says false → check backend logs for
    //      [recheck/balloon], [cart_add/balloon], or [form_build/balloon]
    //      to localize where the flag dropped.
    // console.log("[fs-widget][balloon/page3] hasBalloonItem=", hasBalloonItem,
    //             "items=", ((fullCart && fullCart.items) || []).map(function (it) {
    //               return {
    //                 product_name:        it.product_name,
    //                 variant_id:          it.variant_id,
    //                 has_balloon_wording: it.has_balloon_wording,
    //               };
    //             }),
    //             // v2.31.8 diagnostic: also dump the cart-level
    //             // balloon_wording value + the draft's current value
    //             // for it. Tells us whether the field would have a
    //             // pre-filled value if it rendered, and confirms the
    //             // draft seeding logic ran.
    //             "fullCart.balloon_wording=", (fullCart || {}).balloon_wording,
    //             "wizardDetailsDraft.balloon_wording=",
    //             wizardDetailsDraft && wizardDetailsDraft.balloon_wording);
    if (hasBalloonItem) {
      var bwDraft = wizardDetailsDraft.balloon_wording;
      var bwValue = (bwDraft !== undefined && bwDraft !== null) ? bwDraft : "";
      // Stamp the draft so submission picks up the value even if
      // the customer never focuses the field (mirrors the
      // envelope/message-card pre-stamp pattern).
      if (wizardDetailsDraft.balloon_wording === undefined) {
        wizardDetailsDraft.balloon_wording = bwValue;
      }
      var bwErr = _wizardFieldError("balloon_wording");
      html += '<div class="fs-chatbot-wiz-details-section">'
            + '  <div class="fs-chatbot-wiz-field'
            +      (bwErr ? ' fs-chatbot-wiz-field-error' : '') + '">'
            + '    <label for="fs-wiz-balloon_wording">Text On Balloon</label>'
            + '    <input type="text" id="fs-wiz-balloon_wording" '
            + '           data-details-field="balloon_wording" '
            + '           maxlength="35" '
            + '           value="' + escapeHtml(bwValue) + '">'
            // v2.31.9: charset hint below the input. Visible by
            // default so the customer knows the constraint BEFORE
            // they hit an error. Tied to the field via aria-describedby
            // for assistive-tech users.
            + '    <div class="fs-chatbot-wiz-field-hint" '
            + '         id="fs-wiz-balloon_wording-hint">'
            + '      Roman letters, numbers, and basic punctuation only.'
            + '    </div>'
            + (bwErr
                ? '    <div class="fs-chatbot-wiz-field-error-msg">' + escapeHtml(bwErr) + '</div>'
                : '')
            + '  </div>'
            + '</div>';
    }

    // Per-unit message card fields (v2.30.0). Each card-eligible UNIT
    // (cart line × quantity) gets its own envelope_name + message
    // section. Sections render in global unit order (cart-line order,
    // then 0..qty-1 within each line). The header shows
    // "<product_name> (<variant_name>) - N of <total>" where <total>
    // counts ALL units (including non-card-eligible ones).
    //
    // Field IDs: <pid>_<vid>_<idx>_envelope and <pid>_<vid>_<idx>_message.
    // Defaults are pre-filled from fullCart.card_messages — the
    // backend reconciles this dict on every mutation, so by the time
    // the widget renders page 3 the entries are aligned with the
    // current items + quantities.
    var items = (fullCart && fullCart.items) || [];
    var cardMessages = (fullCart && fullCart.card_messages) || {};
    var anyCardRendered = false;
    // Total = sum of ALL quantities, card-eligible or not
    var totalUnits = 0;
    items.forEach(function (it) {
      totalUnits += Math.max(0, parseInt(it.quantity, 10) || 0);
    });
    // Iterate items, expanding by quantity to get per-unit blocks,
    // while tracking a global position counter that advances for
    // every unit (eligible or not). Only eligible units render.
    var globalPos = 0;
    items.forEach(function (it) {
      var pid = String(it.product_id || "");
      var vid = String(it.variant_id || "");
      var qty = Math.max(0, parseInt(it.quantity, 10) || 0);
      var eligible = !!it.includes_message_card;
      for (var unitIdx = 0; unitIdx < qty; unitIdx++) {
        globalPos++;
        if (!eligible || !pid || !vid) continue;
        anyCardRendered = true;
        var key = pid + "_" + vid + "_" + unitIdx;
        var envId  = key + "_envelope";
        var msgId  = key + "_message";
        var entry  = cardMessages[key] || {envelope_name: "", message: ""};

        // Prefer the in-flight wizardDetailsDraft value if the
        // customer has typed something; otherwise fall back to the
        // backend's pre-fill from cart.card_messages.
        var envValue = (wizardDetailsDraft[envId] !== undefined
                        && wizardDetailsDraft[envId] !== null)
                     ? wizardDetailsDraft[envId]
                     : (entry.envelope_name || "");
        var msgValue = (wizardDetailsDraft[msgId] !== undefined
                        && wizardDetailsDraft[msgId] !== null)
                     ? wizardDetailsDraft[msgId]
                     : (entry.message || "");

        // Stamp the draft so submission picks up the value even if
        // the customer never focuses the field.
        if (wizardDetailsDraft[envId] === undefined) {
          wizardDetailsDraft[envId] = envValue;
        }
        if (wizardDetailsDraft[msgId] === undefined) {
          wizardDetailsDraft[msgId] = msgValue;
        }

        var envErr = _wizardFieldError(envId);
        var msgErr = _wizardFieldError(msgId);

        var pname = (it.product_name || "").trim();
        var vname = (it.variant_name || "").trim();
        var labelBase = (vname && vname !== pname)
                      ? (pname + " (" + vname + ")")
                      : pname;
        var heading = labelBase + " - " + globalPos + " of " + totalUnits;

        html += '<div class="fs-chatbot-wiz-details-section">'
              + '  <div class="fs-chatbot-wiz-details-heading">'
              +      escapeHtml(heading) + '</div>'
              // Envelope name field
              + '  <div class="fs-chatbot-wiz-field'
              +      (envErr ? ' fs-chatbot-wiz-field-error' : '') + '">'
              + '    <label for="fs-wiz-' + envId + '">Recipient name on envelope</label>'
              + '    <input type="text" id="fs-wiz-' + envId + '" '
              + '           data-details-field="' + envId + '" '
              + '           maxlength="120" value="' + escapeHtml(envValue) + '">'
              + (envErr
                  ? '    <div class="fs-chatbot-wiz-field-error-msg">' + escapeHtml(envErr) + '</div>'
                  : '')
              + '  </div>'
              // Message field
              + '  <div class="fs-chatbot-wiz-field'
              +      (msgErr ? ' fs-chatbot-wiz-field-error' : '') + '">'
              + '    <label for="fs-wiz-' + msgId + '">Message</label>'
              + '    <textarea id="fs-wiz-' + msgId + '" '
              + '              data-details-field="' + msgId + '" '
              + '              rows="4" maxlength="550">'
              +      escapeHtml(msgValue)
              + '</textarea>'
              + (msgErr
                  ? '    <div class="fs-chatbot-wiz-field-error-msg">' + escapeHtml(msgErr) + '</div>'
                  : '')
              + '  </div>'
              + '</div>';
      }
    });

    // One help note below all card sections — explains what blank
    // fields produce. Only shown when at least one card section
    // rendered (otherwise it'd be misleading filler).
    if (anyCardRendered) {
      html += '<div class="fs-chatbot-wiz-card-help">'
            +   'Leave the message field blank to receive an empty card '
            +   'for bouquets or fruit baskets. '
            +   'If you wish to include “To xx” and “From xx” on the message card, please add them into the message content.'
            + '</div>';
    }

    $body.innerHTML = html;

    // Wire input handlers — update wizardDetailsDraft on every change.
    // No re-render trigger needed (v2.29.8 dropped the blank-toggle that
    // controlled textarea visibility); both fields are always present.
    $body.querySelectorAll("[data-details-field]").forEach(function (el) {
      var fieldId = el.getAttribute("data-details-field");
      var handler = function () {
        wizardDetailsDraft[fieldId] = el.value;
      };
      el.addEventListener("input", handler);
      if (el.tagName === "SELECT") {
        el.addEventListener("change", handler);
      }
    });

    // v2.55.110: customisation-summary delete ("x"). Delete-only — there
    // is no edit affordance. Clears cart.product_remark server-side, then
    // re-renders the page from the fresh cart.
    var $remarkX = $body.querySelector("#fs-product-remark-x");
    if ($remarkX) {
      $remarkX.addEventListener("click", _clearProductRemark);
    }

    // v2.31.9: balloon-wording keystroke filter. Installed ONLY on the
    // balloon_wording input. Normalises smart quotes / em-dashes from
    // iOS/macOS autocorrect, then strips anything outside the allowed
    // ASCII set. Runs alongside the generic [data-details-field]
    // handler above; both end up writing to wizardDetailsDraft, but
    // this one also mutates el.value so the customer sees their input
    // converge to a valid string in real time.
    //
    // Caret-position preservation: if we naively assign el.value back
    // (after stripping bad chars), the caret jumps to the end — every
    // time. We compute the delta and adjust selectionStart manually
    // so the customer can continue editing in-place.
    var $balloonInput = $body.querySelector("#fs-wiz-balloon_wording");
    if ($balloonInput) {
      $balloonInput.addEventListener("input", function () {
        var raw       = $balloonInput.value;
        var caret     = $balloonInput.selectionStart;
        var normalised = _normaliseBalloonWording(raw);
        var cleaned    = _filterBalloonWording(normalised);
        if (cleaned !== raw) {
          // Adjust caret: clamp to the new length (handles the case
          // where the customer pasted something with bad chars in
          // the middle — caret should sit just after the surviving
          // chars before its original position).
          //
          // Approximation: count surviving chars up to caret in the
          // original string, set caret there. Edge cases (multiple
          // bad chars before/after caret) are rare; this gives a
          // sensible default for the common case.
          var survivingBeforeCaret = _filterBalloonWording(
            _normaliseBalloonWording(raw.slice(0, caret))
          ).length;
          $balloonInput.value = cleaned;
          try {
            $balloonInput.setSelectionRange(survivingBeforeCaret, survivingBeforeCaret);
          } catch (_) {
            // setSelectionRange throws on inputs that don't support
            // selection ranges (rare for type=text but defensive).
          }
          // Update draft with the cleaned value (the generic handler
          // already wrote `raw` to the draft on its own event — overwrite
          // with the cleaned version so submission gets the good data).
          wizardDetailsDraft.balloon_wording = cleaned;
        }
      });
    }

    _updateFooterForDetailsPage();
  }

  function _detailsField(name, label, inputType, err, opts) {
    // opts: optional { disabled: bool, placeholder: string }
    // v2.31.0: added to support pickup-mode recipient fields which
    // are rendered disabled with a "Same as sender" placeholder.
    opts = opts || {};
    var fieldErr = err
      ? '<div class="fs-chatbot-wiz-field-error-msg">' + escapeHtml(err) + '</div>'
      : '';
    err = _wizardFieldError(name);   // re-lookup in case caller passed null
    var errCls = err ? ' fs-chatbot-wiz-field-error' : '';
    var errMsg = err
      ? '<div class="fs-chatbot-wiz-field-error-msg">' + escapeHtml(err) + '</div>'
      : '';
    var value = (wizardDetailsDraft && wizardDetailsDraft[name]) || "";
    // Disabled fields hide their value (don't pre-populate). The
    // backend mirrors buyer→recipient at submission time; showing
    // mirrored content in the input would be confusing.
    var displayValue = opts.disabled ? "" : value;
    var disabledAttr = opts.disabled ? " disabled" : "";
    var placeholderAttr = opts.placeholder
      ? ' placeholder="' + escapeHtml(opts.placeholder) + '"'
      : "";
    var disabledCls = opts.disabled ? " fs-chatbot-wiz-field-disabled" : "";
    return ''
      + '<div class="fs-chatbot-wiz-field' + errCls + disabledCls + '">'
      + '  <label for="fs-wiz-' + name + '">' + escapeHtml(label) + '</label>'
      + '  <input type="' + inputType + '" id="fs-wiz-' + name + '" '
      +        'data-details-field="' + name + '" '
      +        placeholderAttr
      +        disabledAttr + ' '
      +        'value="' + escapeHtml(displayValue) + '">'
      + errMsg
      + '</div>';
  }

  function _renderItemsSection() {
    var expanded = !wizardCollapsed.items;
    var n = wizardDraft.items.length;
    var summary = n === 0 ? "Empty" : (n + " line" + (n === 1 ? "" : "s"));
    var rows = wizardDraft.items.map(function (it, idx) {
      var zeroClass = it.pending_qty === 0 ? " fs-chatbot-wiz-item-zero" : "";
      var lineTotal = it.pending_qty * it.price_cents;
      var fieldId = "item:" + it.product_id + ":" + it.variant_id + ":quantity";
      var hasErr = _wizardFieldError(fieldId);
      return ''
        + '<div class="fs-chatbot-wiz-item' + zeroClass + '" data-idx="' + idx + '">'
        + '  <div class="fs-chatbot-wiz-item-name">'
        +    escapeHtml(it.product_name)
        +    (it.variant_name
              ? '<span class="fs-chatbot-wiz-item-variant">' + escapeHtml(it.variant_name) + '</span>'
              : '')
        +    (hasErr
              ? '<div class="fs-chatbot-wiz-field-error-msg">' + escapeHtml(hasErr) + '</div>'
              : '')
        + '  </div>'
        + '  <div class="fs-chatbot-wiz-item-price">' + _formatPriceCents(lineTotal) + '</div>'
        + '  <div class="fs-chatbot-wiz-qty">'
        + '    <button class="fs-chatbot-wiz-qty-btn" type="button" data-action="dec" data-idx="' + idx + '"'
        +        (it.pending_qty === 0 ? ' disabled' : '') + '>−</button>'
        + '    <span class="fs-chatbot-wiz-qty-value">' + it.pending_qty + '</span>'
        + '    <button class="fs-chatbot-wiz-qty-btn" type="button" data-action="inc" data-idx="' + idx + '">+</button>'
        + '  </div>'
        + '</div>';
    }).join("");
    return _section("items", "Items", summary, expanded, rows);
  }

  function _renderDateSection() {
    var expanded = !wizardCollapsed.date;
    var label = wizardDraft.pending_date
      ? formatDateShort(wizardDraft.pending_date)
      : "Not selected";
    // v2.33.4: surface ALL delivery_date errors, not just the first.
    // The backend emits one error per unavailable item on the page-1
    // recheck (introduced in v2.33.3), and a customer with multiple
    // affected items needs to see all of them at once — otherwise
    // they fix the date for the first item, resubmit, see the next,
    // and only learn about the full set after several round trips.
    var dateErrs = _wizardFieldErrors("delivery_date");
    var hasErr = dateErrs.length > 0;
    var summary = label;
    // Label is mode-neutral since the same date field serves both
    // delivery and pickup. v2.30.1 introduced the neutral wording;
    // v2.42.0 aligned the exact phrasing with form_strings.py's
    // label_delivery_date ("delivery or pick up date") so chat-side
    // forms, the wizard, the product-card place-order form, and
    // backend buttons all use one phrase. The data field remains
    // `delivery_date` for backwards compat.
    var errBlock = "";
    if (hasErr) {
      // Multiple messages render as a stack of error-msg divs so each
      // gets its own line + styling. Single error renders identically
      // — the loop produces the same output as the pre-v2.33.4
      // single-message render.
      errBlock = dateErrs.map(function (m) {
        return '<div class="fs-chatbot-wiz-field-error-msg">' + escapeHtml(m) + '</div>';
      }).join("");
    }
    var body = ''
      + '<div class="fs-chatbot-wiz-field' + (hasErr ? ' fs-chatbot-wiz-field-error' : '') + '">'
      + '  <label for="fs-wiz-date">Delivery or pick up date</label>'
      + '  <input type="text" id="fs-wiz-date" readonly placeholder="Tap to choose a date" '
      +     'value="' + escapeHtml(wizardDraft.pending_date || "") + '" />'
      +     errBlock
      + '</div>';
    return _section("date", "Delivery or pick up date", summary, expanded, body);
  }

  function _renderAddressSection() {
    var expanded = !wizardCollapsed.address;
    var isPickup = wizardDraft.pending_fulfilment === "pickup";

    if (isPickup) {
      // Read-only info block — the customer picks up at the store, so
      // they don't fill in an address. The canned values are mirrored
      // here for display; the server is the source of truth.
      // (PICKUP_ADDRESS_DISPLAY is a widget-only constant; if the
      // backend address constant ever changes, update both — there's
      // a comment on the backend constant noting this.)
      var pickupBody = ''
        + '<div class="fs-chatbot-wiz-pickup-info">'
        + '  <div class="fs-chatbot-wiz-pickup-line">'
        + '    <strong>Self-pickup at Flower Sugar</strong>'
        + '  </div>'
        + '  <div class="fs-chatbot-wiz-pickup-line">'
        +      PICKUP_ADDRESS_DISPLAY.address1
        + '  </div>'
        + '  <div class="fs-chatbot-wiz-pickup-line">'
        +      PICKUP_ADDRESS_DISPLAY.postal_code + ' '
        +      PICKUP_ADDRESS_DISPLAY.city + ', '
        +      PICKUP_ADDRESS_DISPLAY.state
        + '  </div>'
        + '</div>';
      return _section("address", "Pickup location",
                      "Self-pickup at Flower Sugar",
                      expanded, pickupBody);
    }

    // Delivery mode — standard address form.
    var a = wizardDraft.address;
    var summary = a.address_line
      ? (a.address_line.length > 28 ? a.address_line.slice(0, 28) + "…" : a.address_line)
      : "Not set";

    var errLine = _wizardFieldError("delivery_address.address_line");
    var errPc   = _wizardFieldError("delivery_address.postal_code");
    var errCity = _wizardFieldError("delivery_address.city");
    var errSt   = _wizardFieldError("delivery_address.state");

    var stateOptions = _malaysiaStateOptions(a.state);

    var body = ''
      + _addrField("address_line", "Address line", a.address_line, errLine, "text", null)
      + _addrField("postal_code", "Postal code", a.postal_code, errPc, "text", "[0-9]{5}")
      + _addrField("city", "City", a.city, errCity, "text", null)
      + '<div class="fs-chatbot-wiz-field' + (errSt ? ' fs-chatbot-wiz-field-error' : '') + '">'
      + '  <label for="fs-wiz-state">State</label>'
      + '  <select id="fs-wiz-state" data-addr-field="state">' + stateOptions + '</select>'
      + (errSt ? '<div class="fs-chatbot-wiz-field-error-msg">' + escapeHtml(errSt) + '</div>' : '')
      + '</div>';
    return _section("address", "Delivery address", summary, expanded, body);
  }

  // v2.29.5: widget-only mirror of the backend PICKUP_ADDRESS constant.
  // Kept in sync with v2/handlers/place_order_handler.py:PICKUP_ADDRESS.
  // Used purely for display in the pickup info block — the server is
  // the source of truth for the actual address stamped on the cart.
  var PICKUP_ADDRESS_DISPLAY = {
    address1:    "Pick Up, 45G, Jalan PJU 1A/41B",
    postal_code: "47301",
    city:        "Petaling Jaya",
    state:       "Selangor",
  };

  // ─────────────────────────────────────────────────────────────────────
  // Google Places address autocomplete (search-while-type on the address
  // line). Gated behind ADDR_AC_ON (data-maps-key + data-address-autocomplete).
  // Fail-soft throughout: any load/parse failure leaves the plain text
  // input fully functional — manual typing is never blocked.
  // ─────────────────────────────────────────────────────────────────────

  // Maps the Google administrative_area_level_1 name → the ISO code the
  // state <select> uses (see _malaysiaStateOptions). Keys are lower-cased,
  // punctuation-stripped names; aliases cover the federal territories'
  // long Google names ("Federal Territory of Kuala Lumpur").
  var _MY_STATE_NAME_TO_ISO = {
    "johor": "MY-JHR",
    "kedah": "MY-KDH",
    "kelantan": "MY-KTN",
    "kuala lumpur": "MY-KUL",
    "wilayah persekutuan kuala lumpur": "MY-KUL",
    "federal territory of kuala lumpur": "MY-KUL",
    "labuan": "MY-LBN",
    "wilayah persekutuan labuan": "MY-LBN",
    "federal territory of labuan": "MY-LBN",
    "melaka": "MY-MLK",
    "malacca": "MY-MLK",
    "negeri sembilan": "MY-NSN",
    "pahang": "MY-PHG",
    "penang": "MY-PNG",
    "pulau pinang": "MY-PNG",
    "perak": "MY-PRK",
    "perlis": "MY-PLS",
    "putrajaya": "MY-PJY",
    "wilayah persekutuan putrajaya": "MY-PJY",
    "federal territory of putrajaya": "MY-PJY",
    "sabah": "MY-SBH",
    "sarawak": "MY-SWK",
    "selangor": "MY-SGR",
    "terengganu": "MY-TRG"
  };

  function _normStateName(s) {
    return String(s || "")
      .toLowerCase()
      .replace(/[.,]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  // Module-level loader state so the Maps script is injected at most once.
  var _mapsLoadState = "idle";   // idle | loading | ready | failed
  var _mapsReadyCbs = [];

  function _loadGoogleMaps(cb) {
    if (!ADDR_AC_ON) return;            // feature off — never load
    if (_mapsLoadState === "ready") { try { cb(); } catch (e) {} return; }
    if (typeof cb === "function") _mapsReadyCbs.push(cb);

    // Already present (e.g. theme loaded it) — just wait for places lib.
    if (window.google && window.google.maps && window.google.maps.places) {
      _mapsLoadState = "ready";
      _flushMapsReady();
      return;
    }
    if (_mapsLoadState === "loading") return;   // a load is already in flight
    _mapsLoadState = "loading";

    try {
      var s = document.createElement("script");
      s.src = "https://maps.googleapis.com/maps/api/js?key=" +
        encodeURIComponent(MAPS_API_KEY) + "&libraries=places&loading=async";
      s.async = true;
      s.defer = true;
      s.onload = function () {
        if (window.google && window.google.maps && window.google.maps.places) {
          _mapsLoadState = "ready";
          _flushMapsReady();
        } else {
          _mapsLoadState = "failed";
        }
      };
      s.onerror = function () {
        _mapsLoadState = "failed";
        // Plain text input keeps working; nothing else to do.
        try { console.warn("[FlowerSugar] Google Maps failed to load; address autocomplete disabled."); } catch (e) {}
      };
      document.head.appendChild(s);
    } catch (e) {
      _mapsLoadState = "failed";
    }
  }

  function _flushMapsReady() {
    var cbs = _mapsReadyCbs.slice();
    _mapsReadyCbs.length = 0;
    cbs.forEach(function (fn) { try { fn(); } catch (e) {} });
  }

  // Parse a google.maps.places.PlaceResult's address_components into our
  // four fields. Returns {address_line, postal_code, city, state(ISO)}.
  function _parsePlaceComponents(place) {
    var out = { address_line: "", postal_code: "", city: "", state: "" };
    if (!place || !place.address_components) return out;

    var get = function (type) {
      for (var i = 0; i < place.address_components.length; i++) {
        var c = place.address_components[i];
        if (c.types && c.types.indexOf(type) !== -1) return c;
      }
      return null;
    };

    var streetNumber = get("street_number");
    var route = get("route");
    var premise = get("premise");
    var subpremise = get("subpremise");
    var sublocality = get("sublocality") || get("sublocality_level_1");
    var locality = get("locality");
    var postalTown = get("postal_town");
    var adminL2 = get("administrative_area_level_2");
    var adminL1 = get("administrative_area_level_1");
    var postal = get("postal_code");

    // Address line: prefer street number + route; fall back to premise /
    // sublocality / the place name so something useful always lands.
    var lineParts = [];
    if (streetNumber) lineParts.push(streetNumber.long_name);
    if (route) lineParts.push(route.long_name);
    var line = lineParts.join(" ").trim();
    if (!line) {
      var fallbacks = [];
      if (subpremise) fallbacks.push(subpremise.long_name);
      if (premise) fallbacks.push(premise.long_name);
      if (sublocality) fallbacks.push(sublocality.long_name);
      line = fallbacks.join(", ").trim();
    }
    // Last resort: the place's own name (e.g. a building) if not already
    // captured and it isn't just the city.
    if (!line && place.name && (!locality || place.name !== locality.long_name)) {
      line = place.name;
    }
    out.address_line = line;

    out.postal_code = postal ? postal.long_name : "";
    out.city = (locality && locality.long_name) ||
               (postalTown && postalTown.long_name) ||
               (adminL2 && adminL2.long_name) || "";

    if (adminL1) {
      var iso = _MY_STATE_NAME_TO_ISO[_normStateName(adminL1.long_name)] ||
                _MY_STATE_NAME_TO_ISO[_normStateName(adminL1.short_name)] || "";
      out.state = iso;
    }
    return out;
  }

  // Attach Places Autocomplete to the address-line input that exists in the
  // freshly-rendered wizard body. Called from _wireWizardBody after each
  // render. Idempotent per input (guards with a data flag).
  function _wireAddressAutocomplete($body) {
    if (!ADDR_AC_ON || !$body) return;
    var input = $body.querySelector("#fs-wiz-addr-address_line");
    if (!input) return;                       // pickup mode or no address section
    if (input.getAttribute("data-ac-wired") === "1") return;

    // Kick the loader (no-op if already loaded). The actual binding happens
    // in the ready callback so it survives the async script load.
    _loadGoogleMaps(function () {
      // The input may have been re-rendered away while loading; re-resolve
      // from the live DOM and re-check the guard.
      var live = document.getElementById("fs-wiz-addr-address_line");
      if (!live || live.getAttribute("data-ac-wired") === "1") return;
      if (!(window.google && window.google.maps && window.google.maps.places)) return;
      try {
        var ac = new google.maps.places.Autocomplete(live, {
          componentRestrictions: { country: "my" },
          fields: ["address_components", "formatted_address", "name"],
          types: ["geocode"]
        });
        live.setAttribute("data-ac-wired", "1");
        // Stop the browser's native autofill dropdown fighting the
        // Places dropdown.
        live.setAttribute("autocomplete", "off");

        ac.addListener("place_changed", function () {
          var place = ac.getPlace();
          var parsed = _parsePlaceComponents(place);
          // Only overwrite fields we actually resolved — never blank an
          // existing value with an empty parse.
          if (parsed.address_line) wizardDraft.address.address_line = parsed.address_line;
          if (parsed.postal_code) wizardDraft.address.postal_code = parsed.postal_code;
          if (parsed.city) wizardDraft.address.city = parsed.city;
          if (parsed.state) wizardDraft.address.state = parsed.state;

          // Clear stale validation errors for the fields we just filled so
          // the customer isn't shown red on freshly-populated values.
          _clearAddressErrorsFor(parsed);

          // Keep the address section open and re-render so the state
          // <select> + the text inputs reflect the chosen place.
          wizardCollapsed.address = false;
          renderWizardBody();
        });
      } catch (e) {
        // Binding failed — leave the plain input working.
        try { console.warn("[FlowerSugar] address autocomplete bind failed:", e); } catch (e2) {}
      }
    });
  }

  // Remove wizardErrors entries for fields populated by an autocomplete pick.
  function _clearAddressErrorsFor(parsed) {
    if (!wizardErrors || !wizardErrors.length) return;
    var filled = {};
    if (parsed.address_line) filled["delivery_address.address_line"] = true;
    if (parsed.postal_code) filled["delivery_address.postal_code"] = true;
    if (parsed.city) filled["delivery_address.city"] = true;
    if (parsed.state) filled["delivery_address.state"] = true;
    // Also clear the bare server-side delivery_address error if every
    // required field now has a value.
    wizardErrors = wizardErrors.filter(function (e) {
      if (!e || !e.field) return true;
      if (filled[e.field]) return false;
      return true;
    });
    var a = wizardDraft.address;
    if (a.address_line && /^[0-9]{5}$/.test(String(a.postal_code || "")) &&
        a.city && a.state) {
      wizardErrors = wizardErrors.filter(function (e) {
        return !(e && (e.field === "delivery_address" || e.field === "_form"));
      });
    }
  }

  function _addrField(name, label, value, err, type, pattern) {
    var fieldErr = err
      ? '<div class="fs-chatbot-wiz-field-error-msg">' + escapeHtml(err) + '</div>'
      : '';
    var patternAttr = pattern ? ' pattern="' + pattern + '"' : '';
    return ''
      + '<div class="fs-chatbot-wiz-field' + (err ? ' fs-chatbot-wiz-field-error' : '') + '">'
      + '  <label for="fs-wiz-addr-' + name + '">' + escapeHtml(label) + '</label>'
      + '  <input type="' + type + '" id="fs-wiz-addr-' + name + '" '
      +    'data-addr-field="' + name + '" '
      +    'value="' + escapeHtml(value || "") + '"' + patternAttr + ' />'
      + fieldErr
      + '</div>';
  }

  function _section(id, title, summary, expanded, bodyHtml) {
    var cls = expanded ? "fs-chatbot-wiz-section fs-chatbot-wiz-expanded" : "fs-chatbot-wiz-section";
    return ''
      + '<div class="' + cls + '" data-section="' + id + '">'
      + '  <button class="fs-chatbot-wiz-section-head" type="button" data-toggle="' + id + '">'
      + '    <span class="fs-chatbot-wiz-section-title">' + escapeHtml(title) + '</span>'
      + '    <span class="fs-chatbot-wiz-section-summary">' + escapeHtml(summary) + '</span>'
      + '    <svg class="fs-chatbot-wiz-section-chev" viewBox="0 0 24 24" fill="none" '
      +        'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
      + '      <path d="M6 9l6 6 6-6"/>'
      + '    </svg>'
      + '  </button>'
      + '  <div class="fs-chatbot-wiz-section-body">' + bodyHtml + '</div>'
      + '</div>';
  }

  function _malaysiaStateOptions(selected) {
    // Minimal MY state list. Matches the existing address form's
    // expectations (ISO province codes from malaysia_states).
    var states = [
      ["",        "Select state…"],
      ["MY-JHR",  "Johor"],
      ["MY-KDH",  "Kedah"],
      ["MY-KTN",  "Kelantan"],
      ["MY-KUL",  "Kuala Lumpur"],
      ["MY-LBN",  "Labuan"],
      ["MY-MLK",  "Melaka"],
      ["MY-NSN",  "Negeri Sembilan"],
      ["MY-PHG",  "Pahang"],
      ["MY-PNG",  "Penang"],
      ["MY-PRK",  "Perak"],
      ["MY-PLS",  "Perlis"],
      ["MY-PJY",  "Putrajaya"],
      ["MY-SBH",  "Sabah"],
      ["MY-SWK",  "Sarawak"],
      ["MY-SGR",  "Selangor"],
      ["MY-TRG",  "Terengganu"],
    ];
    return states.map(function (s) {
      var sel = s[0] === selected ? " selected" : "";
      return '<option value="' + s[0] + '"' + sel + '>' + escapeHtml(s[1]) + '</option>';
    }).join("");
  }

  // v2.33.10: inactivity-timer helpers.
  //
  // _wizardActivityTimerStart  — called on openWizard; arms both timers.
  // _wizardActivityTimerStop   — called on closeWizard or expiry; clears both.
  // _wizardActivityTimerReset  — called on any wizard interaction; restarts.
  // _wizardActivityWarn        — fires at 55min; shows a transient notice.
  // _wizardExpire              — fires at 60min; closes wizard + flags notice.
  function _wizardActivityTimerStop() {
    if (wizardActivityTimerId !== null) {
      clearTimeout(wizardActivityTimerId);
      wizardActivityTimerId = null;
    }
    if (wizardActivityWarnId !== null) {
      clearTimeout(wizardActivityWarnId);
      wizardActivityWarnId = null;
    }
  }

  function _wizardActivityTimerStart() {
    _wizardActivityTimerStop();
    wizardActivityWarnId  = setTimeout(_wizardActivityWarn,  WIZARD_WARN_MS);
    wizardActivityTimerId = setTimeout(_wizardExpire,        WIZARD_INACTIVITY_MS);
  }

  function _wizardActivityTimerReset() {
    if (!wizardOpen) return;
    _wizardActivityTimerStart();
  }

  function _wizardActivityWarn() {
    if (!wizardOpen) return;
    var WARN_MSG = "Your session will close in 5 minutes due to inactivity. "
                 + "Interact with the wizard to keep it open.";
    var alreadyWarned = wizardErrors.some(function (e) {
      return e.field === "_inactivity_warn";
    });
    if (!alreadyWarned) {
      wizardErrors.push({ field: "_inactivity_warn", message: WARN_MSG });
      renderWizard();
    }
  }

  function _wizardExpire() {
    if (!wizardOpen) return;
    wizardExpiredNotice = true;  // openWizard reads + clears on re-open
    closeWizard();
    // closeWizard stops the timers.
  }

  function _wizardFieldError(fieldId) {
    for (var i = 0; i < wizardErrors.length; i++) {
      if (wizardErrors[i].field === fieldId) return wizardErrors[i].message;
    }
    return null;
  }

  // v2.33.4: plural variant. Returns ALL error messages targeting
  // `fieldId`, not just the first. Used for fields where the backend
  // may emit multiple errors per submission — in particular
  // `delivery_date` (one per unavailable item on a multi-item cart).
  // Without this, a customer with two EA-too-late items would see
  // only the first one, fix the date for THAT item, resubmit, then
  // see the second — annoying multi-round trip.
  function _wizardFieldErrors(fieldId) {
    var out = [];
    for (var i = 0; i < wizardErrors.length; i++) {
      if (wizardErrors[i].field === fieldId) {
        out.push(wizardErrors[i].message);
      }
    }
    return out;
  }

  // v2.33.10: build the Page 3 pickup-time statement, or empty string
  // if the conditions aren't met (delivery mode, pickup date not
  // today/tomorrow, no cart items).
  //
  // Returns one of:
  //   ""                                                  (don't render)
  //   "All item(s) in your cart are ready made. Pick up is available from {date} onwards."
  //   "Some of all item(s) in your cart are not ready made. Pick up is available from {date} onwards."
  //
  // The "all ready made" branch fires when EVERY cart line is "fully
  // ready made" — i.e. line.quantity ≤ line.ready_made_quantity_at_add_time
  // (the live snapshot refreshed every recheck in v2.53.7+). If any
  // line's quantity exceeds the snapshotted ready-made stock, that line
  // must include at least one unit prepared from scratch, and the
  // statement switches to the "Some items are not ready made" wording.
  //
  // {date} is max() of every line's CHOSEN EPD (per-line: optimistic
  // when fully ready-made, made-to-order otherwise — see v2.53.7),
  // formatted as "10:15 AM, Friday 30 May 2026" (matches v2.33.7
  // BUSINESS STATUS).
  function _buildPickupTimeStatement() {
    if (!fullCart) return "";
    if (fullCart.fulfilment_mode !== "pickup") return "";

    var items = fullCart.items || [];
    if (items.length === 0) return "";

    // Check if pickup date is today or tomorrow in Malaysia time.
    var pickupDateIso = fullCart.delivery_date;
    if (!pickupDateIso) return "";

    // Compute today/tomorrow in Asia/Kuala_Lumpur (UTC+8). Avoid
    // relying on the customer's browser tz — they might be travelling
    // outside MY, but the shop is in MY and that's what matters.
    var nowMs = Date.now();
    var kl8h  = 8 * 3600 * 1000;
    // The MY-time date for ANY given UTC instant is just floor(utc + 8h)
    // / 86400000. This avoids the Date object's local-tz baggage.
    function _klDateString(utcMs) {
      var d = new Date(utcMs + kl8h);
      // Use UTC accessors against the shifted ms to read the MY date.
      var y = d.getUTCFullYear();
      var m = ("0" + (d.getUTCMonth() + 1)).slice(-2);
      var day = ("0" + d.getUTCDate()).slice(-2);
      return y + "-" + m + "-" + day;
    }
    var todayMy = _klDateString(nowMs);
    var tomorrowMy = _klDateString(nowMs + 86400000);
    // Pickup date arrives as ISO ("2026-05-30"). If formatted differently
    // (e.g. "May 30, 2026"), normalise to ISO first.
    var pickupDateMy = pickupDateIso;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(pickupDateIso)) {
      // Fallback parse — accept Date() best-effort.
      try {
        var parsed = new Date(pickupDateIso);
        if (!isNaN(parsed.getTime())) {
          pickupDateMy = _klDateString(parsed.getTime());
        }
      } catch (_e) { /* keep original */ }
    }
    if (pickupDateMy !== todayMy && pickupDateMy !== tomorrowMy) return "";

    // Compute max() of each line's earliest_pickup_datetime.
    // Items missing the field don't contribute (treated as "unknown").
    // If NONE of the items have the field, we skip the statement (the
    // backend hasn't propagated EPD — likely an old session).
    //
    // v2.53.7: PER-LINE EPD SELECTION. Each cart line now carries
    // two EPDs:
    //   - earliest_pickup_datetime: ready-made-optimistic (used when
    //     the line's quantity ≤ ready_made_quantity_at_add_time)
    //   - earliest_pickup_datetime_made_to_order: made-from-scratch
    //     (used when quantity > ready_made_quantity_at_add_time, i.e.
    //     at least one unit must be freshly prepared)
    // Lines are "fully ready made" only when quantity is covered by
    // ready_made_quantity_at_add_time; if any line isn't fully ready
    // made, the Page 3 statement switches to the "Some items are
    // not ready made" wording.
    //
    // Backward compat: a cart line from a pre-v2.53.7 session has
    // `ready_made_at_add_time: bool` instead of the new live int.
    // The handler scrubs the old field on the next recheck, but
    // during the migration window we tolerate both shapes — see
    // _lineIsFullyReadyMade below.
    var allEpds = [];
    var allReadyMade = true;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var lineQty = parseInt(it.quantity, 10) || 0;
      var lineRmq = parseInt(it.ready_made_quantity_at_add_time, 10);
      if (isNaN(lineRmq)) lineRmq = 0;
      var lineFullyReadyMade = (lineQty <= lineRmq && lineRmq > 0);
      // v2.53.7 backward-compat tail: if the new field isn't on the
      // line (pre-v2.53.7 sessions) AND the old bool is true, treat
      // as fully ready-made by the old semantics. This window closes
      // as soon as the customer triggers a recheck (any cart edit).
      if (!("ready_made_quantity_at_add_time" in it)
          && it.ready_made_at_add_time) {
        lineFullyReadyMade = true;
      }
      // Pick which EPD this line contributes.
      var epd;
      if (lineFullyReadyMade) {
        epd = (it.earliest_pickup_datetime || "").trim();
      } else {
        // Made-to-order baseline; fall back to optimistic if the
        // upstream hasn't provided the new field yet (defensive).
        epd = (it.earliest_pickup_datetime_made_to_order || "").trim()
            || (it.earliest_pickup_datetime || "").trim();
      }
      if (epd) allEpds.push(epd);
      if (!lineFullyReadyMade) allReadyMade = false;
    }
    if (allEpds.length === 0) return "";
    allEpds.sort();
    var latestEpdIso = allEpds[allEpds.length - 1];

    // Format the datetime as "10:15 AM, Friday 30 May 2026" in MY tz.
    var latestDisplay = _formatPickupDatetimeForDisplay(latestEpdIso);
    if (!latestDisplay) return "";

    if (allReadyMade) {
      return "All item(s) in your cart are ready made. Pick up is available from "
           + latestDisplay + " onwards. "
           + "Any customisation may result in longer preparation time.";
    } else {
      return "Some or all item(s) in your cart are not ready made. "
           + "Pick up is available from " + latestDisplay + " onwards. "
           + "Any customisation may result in longer preparation time.";
    }
  }

  // v2.33.10: format an ISO datetime string into the customer-facing
  // form "10:15 AM, Friday 30 May 2026" in Malaysia time.
  //
  // The input is an ISO string with timezone offset (e.g.
  // "2026-05-30T10:15:00+08:00"). The output displays the date/time
  // as seen by someone IN Malaysia, regardless of where the customer's
  // browser is located.
  function _formatPickupDatetimeForDisplay(isoString) {
    if (!isoString) return "";
    var d;
    try {
      d = new Date(isoString);
      if (isNaN(d.getTime())) return "";
    } catch (_e) { return ""; }

    // Convert the UTC instant to Malaysia-time field values. Trick:
    // add 8 hours to the absolute UTC time, then READ via getUTC* —
    // since getUTC* returns UTC fields, shifting the underlying ms
    // by +8h makes those UTC fields read as MY-time fields.
    var kl8h = 8 * 3600 * 1000;
    var shifted = new Date(d.getTime() + kl8h);

    var monthNames = ["January", "February", "March", "April", "May", "June",
                      "July", "August", "September", "October", "November", "December"];
    var dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday",
                    "Friday", "Saturday"];
    var hours = shifted.getUTCHours();
    var minutes = shifted.getUTCMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    var hour12 = hours % 12;
    if (hour12 === 0) hour12 = 12;
    var mm = ("0" + minutes).slice(-2);
    var weekday = dayNames[shifted.getUTCDay()];
    var day = shifted.getUTCDate();
    var month = monthNames[shifted.getUTCMonth()];
    var year = shifted.getUTCFullYear();

    return hour12 + ":" + mm + " " + ampm + ", " + weekday + " " + day + " " + month + " " + year;
  }

  // ── Wiring ──────────────────────────────────────────────────────────
  function _wireWizardBody($body) {
    // v2.29.5: fulfilment toggle (Delivery / Pickup)
    var fbtns = $body.querySelectorAll("[data-fulfilment]");
    fbtns.forEach(function (b) {
      b.addEventListener("click", function () {
        var nextMode = b.getAttribute("data-fulfilment");
        if (nextMode === wizardDraft.pending_fulfilment) return;
        wizardDraft.pending_fulfilment = nextMode;
        // v2.55.72 — auto-manage the address section visibility with the
        // mode. Delivery REQUIRES an address, so expand it the moment
        // delivery is chosen (the customer must fill it before Proceed).
        // Pickup uses the canned store address, so collapse the read-only
        // pickup-info block to keep page 1 compact.
        if (nextMode === "delivery") {
          wizardCollapsed.address = false;
        } else {
          wizardCollapsed.address = true;
        }
        // Re-render so the address section can switch between the
        // form (delivery) and the read-only pickup info block.
        renderWizardBody();
      });
    });

    // Section toggle
    var toggles = $body.querySelectorAll("[data-toggle]");
    toggles.forEach(function (t) {
      t.addEventListener("click", function () {
        var id = t.getAttribute("data-toggle");
        wizardCollapsed[id] = !wizardCollapsed[id];
        var sec = $body.querySelector('[data-section="' + id + '"]');
        if (sec) {
          if (wizardCollapsed[id]) sec.classList.remove("fs-chatbot-wiz-expanded");
          else sec.classList.add("fs-chatbot-wiz-expanded");
        }
      });
    });

    // Quantity +/-
    var qtyButtons = $body.querySelectorAll(".fs-chatbot-wiz-qty-btn");
    qtyButtons.forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.stopPropagation();
        var idx = parseInt(b.getAttribute("data-idx"), 10);
        var action = b.getAttribute("data-action");
        var line = wizardDraft.items[idx];
        if (!line) return;
        if (action === "inc") {
          line.pending_qty = (line.pending_qty || 0) + 1;
        } else if (action === "dec") {
          line.pending_qty = Math.max(0, (line.pending_qty || 0) - 1);
        }
        // Re-render to update the row's zero-state class + the
        // disable state of the − button.
        renderWizardBody();
      });
    });

    // Address fields
    var addrInputs = $body.querySelectorAll("[data-addr-field]");
    addrInputs.forEach(function (inp) {
      var field = inp.getAttribute("data-addr-field");
      inp.addEventListener("input", function () {
        wizardDraft.address[field] = inp.value;
      });
      // For <select>, also listen on change.
      if (inp.tagName === "SELECT") {
        inp.addEventListener("change", function () {
          wizardDraft.address[field] = inp.value;
        });
      }
    });

    // v2.55.78 — Google Places autocomplete on the address line (gated by
    // data-maps-key + data-address-autocomplete). No-op when disabled or in
    // pickup mode (the address-line input only exists in delivery mode).
    _wireAddressAutocomplete($body);

    // Date picker — wire jQuery UI if available, native fallback otherwise.
    var dInput = $body.querySelector("#fs-wiz-date");
    if (dInput) {
      _wireWizardDatePicker(dInput);
    }
  }

  function _wireWizardDatePicker(input) {
    // Build the union of disabled_dates across cart items, normalised
    // to slash-form which is what jQuery UI's beforeShowDay expects.
    var disabledSlash = _wizardUnionDisabledSlash();

    var $jq = window.jQuery;
    var jqUiAvailable = $jq && $jq.datepicker;

    if (jqUiAvailable) {
      // Pre-fill the input in SLASH form so jQuery UI's parser can
      // read the current value using dateFormat: "yy/mm/dd". If we
      // leave it as ISO ("2026-05-25"), jQuery UI fails to parse and
      // the picker opens with an unpredictable month — observed as
      // "no selectable dates" because the picker's internal currentDay
      // didn't match any rendered cell.
      if (wizardDraft.pending_date && /^\d{4}-\d{2}-\d{2}$/.test(wizardDraft.pending_date)) {
        input.value = wizardDraft.pending_date.replace(/-/g, "/");
      }

      // Build minDate as a JS Date object (matches the existing
      // variant+date form's _initDatepicker pattern). Passing a string
      // here in a non-default dateFormat triggered the "no selectable
      // dates" bug in v2.29.2.
      var minIso = _wizardMinDate();
      var minDate = null;
      if (minIso && /^\d{4}-\d{2}-\d{2}$/.test(minIso)) {
        var parts = minIso.split("-");
        minDate = new Date(
          Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]),
        );
      }

      // Pre-compute the floor date for beforeShowDay. We pass minDate
      // to .datepicker() AND check the floor in beforeShowDay — belt-
      // and-braces. If minDate is rejected by jQuery UI (observed when
      // a stray non-dash-format slipped through despite our regex
      // gate), beforeShowDay still greys out past dates.
      var floorIso = _wizardMinDate();   // dash form, normalised
      var floorParts = floorIso && floorIso.split("-");
      var floorTs = floorParts && floorParts.length === 3
        ? new Date(Number(floorParts[0]), Number(floorParts[1]) - 1,
                   Number(floorParts[2])).getTime()
        : null;

      try {
        // Tear down any prior instance bound to this input (the wizard
        // is re-rendered on every state change, but the input is
        // re-created from innerHTML so this is mostly defensive).
        try { $jq(input).datepicker("destroy"); } catch (_) {}

        $jq(input).datepicker({
          minDate:        minDate,
          maxDate:        "+1m",
          dateFormat:     "yy/mm/dd",     // SLASH form — matches existing widget pattern
          constrainInput: true,
          beforeShowDay:  function (x) {
            // Defence-in-depth: reject dates before the floor even if
            // jQuery UI's own minDate enforcement misbehaves.
            if (floorTs !== null && x.getTime() < floorTs) {
              return [false, ""];
            }
            var dd = String(x.getDate()).padStart(2, "0");
            var mm = String(x.getMonth() + 1).padStart(2, "0");
            var yy = x.getFullYear();
            var xSlash = yy + "/" + mm + "/" + dd;
            if (disabledSlash.indexOf(xSlash) >= 0) return [false, ""];
            return [true, ""];
          },
          beforeShow: function (inputEl) {
            // Pin the picker to the input using viewport coords — same
            // trick the variant+date form uses (see _pinDatepickerToInput
            // for the why). requestAnimationFrame to run AFTER jQuery UI
            // has placed the picker, so we overwrite its (wrong) coords.
            requestAnimationFrame(function () {
              _pinDatepickerToInput(inputEl);
            });
            return {};
          },
          onSelect: function (dateStrSlash) {
            // jQuery UI hands us the slash-form string. Convert to ISO
            // for the draft (and for endpoint submission).
            wizardDraft.pending_date = dateStrSlash.replace(/\//g, "-");
            // Re-render so the section summary updates ("25 May").
            renderWizardBody();
          },
        });
      } catch (e) {
        // jQuery UI init threw — fall back to native picker.
        console.error("[wizard] datepicker init failed:", e && e.message);
        _initWizardNativeDate(input);
        return;
      }

      // Click-to-open. `readonly` blocks the default keyboard handlers
      // but click still fires.
      var openPicker = function () { $jq(input).datepicker("show"); };
      input.addEventListener("focus", openPicker);
      input.addEventListener("click", openPicker);
    } else {
      _initWizardNativeDate(input);
    }
  }

  function _initWizardNativeDate(input) {
    // Native fallback: HTML5 <input type="date"> expects ISO format,
    // which is what wizardDraft.pending_date already stores.
    input.type = "date";
    input.removeAttribute("readonly");
    input.min = _wizardMinDate();
    if (typeof _maxOrderIso === "function") {
      input.max = _maxOrderIso();
    }
    if (wizardDraft.pending_date) {
      input.value = wizardDraft.pending_date;
    }
    input.addEventListener("change", function () {
      wizardDraft.pending_date = input.value || null;
      renderWizardBody();
    });
  }

  function _wizardUnionDisabledSlash() {
    var seen = {};
    var out = [];
    (wizardDraft.items || []).forEach(function (it) {
      (it.disabled_dates || []).forEach(function (d) {
        // The cart's disabled_dates are now dash-form (v2.29.0
        // egress normalisation). The picker wants slash form.
        var iso = (typeof _toIsoDate === "function") ? _toIsoDate(d) : d;
        if (!iso || iso.length !== 10) return;
        var slash = iso.replace(/-/g, "/");
        if (!seen[slash]) {
          seen[slash] = true;
          out.push(slash);
        }
      });
    });
    return out;
  }

  function _wizardMinDate() {
    // Floor: today, OR latest earliest_availability across items.
    //
    // v2.32.9 — robust implementation. Switched from lexicographic
    // string comparison to actual Date comparison. The old approach
    // was fragile in three subtle ways:
    //   1. A format like "2026-6-4" (no zero-padding) would silently
    //      sort BEFORE "2026-05-29" and be ignored, leaving the floor
    //      stuck at today even when the item required a future date.
    //   2. A bad value like the bare string "today" (defensive code in
    //      old branches) would compare unpredictably.
    //   3. The slash-form coercion at line 3329 was correct but only
    //      handled exact 10-char "YYYY/MM/DD". Any other delimiter
    //      pattern fell through to the floor and was silently ignored.
    //
    // The new implementation parses to a Date object, falls back to
    // skipping the value if parsing fails, and uses `.getTime()`
    // comparison. Diagnostic log emits the computed floor + each
    // contributing item so a customer report ("picker shows wrong
    // earliest") is debuggable from a single log line.
    //
    // v2.32.9 also normalises `earliest_availability` at the backend
    // egress (`_item_for_wire`), so the inputs arrive in
    // YYYY-MM-DD form from the server. The client-side coercion
    // below is belt-and-braces — if a future backend regression
    // sends slash form, the widget still copes.
    var today = _todayIso();
    var floorIso = today;
    var floorTs = _isoToTs(today);
    var contributions = [];
    (wizardDraft.items || []).forEach(function (it) {
      var ea = it.earliest_availability;
      if (!ea) return;
      // Coerce slash → dash.
      if (typeof ea === "string" && ea.indexOf("/") >= 0) {
        ea = ea.replace(/\//g, "-");
      }
      // _toIsoDate handles a wider range of input shapes than the
      // strict YYYY-MM-DD regex used pre-v2.32.9. Returns "" on
      // failure, which the !iso guard below rejects. Length check
      // softened from `!== 10` to `< 8` so non-zero-padded forms
      // (e.g. "2026-6-4") still flow through to _isoToTs, which
      // accepts \d{1,2} for month/day.
      var iso = (typeof _toIsoDate === "function") ? _toIsoDate(ea) : ea;
      if (!iso || iso.length < 8) {
        contributions.push({
          name: it.product_name || "?",
          raw:  it.earliest_availability,
          skipped: "unparseable",
        });
        return;
      }
      var ts = _isoToTs(iso);
      if (ts === null) {
        contributions.push({
          name: it.product_name || "?",
          raw:  it.earliest_availability,
          skipped: "ts-parse-failed",
        });
        return;
      }
      // Canonicalize iso from the timestamp so a non-padded input
      // ("2026-6-4") still produces a YYYY-MM-DD floor value
      // suitable for the picker's minDate regex check.
      var canonIso = _tsToIso(ts);
      contributions.push({
        name: it.product_name || "?",
        iso:  canonIso,
      });
      if (ts > floorTs) {
        floorTs = ts;
        floorIso = canonIso;
      }
    });
    // Diagnostic: log only when contributions are non-empty (most
    // page renders have items so this fires once per wizard render).
    // The contributions list is small (≤ cart length) and the values
    // are non-PII catalogue dates.
    if (contributions.length > 0) {
      // console.log("[wizard/min-date] floor=" + floorIso
      //   + " today=" + today
      //   + " contributions=" + JSON.stringify(contributions));
    }
    return floorIso;
  }

  // Parse a YYYY-MM-DD ISO date string to a midnight-local
  // timestamp. Returns null if the input doesn't parse cleanly.
  // Local-midnight (not UTC) so comparisons match the customer's
  // calendar day, which is what they're picking from the picker.
  //
  // Accepts non-zero-padded month/day too ("2026-6-4") since some
  // upstream sources don't pad. The Date constructor handles the
  // sentinel checks (year/month/day in valid ranges).
  function _isoToTs(iso) {
    if (typeof iso !== "string" || !iso) return null;
    var m = iso.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (!m) return null;
    var year  = Number(m[1]);
    var month = Number(m[2]);
    var day   = Number(m[3]);
    if (!year || !month || !day) return null;
    if (month < 1 || month > 12 || day < 1 || day > 31) return null;
    return new Date(year, month - 1, day).getTime();
  }

  // Inverse of _isoToTs: produce a zero-padded YYYY-MM-DD string
  // from a timestamp. Used by _wizardMinDate to canonicalize the
  // floor value so the picker's minDate regex passes.
  function _tsToIso(ts) {
    var d = new Date(ts);
    var y  = d.getFullYear();
    var mo = String(d.getMonth() + 1).padStart(2, "0");
    var da = String(d.getDate()).padStart(2, "0");
    return y + "-" + mo + "-" + da;
  }

  // v2.29.3: footer renderers per page.
  //
  // Page 1 (items): single Proceed button + validating-changes status.
  // Page 2 (options): Back + Confirm.
  // The footer is rebuilt on page transitions; in-page updates (busy
  // state) only mutate the existing button text/disabled, no rebuild.
  function _updateFooterForItemsPage() {
    var $footer = document.getElementById("fs-wizard-footer");
    if (!$footer) return;
    // v2.30.2: page 1 now has a Back button on the left, mirroring
    // the Back+Proceed arrangement on pages 2 and 3. "Back" from
    // page 1 has no in-wizard destination (it IS the first page),
    // so it acts as a "cancel and return to chat" affordance — the
    // same effect as the top-right Cancel button. Customers learn
    // one navigation pattern: Back steps backward, even when that
    // means exiting the modal.
    $footer.innerHTML = ''
      + '<button class="fs-chatbot-wizard-back" id="fs-wizard-back" type="button"'
      +   (wizardBusy ? " disabled" : "") + '>Back</button>'
      + '<span class="fs-chatbot-wizard-status" id="fs-wizard-status">'
      +   (wizardBusy ? "validating changes…" : "")
      + '</span>'
      + '<button class="fs-chatbot-wizard-proceed" id="fs-wizard-proceed" type="button"'
      +   (wizardBusy ? " disabled" : "") + '>'
      +   (wizardBusy ? "Validating…" : "Proceed")
      + '</button>';
    var $back = document.getElementById("fs-wizard-back");
    var $btn  = document.getElementById("fs-wizard-proceed");
    if ($back) $back.addEventListener("click", function () {
      // Page 1 has no prior wizard page — Back closes the modal
      // and returns the customer to the chat. Equivalent to the
      // top-right Cancel button. Any pending edits in wizardDraft
      // are discarded; the server-side cart is unchanged (page-1
      // commit hasn't happened yet).
      if (wizardBusy) return;
      closeWizard();
    });
    if ($btn) $btn.addEventListener("click", submitWizard);
  }

  function _updateFooterForOptionsPage() {
    var $footer = document.getElementById("fs-wizard-footer");
    if (!$footer) return;
    var canConfirm = !!wizardSelectedServiceCode && !wizardBusy;
    $footer.innerHTML = ''
      + '<button class="fs-chatbot-wizard-back" id="fs-wizard-back" type="button"'
      +   (wizardBusy ? " disabled" : "") + '>Back</button>'
      + '<span class="fs-chatbot-wizard-status" id="fs-wizard-status">'
      +   (wizardBusy ? "saving choice…" : "")
      + '</span>'
      + '<button class="fs-chatbot-wizard-proceed" id="fs-wizard-proceed" type="button"'
      +   (canConfirm ? "" : " disabled") + '>'
      +   (wizardBusy ? "Saving…" : "Confirm Delivery")
      + '</button>';
    var $back = document.getElementById("fs-wizard-back");
    var $confirm = document.getElementById("fs-wizard-proceed");
    if ($back) $back.addEventListener("click", function () {
      // Pure client-side navigation. Page-1 state lives in wizardDraft,
      // never lost. No endpoint round-trip needed.
      if (wizardBusy) return;
      wizardPage = "items";
      wizardErrors = [];
      renderWizard();
    });
    if ($confirm) $confirm.addEventListener("click", submitWizardOptions);
  }

  // v2.29.4: page-3 footer. Back + Place Order. Back returns to
  // page 1 (not page 2 — options re-confirmation happens via the
  // page-1 flow per the spec). Place Order submits the form.
  function _updateFooterForDetailsPage() {
    var $footer = document.getElementById("fs-wizard-footer");
    if (!$footer) return;
    $footer.innerHTML = ''
      + '<button class="fs-chatbot-wizard-back" id="fs-wizard-back" type="button"'
      +   (wizardBusy ? " disabled" : "") + '>Back</button>'
      + '<span class="fs-chatbot-wizard-status" id="fs-wizard-status">'
      +   (wizardBusy ? "placing order…" : "")
      + '</span>'
      + '<button class="fs-chatbot-wizard-proceed" id="fs-wizard-proceed" type="button"'
      +   (wizardBusy ? " disabled" : "") + '>'
      +   (wizardBusy ? btnLabel("placing") : btnLabel("place_order"))
      + '</button>';
    var $back = document.getElementById("fs-wizard-back");
    var $place = document.getElementById("fs-wizard-proceed");
    if ($back) $back.addEventListener("click", function () {
      // Per spec: Back from page 3 returns to page 1 (NOT page 2).
      // Options re-confirmation happens via a fresh page-1 flow if
      // needed. The customer's draft data on page 1 + page 3 is
      // preserved (wizardDraft + wizardDetailsDraft survive).
      if (wizardBusy) return;
      wizardPage = "items";
      wizardErrors = [];
      renderWizard();
    });
    if ($place) $place.addEventListener("click", submitWizardDetails);
  }

  // ── Submit ──────────────────────────────────────────────────────────
  // v2.55.72 — client-side page-1 validation. Runs BEFORE the /cart/edit
  // round-trip so the customer gets an instant, field-scoped reason when
  // something required is missing, and the wizard never advances on an
  // incomplete page 1. The server re-validates the same prerequisites
  // (active_cart._handle_page_items) as the authoritative backstop — this
  // is purely for fast, local feedback. Returns an array of {field,message}
  // (empty when valid).
  function _validateWizardPage1() {
    var errs = [];
    var draft = wizardDraft || {};

    // Does any item remain with a positive quantity?
    var anyItem = (draft.items || []).some(function (it) {
      return Number(it.pending_qty) > 0;
    });

    // v2.55.80 — clearing the cart is a VALID action, not an error.
    // If the customer has removed every item (cart will be empty after this
    // submit), there is nothing to check out: the date and address fields are
    // irrelevant, and the server treats an empty cart as a success-close
    // (status=success, next_page=null → the wizard closes and hands back to
    // chat). So when no item remains, allow the submit through with NO errors
    // instead of blocking on "add an item" / date / address. Previously the
    // "at least one item" guard fired here and the /cart/edit call was never
    // made, leaving the customer unable to empty their cart from the wizard.
    if (!anyItem) {
      return errs;   // empty cart → let submitWizard call the server, which closes
    }

    // From here on there IS at least one item, so the remaining page-1
    // fields are required.

    // A delivery / pick-up date is required.
    if (!draft.pending_date) {
      errs.push({ field: "delivery_date",
                  message: "Please choose a delivery or pick-up date to continue." });
    }

    // Delivery mode requires a complete address. Pickup uses the
    // canned store address, so it has no address fields to validate.
    if (draft.pending_fulfilment === "delivery") {
      var a = draft.address || {};
      if (!a.address_line || !String(a.address_line).trim()) {
        errs.push({ field: "delivery_address.address_line",
                    message: "Please enter the delivery address." });
      }
      if (!/^[0-9]{5}$/.test(String(a.postal_code || "").trim())) {
        errs.push({ field: "delivery_address.postal_code",
                    message: "Please enter a valid 5-digit postal code." });
      }
      if (!a.city || !String(a.city).trim()) {
        errs.push({ field: "delivery_address.city",
                    message: "Please enter the city." });
      }
      if (!a.state || !String(a.state).trim()) {
        errs.push({ field: "delivery_address.state",
                    message: "Please select the state." });
      }
    }

    return errs;
  }

  function submitWizard() {
    if (!wizardDraft || wizardBusy) return;

    // v2.55.72 — gate the advance on client-side validation. If page 1 is
    // incomplete, surface the errors in place (expanding the offending
    // sections) and DO NOT call the endpoint — the customer stays on page 1.
    var clientErrors = _validateWizardPage1();
    if (clientErrors.length > 0) {
      wizardErrors = clientErrors;
      _autoExpandSectionsWithErrors();
      renderWizardBody();
      return;
    }

    var payload = _buildWizardPayload();
    wizardBusy = true;
    wizardErrors = [];
    _updateFooterForItemsPage();

    api("/cart/edit", {
      widget_key: WIDGET_KEY,
      session_id: SESSION_ID,
      page:       "items",
      payload:    payload,
      tab_id:     TAB_ID,
    }).then(function (res) {
      wizardBusy = false;
      if (res.status !== 200 || !res.body) {
        wizardErrors = [{ field: "_form", message: "Couldn't reach the server. Please try again." }];
        renderWizardBody();
        return;
      }
      if (res.body.status === "error") {
        wizardErrors = (res.body.errors || []);
        if (wizardErrors.length === 0) {
          wizardErrors = [{ field: "_form", message: res.body.message || "Couldn't save changes." }];
        }
        // Refresh cart state from response (server may have applied
        // partial changes before validation failed).
        if (res.body.cart) {
          fullCart = res.body.cart;
          renderCartPanel();
        }
        renderWizardBody();
        return;
      }
      // Success — page-1 changes applied. Update cached cart.
      if (res.body.cart) {
        fullCart = res.body.cart;
        renderCartPanel();
        // Re-snapshot the draft so original_qty matches new state.
        // Without this, hitting Back from page 2 and then Proceed
        // again would try to re-apply the same delta.
        wizardDraft = _wizardSnapshotFromCart(fullCart);

        // v2.55.81 — propagate the edit to the Shopify storefront cart on
        // THIS tab. Previously this relied solely on the Firestore
        // onSnapshot listener (which classifies written_by_tab===TAB_ID and
        // pushes). But that listener is only connected once a token has been
        // applied — and a token is minted lazily on the first /chat send.
        // A customer who opens the cart wizard and edits an item WITHOUT
        // chatting first has no listener, so the edit never reached Shopify
        // on this tab. Pushing directly from the /cart/edit response makes
        // the wizard self-sufficient. pushToShopify diffs against Shopify's
        // adopted cart (removes → changes → adds) and has loop protection,
        // so it is safe/idempotent even when the listener IS connected and
        // also fires — the second push computes an empty diff. Guarded on
        // Shopify having adopted a cart (a storefront tab, not the agent
        // dashboard, which has no Shopify cart to push to).
        try {
          if (FS_SHOPIFY_CART &&
              FS_SHOPIFY_CART.hasAdoptedItems &&
              FS_SHOPIFY_CART.hasAdoptedItems()) {
            FS_SHOPIFY_CART.pushToShopify(
              fullCart.items || [],
              fullCart.delivery_date || fullCart.current_delivery_date || null
            );
          }
        } catch (e) {
          console.warn("[fs-widget][wizard] pushToShopify after page-1 edit " +
                       "failed (non-fatal):", e && e.message);
        }
      }

      // v2.29.3: chain into page 2 if the server signalled options
      // next. Otherwise close the modal and drop the customer into
      // chat (this happens when cart went empty, or for other edge
      // cases the server flags with next_page=null).
      if (res.body.next_page === "options") {
        wizardPage = "options";
        wizardErrors = [];
        // Pre-select the previously-chosen option if still cached.
        // The cart's delivery_option_selected may be null (page-1
        // edits invalidated it) or carry the previous code.
        wizardSelectedServiceCode =
          (fullCart.delivery_option_selected || {}).service_code || null;
        // Render the page first (shows loading state if options
        // haven't been fetched), then kick the fetch.
        renderWizard();
        submitWizardOptions({ fetchOnly: true });
        return;
      }

      // v2.29.6: pickup customers skip page 2 — server returns
      // next_page="details" directly from page 1. Chain into page 3
      // the same way the page-2 success handler does. Without this,
      // a pickup customer hitting Proceed would exit the wizard.
      if (res.body.next_page === "details") {
        wizardPage = "details";
        wizardErrors = [];
        wizardDetailsDraft = null;   // re-seed from fresh cart in renderer
        renderWizard();
        return;
      }

      // No more pages — close modal, hand back to chat.
      closeWizard();
      addBubble("bot", "Cart updated. " + _nextStepHint(res.body.next_page), {});
    }).catch(function () {
      wizardBusy = false;
      wizardErrors = [{ field: "_form", message: "Network error. Please try again." }];
      renderWizardBody();
    });
  }

  // v2.29.3: page-2 submission. Two modes:
  //   fetchOnly=true  → no service_code in payload, server fetches/returns options
  //   fetchOnly=false → service_code present, server records selection
  function submitWizardOptions(opts) {
    opts = opts || {};
    if (wizardBusy) return;
    if (!opts.fetchOnly && !wizardSelectedServiceCode) return;

    wizardBusy = true;
    wizardErrors = [];
    _updateFooterForOptionsPage();
    // Re-render the body too — page-2 shows "fetching delivery
    // options…" placeholder when options aren't loaded yet.
    if (opts.fetchOnly) renderWizardOptions();

    var payload = {};
    if (!opts.fetchOnly) {
      payload.service_code = wizardSelectedServiceCode;
    }

    api("/cart/edit", {
      widget_key: WIDGET_KEY,
      session_id: SESSION_ID,
      page:       "options",
      payload:    payload,
      tab_id:     TAB_ID,
    }).then(function (res) {
      wizardBusy = false;
      if (res.status !== 200 || !res.body) {
        wizardErrors = [{ field: "_form", message: "Couldn't reach the server. Please try again." }];
        renderWizardOptions();
        return;
      }
      if (res.body.status === "error") {
        wizardErrors = (res.body.errors || []);
        if (wizardErrors.length === 0) {
          wizardErrors = [{ field: "_form", message: res.body.message || "Couldn't load options." }];
        }
        // Cart may have come back with fresh options even though
        // the request was rejected — refresh either way.
        if (res.body.cart) {
          fullCart = res.body.cart;
          renderCartPanel();
        }
        renderWizardOptions();
        return;
      }
      // Success. Refresh cart from response.
      if (res.body.cart) {
        fullCart = res.body.cart;
        renderCartPanel();
      }
      if (opts.fetchOnly) {
        // Fetch mode — stay on page 2 and render the options list.
        renderWizardOptions();
        return;
      }
      // Selection mode — server moved cart forward. v2.29.4: if the
      // server signals page 3 next, transition the wizard instead of
      // closing. Otherwise (shouldn't normally happen), close modal.
      if (res.body.next_page === "details") {
        wizardPage = "details";
        wizardErrors = [];
        // Reset wizardDetailsDraft to null so renderWizardDetails
        // re-seeds it from the fresh cart's form_data /
        // partial_form_data.
        wizardDetailsDraft = null;
        renderWizard();
        return;
      }
      // Fallback (e.g., next_page=null) — close modal, hand to chat.
      closeWizard();
      addBubble("bot", "Delivery option saved. " + _nextStepHint(res.body.next_page), {});
    }).catch(function () {
      wizardBusy = false;
      wizardErrors = [{ field: "_form", message: "Network error. Please try again." }];
      renderWizardOptions();
    });
  }

  // v2.29.4: page-3 submission. POSTs the form draft to /cart/edit
  // page=details. On success the modal closes and a chat bubble shows
  // the order summary + WhatsApp button (same UX as the conv flow's
  // submitted-stage).
  function submitWizardDetails() {
    if (wizardBusy || !wizardDetailsDraft) return;

    // v2.31.9: balloon-wording safety-net validation. The keystroke
    // filter (in renderWizardDetails) catches typed and pasted bad
    // chars in real time. This is the belt-and-braces check: if
    // anything invalid slipped through (browser extensions inserting
    // text, IME autocorrect that fires after the input event,
    // programmatic value assignment), reject with a clear error
    // instead of sending bad data to the print queue.
    //
    // Normalises smart quotes etc before the check, so a value still
    // carrying them (rare, given the keystroke filter normalises too)
    // is treated leniently. Only TRULY out-of-set characters trip
    // this error.
    var bwRaw = wizardDetailsDraft.balloon_wording;
    if (typeof bwRaw === "string" && bwRaw) {
      var bwNormalised = _normaliseBalloonWording(bwRaw);
      if (bwNormalised !== bwRaw) {
        // Normalisation changed the value — write the clean version
        // back to the draft so the submission carries the cleaned
        // value, not the curly-quote version.
        wizardDetailsDraft.balloon_wording = bwNormalised;
      }
      if (!_isBalloonWordingValid(bwNormalised)) {
        wizardErrors = [{
          field:   "balloon_wording",
          message: "Only Roman letters, numbers, and common punctuation are supported on balloons.",
        }];
        renderWizardDetails();
        return;
      }
    }

    wizardBusy = true;
    wizardErrors = [];
    _updateFooterForDetailsPage();

    // v2.32.0 diagnostic: log what the widget is POSTing to
    // /cart/edit page=details. Lets us correlate browser-side data
    // with the backend's [cart_edit/details] entry log. Look at
    // wizardDetailsDraft to see what the customer filled in; look
    // at fullCart (logged on cart_sync) to see the cart state at
    // submit time.
    // console.log("[fs-widget][submit/details] POSTing /cart/edit page=details",
    //             "draft_keys=", Object.keys(wizardDetailsDraft || {}),
    //             "draft=", wizardDetailsDraft,
    //             "cart.items=", (fullCart || {}).items,
    //             "cart.stage=", (fullCart || {}).stage,
    //             "cart.delivery_date=", (fullCart || {}).delivery_date,
    //             "cart.delivery_option_selected=",
    //               (fullCart || {}).delivery_option_selected);

    // v2.55.177 — defer live onSnapshot events while this submit POST is in
    // flight, so the backend-persisted confirmation (written during the POST)
    // can be deduped against the id the response returns, instead of
    // double-rendering. Balanced by endInFlight() in .finally below.
    FS_FIRESTORE.beginInFlight();
    api("/cart/edit", {
      widget_key: WIDGET_KEY,
      session_id: SESSION_ID,
      page:       "details",
      payload:    wizardDetailsDraft,
      tab_id:     TAB_ID,
    }).then(function (res) {
      wizardBusy = false;
      // v2.32.0 diagnostic: log the full response. The customer
      // sees a friendly error in the form, but we need the full
      // server payload to diagnose. Distinguishes success-with-cart
      // from error-with-errors-list from network-or-server-failure.
      // console.log("[fs-widget][submit/details] response",
      //             "status=", res.status,
      //             "body.status=", res.body && res.body.status,
      //             "body.next_page=", res.body && res.body.next_page,
      //             "body.errors=", res.body && res.body.errors,
      //             "body.draft_order_number=",
      //               res.body && res.body.draft_order_number,
      //             "body=", res.body);

      if (res.status !== 200 || !res.body) {
        wizardErrors = [{ field: "_form", message: "Couldn't reach the server. Please try again." }];
        renderWizardDetails();
        return;
      }
      if (res.body.status === "error") {
        wizardErrors = (res.body.errors || []);
        if (wizardErrors.length === 0) {
          wizardErrors = [{ field: "_form", message: res.body.message || "Couldn't place the order." }];
        }
        if (res.body.cart) {
          fullCart = res.body.cart;
          renderCartPanel();
        }
        renderWizardDetails();
        return;
      }
      // v2.32.0: Success — Shopify draft order created. The cart
      // arrives cleared (items: []) which will auto-hide the cart
      // bar; buyer/recipient/address fields are preserved on the
      // cart for the next order's pre-fill.
      if (res.body.cart) {
        fullCart = res.body.cart;
        renderCartPanel();
      }
      // v2.55.177 — register the persisted confirmation's id (returned by the
      // backend) so the live listener's deferred event for it is suppressed on
      // flush, instead of double-rendering the bubble we addBubble below.
      FS_FIRESTORE.registerSeenId(res.body.assistant_message_id);
      var summary           = res.body.summary || "";
      var waUrl             = res.body.whatsapp_url || "";
      var paymentLink       = res.body.payment_link || "";
      // v2.55.177 — strip any leading '#'; the draft name already carries one
      // and the composition below prepends '#', which produced "##D9130".
      var draftOrderNumber  = String(res.body.draft_order_number || "").replace(/^#+/, "");
      var bankDetails       = res.body.bank_details || null;
      var expiryNote        = res.body.payment_expiry_note || "";

      closeWizard();

      // Build the bubble text. Backend sends `summary` (the existing
      // order summary block); widget builds the customer-facing
      // framing around it. The bank details and the expiry hint are
      // separate fields so the widget can render the tap-to-copy
      // affordance and the muted hint with their own styling.
      var bubbleText = "Order #" + draftOrderNumber + " created successfully!\n\n"
                     + summary
                     + "\n\n💳 Payment options\n\n"
                     + "Tap \"Pay Online\" below to pay via the secure payment link.";

      if (bankDetails) {
        bubbleText += "\n\nOr pay via bank transfer:";
      }

      // Two-button row. The bank-details block + expiry note are
      // rendered as opts so the widget knows to apply special UI to
      // them (tap-to-copy + muted text respectively).
      var bubbleButtons = [];
      if (paymentLink) {
        bubbleButtons.push({ label: "Pay Online", url: paymentLink });
      }
      if (waUrl) {
        bubbleButtons.push({ label: "WhatsApp Slip", url: waUrl });
      }

      // v2.55.177 — defense-in-depth: if the deferred-flush already rendered
      // the persisted confirmation node, don't addBubble a duplicate.
      var _wizAssistantId = res.body.assistant_message_id;
      if (_wizAssistantId && FS_FIRESTORE.hasRenderedNode(_wizAssistantId)) {
        // listener already rendered this confirmation; skip our addBubble.
      } else {
        addBubble("bot", bubbleText, {
          buttons:              bubbleButtons,
          bank_details:         bankDetails,
          payment_expiry_note:  expiryNote,
          // The bank-transfer footnote text lives in bank_details.note;
          // the closing "share slip via WhatsApp" copy is added inline
          // by the widget so it can reference the draft order number
          // dynamically without requiring a backend round-trip just
          // for text composition.
          draft_order_number:   draftOrderNumber,
        });
      }
    }).catch(function () {
      wizardBusy = false;
      wizardErrors = [{ field: "_form", message: "Network error. Please try again." }];
      renderWizardDetails();
    }).finally(function () {
      FS_FIRESTORE.endInFlight();   // v2.55.177 — balance beginInFlight above
    });
  }

  function _nextStepHint(nextPage) {
    if (nextPage === "options") return "I'll show you delivery options next.";
    if (nextPage === "details") return "Just need a few more details to finish.";
    return "What else can I help with?";
  }

  function _buildWizardPayload() {
    var p = {};

    // Items: send only lines whose qty changed (including 0 → remove)
    var changedItems = [];
    (wizardDraft.items || []).forEach(function (it) {
      if (it.pending_qty !== it.original_qty) {
        changedItems.push({
          product_id: it.product_id,
          variant_id: it.variant_id,
          quantity:   it.pending_qty,
        });
      }
    });
    if (changedItems.length > 0) {
      p.items = changedItems;
    }

    // Date: send only if changed
    if (wizardDraft.pending_date !== wizardDraft.original_date) {
      p.delivery_date = wizardDraft.pending_date;
    }

    // v2.29.5: fulfilment_mode. Always send if it changed from the
    // original (the server's _set_fulfilment_mode is no-op on unchanged
    // values, but the explicit signal lets the server distinguish
    // "customer kept the same mode" from "customer never specified").
    if (wizardDraft.pending_fulfilment !== wizardDraft.original_fulfilment) {
      p.fulfilment_mode = wizardDraft.pending_fulfilment;
    }

    // Address: only sent when customer is in delivery mode. Pickup
    // mode uses the server's canned address — any address in the
    // payload would be ignored anyway, but sending it would be
    // confusing in the access logs.
    if (wizardDraft.pending_fulfilment === "delivery") {
      var a = wizardDraft.address;
      if (a.address_line || a.postal_code || a.city || a.state) {
        p.delivery_address = {
          address_line: a.address_line,
          postal_code:  a.postal_code,
          city:         a.city,
          state:        a.state,
        };
      }
    }

    return p;
  }

  // ---------------------------------------------------------------------
  // Page context — what page the customer is on, sent with every message.
  //
  // PRIMARY SOURCE: a stable JSON block the Shopify theme emits before
  // </body> on every page:
  //
  //     <script type="application/json" id="fs-page-context">
  //       { "schema": "fs-page-context/1", "page_type": "...",
  //         "product": {...}, "collection": {...} }
  //     </script>
  //
  // Reading this block avoids scraping fragile theme markup. When the block
  // is absent (older theme pages, non-Shopify, snippet not yet installed)
  // we fall back to the legacy URL-regex detection so nothing regresses.
  //
  // LIVE VARIANT — important: the theme's Liquid `product.selected_variant`
  // only reflects the variant at PAGE LOAD, and only when ?variant= is in
  // the URL. The customer switches variant client-side via colour radios
  // (input[name="Colour"], each carrying data-variant-id, exactly one
  // `checked`) with no page reload. So for the variant the customer is
  // ACTUALLY looking at right now we must read the DOM, and only fall back
  // to selected_variant when no radio is present/checked.
  //
  // SHAPE: the returned object keeps the legacy flat keys
  // (category / product_name / product_id / collection_name) so anything
  // downstream that already reads message meta keeps working, and ADDS the
  // richer structured fields (schema / page_type / product / collection /
  // live_variant_id) from the hook.
  //
  // NOTE: cart state (/cart.js) is intentionally NOT collected here — that
  // is deferred to a later task. page_context covers page / product /
  // collection only.
  // ---------------------------------------------------------------------

  // Read + parse the <script id="fs-page-context"> JSON block. Returns the
  // parsed object on success, or null if the block is absent / unparseable
  // / not the schema we understand.
  function readPageContextHook() {
    var el = document.getElementById("fs-page-context");
    if (!el) return null;
    var raw = el.textContent || el.innerText || "";
    if (!raw.trim()) return null;
    var parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      return null;
    }
    if (!parsed || typeof parsed !== "object") return null;
    // Accept the 1.x schema family; ignore anything we don't recognise so a
    // future incompatible schema can't feed the widget garbage.
    var schema = String(parsed.schema || "");
    if (schema.indexOf("fs-page-context/1") !== 0) return null;
    return parsed;
  }

  // The variant the customer is looking at RIGHT NOW. The colour radios
  // re-render the product image/price client-side without a reload, so the
  // checked radio is the source of truth; selected_variant (from Liquid) is
  // only correct at page load. Returns a variant-id string, or null.
  function getLiveVariantId(hookProduct) {
    // 1. DOM — the radio the customer has actually selected.
    var radios = document.querySelectorAll('input[name="Colour"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) {
        var vid = radios[i].getAttribute("data-variant-id");
        if (vid) return String(vid);
      }
    }
    // 2. Fall back to the page-load variant from the hook.
    if (
      hookProduct &&
      hookProduct.selected_variant &&
      hookProduct.selected_variant.id != null
    ) {
      return String(hookProduct.selected_variant.id);
    }
    return null;
  }

  // Legacy detection — URL regex. Used only when the hook block is absent.
  function getPageContextFromUrl() {
    var path = location.pathname;

    var productMatch = path.match(/\/products\/([^\/\?#]+)/);
    if (productMatch) {
      var pid = (
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product &&
        window.ShopifyAnalytics.meta.product.id
      ) || null;
      return {
        category: "product",
        product_name: productMatch[1],
        product_id: pid,
      };
    }

    var colMatch = path.match(/\/collections\/([^\/\?#]+)/);
    if (colMatch) {
      return {
        category: "collection",
        collection_name: colMatch[1],
      };
    }

    if (path === "/" || path === "") {
      return { category: "home" };
    }

    return { category: "other" };
  }

  // Build the page_context object sent on every /chat and /chat/form_submit.
  // hook present  → structured context, hook absent → legacy URL context;
  // either way the legacy flat keys are populated for backward compat.
  function getPageContext() {
    var hook = readPageContextHook();
    var ctx;

    if (!hook) {
      // No hook — legacy URL-regex behaviour.
      ctx = getPageContextFromUrl();
      ctx.context_source = "url";
      return ctx;
    }

    var pageType = hook.page_type || "other";
    // Map Shopify page_type onto the legacy `category` vocabulary so
    // downstream meta readers see a familiar value.
    var categoryMap = {
      product: "product",
      collection: "collection",
      index: "home",
      home: "home",
    };

    ctx = {
      context_source: "hook",
      schema: hook.schema,
      page_type: pageType,
      category: categoryMap[pageType] || "other",
    };

    if (hook.product) {
      var liveVariantId = getLiveVariantId(hook.product);
      ctx.product = {
        id: hook.product.id != null ? String(hook.product.id) : null,
        title: hook.product.title || null,
        handle: hook.product.handle || null,
        variants: hook.product.variants || null,
        // The variant at page load (from Liquid). Kept for reference.
        selected_variant: hook.product.selected_variant || null,
        // The variant the customer is looking at NOW (DOM-derived).
        live_variant_id: liveVariantId,
      };
      // Legacy flat keys — title preferred, handle as a fallback.
      ctx.product_name =
        hook.product.title || hook.product.handle || null;
      ctx.product_id =
        hook.product.id != null ? String(hook.product.id) : null;
      ctx.live_variant_id = liveVariantId;
    }

    if (hook.collection) {
      ctx.collection = {
        id: hook.collection.id != null ? String(hook.collection.id) : null,
        title: hook.collection.title || null,
        handle: hook.collection.handle || null,
      };
      ctx.collection_name =
        hook.collection.title || hook.collection.handle || null;
    }

    return ctx;
  }

  // ---------------------------------------------------------------------
  // v2.55.50 — ad-click attribution capture (Google Ads + Meta).
  //
  // Widget customers place orders via the bot and pay by WhatsApp slip, so
  // they never reach Shopify's checkout/thank-you page where the standard
  // Purchase pixel fires. To attribute those conversions later (a server-
  // side click-conversion upload to Google Ads / Meta CAPI at payment
  // confirmation, and/or a client-side event at order placement), we must
  // capture the ad-click identifiers NOW and persist them on the session.
  //
  // What we capture:
  //   gclid / gbraid / wbraid — Google Ads click ids (URL params on the
  //       landing page; also mirrored in the _gcl_aw cookie when gtag is
  //       installed).
  //   fbclid                  — Meta click id (URL param on landing).
  //   _fbp                    — Meta browser id cookie (set by the Pixel).
  //   _fbc                    — Meta click cookie (set by the Pixel from
  //       fbclid). When the Pixel ISN'T installed, we synthesize _fbc from
  //       fbclid in Meta's required format: "fb.1.<ms>.<fbclid>".
  //
  // Why persist locally: gclid/fbclid live only on the LANDING url. By the
  // time the customer engages the bot (possibly several pages later) the
  // param is gone. We store first-touch values in localStorage and reread
  // them thereafter, refreshing only when a NEW click id arrives (the
  // customer clicked a fresh ad). The captured timestamp is kept so the
  // server can build a valid _fbc and respect attribution windows.
  // ---------------------------------------------------------------------
  var _ATTRIB_KEY = "fs_attribution_" + SESSION_ID;
  var _attributionCache = null;

  function _readStoredAttribution() {
    try {
      var raw = localStorage.getItem(_ATTRIB_KEY);
      if (!raw) return {};
      var p = JSON.parse(raw);
      return (p && typeof p === "object") ? p : {};
    } catch (_) { return {}; }
  }

  function _persistAttribution(obj) {
    try { localStorage.setItem(_ATTRIB_KEY, JSON.stringify(obj)); } catch (_) {}
  }

  // Capture once per page load, merge with stored first-touch values.
  function captureAttribution() {
    var stored = _readStoredAttribution();
    var params;
    try { params = new URLSearchParams(location.search); }
    catch (_) { params = { get: function () { return null; } }; }

    var now = Date.now();
    var out = {};
    // Carry forward everything already stored (first-touch sticky).
    for (var k in stored) { if (stored.hasOwnProperty(k)) out[k] = stored[k]; }

    // URL click ids — last-touch refresh: a freshly-present param wins
    // (the customer just clicked a new ad), else keep the stored value.
    var urlGclid  = params.get("gclid");
    var urlGbraid = params.get("gbraid");
    var urlWbraid = params.get("wbraid");
    var urlFbclid = params.get("fbclid");
    if (urlGclid)  { out.gclid = urlGclid;   out.gclid_at = now; }
    if (urlGbraid) { out.gbraid = urlGbraid; }
    if (urlWbraid) { out.wbraid = urlWbraid; }
    if (urlFbclid) { out.fbclid = urlFbclid; out.fbclid_at = now; }

    // Google's gtag cookie (present when gtag.js is installed). Useful as
    // a fallback when the gclid param wasn't on this particular page.
    var gclAw = getCookie("_gcl_aw");
    if (gclAw) out.gcl_aw = gclAw;

    // Meta cookies set by the Pixel (if installed).
    var fbp = getCookie("_fbp");
    var fbc = getCookie("_fbc");
    if (fbp) out.fbp = fbp;
    if (fbc) {
      out.fbc = fbc;                       // Pixel-set, authoritative
    } else if (out.fbclid && !out.fbc) {
      // No Pixel cookie — synthesize _fbc from fbclid in Meta's format so
      // a server-side CAPI call has a valid click id. Use the capture time.
      out.fbc = "fb.1." + (out.fbclid_at || now) + "." + out.fbclid;
      out.fbc_synthesized = true;
    }

    out.landing_url = out.landing_url || location.href;
    out.captured_at = out.captured_at || new Date(now).toISOString();

    // Only persist if we actually hold any signal (avoid writing an empty
    // shell on a pure organic visit with no prior attribution).
    var hasSignal = !!(out.gclid || out.gbraid || out.wbraid || out.fbclid ||
                       out.gcl_aw || out.fbp || out.fbc);
    if (hasSignal) _persistAttribution(out);
    _attributionCache = out;
    return out;
  }

  // Return the attribution block to attach to requests. Null when there's
  // nothing to report (keeps payloads clean for organic visitors).
  function getAttribution() {
    var a = _attributionCache || _readStoredAttribution();
    if (!a || !Object.keys(a).length) return null;
    return a;
  }

  // ---------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------
  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, function (c) {
      return ({
        "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
      })[c];
    });
  }

  function linkify(text) {
    var safe = escapeHtml(text);
    var urlRe = /(https?:\/\/[^\s<]+[^\s<.,!?;:'"\)])/g;
    return safe.replace(urlRe, function (url) {
      return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + "</a>";
    });
  }

  // Format a Date as the customer-facing per-message timestamp.
  // Pattern is contextual — same as WhatsApp/iMessage:
  //   - same calendar day as now   → "HH:MM"
  //   - within the last week       → "Mon HH:MM"   (short day name)
  //   - older                      → "DD/MM/YYYY HH:MM"
  // 24-hour clock everywhere; Malaysian customers default to it and
  // it keeps the string short under the narrow mobile bubble width.
  //
  // Day-name and date use the customer's local timezone. The same-day
  // check compares calendar-day integers (Y/M/D) directly so we don't
  // get tripped by partial days at midnight UTC.
  var _SHORT_DAY = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  function _formatMessageTimestamp(d) {
    d = d || new Date();
    var hh = String(d.getHours()).padStart(2, "0");
    var mm = String(d.getMinutes()).padStart(2, "0");
    var time = hh + ":" + mm;

    var now = new Date();
    var sameDay = d.getFullYear() === now.getFullYear()
               && d.getMonth()    === now.getMonth()
               && d.getDate()     === now.getDate();
    if (sameDay) return time;

    // Distance in calendar days. Use midnight of each date so DST
    // shifts and partial-hour offsets don't drift the count.
    var midA = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    var midB = new Date(d.getFullYear(),   d.getMonth(),   d.getDate()).getTime();
    var dayDiff = Math.round((midA - midB) / 86400000);

    if (dayDiff >= 1 && dayDiff < 7) {
      return _SHORT_DAY[d.getDay()] + " " + time;
    }

    // Older than a week, or in the future (unusual but defensive)
    var dd = String(d.getDate()).padStart(2, "0");
    var mo = String(d.getMonth() + 1).padStart(2, "0");
    var yy = d.getFullYear();
    return dd + "/" + mo + "/" + yy + " " + time;
  }

  function _appendTimestampTo(wrap, isoOverride) {
    // Attach a per-message timestamp under a bubble wrapper. Used by
    // addBubble for every persisted message. NOT used for the typing
    // indicator (transient) or the welcome card (one-off).
    //
    // `isoOverride` lets loadHistory pass the message's original
    // server timestamp (ISO from session_store) so historical
    // messages show when they were SENT, not when the page reloaded.
    // Live (non-history) bubbles pass nothing and get "now".
    var d = null;
    if (isoOverride) {
      var parsed = new Date(isoOverride);
      if (!isNaN(parsed.getTime())) d = parsed;
    }
    var ts = document.createElement("div");
    ts.className = "fs-chatbot-msg-ts";
    ts.textContent = _formatMessageTimestamp(d);
    wrap.appendChild(ts);
  }

  function scrollToBottom(force) {
    // `force` = true means "always snap to bottom" (used for explicit
    // user-triggered scrolls and the initial open of the panel). When
    // false/undefined, only auto-scroll if the customer is ALREADY at
    // (or near) the bottom — otherwise they've scrolled up intentionally
    // to read history and a snap-down would be disruptive. The
    // scroll-to-bottom button gives them a one-click way to catch up.
    var wantSnap = !!force || _isAtBottom();
    requestAnimationFrame(function () {
      if (wantSnap) {
        $messages.scrollTop = $messages.scrollHeight;
      }
      // Programmatic scrollTop assignment doesn't fire a scroll event
      // synchronously across all browsers — reconcile the button's
      // visibility explicitly so it hides as expected after a new
      // bubble auto-scrolls the conversation. When the customer was
      // scrolled-up and we didn't snap, the button stays visible to
      // signal that new content appeared below.
      if ($scrollBottom) _updateScrollBottomVisibility();
    });
  }

  function addBubble(role, text, opts) {
    opts = opts || {};
    var wrap = document.createElement("div");
    wrap.className = "fs-chatbot-msg fs-chatbot-" + role;

    if (text) {
      var b = document.createElement("div");
      b.className = "fs-chatbot-bubble";
      b.innerHTML = linkify(text);
      wrap.appendChild(b);
    }

    if (opts.products && opts.products.length) {
      var grid = document.createElement("div");
      grid.className = "fs-chatbot-products";
      // v2.31.8 diagnostic: log every card's variants with their
      // balloon/card flags AT RENDER TIME. This is the variant data
      // the widget will pass to openVariantDateForm when the customer
      // clicks Place Order. If a variant's has_balloon_wording is
      // undefined HERE, the loss is upstream (backend [response/balloon]
      // log will show the same). If it's true here but undefined at
      // [balloon/vdf] click time, something in between is stripping
      // it (unlikely; nothing currently does).
      // console.log("[fs-widget][balloon/cards_rendered] count=",
                  // opts.products.length, "cards=",
                  // opts.products.map(function (p) {
                    // return {
                      // product_id: p.id,
                      // title: p.title,
                      // variants: (p.variants || []).map(function (vv) {
                        // return {
                          // variant_id:          vv.variant_id,
                          // variant_name:        vv.variant_name,
                          // has_card:            vv.has_card,
                          // has_balloon_wording: vv.has_balloon_wording,
                        // };
                      // }),
                    // };
                  // }));
      opts.products.forEach(function (p) {
        // ── Card structure ──────────────────────────────────────────
        // <div class="fs-chatbot-product">                       ← outer (no anchor)
        //   <a class="fs-chatbot-product-link" href=p.url ...>   ← image + body
        //     <img>
        //     <div class="fs-chatbot-product-body">
        //       <div class="fs-chatbot-product-title">…
        //       <div class="fs-chatbot-product-price">…
        //   </a>
        //   <button class="fs-chatbot-product-cta-btn">Place Order</button>
        //
        // Card body click → opens product URL in a new tab (the link
        // wraps image + body). The "Place Order" button is OUTSIDE the
        // link, so its click does NOT navigate — it opens the inline
        // Variant + Date form, pure-frontend.
        var card = document.createElement("div");
        card.className = "fs-chatbot-product";

        var link = document.createElement("a");
        link.className = "fs-chatbot-product-link";
        link.href = p.url || "#";
        link.target = "_blank";
        link.rel = "noopener noreferrer";

        var img = document.createElement("img");
        img.className = "fs-chatbot-product-img";
        img.alt = p.title || "Bouquet";
        img.loading = "lazy";
        img.src = p.image || "";
        link.appendChild(img);

        var body = document.createElement("div");
        body.className = "fs-chatbot-product-body";
        body.innerHTML =
          '<div class="fs-chatbot-product-title">' + escapeHtml(p.title || "") + '</div>' +
          '<div class="fs-chatbot-product-price">' + escapeHtml(p.price || "") + '</div>';
        link.appendChild(body);

        card.appendChild(link);

        // Place Order button — opens the variant + date form.
        //
        // Three gate conditions, in priority order:
        //
        //   1. No variants array (older backend / a search result that
        //      didn't go through fuzzy_search) → "Place Order" disabled
        //      with the legacy tooltip pointing at the product page.
        //
        //   2. v2.32.5: ALL variants sold out (inventory <= 0 for every
        //      variant) → button text becomes "Sold out", disabled, with
        //      a tooltip explaining the state. The card itself still
        //      renders normally — price, image, link to product page all
        //      work — so the customer can still browse / wishlist /
        //      navigate to the live storefront. Only the in-chat
        //      ordering path is gated.
        //
        //   3. Mixed inventory (some sold out, some in stock) → button
        //      stays "Place Order" enabled. The variant picker
        //      (openVariantDateForm) handles per-variant gating
        //      separately, so a customer who picks a sold-out variant
        //      there sees the Add to order button disable inline.
        //
        // Inventory check uses `> 0` not `!= 0` because some upstream
        // responses may return negative inventory (overselling indicator
        // on Shopify); treat anything not strictly positive as out.
        var hasVariants = Array.isArray(p.variants) && p.variants.length > 0;
        var allSoldOut = hasVariants && p.variants.every(function (v) {
          // null/undefined inventory is treated as IN STOCK (legacy
          // safety — older backend responses may not carry the field,
          // and we don't want to mark every card sold out by mistake).
          var inv = v && v.inventory;
          if (inv === undefined || inv === null) return false;
          return Number(inv) <= 0;
        });
        var cta = document.createElement("button");
        cta.type = "button";
        cta.className = "fs-chatbot-product-cta-btn"
                      + (hasVariants && !allSoldOut ? "" : " fs-chatbot-disabled");
        if (!hasVariants) {
          // v2.55.71 — a card with no variants can't drive the in-chat
          // Variant + Date picker. Previously we rendered a DISABLED "Place
          // Order" button (greyed, tooltip only) — a dead end the customer
          // couldn't act on. Now, if we have a product URL, turn the CTA into
          // an actionable link that opens the product page in a new tab so
          // the customer can still order. Only fall back to a disabled button
          // when there's genuinely nowhere to send them.
          if (p.url) {
            cta.textContent = "View on product page";
            cta.className = "fs-chatbot-product-cta-btn";  // not disabled
            cta.title = "Open the product page to choose options and order.";
            cta.addEventListener("click", function () {
              window.open(p.url, "_blank", "noopener");
            });
          } else {
            cta.textContent = btnLabel("place_order");
            cta.disabled = true;
            cta.title = "Variant data unavailable — please contact us to order.";
          }
        } else if (allSoldOut) {
          // v2.32.5: clearer at-a-glance than a tooltip alone. The
          // customer should immediately see WHY the button is dead.
          cta.textContent = "Sold out";
          cta.disabled = true;
          cta.title = "Sold out — all variants currently unavailable.";
        } else {
          cta.textContent = btnLabel("place_order");
          cta.addEventListener("click", function () {
            openVariantDateForm(p, card);
          });
        }
        card.appendChild(cta);

        grid.appendChild(card);
      });
      wrap.appendChild(grid);
    }

    // v2.55.93 — PHOTO-DISPLAY CHANNEL. reply.photos is a list of
    // {image, title, url}. Unlike product cards (one card → one image, with a
    // Place Order button), this renders EVERY supplied photo as an image+title
    // tile — so "photo of Luxe Red 6 stalks" shows all matching variant photos.
    // The bot decides what to show; the widget just renders. Generic by design:
    // future non-product photos use the same field.
    if (opts.photos && opts.photos.length) {
      var pgrid = document.createElement("div");
      pgrid.className = "fs-chatbot-photos";
      opts.photos.forEach(function (ph) {
        if (!ph || !ph.image) { return; }
        // A tile is a link when a url is provided (tap → product page),
        // otherwise a plain div (e.g. a future non-product photo).
        var tile = document.createElement(ph.url ? "a" : "div");
        tile.className = "fs-chatbot-photo";
        if (ph.url) {
          tile.href = ph.url;
          tile.target = "_blank";
          tile.rel = "noopener noreferrer";
        }
        var pimg = document.createElement("img");
        pimg.className = "fs-chatbot-photo-img";
        pimg.alt = ph.title || "Photo";
        pimg.loading = "lazy";
        pimg.src = ph.image;
        // Hide the tile entirely if the image fails to load, rather than
        // showing a broken-image icon with a caption underneath.
        pimg.addEventListener("error", function () {
          tile.style.display = "none";
        });
        tile.appendChild(pimg);
        if (ph.title) {
          var ptitle = document.createElement("div");
          ptitle.className = "fs-chatbot-photo-title";
          ptitle.textContent = ph.title;
          tile.appendChild(ptitle);
        }
        pgrid.appendChild(tile);
      });
      wrap.appendChild(pgrid);
    }

    // v2.32.0: bank-transfer details block. Rendered as a structured
    // panel BEFORE the buttons so the customer sees both payment
    // options simultaneously: bank transfer info above, "Pay Online"
    // button below. Only the account number row is tap-to-copy (the
    // bank name and account name are plain text — the customer rarely
    // needs to copy those into a payment app).
    //
    // History replay: opts.bank_details is saved as meta.bank_details
    // server-side and re-passed on history load, so this block
    // re-renders identically when the customer scrolls back.
    if (opts.bank_details) {
      var bd = opts.bank_details;
      var bdBlock = document.createElement("div");
      bdBlock.className = "fs-chatbot-bank-details";

      // Bank name row (plain text)
      var bdRow1 = document.createElement("div");
      bdRow1.className = "fs-chatbot-bank-row";
      bdRow1.innerHTML = '<span class="fs-chatbot-bank-label">Bank:</span> '
                       + '<span>' + escapeHtml(bd.bank_name || "") + '</span>';
      bdBlock.appendChild(bdRow1);

      // Account name row (plain text)
      var bdRow2 = document.createElement("div");
      bdRow2.className = "fs-chatbot-bank-row";
      bdRow2.innerHTML = '<span class="fs-chatbot-bank-label">Name:</span> '
                       + '<span>' + escapeHtml(bd.account_name || "") + '</span>';
      bdBlock.appendChild(bdRow2);

      // Account number row — tap to copy. Same UX as the session-ref
      // pattern under WhatsApp buttons elsewhere in the widget.
      var bdRow3 = document.createElement("div");
      bdRow3.className = "fs-chatbot-bank-row fs-chatbot-bank-account-row";
      bdRow3.innerHTML = '<span class="fs-chatbot-bank-label">Account:</span> '
                       + '<span class="fs-chatbot-bank-account">'
                       +   escapeHtml(bd.account_number || "")
                       + '</span>'
                       + '<span class="fs-chatbot-bank-copy-hint">tap to copy</span>';
      bdRow3.style.cursor = "pointer";
      bdRow3.addEventListener("click", function () {
        var accountNum = bd.account_number || "";
        if (!accountNum) return;
        navigator.clipboard.writeText(accountNum).then(function () {
          bdRow3.classList.add("fs-chatbot-bank-copied");
          var hint = bdRow3.querySelector(".fs-chatbot-bank-copy-hint");
          if (hint) hint.textContent = "copied!";
          setTimeout(function () {
            bdRow3.classList.remove("fs-chatbot-bank-copied");
            if (hint) hint.textContent = "tap to copy";
          }, 2500);
        }).catch(function () {
          // Clipboard API blocked — select the account number so the
          // customer can copy with their keyboard. Same fallback as
          // the session-ref pattern.
          var range = document.createRange();
          range.selectNode(bdRow3.querySelector(".fs-chatbot-bank-account"));
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(range);
        });
      });
      bdBlock.appendChild(bdRow3);

      // Bank-transfer footnote (e.g. "Please use Instant Transfer or
      // DuitNow only."). Server controls the text via the
      // BANK_PAYMENT_NOTE env var.
      if (bd.note) {
        var bdNote = document.createElement("div");
        bdNote.className = "fs-chatbot-bank-note";
        bdNote.textContent = bd.note;
        bdBlock.appendChild(bdNote);
      }

      // Slip-sharing instruction (specific to this order, references
      // the draft order number).
      if (opts.draft_order_number) {
        var bdSlip = document.createElement("div");
        bdSlip.className = "fs-chatbot-bank-slip-note";
        bdSlip.textContent =
          "After bank transfer, please share the payment slip via "
          + "WhatsApp and mention order #" + String(opts.draft_order_number).replace(/^#+/, "") + ".";
        bdBlock.appendChild(bdSlip);
      }

      wrap.appendChild(bdBlock);
    }

    if (opts.buttons && opts.buttons.length) {
      var btnRow = document.createElement("div");
      btnRow.className = "fs-chatbot-btn-row";
      opts.buttons.forEach(function (btn) {
        // Quick-action buttons (no URL, has an `action` field) → render as
        // <button> that POSTs back to /chat with the action as quick_action.
        if (!btn.url && btn.action) {
          // v2.55.156 — keep exactly ONE "Proceed to order" button (the
          // latest). The backend re-emits it on every non-empty-cart reply;
          // before adding this one, drop any from PRIOR bubbles so they don't
          // accumulate one-per-turn. The current btnRow is not in the DOM yet,
          // so only prior bubbles match. Paired with the send() exemption
          // above, the prior one stays visible through the round-trip and is
          // swapped for this fresh one only once the reply renders — gap-free.
          if (btn.action === "continue_to_delivery") {
            document.querySelectorAll(
              '.fs-chatbot-btn-quick[data-action="continue_to_delivery"]'
            ).forEach(function (old) {
              var r = old.closest(".fs-chatbot-btn-row");
              old.remove();
              if (r && !r.querySelector("a, button")) r.remove();
            });
          }
          var btnEl = document.createElement("button");
          btnEl.type = "button";
          btnEl.className = "fs-chatbot-btn fs-chatbot-btn-quick";
          btnEl.setAttribute("data-action", btn.action);
          btnEl.innerHTML =
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>' +
            "<span>" + escapeHtml(btn.label || "Continue") + "</span>";
          btnEl.addEventListener("click", function () {
            if (isSending) return;
            // v2.41.0 — handle the client-side `continue_to_delivery`
            // branch BEFORE disabling sibling buttons. This action
            // opens the wizard locally with no /chat round-trip
            // (see below), and the same button needs to remain
            // clickable so the customer can re-open the wizard after
            // closing it. Pre-v2.41.0 the disable below ran first,
            // permanently disabling the button after the first click;
            // the customer would close the wizard, tap "Proceed to
            // order" again, and nothing would happen (disabled button
            // silently swallows the tap, no error, no signal).
            //
            // Safe to skip the disable: openWizard() is idempotent
            // (guards on wizardOpen below in its own body), so even
            // rapid taps don't double-open anything. Other quick
            // actions still go through send() and DO need the
            // disable to prevent double-submission to /chat.
            //
            // v2.31.0: "Proceed to order" opens the wizard client-side
            // (no backend round-trip). The cart state already has
            // everything the wizard needs; the wizard's first commit
            // is the next backend call. This bypasses LLM latency
            // for the chat → wizard handoff. Other quick actions
            // (add_another_item, change_*, cancel_order, etc.) still
            // flow through /chat.
            if (btn.action === "continue_to_delivery") {
              openWizard();
              return;
            }
            // Disable all sibling quick-action buttons to prevent
            // double-click from re-submitting the same /chat action.
            // Re-enabled implicitly when the next bot response renders
            // a new bubble with new buttons.
            btnRow.querySelectorAll(".fs-chatbot-btn-quick").forEach(function (b) { b.disabled = true; });
            send("", btn.action);
          });
          btnRow.appendChild(btnEl);
          return;   // skip URL-link branch below
        }

        var a = document.createElement("a");
        var isWa = /wa\.me|whatsapp/i.test(btn.url || "") || /whatsapp/i.test(btn.label || "");

        // For WhatsApp buttons: append session ID to the message text so CS
        // agents can look up the chat history without asking the customer.
        var href = btn.url || "#";
        if (isWa && href !== "#") {
          // v2.55.49 — only add a generic session-ref message to a BARE
          // wa.me link (no ?text= yet). Buttons like "WhatsApp Slip", the
          // order-summary handoff, and edit-order links arrive with a
          // purpose-built text= already set by the backend; appending a
          // second text= here produced a duplicate ?text=…&text=… where
          // WhatsApp honours the LAST one — replacing the slip/order
          // message with the generic "I need help" text. So: never touch a
          // URL that already carries a text= param.
          var hasText = /[?&]text=/i.test(href);
          if (!hasText) {
            var separator = href.indexOf("?") === -1 ? "?" : "&";
            href += separator + "text=" +
              encodeURIComponent("Hi Flower Sugar, I need help. My reference: " + SESSION_ID);
          }
        }

        a.href = href;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.className = "fs-chatbot-btn " + (isWa ? "fs-chatbot-btn-whatsapp" : "fs-chatbot-btn-primary");
        a.innerHTML =
          (isWa
            ? '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.4.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5 0 1.5 1.1 2.9 1.2 3.1.1.2 2.1 3.2 5.1 4.5 1.8.7 2.4.8 3.3.7.5-.1 1.7-.7 2-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.4zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.3 5L2 22l5.1-1.3c1.4.8 3.1 1.3 4.9 1.3 5.5 0 10-4.5 10-10S17.5 2 12 2z"/></svg>'
            : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>'
          ) + "<span>" + escapeHtml(btn.label || "Open") + "</span>";
        btnRow.appendChild(a);

        // Below every WhatsApp button, show a small session ID reference
        // the customer can copy and give to CS staff.
        if (isWa) {
          var refEl = document.createElement("div");
          refEl.className = "fs-chatbot-session-ref";
          // Show last 12 chars of session ID — enough to be unique, short enough to quote
          var shortId = SESSION_ID.slice(-12);
          refEl.innerHTML =
            '<span class="fs-chatbot-ref-copy">Ref:</span>' +
            '<span class="fs-chatbot-ref-id">' + escapeHtml(shortId) + '</span>' +
            '<span class="fs-chatbot-ref-copy">· click to copy</span>';
          refEl.addEventListener("click", function () {
            navigator.clipboard.writeText(SESSION_ID).then(function () {
              refEl.classList.add("fs-chatbot-copied");
              refEl.querySelector(".fs-chatbot-ref-copy:last-child").textContent = "· copied!";
              setTimeout(function () {
                refEl.classList.remove("fs-chatbot-copied");
                refEl.querySelector(".fs-chatbot-ref-copy:last-child").textContent = "· click to copy";
              }, 2500);
            }).catch(function () {
              // Clipboard API may be blocked — select text as fallback
              var range = document.createRange();
              range.selectNode(refEl.querySelector(".fs-chatbot-ref-id"));
              window.getSelection().removeAllRanges();
              window.getSelection().addRange(range);
            });
          });
          btnRow.appendChild(refEl);
        }
      });
      wrap.appendChild(btnRow);
    }

    // v2.32.0: payment-link expiry hint, shown below the buttons.
    // Permanent muted text (not a countdown timer). The Shopify side
    // enforces the actual 15-minute expiry; this just sets the
    // customer's expectation. History replay shows the same hint
    // weeks later — if the customer taps an expired link, Shopify's
    // page surfaces the expiry; that's fine.
    if (opts.payment_expiry_note) {
      var expiryEl = document.createElement("div");
      expiryEl.className = "fs-chatbot-payment-expiry";
      expiryEl.textContent = opts.payment_expiry_note;
      wrap.appendChild(expiryEl);
    }

    if (opts.form) {
      var formBubble = renderForm(opts.form);
      wrap.appendChild(formBubble);
    }

    if (opts.delivery_quote) {
      var quoteBlock = renderDeliveryQuote(opts.delivery_quote);
      if (quoteBlock) wrap.appendChild(quoteBlock);
    }

    // v2.55.59 — order-details bubble (authenticated order lookup). Renders
    // the upstream {value, remark} object as labelled rows; keys are dynamic
    // so the renderer iterates whatever arrives.
    if (opts.order_details_card) {
      var odBlock = renderOrderDetailsCard(opts.order_details_card);
      if (odBlock) wrap.appendChild(odBlock);
    }

    // Per-message timestamp (HH:MM). Sits under everything else in
    // the wrap so it appears at the bottom of the message group. The
    // opts.ts override is used by loadHistory to show the message's
    // original send time, not the page-reload time.
    _appendTimestampTo(wrap, opts.ts);

    $messages.appendChild(wrap);
    // User bubbles are always force-snapped (the customer just hit
    // send — they want to see their message). Bot bubbles auto-snap
    // only when the customer is already at the bottom; if they're
    // reading history the bot's reply waits below and the scroll-to-
    // bottom button surfaces to flag the new content.
    scrollToBottom(role === "user");
    // v2.55.0: notify FS_PHONE of substantive bot turns so the
    // soft-prompt counter can advance. Only counts bot bubbles WITH
    // text (typing-indicator bubbles and pure-product/buttons
    // bubbles without text don't count as substantive turns —
    // we want the prompt to fire once a real conversation is
    // underway). Wrapped defensively because addBubble runs early
    // in the IIFE lifecycle before FS_PHONE is defined; the typeof
    // check covers init-time calls.
    if (role === "bot" && text && typeof FS_PHONE !== "undefined") {
      try { FS_PHONE.onBotTurn(); } catch (_) {}
    }
    // ╔═══ FS LIVE-AGENT AMENDMENT (bot-server-owned) ═══╗
    return wrap;   // lets the live-agent module map + later remove this node
    // ╚══════════════════════════════════════════════════╝
  }

  // ---------------------------------------------------------------------
  // Delivery quote rendering (bypassed P3)
  // ---------------------------------------------------------------------
  // Renders a structured delivery rates block. Modes:
  //   generic       — two tiers (above RM80 + below RM80)
  //   specific_item — one tier + item label header
  //   no_service    — friendly empty-state
  //
  // The compiler upstream guarantees the structure; we just paint it.
  function renderDeliveryQuote(quote) {
    if (!quote) return null;
    var card = document.createElement("div");
    card.className = "fs-chatbot-delivery-quote";

    if (quote.mode === "no_service") {
      // The intro text already explained it — render a small visual cue
      var note = document.createElement("div");
      note.className = "fs-chatbot-delivery-quote-empty";
      note.textContent = "✕";
      card.appendChild(note);
      return card;
    }

    // Specific-item mode — show the item label(s) as a header above the
    // rates. Supports both shapes: a single `item`, or a multi-item `items`
    // list (one combined rate set covers the whole cart either way).
    if (quote.mode === "specific_item") {
      // Build the list of items to label. Prefer the `items` array; fall
      // back to the legacy single `item` key.
      var quoteItems = [];
      if (Array.isArray(quote.items) && quote.items.length) {
        quoteItems = quote.items;
      } else if (quote.item) {
        quoteItems = [quote.item];
      }

      function itemLabel(it) {
        var label = it.product_name || "";
        if (it.variant_name) label += " — " + it.variant_name;
        if (it.quantity && it.quantity > 1) {
          label = it.quantity + "× " + label;
        }
        return label;
      }

      if (quoteItems.length === 1) {
        var itemHeader = document.createElement("div");
        itemHeader.className = "fs-chatbot-delivery-quote-item";
        itemHeader.textContent = itemLabel(quoteItems[0]);
        card.appendChild(itemHeader);
      } else if (quoteItems.length > 1) {
        // One label line per item.
        quoteItems.forEach(function (it) {
          var line = document.createElement("div");
          line.className = "fs-chatbot-delivery-quote-item";
          line.textContent = itemLabel(it);
          card.appendChild(line);
        });
      }

      var ratesList = renderRatesList(quote.rates || []);
      if (ratesList) card.appendChild(ratesList);
    }

    // Generic mode — two tiers
    if (quote.mode === "generic") {
      // Above RM80 tier
      if (quote.above_rm80 && quote.above_rm80.rates && quote.above_rm80.rates.length) {
        var aboveTier = document.createElement("div");
        aboveTier.className = "fs-chatbot-delivery-quote-tier";
        var aboveLabel = document.createElement("div");
        aboveLabel.className = "fs-chatbot-delivery-quote-tier-label";
        // Use compiler-supplied label (localised). Fall back to the
        // endpoint's `eligibility` string, then to a generic English label.
        aboveLabel.textContent = quote.above_rm80.tier_label
          || quote.above_rm80.eligibility
          || "For eligible orders above RM80";
        aboveTier.appendChild(aboveLabel);
        var aboveRates = renderRatesList(quote.above_rm80.rates);
        if (aboveRates) aboveTier.appendChild(aboveRates);
        card.appendChild(aboveTier);
      }
      // Below RM80 tier
      if (quote.below_rm80 && quote.below_rm80.rates && quote.below_rm80.rates.length) {
        var belowTier = document.createElement("div");
        belowTier.className = "fs-chatbot-delivery-quote-tier";
        var belowLabel = document.createElement("div");
        belowLabel.className = "fs-chatbot-delivery-quote-tier-label";
        belowLabel.textContent = quote.below_rm80.tier_label
          || quote.below_rm80.eligibility
          || "For orders below RM80";
        belowTier.appendChild(belowLabel);
        var belowRates = renderRatesList(quote.below_rm80.rates);
        if (belowRates) belowTier.appendChild(belowRates);
        card.appendChild(belowTier);
      }
    }

    // Disclaimers — small print explaining the limits of the quote.
    // Rendered as a bulleted list below the rates and above the expiry.
    // The compiler supplies these as a list of plain strings, already
    // localised. Skip entirely for empty/missing.
    if (Array.isArray(quote.disclaimers) && quote.disclaimers.length) {
      var disclaimerBlock = document.createElement("ul");
      disclaimerBlock.className = "fs-chatbot-delivery-quote-disclaimers";
      quote.disclaimers.forEach(function (text) {
        var li = document.createElement("li");
        li.textContent = String(text);
        disclaimerBlock.appendChild(li);
      });
      card.appendChild(disclaimerBlock);
    }

    // Validity expiry footer (common to both modes)
    if (quote.endpoint_expiry) {
      var expiry = document.createElement("div");
      expiry.className = "fs-chatbot-delivery-quote-expiry";
      expiry.textContent = quote.endpoint_expiry;
      card.appendChild(expiry);
    }

    // v2.55.20+hotfix8 — defensive: if no mode-specific branch
    // populated the card, return null so addBubble doesn't append
    // an empty styled div (which renders as a hollow bubble below
    // the text). Triggered by quote.mode values the renderer
    // doesn't know about (e.g. out_of_coverage in v2.55.21). The
    // backend should also set delivery_quote=null for those modes;
    // this is belt-and-braces for future modes that ship without a
    // matching renderer branch.
    if (!card.children.length) {
      return null;
    }

    return card;
  }

  // v2.55.59 — render the authenticated order-details bubble. The payload is
  // { fields: {fieldKey: {value, remark}, ...}, order_number }. Keys are
  // DYNAMIC (the upstream may add/rename/remove fields), so we iterate
  // whatever arrives rather than reaching for named keys. Rules:
  //   - value shown as the row value; remark as a tooltip + small subtext
  //   - booleans → Yes / No
  //   - null / "" → "—"
  //   - the upstream returns ONLY disclosure-safe fields (confidentiality is
  //     enforced upstream), so we faithfully display everything it sends.
  function renderOrderDetailsCard(payload) {
    if (!payload || typeof payload !== "object") return null;
    var fields = payload.fields;
    if (!fields || typeof fields !== "object") return null;

    var card = document.createElement("div");
    card.className = "fs-chatbot-order-details";

    if (payload.order_number) {
      var hdr = document.createElement("div");
      hdr.className = "fs-chatbot-od-header";
      hdr.textContent = "Order #" + String(payload.order_number).replace(/^#/, "");
      card.appendChild(hdr);
    }

    function prettifyKey(k) {
      // snake_case / camelCase → Title Case.
      return String(k)
        .replace(/_/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }

    // v2.55.63 — explicit label overrides where the prettified key isn't the
    // wording we want. Falls back to prettifyKey for any key not listed.
    var LABEL_OVERRIDES = {
      "delivery_date": "Delivery/Pick Up Date",
    };
    function labelFor(key) {
      return LABEL_OVERRIDES[key] || prettifyKey(key);
    }

    function displayValue(v) {
      if (v === true) return "Yes";
      if (v === false) return "No";
      if (v === null || v === undefined || v === "") return "—";
      return String(v);
    }

    Object.keys(fields).forEach(function (key) {
      var entry = fields[key];
      // Each entry may be {value, remark} OR a bare value (e.g. the upstream
      // sends payment_status as a bare boolean). We display the value only —
      // v2.55.63 hides the remark entirely (no tooltip, no subtext).
      var value;
      if (entry && typeof entry === "object" && ("value" in entry)) {
        value = entry.value;
      } else {
        value = entry;
      }

      var row = document.createElement("div");
      row.className = "fs-chatbot-od-row";

      var label = document.createElement("div");
      label.className = "fs-chatbot-od-label";
      label.textContent = labelFor(key);

      var val = document.createElement("div");
      val.className = "fs-chatbot-od-value";
      val.textContent = displayValue(value);

      row.appendChild(label);
      row.appendChild(val);

      card.appendChild(row);
    });

    // v2.55.82 — receipt / e-invoice documents. The handler only attaches
    // these when payment is made and the URLs are present; the raw URL keys
    // were already stripped from `fields`, so we render them here as actions.
    //   - receipt: a direct download (opens the URL in a new tab).
    //   - e-invoice: opens the link where the buyer fills statutory details;
    //     the completed document downloads from the same link 2 days after
    //     the delivery date. Rendered as a link + a short caveat note.
    var docs = payload.documents;
    if (docs && typeof docs === "object" &&
        (docs.receipt || docs.e_invoice)) {
      var docWrap = document.createElement("div");
      docWrap.className = "fs-chatbot-od-documents";

      function _docButton(text, url) {
        var a = document.createElement("a");
        a.className = "fs-chatbot-od-doc-btn";
        a.textContent = text;
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        return a;
      }

      if (docs.receipt && docs.receipt.url) {
        docWrap.appendChild(_docButton("Download receipt", docs.receipt.url));
      }
      if (docs.e_invoice && docs.e_invoice.url) {
        docWrap.appendChild(_docButton("Get e-invoice", docs.e_invoice.url));
        var note = document.createElement("div");
        note.className = "fs-chatbot-od-doc-note";
        var days = (docs.e_invoice.available_after_delivery_days != null)
          ? docs.e_invoice.available_after_delivery_days : 2;
        note.textContent =
          "Fill in your statutory details at the link. The e-invoice is " +
          "downloadable from the same link " + days +
          " days after the delivery date.";
        docWrap.appendChild(note);
      }

      card.appendChild(docWrap);
    }

    if (!card.children.length) return null;
    return card;
  }

  function renderRatesList(rates) {
    if (!rates || !rates.length) return null;
    // Table-style grid: two columns, service name flexes, price column auto-sizes.
    // Each row is a sub-grid item. Header above the rows shows column intent.
    var grid = document.createElement("div");
    grid.className = "fs-chatbot-delivery-rates";
    rates.forEach(function (r) {
      var row = document.createElement("div");
      row.className = "fs-chatbot-delivery-rate-row";
      var name = document.createElement("div");
      name.className = "fs-chatbot-delivery-rate-name";
      name.textContent = r.service_name || "";
      var price = document.createElement("div");
      price.className = "fs-chatbot-delivery-rate-price";
      // The compiler guarantees total_price_myr is a customer-ready string
      // like "Free" or "RM15.00" — render verbatim.
      price.textContent = r.total_price_myr || "—";
      // Visually emphasise "Free"
      if ((r.total_price_myr || "").toLowerCase() === "free") {
        price.classList.add("fs-chatbot-delivery-rate-free");
      }
      row.appendChild(name);
      row.appendChild(price);
      grid.appendChild(row);
    });
    return grid;
  }

  // ---------------------------------------------------------------------
  // Form rendering (Stage F)
  // ---------------------------------------------------------------------
  // Builds a DOM form from a backend Form definition:
  //   { form_id, fields: [...], submit_label, cancel_label }
  //
  // Each field has type ∈ {date, text, textarea, select} and optional
  // show_when conditional rendering. Validation runs client-side on
  // submit; server-side validation is the source of truth.

  // ---------------------------------------------------------------------
  // openVariantDateForm — the inline Variant + Date form that opens when
  // the customer clicks "Place Order" on a product card.
  //
  // This is a pure-frontend form — no /chat round-trip on open. The
  // card's `variants` array (sent by the backend) carries every variant
  // record needed: variant_id, variant_name, price_int, inventory,
  // earliest_availability, disabled_dates, has_card.
  //
  // On submit the form calls send(null, "place_order_from_card", {...})
  // which routes to place_order_handler with the resolved variant + date
  // in a single round-trip.
  //
  // Toggle behaviour: clicking Place Order on a card that already has an
  // open form closes it (it's the same affordance).
  //
  // Pre-select rule for the date: if cartState.delivery_date is known
  // and is BOTH on or after the selected variant's earliest_availability
  // AND not in its disabled_dates, that date is pre-selected. Otherwise
  // the field starts empty and the customer picks.
  //
  // Variant change: a different variant can have a different
  // earliest_availability and disabled_dates, so the min and the date
  // validity are re-evaluated whenever the variant select changes.
  // ---------------------------------------------------------------------

  function _toIsoDate(s) {
    // Accept "YYYY-MM-DD", "YYYY/MM/DD", or "May 21, 2026" — return ISO
    // "YYYY-MM-DD" or "" if not parseable. Used to normalise
    // earliest_availability and disabled_dates for comparison.
    if (!s) return "";
    s = String(s).trim();
    if (!s) return "";
    // ISO with dashes already
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    // Slash form
    var m = s.match(/^(\d{4})\/(\d{2})\/(\d{2})$/);
    if (m) return m[1] + "-" + m[2] + "-" + m[3];
    // Try Date.parse (handles "May 21, 2026")
    var d = new Date(s);
    if (isNaN(d.getTime())) return "";
    var y = d.getFullYear();
    var mo = String(d.getMonth() + 1).padStart(2, "0");
    var da = String(d.getDate()).padStart(2, "0");
    return y + "-" + mo + "-" + da;
  }

  // Customers can only order for delivery within this many calendar
  // months from today. Matches the live product page's datepicker
  // (`maxDate: "+1m"`) and is enforced in both the jQuery UI picker
  // (via the `maxDate` option) and our own min/disabled validation
  // (so the native fallback + submit handler reject the same range).
  // Re-computed on each form open via _maxOrderIso() so a page kept
  // open across midnight uses the correct ceiling.
  var MAX_ORDER_MONTHS_OUT = 1;

  function _maxOrderIso() {
    var d = new Date();
    d.setMonth(d.getMonth() + MAX_ORDER_MONTHS_OUT);
    var y  = d.getFullYear();
    var mo = String(d.getMonth() + 1).padStart(2, "0");
    var da = String(d.getDate()).padStart(2, "0");
    return y + "-" + mo + "-" + da;
  }

  // Today's date in the customer's local timezone as ISO "YYYY-MM-DD".
  // The min-date floor in the picker. We use local-time year/month/day
  // (not UTC) so MY customers near midnight see "today" by THEIR clock,
  // not UTC's. Same approach as _maxOrderIso for consistency.
  function _todayIso() {
    var d = new Date();
    var y  = d.getFullYear();
    var mo = String(d.getMonth() + 1).padStart(2, "0");
    var da = String(d.getDate()).padStart(2, "0");
    return y + "-" + mo + "-" + da;
  }

  // The effective earliest-pickable date for a variant. Clamps the
  // variant's `earliest_availability` to today — defends against the
  // endpoint returning a stale value (e.g. "2026-05-23" when today is
  // already May 24; observed in production with the get_products
  // endpoint's variant rows). If the variant has no earliest_availability
  // at all, today is the floor.
  function _effectiveMinIso(variant) {
    var rawMin = variant && variant.earliest_availability
                   ? _toIsoDate(variant.earliest_availability)
                   : "";
    var today = _todayIso();
    // Plain ISO string comparison works because YYYY-MM-DD is
    // lexicographically ordered — no Date parse needed.
    if (!rawMin) return today;
    return rawMin < today ? today : rawMin;
  }

  // Pin jQuery UI's #ui-datepicker-div to a specific input using
  // viewport coordinates. jQuery UI itself uses `position: absolute`
  // + offsetParent-relative math, which produces wrong coordinates
  // when the input lives inside our `position: fixed` chat panel
  // (the picker ends up off-screen, usually upper-left of viewport).
  //
  // We override to `position: fixed` and use `getBoundingClientRect`,
  // which returns viewport-relative coords — no offsetParent walk
  // needed. Open the picker downwards by default; if it'd run off
  // the bottom of the viewport, open upwards.
  function _pinDatepickerToInput(input) {
    var div = document.getElementById("ui-datepicker-div");
    if (!div || !input) return;
    if (getComputedStyle(div).display === "none") return;

    var inputRect = input.getBoundingClientRect();
    var divRect   = div.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;

    var top  = inputRect.bottom + 2; // 2px gap below the input
    // If the calendar would overflow the bottom of the viewport,
    // flip it above the input.
    if (top + divRect.height > vh - 8) {
      top = Math.max(8, inputRect.top - divRect.height - 2);
    }
    // Align left edges by default; clamp to viewport.
    var left = inputRect.left;
    var maxLeft = (window.innerWidth || document.documentElement.clientWidth)
                  - divRect.width - 8;
    if (left > maxLeft) left = Math.max(8, maxLeft);

    div.style.position = "fixed";
    div.style.top  = top  + "px";
    div.style.left = left + "px";
  }

  // Unique id counter for the variant+date form's date input. jQuery
  // UI's _selectDay / _adjustDate handlers look up the owning input
  // via document.getElementById(input.id) — if the input has no id,
  // the lookup returns null and `_getInst(null)` throws "Missing
  // instance data for this datepicker". Counter survives across
  // multiple opens so each form gets a fresh, document-unique id
  // (even after toggling the form closed and back open).
  var _vdfDateInputCounter = 0;

  function openVariantDateForm(product, cardEl) {
    // Toggle: if this card already has a form open elsewhere in the
    // chat stream, remove it and return. The form lives as a chat
    // bubble in $messages, not inside the card — but the card holds a
    // ref to it so toggle still works from the same button.
    if (cardEl._variantDateBubble && cardEl._variantDateBubble.parentNode) {
      if (cardEl._variantDateBubble._teardownScrollClose) {
        cardEl._variantDateBubble._teardownScrollClose();
      }
      _unregisterActiveForm(cardEl._variantDateBubble);
      cardEl._variantDateBubble.remove();
      cardEl._variantDateBubble = null;
      return;
    }

    // Single active-form rule (v2.55.171): clicking Place Order opens a
    // variant-date form, so first cancel EVERY form currently locking the
    // composer — other variant-date pickers AND server forms (e.g. an open
    // delivery_fee form). Previously server forms were left alone, so the
    // composer stayed disabled on the abandoned form after this one was
    // answered. The new form is client-built (no server form_id) → pass null.
    _supersedeActiveForms(null);

    var variants = product.variants || [];
    if (!variants.length) return;  // Nothing to do — button is disabled in this case

    // ── Wrapper bubble (so the form appears as a normal bot bubble) ──
    var wrap = document.createElement("div");
    wrap.className = "fs-chatbot-msg fs-chatbot-bot fs-chatbot-variant-date-bubble";

    var form = document.createElement("div");
    form.className = "fs-chatbot-variant-date-form";
    form.setAttribute("data-product-id", String(product.id || ""));

    // ── Product header (so the form is identifiable away from the card) ──
    var header = document.createElement("div");
    header.className = "fs-chatbot-vdf-header";
    header.textContent = btnLabel("place_order") + " — " + (product.title || "");
    form.appendChild(header);

    // ── Variant select ─────────────────────────────────────────────
    var vWrap = document.createElement("div");
    vWrap.className = "fs-chatbot-vdf-field";
    var vLabel = document.createElement("label");
    vLabel.className = "fs-chatbot-vdf-label";
    vLabel.textContent = "Variant";
    var vSel = document.createElement("select");
    variants.forEach(function (v, i) {
      var opt = document.createElement("option");
      opt.value = String(i);
      var label = v.variant_name || "Default";
      // price_int is in CENTS (v2.28.7 endpoint contract). Divide by 100
      // for the customer-visible "RM118" label. Was "RM" + v.price_int
      // pre-v2.28.7 when the endpoint returned ringgit — that path now
      // produces "RM11800", which reads as RM11,800.
      if (v.price_int) label += " — RM" + (v.price_int / 100);
      if (v.inventory !== undefined && v.inventory !== null && v.inventory <= 0) {
        label += " (sold out)";
      }
      opt.textContent = label;
      vSel.appendChild(opt);
    });
    vWrap.appendChild(vLabel);
    vWrap.appendChild(vSel);
    form.appendChild(vWrap);

    // ── Date input ─────────────────────────────────────────────────
    // Use jQuery UI's datepicker when available (it's loaded on the
    // Shopify product page already, and matches the visual style of
    // the main site's product form). It visually greys out disabled
    // dates via beforeShowDay — the core thing native <input
    // type="date"> can't do.
    //
    // Feature detection: if jQuery + jQuery UI's datepicker aren't on
    // the host page, fall back to native <input type="date"> with the
    // live-validate change handler. Both paths populate the SAME
    // dInput value (ISO form, "YYYY-MM-DD"; held in `data-iso` in
    // datepicker mode, `.value` in native mode) so the submit handler
    // and validation below don't need to know which mode is active.
    //
    // ── jQuery instance resolution ────────────────────────────────
    // A page can have multiple jQuery instances. jQuery UI registers
    // its `.fn.datepicker` plugin *and* its `.ui` namespace on whichever
    // jQuery instance was active at the time UI loaded. If the page
    // later reassigns `window.jQuery`, picking `.fn.datepicker` from
    // the wrong instance fails subtly: init succeeds (the plugin
    // function is reachable), but $.data lookups during click handling
    // go through a different cache and throw "Missing instance data
    // for this datepicker".
    //
    // Picking the candidate where BOTH `.fn.datepicker` is a function
    // AND `.ui.datepicker` is set avoids this — jQuery UI's `.ui`
    // namespace lives on its real owner. If no candidate has `.ui`
    // (single-jQuery page), fall back to whichever has `.fn.datepicker`.
    function resolveJQueryUI() {
      var candidates = [];
      if (window.jQuery)                              candidates.push(window.jQuery);
      if (window.$  && window.$  !== window.jQuery)   candidates.push(window.$);
      if (window.jq && window.jq !== window.jQuery
                    && window.jq !== window.$)        candidates.push(window.jq);
      var withUi = null, anyWithFn = null;
      for (var i = 0; i < candidates.length; i++) {
        var c = candidates[i];
        var hasFn = !!(c && c.fn && typeof c.fn.datepicker === "function");
        var hasUi = !!(c && c.ui && c.ui.datepicker);
        if (hasFn && hasUi && !withUi)   withUi    = c;
        if (hasFn          && !anyWithFn) anyWithFn = c;
      }
      return withUi || anyWithFn || null;
    }

    var $jq = resolveJQueryUI();
    var useDatepicker = !!$jq;
    // One concise line tells us what mode we're in. Mode-specific
    // details (variant id, constraints, etc.) get logged downstream.
    // console.log("[vdf] datepicker mode:", useDatepicker ? "jQuery UI" : "native fallback");

    var dWrap = document.createElement("div");
    dWrap.className = "fs-chatbot-vdf-field";
    var dLabel = document.createElement("label");
    dLabel.className = "fs-chatbot-vdf-label";
    // v2.42.0 — mode-neutral wording matches the form_strings table's
    // label_delivery_date ("delivery or pick up date") for consistency
    // across surfaces. The product card's Place Order form doesn't yet
    // know whether the customer will pick delivery or pickup.
    dLabel.textContent = "Delivery or pick up date";
    var dInput = document.createElement("input");
    // jQuery UI datepicker's day-click and arrow-click handlers
    // identify the owning input by document.getElementById(input.id).
    // Without an id, getElementById returns null, _getInst(null)
    // throws "Missing instance data for this datepicker", and every
    // click inside the calendar fails. Assign a unique id BEFORE
    // calling .datepicker(opts) so the handlers can resolve back.
    _vdfDateInputCounter += 1;
    dInput.id = "fs-vdf-date-" + _vdfDateInputCounter;
    if (useDatepicker) {
      // jQuery UI datepicker attaches to a text input. The actual ISO
      // value is mirrored to dInput.value; what the user sees is the
      // datepicker's "yy/mm/dd" string.
      dInput.type = "text";
      dInput.readOnly = true;          // pick via calendar, not typing
      dInput.placeholder = "Select date";
      dInput.style.cursor = "pointer";
      dInput.style.background = "#fff";
    } else {
      dInput.type = "date";
    }
    dWrap.appendChild(dLabel);
    dWrap.appendChild(dInput);
    form.appendChild(dWrap);

    var errEl = document.createElement("div");
    errEl.className = "fs-chatbot-vdf-error";
    form.appendChild(errEl);

    // ── Actions ────────────────────────────────────────────────────
    var actions = document.createElement("div");
    actions.className = "fs-chatbot-vdf-actions";
    var cancelBtn = document.createElement("button");
    cancelBtn.type = "button";
    cancelBtn.className = "fs-chatbot-vdf-cancel";
    cancelBtn.textContent = "Cancel";
    cancelBtn.addEventListener("click", function () {
      if (wrap._teardownScrollClose) wrap._teardownScrollClose();
      _unregisterActiveForm(wrap);
      wrap.remove();
      cardEl._variantDateBubble = null;
    });
    var submitBtn = document.createElement("button");
    submitBtn.type = "button";
    submitBtn.className = "fs-chatbot-vdf-submit";
    submitBtn.textContent = "Add to order";
    actions.appendChild(cancelBtn);
    actions.appendChild(submitBtn);
    form.appendChild(actions);

    // ── Per-variant date constraint application ────────────────────
    function currentVariant() { return variants[Number(vSel.value) || 0]; }

    // Convert "yyyy/mm/dd" (jQuery UI format) ↔ "yyyy-mm-dd" (ISO).
    function _slashToIso(s) { return String(s || "").replace(/\//g, "-"); }
    function _isoToSlash(s) { return String(s || "").replace(/-/g, "/"); }

    // Build a beforeShowDay closure for the CURRENT variant. Re-built
    // every time the variant changes (cheap; closure over the current
    // variant's disabled_dates list).
    //
    // Matches the live product page exactly: compare each calendar
    // day's "yyyy/mm/dd" string against the variant's disabled_dates
    // list (also "yyyy/mm/dd"). Disabled days return [false, ""] which
    // makes jQuery UI grey them out and refuse clicks.
    function _buildBeforeShowDay(variant) {
      var disabledSlash = (variant.disabled_dates || []).map(function (d) {
        // The list could contain ISO "2026-06-01" too — normalise.
        return _isoToSlash(_toIsoDate(d) || d);
      });
      return function beforeShowDay(x) {
        var dd = String(x.getDate()).padStart(2, "0");
        var mm = String(x.getMonth() + 1).padStart(2, "0");
        var yy = x.getFullYear();
        var xSlash = yy + "/" + mm + "/" + dd;
        if (disabledSlash.indexOf(xSlash) >= 0) return [false, ""];
        return [true, ""];
      };
    }

    function _initDatepicker() {
      var v = currentVariant();
      // console.log("[vdf] _initDatepicker", {
      //   variant_id:            v.variant_id,
      //   variant_name:          v.variant_name,
      //   earliest_availability: v.earliest_availability,
      //   disabled_dates_count:  (v.disabled_dates || []).length,
      // });

      // Tear down any existing picker (variant change calls this).
      // First-init throws "no instance data" — that's expected, not
      // an error.
      try { $jq(dInput).datepicker("destroy"); } catch (_) {}

      var minIso = _effectiveMinIso(v);
      // jQuery UI accepts a JS Date for minDate; build one from the ISO.
      var minDate = null;
      if (minIso) {
        var parts = minIso.split("-");
        minDate = new Date(
          Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]),
        );
      }
      try {
        $jq(dInput).datepicker({
          minDate:        minDate,        // greys out earlier days
          // Customers can only order for delivery up to one month out.
          // Matches the live product page's datepicker option. Uses
          // jQuery UI's offset notation (`+1m` = "one month from today").
          maxDate:        "+1m",
          dateFormat:     "yy/mm/dd",     // jQuery UI's notation → "2026/05/21"
          constrainInput: true,
          beforeShowDay:  _buildBeforeShowDay(v),
          // jQuery UI's _findPos() walks the offsetParent chain to
          // position #ui-datepicker-div using `position: absolute`.
          // That math goes wrong when the input lives inside our
          // `position: fixed` chat panel — coordinates computed
          // relative to the panel get applied as if relative to the
          // document body, sending the picker to the upper-left of
          // the viewport (still in DOM, just not visible).
          //
          // beforeShow fires after jQuery UI has set the picker's
          // inline `position/top/left`. We override on the next frame
          // (so we run AFTER the picker is visible and its size is
          // measurable) and pin it to the input using viewport coords
          // + `position: fixed`. That bypasses the offsetParent walk
          // entirely.
          beforeShow: function (input) {
            requestAnimationFrame(function () {
              _pinDatepickerToInput(input);
            });
            return {};
          },
          onSelect: function (dateStrSlash) {
            // jQuery UI passes the display-formatted string ("2026/05/21").
            // The visible input keeps that for the user. The ISO form is
            // mirrored to data-iso so the submit handler can read it
            // format-agnostically. Clear any stale error.
            dInput.setAttribute("data-iso", _slashToIso(dateStrSlash));
            errEl.textContent = "";
          },
        });
        // Post-init sanity check — these flags must all be true for
        // clicks inside the calendar to work. If a future regression
        // mounts the form into a shadow root again (or otherwise
        // detaches the input from `document`), `getElementById_finds_us`
        // flips to false and points straight at the cause.
        // console.log("[vdf] datepicker init: post-init state", {
        //   dInput_id:               dInput.id,
        //   hasClass_hasDatepicker:  dInput.classList.contains("hasDatepicker"),
        //   getElementById_finds_us: document.getElementById(dInput.id) === dInput,
        //   dInput_in_document:      document.contains(dInput),
        // });
      } catch (e) {
        console.error("[vdf] datepicker init threw:", e && e.message, e);
      }
    }

    function applyDateConstraints() {
      // Common: validate any currently-selected date against the new
      // variant's constraints; clear it if invalid.
      var v = currentVariant();
      var minIso = _effectiveMinIso(v);
      var maxIso = _maxOrderIso();
      var disabled = Array.isArray(v.disabled_dates) ? v.disabled_dates : [];
      var current = getDateIso();
      if (current) {
        var bad = false;
        if (minIso && current < minIso) bad = true;
        if (!bad && maxIso && current > maxIso) bad = true;
        if (!bad) {
          for (var i = 0; i < disabled.length; i++) {
            if (_toIsoDate(disabled[i]) === current) { bad = true; break; }
          }
        }
        if (bad) setDateIso("");
      }

      if (useDatepicker) {
        // Re-init the picker for the new variant — refreshes minDate
        // and beforeShowDay so the greyed-out days reflect the current
        // variant's disabled_dates.
        _initDatepicker();
      } else {
        // Native fallback: set the min and max attributes so the OS
        // date picker reflects the same constraints the jQuery UI path
        // enforces (the live-validate `change` handler is the final
        // line of defence in either mode).
        if (minIso) dInput.min = minIso; else dInput.removeAttribute("min");
        if (maxIso) dInput.max = maxIso; else dInput.removeAttribute("max");
      }
    }

    // Live validation as the customer picks a date — only meaningful
    // for the native fallback path (the datepicker prevents disabled
    // picks at source). Safe to attach in both modes: when the
    // datepicker is active, dInput is readonly and won't emit `change`
    // from typing; the picker's own onSelect handles updates.
    function validateDateLive() {
      errEl.textContent = "";
      var current = getDateIso();
      if (!current) return;
      var v = currentVariant();
      var minIso = _effectiveMinIso(v);
      var maxIso = _maxOrderIso();
      if (minIso && current < minIso) {
        errEl.textContent = "Earliest available is " + minIso + ".";
        setDateIso("");
        return;
      }
      if (maxIso && current > maxIso) {
        errEl.textContent = "Latest available is " + maxIso +
          " (one month from today).";
        setDateIso("");
        return;
      }
      if (Array.isArray(v.disabled_dates)) {
        for (var i = 0; i < v.disabled_dates.length; i++) {
          if (_toIsoDate(v.disabled_dates[i]) === current) {
            errEl.textContent = "Sorry, " + current +
              " is not available for this variant. Please pick another date.";
            setDateIso("");
            return;
          }
        }
      }
    }
    dInput.addEventListener("change", validateDateLive);

    // Single accessor for "what date is currently selected?" — abstracts
    // over datepicker mode (data-iso attr, set in onSelect) and native
    // mode (.value is ISO directly from <input type="date">).
    function getDateIso() {
      if (useDatepicker) return dInput.getAttribute("data-iso") || "";
      return dInput.value || "";
    }
    // Inverse — clear or set the selection from ISO, handling both modes.
    function setDateIso(iso) {
      if (useDatepicker) {
        if (!iso) {
          dInput.value = "";
          dInput.removeAttribute("data-iso");
          try { $jq(dInput).datepicker("setDate", null); } catch (_) {}
        } else {
          var parts = iso.split("-");
          var d = new Date(
            Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]),
          );
          try { $jq(dInput).datepicker("setDate", d); } catch (_) {}
          dInput.setAttribute("data-iso", iso);
        }
      } else {
        dInput.value = iso || "";
      }
    }

    function maybePreselectFromCart() {
      // Pre-select cartState.delivery_date when valid for the current
      // variant. Only runs when nothing is selected (don't stomp on a
      // user pick after a variant change).
      if (getDateIso()) return;
      if (!cartState || !cartState.delivery_date) return;
      var iso = _toIsoDate(cartState.delivery_date);
      if (!iso) return;
      var v = currentVariant();
      var minIso = _effectiveMinIso(v);
      var maxIso = _maxOrderIso();
      if (minIso && iso < minIso) return;
      if (maxIso && iso > maxIso) return;
      var disabled = Array.isArray(v.disabled_dates) ? v.disabled_dates : [];
      for (var i = 0; i < disabled.length; i++) {
        if (_toIsoDate(disabled[i]) === iso) return;
      }
      setDateIso(iso);
    }

    vSel.addEventListener("change", function () {
      applyDateConstraints();
      maybePreselectFromCart();
      _updateSubmitForInventory();
    });

    // v2.32.5: Inventory-aware Add to Order button gating.
    //
    // The variant picker keeps sold-out variants in the dropdown
    // (with " (sold out)" suffix) so the customer can see the full
    // product lineup, but the Add to Order button is disabled while
    // a sold-out variant is selected. Switching to an in-stock
    // variant re-enables it.
    //
    // Default-selection case: variants[0] (the form's initial
    // selection) might itself be sold out — per product decision,
    // we keep that pre-selection (don't auto-skip to the next
    // in-stock one) and surface the dead Add button with a clear
    // explanatory message. The customer sees the variant they were
    // pre-shown AND understands they need to pick a different one.
    //
    // Null/undefined inventory is treated as IN STOCK (legacy
    // safety — older backend responses didn't always carry the
    // field, and we don't want to dead-button on a missing field).
    // Negative inventory (overselling indicator) treated as out.
    function _isVariantSoldOut(v) {
      if (!v) return false;
      var inv = v.inventory;
      if (inv === undefined || inv === null) return false;
      return Number(inv) <= 0;
    }

    function _updateSubmitForInventory() {
      var v = currentVariant();
      if (_isVariantSoldOut(v)) {
        submitBtn.disabled = true;
        submitBtn.classList.add("fs-chatbot-disabled");
        submitBtn.title = "This variant is sold out — pick another option.";
        // Inline message under the form's error area. We use errEl
        // (already exists for date errors) rather than a separate
        // element to avoid cluttering the form. Cleared when an
        // in-stock variant is selected, OR when the date-error
        // path overwrites it (date errors take priority — if the
        // customer's already trying to fix the date, telling them
        // "also sold out" simultaneously is noise).
        errEl.textContent = "This variant is sold out. Please choose a different one.";
      } else {
        submitBtn.disabled = false;
        submitBtn.classList.remove("fs-chatbot-disabled");
        submitBtn.title = "";
        // Clear the sold-out message if it's still there. Don't
        // clobber an unrelated message (e.g. a date error) — only
        // clear if the visible text is exactly the sold-out one.
        if (errEl.textContent === "This variant is sold out. Please choose a different one.") {
          errEl.textContent = "";
        }
      }
    }

    applyDateConstraints();
    maybePreselectFromCart();
    _updateSubmitForInventory();

    // ── Submit ─────────────────────────────────────────────────────
    submitBtn.addEventListener("click", function () {
      errEl.textContent = "";
      var v = currentVariant();
      var dateIso = getDateIso();

      // v2.32.5: defensive sold-out guard. The button SHOULD be
      // disabled by _updateSubmitForInventory when this is true —
      // we get here anyway via programmatic click, browser
      // accessibility shortcuts, or a stale event from before
      // _updateSubmitForInventory ran. Treat it as a no-op with a
      // clear message rather than POSTing a sold-out add.
      if (_isVariantSoldOut(v)) {
        errEl.textContent = "This variant is sold out. Please choose a different one.";
        return;
      }

      if (!dateIso) {
        errEl.textContent = "Please choose a delivery date.";
        return;
      }
      var minIso = _effectiveMinIso(v);
      var maxIso = _maxOrderIso();
      if (minIso && dateIso < minIso) {
        errEl.textContent = "Earliest available is " + minIso + ".";
        return;
      }
      if (maxIso && dateIso > maxIso) {
        errEl.textContent = "Latest available is " + maxIso +
          " (one month from today).";
        return;
      }
      var disabled = Array.isArray(v.disabled_dates) ? v.disabled_dates : [];
      for (var i = 0; i < disabled.length; i++) {
        if (_toIsoDate(disabled[i]) === dateIso) {
          errEl.textContent = "Sorry, " + dateIso + " is not available for this variant.";
          return;
        }
      }

      // Disable inputs while the request is in flight
      submitBtn.disabled = true;
      cancelBtn.disabled = true;
      vSel.disabled = true;
      dInput.disabled = true;

      // Friendly user-side bubble so the customer sees what they did
      var nameBits = [product.title || "", v.variant_name || ""].filter(Boolean).join(" / ");
      addBubble("user", "Place Order: " + nameBits + " — " + dateIso);

      // Remove the whole bubble so it can't be re-submitted
      if (wrap._teardownScrollClose) wrap._teardownScrollClose();
      _unregisterActiveForm(wrap);
      wrap.remove();
      cardEl._variantDateBubble = null;

      // v2.31.7 diagnostic (kept in v2.31.8): log what the Variant +
      // Date form is about to send. As of v2.31.8 the payload now
      // includes has_balloon_wording (next to has_card) and
      // v.has_balloon_wording arrives populated from card_variant.
      // If v.has_balloon_wording is still undefined here for a SKU
      // that should be balloon-eligible, check tools.py — the
      // fuzzy_search response key may have been renamed upstream.
      // console.log("[fs-widget][balloon/vdf] submitting variant:",
      //             "product=", product.title,
      //             "variant_id=", v.variant_id,
      //             "variant.has_balloon_wording=", v.has_balloon_wording,
      //             "variant.has_card=", v.has_card);

      send(null, "place_order_from_card", {
        product_id:            product.id,
        product_name:          product.title || "",
        variant_id:            v.variant_id,
        variant_name:          v.variant_name || "",
        // price_int is in CENTS (v2.28.7 endpoint contract). The
        // place_order_handler at line 453-456 reads `price` as ringgit
        // and multiplies by 100 to get cents (matches the legacy
        // pre-v2.28.7 widget contract and the slot-seeded path). Send
        // ringgit here to keep the handler's `*100` math correct.
        // Keep this as a "/100" call rather than reading min_price_int
        // — that field is the product-level minimum across variants and
        // can mismatch the SELECTED variant's price for multi-variant
        // products (e.g. "Luxe Red" 18-stalk Black variant prices at
        // RM288 while min_price_int is 138).
        price:                 (v.price_int || 0) / 100,
        quantity:              1,
        delivery_date:         dateIso,
        earliest_availability: v.earliest_availability || null,
        disabled_dates:        v.disabled_dates || [],
        has_card:              !!v.has_card,
        // v2.31.8: has_balloon_wording — whether this variant accepts
        // a printed balloon phrase. Sibling to has_card; same shape,
        // same propagation. Pre-v2.31.8 this key was OMITTED from the
        // payload, so the backend's place_order_from_card path coerced
        // it to False via `bool(payload.get("has_balloon_wording"))`,
        // and the cart line was permanently mis-tagged → Page 3's
        // "Text On Balloon" field never rendered. Adding the key here
        // — given v2.31.8's tools.py fix that makes `v.has_balloon_wording`
        // actually arrive in the card_variant — closes the chain.
        has_balloon_wording:   !!v.has_balloon_wording,
        // v2.32.5: inventory for backend defensive sold-out guard.
        // Primary gating is _updateSubmitForInventory in the widget;
        // this is second-line.
        inventory:             (v.inventory === undefined || v.inventory === null)
                               ? null
                               : Number(v.inventory),
        // grams is intentionally omitted — the place_order handler
        // defaults to 1000g when absent (the same rule applied to slot-
        // seeded items). The card payload doesn't carry grams.
      });
    });

    // Attach the form to the wrapper bubble and append to the chat
    // stream so it appears as a normal bot bubble — not inside the
    // product card grid (where multiple cards would compete for width).
    wrap.appendChild(form);
    $messages.appendChild(wrap);
    $messages.scrollTop = $messages.scrollHeight;
    cardEl._variantDateBubble = wrap;
    // Owner backref for the single-form rule above: lets the global
    // tear-down loop in openVariantDateForm clear the card's
    // _variantDateBubble pointer when the form is closed by opening
    // ANOTHER card's form.
    wrap._ownerCard = cardEl;
    _registerActiveForm(wrap);

    // When the messages list scrolls, jQuery UI's #ui-datepicker-div
    // (anchored at body level with `position: fixed`) doesn't follow
    // the input that moves with the scroll. Close the picker instead
    // — re-opening is one click and avoids an orphaned calendar
    // hovering over unrelated chat history.
    var closePickerOnScroll = function () {
      try { window.jQuery.datepicker._hideDatepicker(); } catch (_) {}
    };
    $messages.addEventListener("scroll", closePickerOnScroll, { passive: true });
    // Keep the listener bound for the form's lifetime; it's no-op
    // when the picker is already hidden. When the form bubble is
    // removed (cancel/submit/toggle), tear down the listener so we
    // don't leak handlers.
    wrap._teardownScrollClose = function () {
      $messages.removeEventListener("scroll", closePickerOnScroll);
    };
  }


  function renderForm(form) {
    var bubble = document.createElement("div");
    bubble.className = "fs-chatbot-form-bubble";
    bubble.setAttribute("data-form-id", form.form_id);
    // Track this server-side form in the active-forms registry. The
    // input lock state is derived from activeForms.size — server forms
    // count just like variant-date bubbles. Cancel/submit both flow
    // through removeFormBubble below, which unregisters.
    // v2.55.122 — a NON-BLOCKING form (keep_input_enabled, e.g. the
    // escalation "leave your number" form) is deliberately NOT registered,
    // so the composer stays usable and the customer can keep chatting.
    // v2.55.130 — also key off the known escalation contact form_id, so it
    // stays non-blocking even if keep_input_enabled is dropped on the wire
    // or on history replay. The customer must always be able to ignore this
    // form and keep typing; it persists until they submit it.
    var _nonBlocking = !!form.keep_input_enabled
      || form.form_id === "escalation_contact";
    if (!_nonBlocking) {
      // v2.55.171 — single active-form rule: cancel any form already locking
      // the composer before this new server form takes over (a re-render of
      // the same form_id just replaces the old bubble; see
      // _supersedeActiveForms).
      _supersedeActiveForms(form.form_id);
      _registerActiveForm(bubble);
    }

    // v2.55.122 — optional form-level title/intro line (e.g. "Leave your
    // number and we'll contact you on this.").
    if (form.title) {
      var titleEl = document.createElement("div");
      titleEl.className = "fs-chatbot-form-title";
      titleEl.textContent = form.title;
      bubble.appendChild(titleEl);
    }

    var formEl = document.createElement("form");
    formEl.addEventListener("submit", function (e) {
      e.preventDefault();   // we POST via fetch ourselves
    });

    // Track field nodes for show_when evaluation
    var fieldNodes = {};       // id → {wrapper, input, getValue, setError, clearError}
    var fields = form.fields || [];

    fields.forEach(function (field) {
      var node = buildFieldNode(field);
      fieldNodes[field.id] = node;
      formEl.appendChild(node.wrapper);
    });

    // Initial show_when evaluation
    function evalShowWhen() {
      Object.keys(fieldNodes).forEach(function (fid) {
        var fdef = fields.find(function (f) { return f.id === fid; });
        if (!fdef || !fdef.show_when) return;
        var refValue = fieldNodes[fdef.show_when.field] && fieldNodes[fdef.show_when.field].getValue();
        var visible = String(refValue) === String(fdef.show_when.equals);
        fieldNodes[fid].wrapper.classList.toggle("fs-chatbot-hidden", !visible);
      });
    }
    // Wire change handlers on every field so show_when re-evaluates
    Object.keys(fieldNodes).forEach(function (fid) {
      var node = fieldNodes[fid];
      var changeTarget = node.input || node.wrapper;
      changeTarget.addEventListener("change", evalShowWhen);
      // Also handle "input" event for text fields so we react as user types
      changeTarget.addEventListener("input", evalShowWhen);
    });
    evalShowWhen();

    // Action row
    var actions = document.createElement("div");
    actions.className = "fs-chatbot-form-actions";

    var cancelBtn = document.createElement("button");
    cancelBtn.type = "button";
    cancelBtn.className = "fs-chatbot-btn-cancel";
    cancelBtn.textContent = form.cancel_label || "Cancel";

    var submitBtn = document.createElement("button");
    submitBtn.type = "submit";
    submitBtn.className = "fs-chatbot-btn-submit";
    submitBtn.textContent = form.submit_label || "Submit";

    actions.appendChild(cancelBtn);
    actions.appendChild(submitBtn);
    formEl.appendChild(actions);
    bubble.appendChild(formEl);

    // Submit handler — validate, then POST to /chat/form_submit
    submitBtn.addEventListener("click", function () {
      var values = {};
      var firstError = null;

      // Validate visible fields only (hidden fields excluded entirely)
      fields.forEach(function (field) {
        var node = fieldNodes[field.id];
        if (!node) return;
        if (node.wrapper.classList.contains("fs-chatbot-hidden")) {
          node.clearError();
          return;
        }
        var v = node.getValue();
        var err = validateField(field, v);
        if (err) {
          node.setError(err);
          if (!firstError) firstError = field.id;
        } else {
          node.clearError();
          if (v !== null && v !== "") values[field.id] = v;
        }
      });

      if (firstError) {
        // Scroll error into view
        var errEl = fieldNodes[firstError].wrapper;
        if (errEl.scrollIntoView) errEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
        return;
      }

      // Disable buttons during POST
      submitBtn.disabled = true;
      cancelBtn.disabled = true;
      // Pass the full field list so submitForm can render a labelled
      // user-bubble summary of what the customer entered. Without the
      // field metadata we'd only have field IDs (not labels).
      submitForm(form.form_id, values, bubble, fields);
    });

    // Cancel handler — POST to /chat/form_cancel
    cancelBtn.addEventListener("click", function () {
      submitBtn.disabled = true;
      cancelBtn.disabled = true;
      // Pass the cancel button's own label (already in the customer's
      // language because P3/handler produced it) so cancelForm can render
      // a matching user-bubble. e.g. "Cancel" in English, "Batal" in Malay.
      cancelForm(form.form_id, bubble, form.cancel_label);
    });

    return bubble;
  }

  // ---------------------------------------------------------------------
  // Single field builder
  // ---------------------------------------------------------------------
  // Returns { wrapper, input, getValue, setError, clearError }
  function buildFieldNode(field) {
    var wrapper = document.createElement("div");
    wrapper.className = "fs-chatbot-form-field";
    wrapper.setAttribute("data-field-id", field.id);

    // Checkboxes render their own inline label next to the box, so skip
    // the standalone top label for them (it would double the text).
    if (field.type !== "checkbox") {
      var label = document.createElement("label");
      label.innerHTML = escapeHtml(field.label || field.id) +
        (field.required ? '<span class="fs-chatbot-field-required">*</span>' : '');
      wrapper.appendChild(label);
    }

    var input = null;
    var getValue = function () { return null; };

    if (field.type === "date") {
      input = document.createElement("input");
      input.type = "date";
      input.required = !!field.required;
      if (field.min_date) input.min = field.min_date;
      if (field.max_date) input.max = field.max_date;
      if (field.default_value) input.value = field.default_value;
      wrapper.appendChild(input);

      // Disabled-dates notice (since HTML5 doesn't support per-date greying)
      if (field.disabled_dates && field.disabled_dates.length) {
        var notice = document.createElement("span");
        notice.className = "fs-chatbot-disabled-dates";
        var displayed = field.disabled_dates.slice(0, 6).map(formatDateShort).join(", ");
        var more = field.disabled_dates.length > 6
          ? ' and ' + (field.disabled_dates.length - 6) + ' more'
          : '';
        notice.innerHTML = '<strong>Unavailable dates:</strong> ' + displayed + more;
        wrapper.appendChild(notice);
      }
      getValue = function () { return input.value || null; };

    } else if (field.type === "text" || field.type === "email") {
      input = document.createElement("input");
      // v2.55.59 — "email" renders as a text input with type=email so mobile
      // shows the email keyboard and the browser does light native checks.
      // It otherwise behaves exactly like a text field (value, validation).
      input.type = (field.type === "email") ? "email" : "text";
      input.required = !!field.required;
      if (field.placeholder) input.placeholder = field.placeholder;
      if (field.max_length) input.maxLength = field.max_length;
      if (field.default_value) input.value = field.default_value;
      wrapper.appendChild(input);
      getValue = function () { return input.value.trim() || null; };

    } else if (field.type === "textarea") {
      input = document.createElement("textarea");
      input.required = !!field.required;
      if (field.placeholder) input.placeholder = field.placeholder;
      if (field.max_length) input.maxLength = field.max_length;
      if (field.default_value) input.value = field.default_value;
      wrapper.appendChild(input);
      getValue = function () { return input.value.trim() || null; };

    } else if (field.type === "select") {
      var options = field.options || [];

      // Render as radio cards when ≤4 options, otherwise as <select>
      if (options.length <= 4) {
        var group = document.createElement("div");
        group.className = "fs-chatbot-radio-group";
        var radios = [];
        options.forEach(function (opt, idx) {
          var card = document.createElement("label");
          card.className = "fs-chatbot-radio-card";
          var radio = document.createElement("input");
          radio.type = "radio";
          radio.name = "f_" + field.id;
          radio.value = String(opt.value);
          if (field.default_value === opt.value ||
              (idx === 0 && field.default_value !== undefined && field.default_value === null)) {
            // Don't auto-select unless default_value matches
          }
          if (field.default_value !== undefined && String(field.default_value) === String(opt.value)) {
            radio.checked = true;
            card.classList.add("fs-chatbot-selected");
          }
          var body = document.createElement("div");
          body.className = "fs-chatbot-radio-body";
          body.innerHTML =
            '<div class="fs-chatbot-radio-label">' + escapeHtml(opt.label || opt.value) + '</div>' +
            (opt.sublabel
              ? '<div class="fs-chatbot-radio-sublabel">' + escapeHtml(opt.sublabel) + '</div>'
              : '');
          card.appendChild(radio);
          card.appendChild(body);
          group.appendChild(card);
          radios.push(radio);

          radio.addEventListener("change", function () {
            // Update visual selection
            group.querySelectorAll(".fs-chatbot-radio-card").forEach(function (el) {
              el.classList.remove("fs-chatbot-selected");
            });
            card.classList.add("fs-chatbot-selected");
            // Fire a change event on the wrapper so show_when listeners trigger
            wrapper.dispatchEvent(new Event("change", { bubbles: true }));
          });
        });
        wrapper.appendChild(group);
        input = group;     // wrapper-level; show_when reads via getValue
        getValue = function () {
          var checked = radios.find(function (r) { return r.checked; });
          return checked ? checked.value : null;
        };
      } else {
        // Dropdown <select> for many options
        input = document.createElement("select");
        input.required = !!field.required;
        // Empty placeholder option
        var empty = document.createElement("option");
        empty.value = "";
        empty.textContent = "— Pick one —";
        input.appendChild(empty);
        options.forEach(function (opt) {
          var o = document.createElement("option");
          o.value = String(opt.value);
          o.textContent = opt.label || opt.value;
          if (field.default_value !== undefined && String(field.default_value) === String(opt.value)) {
            o.selected = true;
          }
          input.appendChild(o);
        });
        wrapper.appendChild(input);
        getValue = function () { return input.value || null; };
      }

    } else if (field.type === "checkbox") {
      // Single on/off toggle. Rendered as a labelled checkbox row.
      // getValue returns a boolean.
      var checkRow = document.createElement("label");
      checkRow.className = "fs-chatbot-checkbox-row";
      var box = document.createElement("input");
      box.type = "checkbox";
      box.className = "fs-chatbot-checkbox-input";
      box.checked = field.default_value === true ||
                    field.default_value === "true";
      var checkLabel = document.createElement("span");
      checkLabel.className = "fs-chatbot-checkbox-label";
      checkLabel.textContent = field.label || field.id;
      checkRow.appendChild(box);
      checkRow.appendChild(checkLabel);
      wrapper.appendChild(checkRow);
      // Fire change on the wrapper so show_when listeners re-evaluate
      box.addEventListener("change", function () {
        wrapper.dispatchEvent(new Event("change", { bubbles: true }));
      });
      input = box;
      getValue = function () { return box.checked; };

    } else {
      // Unknown type — log and skip
      console.warn("[fs-widget] unknown field type:", field.type);
      var fallback = document.createElement("div");
      fallback.textContent = "(unsupported field type: " + field.type + ")";
      wrapper.appendChild(fallback);
    }

    // Error display element
    var errEl = document.createElement("span");
    errEl.className = "fs-chatbot-field-error";
    wrapper.appendChild(errEl);

    return {
      wrapper:    wrapper,
      input:      input,
      getValue:   getValue,
      setError:   function (msg) {
        wrapper.classList.add("fs-chatbot-has-error");
        errEl.textContent = msg;
      },
      clearError: function () {
        wrapper.classList.remove("fs-chatbot-has-error");
        errEl.textContent = "";
      },
    };
  }

  // ---------------------------------------------------------------------
  // Field validation (client-side; server validates again)
  // ---------------------------------------------------------------------
  function validateField(field, value) {
    var isEmpty = value === null || value === undefined ||
                  (typeof value === "string" && !value.trim());
    if (isEmpty) {
      return field.required ? "This field is required." : null;
    }

    if (field.type === "date") {
      // YYYY-MM-DD check
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return "Please pick a valid date.";
      }
      if (field.disabled_dates && field.disabled_dates.indexOf(value) !== -1) {
        return "This date isn't available. Please pick another.";
      }
      if (field.min_date && value < field.min_date) {
        return "Earliest available date is " + formatDateShort(field.min_date) + ".";
      }
      if (field.max_date && value > field.max_date) {
        return "Latest possible date is " + formatDateShort(field.max_date) + ".";
      }
    }

    if (field.type === "email") {
      // v2.55.59 — light client-side email check. The authoritative check is
      // server-side (handle_email_verify_request validates "@" + a dotted
      // domain); this just catches obvious typos before the round-trip.
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return "Please enter a valid email address.";
      }
    }

    if (field.type === "text" || field.type === "textarea" || field.type === "email") {
      if (field.max_length && value.length > field.max_length) {
        return "Please keep it under " + field.max_length + " characters.";
      }
      if (field.pattern) {
        try {
          var re = new RegExp("^(?:" + field.pattern + ")$");
          if (!re.test(value)) {
            return "Please check the format.";
          }
        } catch (e) {
          console.warn("[fs-widget] bad pattern:", field.pattern);
        }
      }
    }

    if (field.type === "select") {
      var options = field.options || [];
      var valid = options.some(function (o) { return String(o.value) === String(value); });
      if (!valid) return "Please pick one of the options.";
    }

    return null;
  }

  function formatDateShort(iso) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso;
    var parts = iso.split("-");
    var months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    return parseInt(parts[2], 10) + " " + months[parseInt(parts[1], 10) - 1];
  }

  // ---------------------------------------------------------------------
  // Form networking
  // ---------------------------------------------------------------------
  // ---------------------------------------------------------------------
  // Render a "user message" bubble showing what was submitted in a form.
  // Inserted before the form is removed so the conversation reads naturally:
  //   form ask → user-submitted summary → bot reply.
  //
  // For select fields, the option's `label` is used (not the raw value) so
  // the customer sees "36 stalks — RM308" rather than the variant_id "2002".
  // ---------------------------------------------------------------------
  function buildSubmissionSummary(fields, values) {
    if (!fields || !fields.length) return "";

    // Collect (label, displayValue) pairs for each non-empty submitted field
    var pairs = [];
    fields.forEach(function (field) {
      var raw = values[field.id];
      if (raw === undefined || raw === null || raw === "") return;

      var displayValue = String(raw);
      // Normalize whitespace — textarea input may have newlines that
      // would render as spaces anyway in HTML, but a "\n" between two
      // lines of an address reads better as ", " in the summary.
      displayValue = displayValue.replace(/\s*\n\s*/g, ", ").replace(/\s+/g, " ").trim();

      // For select fields, look up the option label by value so the
      // customer sees "36 stalks — RM308" rather than the variant_id "2002"
      if (field.type === "select" && Array.isArray(field.options)) {
        var matched = field.options.find(function (o) {
          return String(o.value) === String(raw);
        });
        if (matched && matched.label) displayValue = matched.label;
      }

      var label = field.label || field.id;
      // Strip trailing colon / question mark from labels so we don't get
      // "Where should we deliver?: 12 Jalan Klang" — make it
      // "Where should we deliver: 12 Jalan Klang"
      label = label.replace(/[?:]\s*$/, "");
      pairs.push({label: label, value: displayValue});
    });

    if (pairs.length === 0) return "";

    // Always show labels (even for single-field forms) — makes the chat
    // history self-documenting when customers scroll back. "Address: 12
    // Jalan Klang" is clearer than just "12 Jalan Klang" without context.
    return pairs.map(function (p) { return p.label + ": " + p.value; }).join(" • ");
  }

  // v2.55.59 — Email verification (two-step), reusing the OTP engine.
  // Step 1: email_verify_request → POST /email_verify/request → on success,
  //         surface the OTP-code form (step 2).
  // Step 2: email_verify_code → POST /email_verify/verify → on success, the
  //         session is now email-verified; prompt the customer to re-ask for
  //         their order so the (now-authenticated) order_details handler runs.
  // Holds the otp_request_id between the two steps.
  var _emailVerifyState = { otpRequestId: null, email: null };

  function _otpCodeForm() {
    return {
      form_id: "email_verify_code",
      fields: [{
        id: "code", type: "text", label: "6-digit code",
        required: true,
        helper: "Check your inbox (and spam folder) for the code.",
      }],
      submit_label: "Verify",
      cancel_label: "Cancel",
    };
  }

  function submitEmailVerify(formId, values, bubbleEl, fields) {
    // Echo what the customer entered (email or code) as a user bubble.
    var summary = buildSubmissionSummary(fields || [], values);
    if (summary) addBubble("user", summary);

    if (formId === "email_verify_request") {
      var email = values.email || "";
      _emailVerifyState.email = email;
      showTyping();
      api("/email_verify/request", {
        widget_key: WIDGET_KEY,
        session_id: SESSION_ID,
        email_address: email,
      }).then(function (res) {
        hideTyping();
        removeFormBubble(bubbleEl);
        var body = res && res.body;
        if (res.status !== 200 || !body || body.status !== "success") {
          // The only surfaced failure is a malformed email (400). The
          // backend is enumeration-safe otherwise, so a non-success here
          // is a genuine input/transport error.
          addBubble("bot", (body && body.error === "invalid_email")
            ? "That doesn't look like a valid email address. Please try again."
            : "Sorry, I couldn't start verification just now. Please try again or contact us on WhatsApp.");
          return;
        }
        _emailVerifyState.otpRequestId = body.otp_request_id;
        // Enumeration-safe instruction from the backend.
        addBubble("bot", body.instruction ||
          "If that email has orders with us, a 6-digit code is on its way. Please enter it below.");
        // Surface the code form (step 2).
        var formBubble = renderForm(_otpCodeForm());
        $messages.appendChild(formBubble);
        scrollToBottom();
      }).catch(function () {
        hideTyping();
        removeFormBubble(bubbleEl);
        addBubble("bot", "Sorry, I couldn't start verification just now. Please try again or contact us on WhatsApp.");
      });
      return;
    }

    // formId === "email_verify_code"
    var code = values.code || "";
    showTyping();
    api("/email_verify/verify", {
      widget_key: WIDGET_KEY,
      session_id: SESSION_ID,
      otp_request_id: _emailVerifyState.otpRequestId,
      code: code,
    }).then(function (res) {
      hideTyping();
      removeFormBubble(bubbleEl);
      var body = res && res.body;
      if (res.status === 200 && body && body.status === "success") {
        addBubble("bot",
          "Thanks — you're verified. What's the order number you'd like to check? "
          + "(You can also just ask to see your recent orders.)");
        return;
      }
      // Map the verify error codes to friendly guidance. Wrong code keeps
      // the form available for a retry.
      var err = (body && body.error) || "";
      if (err === "otp_wrong_code") {
        var remaining = (body && body.remaining_attempts);
        addBubble("bot", "That code didn't match"
          + (typeof remaining === "number" ? " (" + remaining + " attempt"
              + (remaining === 1 ? "" : "s") + " left)" : "")
          + ". Please try again.");
        var retry = renderForm(_otpCodeForm());
        $messages.appendChild(retry);
        scrollToBottom();
      } else if (err === "otp_expired") {
        addBubble("bot", "That code has expired. Let's start over — please enter your email again.");
        var again = renderForm({ form_id: "email_verify_request",
          fields: [{ id: "email", type: "email", label: "Your email address",
                     required: true, helper: "Use the email you ordered with." }],
          submit_label: "Send code", cancel_label: "Cancel" });
        $messages.appendChild(again);
        scrollToBottom();
      } else if (err === "otp_max_attempts" || err === "otp_consumed") {
        addBubble("bot", "Too many attempts on that code. Please request a new one by entering your email again.");
      } else {
        addBubble("bot", "Sorry, I couldn't verify that code. Please try again or contact us on WhatsApp.");
      }
    }).catch(function () {
      hideTyping();
      removeFormBubble(bubbleEl);
      addBubble("bot", "Sorry, I couldn't verify that code. Please try again or contact us on WhatsApp.");
    });
  }

  function submitForm(formId, values, bubbleEl, fields) {
    // v2.55.59 — email-verification forms do NOT go through /chat/form_submit.
    // They drive the dedicated /email_verify/* endpoints (request a code, then
    // verify it), reusing the same OTP engine as phone verification. Intercept
    // here and hand off to the two-step flow.
    if (formId === "email_verify_request" || formId === "email_verify_code") {
      submitEmailVerify(formId, values, bubbleEl, fields);
      return;
    }
    // Show what the customer submitted as a user bubble. We insert this
    // BEFORE removing the form so the message order in the DOM matches the
    // conversation order: form → user submission → bot reply.
    var summary = buildSubmissionSummary(fields || [], values);
    if (summary) {
      addBubble("user", summary);
    }

    showTyping();
    FS_FIRESTORE.beginInFlight();   // v2.53.0
    api("/chat/form_submit", {
      widget_key: WIDGET_KEY,
      session_id: SESSION_ID,
      tab_id:     TAB_ID,
      page_url: location.href,
      page_context: getPageContext(),
      form_id: formId,
      values: values,
    }).then(function (res) {
      hideTyping();
      if (res.status !== 200 || !res.body) {
        addBubble("bot", "Something went wrong submitting the form. Please try again.");
        return;
      }
      // v2.53.0: register IDs for listener dedup.
      FS_FIRESTORE.registerSeenId(res.body.user_message_id);
      FS_FIRESTORE.registerSeenId(res.body.assistant_message_id);

      // Remove the submitted form from the DOM so it can't be re-submitted
      removeFormBubble(bubbleEl);

      var reply = (res.body.reply) || res.body;
      updateCartStateFromReply(reply);
      updateFullCartFromResponse(res.body);
      // v2.55.18 — same defense-in-depth dedup as the /chat .then path.
      // If the listener already rendered the assistant bubble before
      // this .then arrived, skip our addBubble.
      var _formSubmitAssistantId = res.body.assistant_message_id;
      if (_formSubmitAssistantId && FS_FIRESTORE.hasRenderedNode(_formSubmitAssistantId)) {
        // console.info("[FS/form_submit] skip_addBubble (listener already rendered)",
          // "assistant_message_id=" + _formSubmitAssistantId);
      } else {
        addBubble("bot", reply.text || "", {
          products: reply.products,
          photos:   reply.photos,
          buttons:  reply.buttons,
          delivery_quote: reply.delivery_quote,
          order_details_card: reply.order_details_card,
          form:     reply.form,
        });
      }
    }).catch(function () {
      hideTyping();
      addBubble("bot", "I couldn't reach the server. Please try again.");
    }).finally(function () {
      FS_FIRESTORE.endInFlight();   // v2.53.0
    });
  }

  function cancelForm(formId, bubbleEl, cancelLabel) {
    // Show what the customer did as a user bubble — matches the same
    // pattern as submit. The bubble uses the form's own cancel_label
    // (e.g. "Cancel", "Batal") so it reads naturally in their language.
    // Fallback to "Cancelled" if no label is available.
    var bubbleText = cancelLabel || "Cancelled";
    addBubble("user", bubbleText);

    showTyping();
    FS_FIRESTORE.beginInFlight();   // v2.53.0
    api("/chat/form_cancel", {
      widget_key: WIDGET_KEY,
      session_id: SESSION_ID,
      tab_id:     TAB_ID,
      page_url:   location.href,
      form_id:    formId,
    }).then(function (res) {
      hideTyping();
      // v2.53.0: register IDs for listener dedup.
      if (res.body) {
        FS_FIRESTORE.registerSeenId(res.body.user_message_id);
        FS_FIRESTORE.registerSeenId(res.body.assistant_message_id);
      }
      // Remove form from DOM regardless of response status — customer
      // clicked cancel, honour that intent
      removeFormBubble(bubbleEl);
      if (res.status === 200 && res.body && res.body.reply) {
        updateCartStateFromReply(res.body.reply);
        updateFullCartFromResponse(res.body);
        // v2.55.18 — same defense-in-depth dedup as /chat and /form_submit.
        var _formCancelAssistantId = res.body.assistant_message_id;
        if (_formCancelAssistantId && FS_FIRESTORE.hasRenderedNode(_formCancelAssistantId)) {
          // console.info("[FS/form_cancel] skip_addBubble (listener already rendered)",
            // "assistant_message_id=" + _formCancelAssistantId);
        } else {
          addBubble("bot", res.body.reply.text || "", {
            products: res.body.reply.products,
            photos:   res.body.reply.photos,
            buttons:  res.body.reply.buttons,
            delivery_quote: res.body.reply.delivery_quote,
            order_details_card: res.body.reply.order_details_card,
            form:     null,
          });
        }
      }
    }).catch(function () {
      hideTyping();
      removeFormBubble(bubbleEl);
    }).finally(function () {
      FS_FIRESTORE.endInFlight();   // v2.53.0
    });
  }

  function removeFormBubble(bubbleEl) {
    // The form lives inside a .msg wrapper. Find it and remove the whole
    // form section so the bubble's text remains as a conversation marker.
    if (bubbleEl && bubbleEl.parentNode) {
      _unregisterActiveForm(bubbleEl);
      bubbleEl.parentNode.removeChild(bubbleEl);
    }
  }

  function showWelcome() {
    if (hasShownWelcome) return;
    hasShownWelcome = true;
    var w = document.createElement("div");
    w.className = "fs-chatbot-welcome";
    w.innerHTML =
      '<h3 class="fs-chatbot-display">Hello🌸</h3>' +
      '<p>I\'m your Flower Sugar concierge. Ask me anything — recommendations, delivery, tracking, or place an order.</p>' +
      '<p class="fs-chatbot-welcome-langs">You can chat with me in English, Bahasa Melayu, or 中文 — whichever you prefer.</p>';
    $messages.appendChild(w);
    scrollToBottom();
  }

  var typingNode = null;
  function showTyping() {
    if (typingNode) return;
    var wrap = document.createElement("div");
    wrap.className = "fs-chatbot-msg fs-chatbot-bot";
    var t = document.createElement("div");
    t.className = "fs-chatbot-bubble fs-chatbot-typing";
    t.innerHTML = "<span></span><span></span><span></span>";
    wrap.appendChild(t);
    $messages.appendChild(wrap);
    typingNode = wrap;
    // Force-snap: the typing indicator appears in direct response to
    // the customer's just-sent message, so they expect to see it.
    scrollToBottom(true);
  }
  function hideTyping() {
    if (typingNode && typingNode.parentNode) typingNode.parentNode.removeChild(typingNode);
    typingNode = null;
  }

  function autosize() {
    $input.style.height = "auto";
    $input.style.height = Math.min($input.scrollHeight, 120) + "px";
  }
  $input.addEventListener("input", autosize);
  // v2.53.3: typing-signal handler. Fires on every keystroke. The
  // typing module owns debounce/heartbeat internally — this just
  // notifies it that a keystroke happened.
  $input.addEventListener("input", function () {
    try { FS_TYPING.onKeystroke(); } catch (_) {}
  });

  // ---------------------------------------------------------------------
  // Networking
  // ---------------------------------------------------------------------
  // v2.55.4 — when the server returns `redirected_to_session_id` in
  // any response body, this session has been merged into a "live"
  // session (typically after OTP verify). Update the cookie AND the
  // in-memory SESSION_ID variable so all subsequent API calls use the
  // correct session.
  //
  // The widget keeps SESSION_ID as a mutable `var` (line ~122) so we
  // can rewrite it here. After this runs, all `session_id: SESSION_ID`
  // references in the codebase pick up the new value automatically.
  //
  // `_pendingHistoryReloadAfterRedirect` is set when a /history call
  // returned a redirect — the caller needs to know it should treat
  // the response's `messages` as the canonical new view (replacing
  // the previously-rendered messages, not appending).
  var _pendingHistoryReloadAfterRedirect = false;

  function _maybeApplyRedirect(body, path) {
    if (!body || typeof body !== "object") return;
    var target = body.redirected_to_session_id;
    if (!target || typeof target !== "string") return;
    if (target === SESSION_ID) return;   // already aligned (defensive)
    var previous = SESSION_ID;
    SESSION_ID = target;
    setCookie(COOKIE_NAME, target, 365);
    try {
      // console.info(
        // "[FlowerSugar/redirect] session", previous, "→", target,
        // "(path=" + path + ")"
      // );
    } catch (_) {}
    // /history's redirect means the message stream the widget shows
    // should be replaced. Flag so loadHistory's caller can re-render.
    if (path === "/history") {
      _pendingHistoryReloadAfterRedirect = true;
    }
  }

  // v2.55.6 — when any response indicates the session was archived
  // (status: "session_archived" with an archived_new_session_id),
  // wipe the local state and adopt the new session id. This is
  // MORE AGGRESSIVE than redirect handling because the customer (or
  // another device of the same customer) explicitly cleared history.
  //
  // Returns true if the response was an archive signal (the caller
  // can short-circuit its own success path), false otherwise.
  function _maybeApplyArchive(body, path) {
    if (!body || typeof body !== "object") return false;
    if (body.status !== "session_archived") return false;
    var newSid = body.archived_new_session_id;
    if (!newSid || typeof newSid !== "string") return false;
    var previous = SESSION_ID;
    SESSION_ID = newSid;
    setCookie(COOKIE_NAME, newSid, 365);
    try {
      // console.info(
        // "[FlowerSugar/archive] session", previous, "→", newSid,
        // "(path=" + path + ") — wiping local state"
      // );
    } catch (_) {}
    // Wipe the DOM message stream.
    try {
      while ($messages && $messages.firstChild) {
        $messages.removeChild($messages.firstChild);
      }
    } catch (_) {}
    // Clear linked-phone indicator (new session is unlinked).
    try { FS_PHONE.setLinkedFromHistory(null); } catch (_) {}
    // Forget the old session's message ids.
    try { FS_FIRESTORE.resetSeenIds(); } catch (_) {}
    // Reload /history against the new (empty) session so the widget
    // boots the listener + shows the welcome state.
    //
    // Schedule via setTimeout so the current api() call's `.then`
    // can return cleanly first — otherwise loadHistory's nested
    // api() call could race.
    try {
      setTimeout(function () {
        try { loadHistory(); } catch (_) {}
      }, 50);
    } catch (_) {}
    return true;
  }

  function api(path, body) {
    return fetch(ENDPOINT.replace(/\/+$/, "") + path, {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {}),
    }).then(function (r) {
      return r.json().then(function (j) {
        // v2.55.6: archive check FIRST. If the server tells us this
        // session was cleared, wipe local state and adopt a new id.
        // The caller's success path is short-circuited via the
        // returned flag — most callers will see this as a benign
        // "the response had no useful data" event and bail.
        try {
          var archived = _maybeApplyArchive(j, path);
          if (archived) {
            // Return a synthetic body so callers don't crash on
            // missing fields. Status stays as the real HTTP status
            // (typically 200, since the server returned a structured
            // response, not an error).
            return { status: r.status, body: j, archived: true };
          }
        } catch (e) {
          console.warn("[FS/archive] apply failed:", e && e.message);
        }
        // v2.55.4: apply any redirect BEFORE returning to the caller,
        // so the caller's follow-up logic uses the new SESSION_ID.
        try { _maybeApplyRedirect(j, path); } catch (e) {
          console.warn("[FS/redirect] apply failed:", e && e.message);
        }
        return { status: r.status, body: j };
      });
    });
  }

  function warm() {
    fetch(ENDPOINT.replace(/\/+$/, "") + "/health").catch(function () {});
  }

  function loadHistory() {
    api("/history", { widget_key: WIDGET_KEY, session_id: SESSION_ID })
      .then(function (res) {
        if (res.status !== 200 || !res.body || !res.body.messages) {
          // v2.53.0: still boot the Firestore listener even on /history
          // failure — the customer can still receive new messages live.
          FS_FIRESTORE.boot();
          return;
        }
        var msgs = res.body.messages;

        // ╔═══ HISTORY-ORDER DIAGNOSTIC (v2.34.x) ═══╗
        try {
          var _preview = msgs.map(function (m, i) {
            return {
              i: i, id: m.id, role: m.role,
              created: m.created || "NULL",
              text: (m.text || "").slice(0, 32),
            };
          });
          // console.info("[FlowerSugar/history] received from /history",
                       // "session=" + SESSION_ID, "count=" + msgs.length,
                       // "last_known_ts=" + (res.body.last_known_ts || "null"),
                       // _preview);
        } catch (_) {}
        // ╚══════════════════════════════════════════╝

        // v2.53.0: seed the Firestore listener's anchor BEFORE rendering
        // bubbles, so when attachListeners runs after this block, it
        // knows where to start the `created > last_known_ts` filter.
        if (res.body.last_known_ts) {
          FS_FIRESTORE.setLastKnownTs(res.body.last_known_ts);
        }

        // v2.55.0: surface linked phone (if any) so the header
        // subtitle shows "Saved as +6012•••6789" on widget mount.
        // Also tells FS_PHONE not to show the soft prompt (linked
        // customers never see it).
        try {
          FS_PHONE.setLinkedFromHistory(res.body.linked_phone);
        } catch (_) {}

        if (!msgs.length) { showWelcome(); }
        else {
          msgs.forEach(function (m, _idx) {
            var role = m.role === "user" ? "user" : "bot";
            var meta = m.meta || {};
            // v2.53.0: never render a message the agent has hidden.
            // Still register its id in the seen-set so the Firestore
            // listener's initial snapshot skips it too.
            if (meta.hidden) {
              FS_FIRESTORE.registerSeenId(m.id);
              return;
            }
            var opts = { buttons: meta.buttons, ts: m.created };
            if (RENDER_HISTORICAL_STRUCTURED) {
              opts.products = meta.products;
              opts.photos   = meta.photos;
              opts.delivery_quote = meta.delivery_quote;
              opts.order_details_card = meta.order_details_card;
              // v2.32.0: payment artifacts always replayed regardless
              // of RENDER_HISTORICAL_STRUCTURED — they're a durable
              // record, not "rich" content like product cards.
              opts.bank_details        = meta.bank_details;
              opts.payment_expiry_note = meta.payment_expiry_note;
              opts.draft_order_number  = meta.draft_order_number;
            }
            try {
              // console.info("[FlowerSugar/history] addBubble",
                           // "i=" + _idx, "id=" + m.id, "role=" + role,
                           // "created=" + (m.created || "NULL"),
                           // "text=" + (m.text || "").slice(0, 32));
            } catch (_) {}
            var node = addBubble(role, m.text || "", opts);
            // v2.53.0: register the rendered node in the listener's
            // seen-set + map so retraction (meta.hidden) and delete
            // can find it later.
            FS_FIRESTORE.registerSeenId(m.id, node);
          });
        }
        // v2.53.0: backfill ids are registered — boot the listener.
        // boot() is idempotent so calling it on every history reload
        // is safe.
        FS_FIRESTORE.boot();
      })
      .catch(function () {
        showWelcome();
        FS_FIRESTORE.boot();
      });
  }

  // v2.29.1 — cold-start cart-panel population. Called at boot (in
  // parallel with loadHistory) so the panel is populated before the
  // customer types anything. On every subsequent chat response, the
  // panel is refreshed from response.cart via updateFullCartFromResponse.
  //
  // Soft fail: any error → panel stays hidden (no items rendered).
  // The chat itself still works.
  function loadCartState() {
    // v2.55.19 hotfix: returns the promise so the caller can chain
    // FS_SHOPIFY_CART.boot() AFTER loadCartState resolves. Previously
    // both ran in parallel; if Shopify's /cart.js returned first, the
    // adoption could be wiped by setFullCart() arriving later.
    // console.info("[FS/cart_state] fetch /cart/state — starting");
    return api("/cart/state", { widget_key: WIDGET_KEY, session_id: SESSION_ID })
      .then(function (res) {
        if (res.status !== 200 || !res.body) {
          // console.info("[FS/cart_state] /cart/state non-200 or no body",
            // "status=" + res.status);
          return;
        }
        if (res.body.status !== "success") {
          // console.info("[FS/cart_state] /cart/state body.status not success",
            // "body_status=" + res.body.status);
          return;
        }
        var itemCount = (res.body.cart && Array.isArray(res.body.cart.items))
          ? res.body.cart.items.length : 0;
        // console.info("[FS/cart_state] /cart/state — got cart",
          // "items_n=" + itemCount);
        setFullCart(res.body.cart);
      })
      .catch(function (err) {
        // soft fail — panel stays hidden
        // console.info("[FS/cart_state] /cart/state failed (soft):",
          // err && err.message);
      });
  }

  function send(message, quickAction, quickActionPayload) {
    if (isSending) return;
    if (!message && !quickAction) return;

    // v2.31.0 Phase 5: when the customer sends a TYPED message
    // (not a quick-action click), hide any quick-action button rows
    // on prior bot bubbles. The buttons no longer represent valid
    // next-steps — the customer's typed message is now driving the
    // flow. Hiding prevents confused later taps on stale affordances.
    //
    // Why typed-message only: a quick-action click already disables
    // its own button row (handled in the dispatch handler). Hiding
    // ALL rows on every send would double-disable the row the
    // customer just clicked, which is harmless but redundant.
    if (message) {
      var staleRows = document.querySelectorAll(".fs-chatbot-btn-row");
      staleRows.forEach(function (row) {
        // Hide STALE quick-action buttons on prior bubbles, but KEEP the
        // evergreen "Proceed to order" (continue_to_delivery): it stays valid
        // for as long as the cart has items (it just opens the wizard
        // locally), exactly like the WhatsApp URL buttons we already preserve.
        // v2.55.156 — pre-fix this hid the WHOLE row, so typing a message
        // removed the only checkout affordance for the entire (often 15-30s)
        // round-trip. Now we hide each non-proceed quick-action individually
        // and only collapse the row if nothing evergreen survives.
        var quicks = row.querySelectorAll(".fs-chatbot-btn-quick");
        if (!quicks.length) return;
        var keptProceed = false;
        quicks.forEach(function (b) {
          if (b.getAttribute("data-action") === "continue_to_delivery") {
            keptProceed = true;          // evergreen — leave visible
          } else {
            b.style.display = "none";    // genuinely stale — hide
          }
        });
        if (!keptProceed) row.style.display = "none";
      });
    }

    if (message) addBubble("user", message);
    isSending = true;
    _updateInputLockState();
    showTyping();
    // v2.53.0: tell the Firestore listener a POST is in flight, so
    // any onSnapshot fire for the same message gets deferred until
    // the POST returns IDs we can use for dedup.
    FS_FIRESTORE.beginInFlight();
    // v2.53.3: send means typing is done. Clear the signal immediately
    // so other tabs unlock without waiting for the stop timer.
    try { FS_TYPING.onSend(); } catch (_) {}

    // v2.53.4 diag: log every send attempt with the outgoing body so a
    // later "no response rendered" report can be traced back to either
    // (a) request never built right, or (b) response came back but
    // wasn't rendered. The actual response gets logged in the .then
    // branches below.
    var _chatStartTs = Date.now();
    // console.info("[FS/chat] POST /chat send",
      // "session=" + SESSION_ID,
      // "tab=" + TAB_ID,
      // "message=" + JSON.stringify(message || "").slice(0, 80),
      // "quick_action=" + (quickAction || "null"));

    api("/chat", {
      widget_key: WIDGET_KEY,
      session_id: SESSION_ID,
      tab_id:     TAB_ID,
      page_url: location.href,
      page_context: getPageContext(),
      // v2.55.50 — ad-click attribution (gclid/fbclid/_fbp/_fbc, captured
      // at landing). null for organic visitors. The backend persists this
      // on the session so a conversion can be uploaded to Google Ads / Meta
      // CAPI when payment is later confirmed (the customer never hits the
      // checkout/thank-you page, so the standard Purchase pixel can't fire).
      attribution: getAttribution(),
      language: "auto",
      message: message || "",
      quick_action: quickAction || null,
      quick_action_payload: quickActionPayload || null,
      // v2.55.42 — lazy Firestore connection. A message is the action that
      // earns the persistent connection (the only reason it exists is to
      // receive PUSH: async agent replies + cross-tab messages). Ask the
      // backend to save the session and mint a token when we don't yet hold
      // one. The backend also re-issues a token if it finds the session doc
      // missing (Gate 2), so we surface our current state either way.
      needs_firestore_token: !FS_FIRESTORE.hasToken(),
    })
      .then(function (res) {
        hideTyping();
        // v2.53.4 diag: log every response. Captures status, the shape
        // of body, and which branch the widget is about to take. If
        // the body is null/undefined/non-200, the next two if-blocks
        // will short-circuit; otherwise the render branch runs.
        try {
          var _bodyShape = res.body ? {
            status:               res.body.status,
            has_reply:            !!res.body.reply,
            reply_text_len:       (res.body.reply && res.body.reply.text || "").length,
            reply_suppressed:     !!(res.body.reply && res.body.reply.suppressed),
            user_message_id:      res.body.user_message_id || null,
            assistant_message_id: res.body.assistant_message_id || null,
            has_form:             !!(res.body.reply && res.body.reply.form),
            has_products:         !!(res.body.reply && res.body.reply.products),
            has_buttons:          !!(res.body.reply && res.body.reply.buttons),
          } : null;
          // console.info("[FS/chat] POST /chat response",
            // "status=" + res.status,
            // "elapsed=" + (Date.now() - _chatStartTs) + "ms",
            // "body=" + JSON.stringify(_bodyShape));
        } catch (e) {
          console.warn("[FS/chat] response-log threw:", e && e.message);
        }

        if (res.status === 429) {
          // console.info("[FS/chat] branch=429");
          addBubble("bot", "You're sending messages a bit too quickly. Please pause for a moment and try again.");
          return;
        }
        if (res.status !== 200 || !res.body || res.body.status !== "success") {
          console.warn("[FS/chat] branch=error_or_non200",
            "status=" + res.status,
            "body_status=" + (res.body && res.body.status));
          addBubble("bot", "Sorry, something went wrong on our side. Please try again or message us on WhatsApp.", {
            buttons: [{
              label: "Open WhatsApp",
              // Session ID injected by addBubble automatically for WhatsApp buttons
              url: "https://wa.me/60196800751",
            }],
          });
          return;
        }
        // v2.55.42 — apply any custom token the backend bundled into the
        // response. The backend returns one when it just saved the session
        // (Gate 1: we asked via needs_firestore_token) OR when it found the
        // session doc missing and recreated it (Gate 2). Either way, adopt
        // the latest token: this opens the persistent connection (first
        // time) or re-signs-in (refresh). No-op when no token is present.
        if (res.body.firestore_token) {
          FS_FIRESTORE.applyToken({
            token:      res.body.firestore_token,
            expires_at: res.body.firestore_token_expires_at,
          });
        }
        // v2.53.0: register the Firestore doc IDs so the listener
        // de-duplicates the echo of our own writes. Both may be null
        // if append_message failed silently — null entries are safe
        // to register (they just don't match anything).
        FS_FIRESTORE.registerSeenId(res.body.user_message_id);
        FS_FIRESTORE.registerSeenId(res.body.assistant_message_id);

        var reply = res.body.reply || {};
        // v2.55.140 — remember the resolved conversation language so order-flow
        // button labels render in the customer's language.
        if (reply.language === "en" || reply.language === "ms" || reply.language === "zh") {
          convoLanguage = reply.language;
          applyStaticButtonLabels();
        }
        updateCartStateFromReply(reply);
        updateFullCartFromResponse(res.body);
        if (reply.suppressed) {
          // Live-agent mode: the bot is silent. The customer's turn is
          // already on screen (optimistic) + persisted server-side; the
          // agent's reply arrives via the widget's persistent Firestore
          // listener. v2.55.42: the listener is opened by applyToken above
          // (this message earned the token). boot() only prepares the SDK
          // and is a harmless idempotent no-op for the connection itself.
          FS_FIRESTORE.boot();
          return;   // skip the empty-bubble render below
        }
        // v2.55.4 diag: log just before addBubble so we know rendering
        // was reached. If you see this line but no bubble appears,
        // the bug is INSIDE addBubble (rendering path).
        // console.info("[FS/chat] branch=render",
          // "text_len=" + (reply.text || "").length,
          // "has_form=" + !!reply.form,
          // "has_products=" + !!reply.products,
          // "buttons=" + (reply.buttons ? reply.buttons.length : 0));

        // v2.55.18 — defense-in-depth dedup. If the listener already
        // painted the assistant bubble before .then arrived (rare,
        // but possible when defer timeout fired or when Firestore
        // notification beat the POST response — see CHANGELOG for
        // the race conditions), skip our own addBubble. The
        // registerSeenId calls above protect FUTURE listener events;
        // hasRenderedNode protects THIS .then call from creating a
        // duplicate of an already-rendered bubble.
        var _assistantId = res.body.assistant_message_id;
        if (_assistantId && FS_FIRESTORE.hasRenderedNode(_assistantId)) {
          // console.info("[FS/chat] branch=skip_addBubble " +
                       // "(listener already rendered)",
            // "assistant_message_id=" + _assistantId);
        } else {
          addBubble("bot", reply.text || "", {
            products: reply.products,
            photos:   reply.photos,
            buttons:  reply.buttons,
            delivery_quote: reply.delivery_quote,
            order_details_card: reply.order_details_card,
            form:     reply.form,
          });
          // console.info("[FS/chat] addBubble returned (bot reply rendered)");
        }
      })
      .catch(function (err) {
        hideTyping();
        // v2.53.4 diag: log the actual error rather than swallowing it.
        // If you see this line for a bug where "the bot doesn't reply",
        // the network or fetch threw — the rest of the path didn't run.
        console.error("[FS/chat] catch path entered",
          "error=" + (err && err.message),
          "stack=" + (err && err.stack));
        addBubble("bot", "I couldn't reach the server. Please check your connection and try again.");
      })
      .finally(function () {
        // v2.53.4 diag: confirm finally runs. If finally fires but
        // neither then nor catch logged anything, something is very
        // wrong with the api() promise.
        // console.info("[FS/chat] finally entered",
          // "total_elapsed=" + (Date.now() - _chatStartTs) + "ms");
        isSending = false;
        _updateInputLockState();
        FS_FIRESTORE.endInFlight();   // v2.53.0
      });
  }

  // ---------------------------------------------------------------------
  // Events
  // ---------------------------------------------------------------------
  // v2.55.2: body-scroll lock for mobile.
  //
  // When the widget panel is open on a mobile-sized viewport (≤480px,
  // matching the panel's fullscreen media query), the underlying host
  // page should NOT scroll. Two reasons:
  //
  //   (1) iOS Safari's URL bar shrinks based on document-level scroll,
  //       which changes 100dvh underneath the widget — fine in theory,
  //       but during the transition the URL bar animation can cause
  //       a visible "jump" in the widget's bottom edge. Locking body
  //       scroll keeps the URL bar in its current state for the whole
  //       conversation.
  //
  //   (2) iOS elastic overscroll (the "rubber band" bounce when you
  //       drag past the top/bottom of the page) propagates UP from
  //       the widget's internal scrollable area to the host page,
  //       and the visual effect is the entire chat widget bouncing
  //       around. Body-locked stops the bounce at the widget edge.
  //
  // Technique: save the current scrollY, set body { position: fixed;
  // top: -scrollY; width: 100%; } to freeze the page at its current
  // position. On unlock, restore the original style and scroll back.
  // `position: fixed` (not `overflow: hidden`) is required because
  // iOS Safari's bounce-scroll IGNORES `overflow: hidden`.
  //
  // Desktop (>480px): widget is a small floating panel; host page
  // scroll should NOT be locked. The matchMedia check gates this.
  var _bodyScrollLockState = null;
  function _isMobileViewport() {
    try {
      return window.matchMedia("(max-width: 480px)").matches;
    } catch (_) {
      return false;
    }
  }
  function _lockBodyScroll() {
    if (_bodyScrollLockState) return;   // already locked
    if (!_isMobileViewport()) return;   // desktop — don't lock
    var body = document.body;
    if (!body) return;
    var scrollY = window.scrollY || window.pageYOffset || 0;
    _bodyScrollLockState = {
      scrollY:   scrollY,
      position:  body.style.position,
      top:       body.style.top,
      width:     body.style.width,
      overflow:  body.style.overflow,
    };
    body.style.position = "fixed";
    body.style.top      = "-" + scrollY + "px";
    body.style.width    = "100%";
    body.style.overflow = "hidden";
  }
  function _unlockBodyScroll() {
    if (!_bodyScrollLockState) return;
    var body = document.body;
    var prev = _bodyScrollLockState;
    _bodyScrollLockState = null;
    if (!body) return;
    body.style.position = prev.position;
    body.style.top      = prev.top;
    body.style.width    = prev.width;
    body.style.overflow = prev.overflow;
    // Restore scroll position (browsers don't preserve it through
    // position:fixed → static transitions).
    window.scrollTo(0, prev.scrollY);
  }

  // ---------------------------------------------------------------------
  // v2.55.45 — Unread message indicator on the launcher
  //
  // When the panel is CLOSED and a new INCOMING message (agent reply or a
  // cross-tab message — never the customer's own) arrives via the Firestore
  // listener, show an indicator on the launcher. Opening the panel clears
  // it. The count persists per-session in localStorage so it survives page
  // navigation while the panel stays closed.
  //
  // Two display modes, switchable with one flag:
  //   "count" (default) — low-capped number: 1, 2, 3+  (cap configurable)
  //   "dot"             — a plain solid dot, no number
  // ---------------------------------------------------------------------
  var FS_UNREAD_BADGE_MODE = "count";   // "count" | "dot"
  var FS_UNREAD_BADGE_CAP  = 3;         // count mode shows up to this, then "N+"
  var _UNREAD_KEY = "fs_unread_" + SESSION_ID;
  var _unreadCount = 0;

  function _loadUnread() {
    try {
      var n = parseInt(localStorage.getItem(_UNREAD_KEY) || "0", 10);
      _unreadCount = (isFinite(n) && n > 0) ? n : 0;
    } catch (_) { _unreadCount = 0; }
  }
  function _persistUnread() {
    try { localStorage.setItem(_UNREAD_KEY, String(_unreadCount)); } catch (_) {}
  }

  function _renderUnreadBadge() {
    var el = $unread;   // resolved below, after the DOM is built
    if (!el) return;
    if (_unreadCount <= 0) {
      el.classList.add("fs-chatbot-hidden");
      el.textContent = "";
      el.removeAttribute("aria-label");
      return;
    }
    if (FS_UNREAD_BADGE_MODE === "dot") {
      el.classList.add("fs-chatbot-unread-dot");
      el.textContent = "";
      el.setAttribute("aria-label", "New messages");
    } else {
      el.classList.remove("fs-chatbot-unread-dot");
      var label = _unreadCount > FS_UNREAD_BADGE_CAP
        ? (FS_UNREAD_BADGE_CAP + "+") : String(_unreadCount);
      el.textContent = label;
      el.setAttribute("aria-label", _unreadCount + " new message"
        + (_unreadCount === 1 ? "" : "s"));
    }
    el.classList.remove("fs-chatbot-hidden");
    // Re-trigger the pop animation on each increment.
    el.style.animation = "none";
    // eslint-disable-next-line no-unused-expressions
    el.offsetHeight;  // reflow
    el.style.animation = "";
  }

  // Called by the Firestore listener when a new incoming message renders
  // while the panel is closed. No-op when the panel is open.
  function _incrementUnread() {
    if ($panel && $panel.classList.contains("fs-chatbot-open")) return;
    _unreadCount += 1;
    _persistUnread();
    _renderUnreadBadge();
  }

  function _clearUnread() {
    if (_unreadCount === 0) return;
    _unreadCount = 0;
    _persistUnread();
    _renderUnreadBadge();
  }

  function openPanel() {
    $panel.classList.add("fs-chatbot-open");
    $launcher.classList.add("fs-chatbot-hidden");
    _clearUnread();   // v2.55.45 — opening the panel marks messages read
    // v2.55.2: lock body scroll on mobile.
    _lockBodyScroll();
    // v2.36.0 — re-evaluate WhatsApp footer visibility on each open.
    // Today this is a no-op (stub returns true), but it makes the
    // future hours-tightening edit work correctly across midnight
    // boundaries: a widget loaded at 23:55 with the panel opened at
    // 00:05 will see the link hide automatically.
    _refreshWhatsAppFooter();
    setTimeout(function () { $input.focus(); }, 150);
  }
  function closePanel() {
    $panel.classList.remove("fs-chatbot-open");
    $launcher.classList.remove("fs-chatbot-hidden");
    // v2.55.2: restore body scroll. No-op if not locked (desktop, or
    // widget closed before opening).
    _unlockBodyScroll();
  }

  $launcher.addEventListener("click", function () {
    openPanel();
    if (!hasShownWelcome && $messages.children.length === 0) loadHistory();
    // v2.29.1: refresh the cart panel on every panel-open so the bar
    // reflects current state (the cart may have moved during a tab
    // backgrounded between visits).
    loadCartState();
  });
  $close.addEventListener("click", closePanel);

  // v2.29.2: cart bar chevron opens the wizard. Click handler on the
  // whole bar (not just the chevron) so the tap target is generous.
  // openWizard() bails out internally if cart is empty.
  document.getElementById("fs-cart-bar").addEventListener("click", function () {
    openWizard();
  });

  // Wizard control handlers. The Cancel button persists through page
  // transitions (it lives in the header, not the footer), so it gets
  // a one-time binding here. Proceed / Back / Confirm are inside the
  // footer which is rebuilt on every page render — the page-specific
  // footer renderers (_updateFooterForItemsPage etc.) bind those.
  document.getElementById("fs-wizard-cancel").addEventListener("click", function () {
    closeWizard();
  });

  $send.addEventListener("click", function () {
    var v = $input.value.trim();
    if (!v) return;
    $input.value = "";
    autosize();
    send(v, null);
  });

  $input.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      $send.click();
    }
  });

  $quick.addEventListener("click", function (e) {
    var btn = e.target.closest(".fs-chatbot-chip");
    if (!btn) return;
    var action = btn.getAttribute("data-action");
    send("", action);
  });

  // ---------------------------------------------------------------------
  // v2.53.0 — Firestore listener module (FS_FIRESTORE)
  // ---------------------------------------------------------------------
  // Absorbs every responsibility of the former flowersugar-widget-
  // liveagent.js module:
  //   - Loads the Firebase modular SDK via inline <script type="module">
  //     (the no-import() pattern from the live-agent module — see its
  //     header comment for full rationale).
  //   - Mints a session-scoped Firebase custom token via bot-server's
  //     POST /customer/token (v2.52.0 endpoint).
  //   - Signs in with the token; the SDK refreshes the underlying ID
  //     token automatically. We re-mint our custom token ~10 minutes
  //     before its 1-hour TTL expires.
  //   - Opens TWO onSnapshot listeners:
  //       (1) session doc — mode + agent_typing
  //       (2) messages subcollection — new messages, modified (hide/
  //           un-hide), and removed (delete).
  //   - De-dups against a seen-set populated from /history and from
  //     POST response IDs (user_message_id, assistant_message_id on
  //     /chat, /chat/form_submit, /chat/form_cancel).
  //   - Defers rendering of listener fires while ANY POST is in
  //     flight (`inFlightCount > 0`); flushes when count hits zero,
  //     when 30 seconds have passed (hard timeout), or on error/abort.
  //   - Renders the agent typing indicator.
  //
  // Lifecycle: always-on. boot() is idempotent. detach() exists for
  // tests but is not called in production.
  //
  // Soft-fail: any error during init logs a warning but does not
  // throw — the bot HTTP path continues to work without live delivery.
  // ---------------------------------------------------------------------
  var FS_FIRESTORE = (function () {
    "use strict";

    // ------------------------------------------------------------------
    // Config — must match the live-agent server / dashboard exactly.
    // Firebase web config is NOT a secret; security is enforced by
    // cs-demo-1's Firestore rules + the session-scoped custom token.
    // ------------------------------------------------------------------
    var FIREBASE_CONFIG = {
      apiKey:            "AIzaSyATqU643i64cXxM7c8smLyQXCesNCMf5Yg",
      authDomain:        "postgresql-287613.firebaseapp.com",
      projectId:         "postgresql-287613",
      storageBucket:     "postgresql-287613.firebasestorage.app",
      messagingSenderId: "541962859153",
      appId:             "1:541962859153:web:12d08819f44bf352158530",
    };
    var FIRESTORE_DATABASE  = "cs-demo-1";
    var SESSIONS_COLLECTION = "fs_chat_sessions";
    var SDK_VERSION = "10.12.0";
    var SDK_BASE    = "https://www.gstatic.com/firebasejs/" + SDK_VERSION + "/";
    var APP_NAME    = "fs-widget-firestore";   // distinct from "fs-live-agent"
    var LOADER_ID   = "fs-fb-modular-loader";  // shared loader element
    var READY_EVENT = "fs-fb-ready";
    var GLOBAL_NS   = "__FS_FB__";

    // Token-refresh: Firebase custom tokens have a 1-hour TTL. We
    // refresh 10 minutes before expiry to absorb minor clock skew
    // and network latency.
    var TOKEN_REFRESH_LEAD_MS = 10 * 60 * 1000;

    // Deferred-rendering hard timeout: if inFlightCount stays > 0 for
    // this long, flush anyway. Prevents a hung POST from indefinitely
    // locking the listener.
    // v2.55.18: raised from 30 s to 5 min. The original 30 s value
    // was below Cloud Run's tail latency for slow LLM turns (33+ s
    // observed in production). When the timeout fired mid-POST, the
    // queue flushed and the listener rendered the user + assistant
    // messages — but then the eventual .then path rendered the
    // assistant bubble AGAIN, creating a duplicate (the addBubble
    // call was unconditional, no dedup against listener-rendered
    // bubbles). Raising the timeout to 5 min puts it above Cloud
    // Run's own default request timeout (300 s for HTTP); if the
    // POST genuinely hangs that long, fetch will have errored out
    // and .catch's finally will run endInFlight to drain the queue.
    var DEFER_TIMEOUT_MS = 5 * 60 * 1000;

    // ------------------------------------------------------------------
    // State.
    // ------------------------------------------------------------------
    var _fb = null;
    var fbApp = null, fbAuth = null, fbDb = null;
    var fbReady       = false;
    var initStarted   = false;
    var refreshTimer  = null;

    // v2.55.42 — lazy Firestore connection. The widget does NOT mint a
    // custom token or open any onSnapshot listener at boot. The persistent
    // connection exists ONLY to receive PUSH that HTTP can't deliver: a
    // human agent's async replies, cross-tab messages, mode flips, typing,
    // and the send_history signal. None of that is needed until there is a
    // conversation, so the token is earned by the FIRST MESSAGE (via the
    // /chat response). Cart persistence does NOT need the token — it goes
    // through the backend /cart/shopify_sync endpoint, which writes to
    // Firestore with the backend's own credentials. So a cart-only session
    // never opens a connection.
    //   sdkReady  = the Firebase SDK is loaded + app initialised (cheap;
    //               may be prepared eagerly, but does NOT sign in).
    //   hasToken  = we have applied a custom token and signed in; the two
    //               onSnapshot listeners + client_typing writes are live.
    var sdkReady      = false;
    var hasToken      = false;

    var unsubSession  = null;
    var unsubMsgs     = null;
    var liveMode      = false;
    var lastKnownTs   = 0;          // epoch ms — set by setLastKnownTs from /history
    var agentTypingNode = null;

    // v2.55.19 hotfix8 — cart-change detection state for the session-doc
    // listener. We fingerprint the cart on every snapshot and only apply
    // when it actually changed (items array, per-item quantity, per-item
    // price, delivery_date). Other session doc fields fire snapshots
    // frequently (client_typing heartbeat, agent_typing) — we don't want
    // to re-render the cart on every one of those.
    //
    //   null  = no snapshot processed yet
    //   "..." = stable fingerprint string of the last cart we observed
    var lastCartFingerprint = null;

    // v2.55.41 — send_history (page-view history burst). Tracks the last
    // request_id we acted on so a re-fired snapshot (reconnect, replay,
    // reload before the bot clears the flag) doesn't burst twice. Acting
    // once per request_id makes the widget side idempotent.
    var _lastHistoryReqId = null;

    // Dedup. `seenIds[id]` is one of:
    //   - DOM node  → bubble is rendered and visible (held by reference
    //                 so hide/un-hide/remove can operate on it)
    //   - HIDDEN_SENTINEL (string) → listener KNOWS about this id and
    //                 it is currently NOT rendered. Two ways to arrive
    //                 here: (a) born hidden — add event had meta.hidden=true,
    //                 listener skipped render but recorded the id;
    //                 (b) was rendered then hidden — modified event with
    //                 meta.hidden=true un-rendered it. Both are eligible
    //                 for re-render when a subsequent modified event flips
    //                 meta.hidden back to false.
    //   - true → registered as seen via registerSeenId() from the POST
    //                 response handler. The listener has NEVER processed
    //                 an add or modified event for this id; the bubble
    //                 (if any) was rendered by the POST .then path or
    //                 the optimistic UI. Modified events for these ids
    //                 must NOT re-render — the bubble already exists
    //                 from another path, and re-rendering creates a
    //                 duplicate. See v2.55.30 (form_submit double-write
    //                 dedup) for the production trace that motivated
    //                 this three-state split.
    //
    // The three-state model replaces an earlier two-state (node | true)
    // model where HIDDEN_SENTINEL and POST-registration both used `true`.
    // That conflation caused the duplicate-bubble bug on form_submit:
    // the server writes the user message TWICE (placeholder, then
    // resolved text), and the second write's modified event re-rendered
    // because seenIds[id] === true matched the un-hide branch's predicate.
    var HIDDEN_SENTINEL = "__fs_listener_hidden__";
    var seenIds = {};

    // POST-in-flight defer mechanism.
    var inFlightCount = 0;
    var deferQueue    = [];   // each entry: { id, m, type } where type is "added"|"modified"|"removed"
    var deferTimeoutHandle = null;

    // ------------------------------------------------------------------
    // SDK loader — see live-agent module's ensureFirebase for full
    // commentary on the no-import() inline-module pattern.
    // ------------------------------------------------------------------
    function ensureFirebase() {
      if (window[GLOBAL_NS]) return Promise.resolve(window[GLOBAL_NS]);
      return new Promise(function (resolve, reject) {
        var settled = false;
        var poll = null, timer = null, onReady = null;
        function cleanup() {
          if (poll)    clearInterval(poll);
          if (timer)   clearTimeout(timer);
          if (onReady) window.removeEventListener(READY_EVENT, onReady);
        }
        function tryResolve() {
          if (settled) return true;
          if (window[GLOBAL_NS]) { settled = true; cleanup(); resolve(window[GLOBAL_NS]); return true; }
          return false;
        }
        onReady = function () { tryResolve(); };
        window.addEventListener(READY_EVENT, onReady);
        poll  = setInterval(tryResolve, 120);
        timer = setTimeout(function () {
          if (settled) return;
          settled = true; cleanup();
          reject(new Error("firebase modular SDK load timed out (CSP or network?)"));
        }, 15000);
        if (!document.getElementById(LOADER_ID)) {
          var s = document.createElement("script");
          s.type = "module";
          s.id   = LOADER_ID;
          s.textContent =
            'import { initializeApp, getApp, getApps } from "' + SDK_BASE + 'firebase-app.js";\n' +
            'import { getAuth, signInWithCustomToken } from "' + SDK_BASE + 'firebase-auth.js";\n' +
            'import { getFirestore, doc, collection, query, where, orderBy, onSnapshot, setDoc, serverTimestamp, deleteField } from "' + SDK_BASE + 'firebase-firestore.js";\n' +
            'window.' + GLOBAL_NS + ' = {\n' +
            '  initializeApp: initializeApp, getApp: getApp, getApps: getApps,\n' +
            '  getAuth: getAuth, signInWithCustomToken: signInWithCustomToken,\n' +
            '  getFirestore: getFirestore, doc: doc, collection: collection,\n' +
            '  query: query, where: where, orderBy: orderBy, onSnapshot: onSnapshot,\n' +
            '  setDoc: setDoc, serverTimestamp: serverTimestamp, deleteField: deleteField\n' +
            '};\n' +
            'window.dispatchEvent(new Event("' + READY_EVENT + '"));';
          document.head.appendChild(s);
        }
        tryResolve();
      });
    }

    // ------------------------------------------------------------------
    // Token mint + sign-in. Returns a Promise resolving when the auth
    // session is established, and schedules a refresh ~10 min before
    // the token's expiry.
    // ------------------------------------------------------------------
    // v2.55.42 — apply a custom token we received (from a /chat response,
    // a /cart/shopify_sync response, or the /customer/token refresh path).
    // This is the SINGLE place that signs in + opens the listeners + schedules
    // refresh. The widget always uses the LATEST token: calling this again
    // with a newer token re-signs-in seamlessly. Requires the SDK to be ready
    // (ensureSdk); if it isn't, it loads it first.
    function applyToken(tokenBody) {
      if (!tokenBody || !tokenBody.token) return Promise.resolve(false);
      return ensureSdk()
        .then(function () {
          return _fb.signInWithCustomToken(fbAuth, tokenBody.token);
        })
        .then(function () {
          var firstConnection = !hasToken;
          hasToken = true;
          // Schedule a refresh. expires_at is epoch ms; refresh
          // TOKEN_REFRESH_LEAD_MS before it. If expires_at is missing
          // or in the past (clock skew), default to 50 minutes ahead.
          var now = Date.now();
          var expiresAt = tokenBody.expires_at || (now + 60 * 60 * 1000);
          var refreshAt = expiresAt - TOKEN_REFRESH_LEAD_MS;
          var delay = Math.max(60 * 1000, refreshAt - now);
          if (refreshTimer) clearTimeout(refreshTimer);
          refreshTimer = setTimeout(function () {
            mintAndSignIn().catch(function (e) {
              console.warn("[FlowerSugar/fs] token refresh failed:", e && e.message);
            });
          }, delay);
          // Open the listeners the first time we connect (idempotent after).
          if (firstConnection) {
            attachListeners();
          }
          return true;
        })
        .catch(function (e) {
          console.warn("[FlowerSugar/fs] applyToken failed (bot path still works):",
                       (e && (e.code || e.name)) || "", e && e.message);
          return false;
        });
    }

    // v2.55.42 — REFRESH path only. Once a session already exists and we
    // hold a token, re-mint before expiry via /customer/token. This is NOT
    // the first-token path — the first token arrives bundled in the /chat
    // (or /cart/shopify_sync) response when the customer first engages.
    function mintAndSignIn() {
      return fetch(ENDPOINT.replace(/\/+$/, "") + "/customer/token", {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ widget_key: WIDGET_KEY, session_id: SESSION_ID }),
      })
        .then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); })
        .then(function (res) {
          if (res.status !== 200 || !res.body || !res.body.token) {
            throw new Error("token mint failed: status=" + res.status);
          }
          return applyToken(res.body);
        });
    }

    // ------------------------------------------------------------------
    // v2.55.42 — ensureSdk: load the Firebase SDK + initialise the app,
    // but DO NOT sign in or open any listener. Cheap and side-effect-free
    // with respect to Firestore (no doc is born). Signing in happens only
    // later, in applyToken, once a message has earned a token. Idempotent.
    // ------------------------------------------------------------------
    function ensureSdk() {
      if (sdkReady) return Promise.resolve();
      if (initStarted) {
        // An init is already in flight; wait a tick and resolve when ready.
        return new Promise(function (resolve) {
          var t = setInterval(function () {
            if (sdkReady || !initStarted) { clearInterval(t); resolve(); }
          }, 50);
        });
      }
      initStarted = true;
      // v2.55.41 — record this page view into the local ring buffer as
      // soon as the widget initialises (best-effort; no network per view).
      try { recordPageView(); } catch (_) {}
      return ensureFirebase()
        .then(function (FB) {
          _fb = FB;
          try {
            fbApp = FB.initializeApp(FIREBASE_CONFIG, APP_NAME);
          } catch (e) {
            fbApp = FB.getApp ? FB.getApp(APP_NAME) : null;
            if (!fbApp) throw e;
          }
          fbAuth = FB.getAuth(fbApp);
          fbDb   = FB.getFirestore(fbApp, FIRESTORE_DATABASE);
          sdkReady = true;
          fbReady  = true;   // back-compat: code paths that gate on fbReady
          initStarted = false;
        })
        .catch(function (e) {
          initStarted = false;
          sdkReady = false;
          fbReady  = false;
          console.warn("[FlowerSugar/fs] SDK init failed (bot path still works):",
                       (e && (e.code || e.name)) || "", e && e.message);
        });
    }

    // ------------------------------------------------------------------
    // v2.55.42 — init() now ONLY prepares the SDK. It does NOT mint a
    // token, sign in, or open listeners (that would birth an empty session
    // doc on a drive-by page load). The connection is opened later by
    // applyToken once the first message earns a token. boot() stays
    // idempotent and safe to call from all existing sites.
    // ------------------------------------------------------------------
    function init() {
      return ensureSdk();
    }

    // ------------------------------------------------------------------
    // v2.55.41 — on-demand page-view history (send_history feature)
    //
    // The widget buffers page views locally (capped ring buffer in
    // localStorage, keyed per session) and bursts the buffer to the bot
    // ONLY when an agent requests it (session.send_history signal). No
    // network traffic per page view; no continuous server-side storage.
    // No IP is ever collected. Best-effort: localStorage may be blocked
    // (Safari private mode) or evicted — the buffer can legitimately be
    // empty, which is fine.
    // ------------------------------------------------------------------
    var PH_KEY = "fs_page_history_" + SESSION_ID;   // per-session buffer
    var PH_CAP = 100;                               // most recent N views

    // v2.55.44 — diagnostic logger for the send_history chain. Writes to
    // the REAL window.console, bypassing the widget's console shadow
    // (v2.55.24) so this trace is visible in production WITHOUT enabling
    // data-debug. Temporary: remove once the "dashboard gets no history"
    // issue is resolved. Tagged so it's easy to grep/filter.
    function _phLog() {
      try {
        var real = (typeof window !== "undefined" && window.console) || null;
        if (!real || !real.log) return;
        var args = ["[FS/page_history]"].concat(
          Array.prototype.slice.call(arguments));
        real.log.apply(real, args);
      } catch (_) {}
    }

    function recordPageView() {
      var buf = [];
      try { buf = JSON.parse(localStorage.getItem(PH_KEY) || "[]"); } catch (_) { buf = []; }
      if (!Array.isArray(buf)) buf = [];
      try {
        buf.push({
          page:      location.pathname + location.search,
          page_url:  location.href,
          timestamp: new Date().toISOString(),
          // NO ip — never collected.
        });
      } catch (_) {}
      if (buf.length > PH_CAP) buf = buf.slice(-PH_CAP);   // ring buffer
      try { localStorage.setItem(PH_KEY, JSON.stringify(buf)); } catch (e) {
        _phLog("recordPageView — localStorage write FAILED",
          "error=" + (e && e.message));
        return;
      }
      _phLog("recordPageView — buffered", "key=" + PH_KEY,
        "buffer_size=" + buf.length, "page=" + (location.pathname + location.search));
    }

    function burstPageHistory(requestId) {
      var buf = [];
      try { buf = JSON.parse(localStorage.getItem(PH_KEY) || "[]"); } catch (_) { buf = []; }
      if (!Array.isArray(buf)) buf = [];
      _phLog("bursting → POST /page_history", "request_id=" + requestId,
        "entries=" + buf.length, "hasToken=" + hasToken);
      // Fire-and-forget. The bot clears the send_history signal after a
      // successful write; we do NOT clear the signal or the local buffer
      // (keep it for future requests / continued navigation).
      api("/page_history", {
        widget_key: WIDGET_KEY,
        session_id: SESSION_ID,
        request_id: requestId,
        history:    buf,
      }).then(function (res) {
        _phLog("burst result",
          "status=" + (res && res.status),
          "server_status=" + (res && res.body && res.body.status),
          "written=" + (res && res.body && res.body.written),
          "ignored=" + (res && res.body && res.body.ignored),
          "reason=" + (res && res.body && res.body.reason));
      }).catch(function (err) {
        _phLog("burst FAILED", "error=" + (err && err.message));
        // Allow a retry on the next snapshot fire for the same request id.
        if (_lastHistoryReqId === requestId) _lastHistoryReqId = null;
      });
    }


    // Fingerprint shape:
    //   "v:<variant_id>|q:<quantity>|p:<price_cents>|lp:<line_price_cents>|d:<delivery_date>"
    //   joined by ";" across items, then "#<cart.delivery_date>#<balloon_wording>"
    //
    // The fields chosen match the user-visible attributes: items,
    // quantity, price (line + unit), delivery date. balloon_wording is
    // included so live-agent edits to that field also trigger a re-
    // render (the wizard's review page may show it).
    // ------------------------------------------------------------------
    function _cartFingerprint(cart) {
      if (!cart || typeof cart !== "object") return "<null>";
      var items = Array.isArray(cart.items) ? cart.items : [];
      var itemsFp = items.map(function (it) {
        if (!it || typeof it !== "object") return "<bad>";
        return [
          "v:"  + (it.variant_id || ""),
          "q:"  + (it.quantity || 0),
          "p:"  + (it.price_cents || 0),
          "lp:" + (it.line_price_cents || 0),
          "d:"  + (it.delivery_date || ""),
        ].join("|");
      }).join(";");
      return itemsFp +
             "#" + (cart.delivery_date || "") +
             "#" + (cart.balloon_wording || "");
    }

    // Detect whether the items SHAPE (presence/identity/quantity)
    // changed, as opposed to just price/balloon changes. Used to
    // decide whether to reset the wizard. Price-only changes don't
    // need a wizard reset because later wizard pages don't depend
    // on prices.
    function _itemsShapeChanged(oldFp, newFp) {
      if (!oldFp || !newFp) return false;
      var oldShape = oldFp.split("#")[0].split(";").map(function (s) {
        // Strip price + line_price fragments, keep v/q/d.
        return s.split("|").filter(function (f) {
          return !/^l?p:/.test(f);
        }).join("|");
      }).join(";");
      var newShape = newFp.split("#")[0].split(";").map(function (s) {
        return s.split("|").filter(function (f) {
          return !/^l?p:/.test(f);
        }).join("|");
      }).join(";");
      return oldShape !== newShape;
    }

    // ------------------------------------------------------------------
    // Listener attach.
    // ------------------------------------------------------------------
    function attachListeners() {
      if (!fbReady || !fbDb || !_fb) {
        _phLog("attachListeners SKIPPED — Firestore not ready",
          "fbReady=" + fbReady, "hasToken=" + hasToken);
        return;
      }
      _phLog("session listener ATTACHING", "session=" + SESSION_ID,
        "hasToken=" + hasToken);

      var sessionRef = _fb.doc(fbDb, SESSIONS_COLLECTION, SESSION_ID);

      // 1) Session doc — mode + agent_typing + client_typing (v2.53.3)
      //                 + cart state (v2.55.19 hotfix8).
      if (unsubSession) unsubSession();
      unsubSession = _fb.onSnapshot(sessionRef, function (snap) {
        var data = snap.exists() ? (snap.data() || {}) : {};
        var nowLive = data.mode === "live_agent";
        if (nowLive !== liveMode) {
          liveMode = nowLive;
          if (!liveMode) setAgentTyping(false);
        }
        setAgentTyping(!!data.agent_typing && liveMode);
        // v2.53.3: surface client_typing to FS_TYPING. The signal
        // shape is { tab_id, page_url, last_heartbeat } | null.
        // FS_TYPING handles the freshness check and the own-tab echo
        // skip, and ultimately calls _updateInputLockState which now
        // also considers the foreign-typing condition.
        try {
          FS_TYPING.onSessionDocSnapshot(data.client_typing);
        } catch (_) {}

        // v2.55.41 — send_history signal. When an agent requests the
        // customer's page-view history, the dashboard sets
        // send_history=true (+ a request_id) on the session doc. React by
        // bursting the locally-buffered history to the bot. Gate on the
        // request_id (not the bare boolean) so a re-fired snapshot
        // (reconnect/replay/reload before the bot clears the flag) can't
        // burst twice — act once per request id. The bot clears the signal
        // after a durable write.
        //
        // v2.55.44 — diagnostics. Log the signal fields on EVERY snapshot
        // and the exact decision, so we can tell apart: (a) the signal
        // never arrives (field absent on every fire → dashboard write not
        // reaching this doc, or listener not attached); (b) it arrives but
        // is gated out (already-acted request_id); (c) it fires the burst.
        try {
          var _hasSignal = ("send_history" in data) || ("send_history_request_id" in data);
          if (_hasSignal) {
            _phLog("snapshot signal seen",
              "send_history=" + JSON.stringify(data.send_history),
              "request_id=" + JSON.stringify(data.send_history_request_id),
              "lastActedReqId=" + JSON.stringify(_lastHistoryReqId));
          }
          if (data.send_history === true &&
              data.send_history_request_id &&
              data.send_history_request_id !== _lastHistoryReqId) {
            _phLog("signal ACCEPTED → bursting",
              "request_id=" + data.send_history_request_id);
            _lastHistoryReqId = data.send_history_request_id;
            burstPageHistory(data.send_history_request_id);
          } else if (data.send_history === true) {
            var _why = !data.send_history_request_id
              ? "no request_id on signal"
              : (data.send_history_request_id === _lastHistoryReqId
                  ? "request_id already acted (idempotent skip)"
                  : "unknown");
            _phLog("signal present but NOT bursting — reason=" + _why);
          }
        } catch (e) {
          console.warn("[FS/page_history] signal handler threw:",
            e && e.message);
        }


        // (already covered by updateFullCartFromResponse), but ALSO:
        //   * Live agent edits the cart via dashboard
        //   * Background recompute / enrichment writes to session.cart
        //   * Out-of-band sync (e.g., Shopify→server via another tab)
        //
        // Without this listener, the widget would only see those
        // changes on the next /chat or page reload. Now it sees them
        // in real-time.
        //
        // Fingerprint check skips re-renders when the cart didn't
        // actually change (session doc fires on EVERY field write —
        // typing heartbeats, mode flips, etc. — and most of those
        // are unrelated to the cart).
        //
        // Shopify authority still applies: if FS_SHOPIFY_CART has
        // adopted, the items + delivery_date fields are preserved
        // from Shopify's view regardless of what's in Firestore.
        // This means live-agent edits to items won't show in the
        // widget in this phase — accepted limitation per "Shopify
        // is source of truth" spec; Phase 2 outbound will let
        // dashboard edits push back to Shopify.
        try {
          var serverCart = data.cart;
          if (serverCart) {
            var newFp = _cartFingerprint(serverCart);
            if (newFp !== lastCartFingerprint) {
              var wasFirstFire = lastCartFingerprint === null;
              console.info("[FS/fs/cart_change]",
                (typeof FS_WIDGET_VERSION !== "undefined" ? FS_WIDGET_VERSION : "?"),
                "first_fire=" + wasFirstFire,
                "old_fp=" + (lastCartFingerprint || "<null>"),
                "new_fp=" + newFp,
                "items_n=" + (serverCart.items || []).length,
                "items_summary=", (serverCart.items || []).map(function (it) {
                  return {
                    variant_id:  it && it.variant_id,
                    quantity:    it && it.quantity,
                    price_cents: it && it.price_cents,
                  };
                }));
              var prevFp = lastCartFingerprint;
              lastCartFingerprint = newFp;

              // ── v2.55.36 — source_action identity (hoisted) ──
              // Classify this Firestore change ONCE so both the push
              // decision and the wizard guard-rail can use it:
              //   _originatingTab  — TAB_ID that wrote this cart, or null
              //   _iOriginated     — this tab performed the source_action
              //   _allShopifyOrigin— (S) Shopify-origin change (every item
              //                       carries _source="shopify_cart_sync")
              //   _isWidgetEdit    — (W) widget/agent edit (bot/empty/clear)
              //   _isForeignChange — a change THIS tab did NOT originate
              //                       (another tab, or server with no tab
              //                       attribution). The wizard's own
              //                       /cart/edit echo is _iOriginated, so
              //                       it is NOT foreign and won't self-close.
              var _csItems        = serverCart.items || [];
              var _originatingTab = serverCart.written_by_tab || null;
              var _allShopifyOrigin = _csItems.length > 0 &&
                _csItems.every(function (it) {
                  return it && it._source === "shopify_cart_sync";
                });
              var _isWidgetEdit  = !_allShopifyOrigin;
              var _iOriginated   = _originatingTab !== null &&
                                   _originatingTab === TAB_ID;
              var _isForeignChange = !_iOriginated;

              // Apply via setFullCart so the Shopify-authority logic
              // runs. The "firestore-snapshot" source label tags the
              // resulting log so we can trace what triggered the
              // re-render.
              setFullCart(serverCart, "firestore-snapshot");

              // v2.55.20 — also push divergence to Shopify if needed.
              // The wizard's /cart/edit handler updates Firestore (via
              // the server) but doesn't touch Shopify. Now that we're
              // listening to Firestore cart changes, we detect the
              // divergence and push it to Shopify here. Same path
              // covers bot-driven additions and live-agent edits.
              //
              // v2.55.20+hotfix2 — if hasAdoptedItems is false (boot
              // hasn't completed yet, or verdict was noop with no
              // adoption), queue the divergence for post-boot processing
              // rather than silently skipping.
              //
              // v2.55.20+hotfix6 — REMOVED the divergence-preview gate.
              // The preview used _computeDiff against raw items, which
              // misses cart-level date changes (per-item dates can match
              // on both sides while cart-level dates differ — the
              // customer's NEW intent). Now we always call pushToShopify
              // with both serverCart.items AND serverCart.delivery_date
              // and let pushToShopify do alignment-aware diffing
              // internally; the no-op early-return handles the
              // genuinely-no-change case cheaply.
              //
              // v2.55.20+hotfix6 — comprehensive instrumentation. Every
              // possible skip path now logs explicitly so silent
              // failures become visible. The previous code had two
              // silent-skip paths (FS_SHOPIFY_CART undefined or
              // serverCart.items not an array) that gave no signal in
              // production logs.
              console.info("[FS/fs/cart_change] evaluating divergence push",
                FS_WIDGET_VERSION,
                "fs_shopify_cart_defined=" + (typeof FS_SHOPIFY_CART !== "undefined"),
                "items_is_array=" + Array.isArray(serverCart.items),
                "items_n=" + (Array.isArray(serverCart.items) ? serverCart.items.length : "n/a"),
                "serverCart_delivery_date=" + (serverCart.delivery_date || "(none)"));

              try {
                if (typeof FS_SHOPIFY_CART === "undefined") {
                  console.warn("[FS/fs/cart_change] SKIP — FS_SHOPIFY_CART undefined",
                               FS_WIDGET_VERSION);
                } else if (!Array.isArray(serverCart.items)) {
                  console.warn("[FS/fs/cart_change] SKIP — serverCart.items not array",
                               FS_WIDGET_VERSION,
                               "items_type=" + (typeof serverCart.items),
                               "items_value=", serverCart.items);
                } else if (
                  // ── Gate 1 — suppress empty stale snapshot ──
                  // v2.55.20+hotfix10. A Firestore snapshot with ZERO items
                  // while the adopted Shopify cart is NON-empty is almost
                  // always a stale/initial read (the first listener fire
                  // before the cart doc is populated), NOT a genuine "the
                  // customer emptied the cart" event. Driving a
                  // pushToShopify REMOVE off it is exactly what started the
                  // quantity-doubling cascade: the removal raced the
                  // corrected snapshot's add-back. A real empty-cart event
                  // arrives as a non-first-fire snapshot AND is preceded by
                  // an explicit clear, so we only suppress the first-fire
                  // empty case here.
                  wasFirstFire &&
                  serverCart.items.length === 0 &&
                  FS_SHOPIFY_CART.hasAdoptedItems &&
                  FS_SHOPIFY_CART.hasAdoptedItems() &&
                  FS_SHOPIFY_CART.getAdoptedItemCount &&
                  FS_SHOPIFY_CART.getAdoptedItemCount() > 0
                ) {
                  _cartTrace("[P1:firestore→push] GATE — empty first-fire snapshot " +
                             "suppressed (adopted cart is non-empty; stale read)",
                    "server_items_n=0",
                    "adopted_items_n=" + FS_SHOPIFY_CART.getAdoptedItemCount());
                  console.info("[FS/fs/cart_change] SKIP — empty first-fire snapshot " +
                               "while adopted cart non-empty (stale read, not a clear)",
                               FS_WIDGET_VERSION,
                               "adopted_items_n=" + FS_SHOPIFY_CART.getAdoptedItemCount());
                } else if (FS_SHOPIFY_CART.hasAdoptedItems &&
                           FS_SHOPIFY_CART.hasAdoptedItems()) {
                  // ── v2.55.36 — source_action identity gate ──
                  // Decide whether THIS tab should push the Firestore cart
                  // to Shopify. Per the source_action model, a tab pushes
                  // to Shopify ONLY when it ORIGINATED a widget/agent (W)
                  // edit. It must NOT push for:
                  //   • a change another tab originated (passive tab — no
                  //     cross-pollination), or
                  //   • its own Shopify→Firestore echo (an (S) change, where
                  //     items carry _source="shopify_cart_sync" — Shopify is
                  //     already the source of that state).
                  // Both non-push cases render-only from this tab's own live
                  // /cart.js (no push, no Firestore write) so the widget UI
                  // and theme drawer reflect Shopify's truth without feeding
                  // the cross-tab write loop.
                  // (Classification computed once, block-scoped above:
                  // _items reuses _csItems; _originatingTab/_isWidgetEdit/
                  // _iOriginated/_allShopifyOrigin already in scope.)
                  var _items = _csItems;

                  if (_iOriginated && _isWidgetEdit) {
                    console.info("[FS/fs/cart_change] source_action=WIDGET_EDIT " +
                                 "on THIS tab — pushing to Shopify",
                                 FS_WIDGET_VERSION,
                                 "originating_tab=" + _originatingTab,
                                 "my_tab=" + TAB_ID,
                                 "items_n=" + _items.length,
                                 "serverCart_delivery_date=" +
                                   (serverCart.delivery_date || "(none)"));
                    _cartTrace("[P1:firestore→push] PUSH — this tab originated " +
                               "a widget/agent edit",
                      "originating_tab=" + _originatingTab,
                      "items_n=" + _items.length);
                    FS_SHOPIFY_CART.pushToShopify(
                      serverCart.items,
                      serverCart.delivery_date
                    );
                  } else {
                    // Passive tab, or this tab's own (S) Shopify echo →
                    // render only. Never push, never write Firestore.
                    console.info("[FS/fs/cart_change] source_action=" +
                                 (_allShopifyOrigin ? "SHOPIFY_ORIGIN" : "FOREIGN_TAB") +
                                 " — render only (no push, no cross-pollination)",
                                 FS_WIDGET_VERSION,
                                 "originating_tab=" + (_originatingTab || "(none)"),
                                 "my_tab=" + TAB_ID,
                                 "items_n=" + _items.length);
                    _cartTrace("[P1:firestore→render] RENDER-ONLY " +
                               (_allShopifyOrigin
                                 ? "(Shopify-origin change / own echo)"
                                 : "(change originated on another tab)"),
                      "originating_tab=" + (_originatingTab || "(none)"),
                      "my_tab=" + TAB_ID);
                    if (FS_SHOPIFY_CART.renderFromLiveCart) {
                      FS_SHOPIFY_CART.renderFromLiveCart();
                    }
                  }
                } else if (FS_SHOPIFY_CART._setPendingDivergence) {
                  console.info("[FS/fs/cart_change] hasAdoptedItems=false — " +
                               "queueing divergence for post-boot push",
                               FS_WIDGET_VERSION,
                               "items_n=" + serverCart.items.length);
                  FS_SHOPIFY_CART._setPendingDivergence(serverCart);
                } else {
                  console.warn("[FS/fs/cart_change] SKIP — FS_SHOPIFY_CART has " +
                               "neither hasAdoptedItems() nor _setPendingDivergence " +
                               "(module init incomplete?)",
                               FS_WIDGET_VERSION,
                               "module_keys=", Object.keys(FS_SHOPIFY_CART || {}));
                }
              } catch (pushErr) {
                console.warn("[FS/fs/cart_change] push divergence check FAILED",
                             FS_WIDGET_VERSION,
                             "error=", pushErr && pushErr.message,
                             "stack=", pushErr && pushErr.stack);
              }

              // ── v2.55.36 — Wizard guard-rail on Firestore cart change ──
              // The wizard edits a snapshot taken at open; it is never
              // live-refreshed. When a cart change arrives we react based
              // on WHO originated it (source_action identity):
              //
              //   • FOREIGN change (another tab's webpage action, an agent
              //     edit, or any write this tab did not originate) that
              //     actually altered the items the customer is editing
              //     (shape / quantity / per-line date — NOT a price-only
              //     background enrichment) → the snapshot is now stale
              //     against a change they didn't make here. CLOSE the wizard
              //     and show a "Cart refreshed" notice.
              //
              //   • OWN change (this tab's own /cart/edit echo, agent edit on
              //     this tab, etc.) → do NOT close — the customer is actively
              //     driving the wizard here. Keep the existing safety reset
              //     to page 1 only when the items shape/qty/date changed, so
              //     later pages don't reference items that no longer exist.
              //
              // We use _itemsShapeChanged (which compares variant/quantity/
              // per-item date and deliberately ignores price_cents/
              // line_price_cents) so a background price re-enrichment — which
              // has no tab attribution and would otherwise look "foreign" —
              // does NOT spuriously close the wizard.
              if (!wasFirstFire && typeof wizardOpen === "boolean" && wizardOpen) {
                try {
                  var _wizardRelevantChange = _itemsShapeChanged(prevFp, newFp);
                  if (_isForeignChange && _wizardRelevantChange) {
                    console.info("[FS/fs/cart_change] wizard CLOSE — foreign " +
                                 "cart change received via Firestore",
                                 FS_WIDGET_VERSION,
                                 "originating_tab=" + (_originatingTab || "(none)"),
                                 "my_tab=" + TAB_ID);
                    if (typeof closeWizard === "function") {
                      closeWizard();
                    }
                    _showCartRefreshedNotice("Cart refreshed");
                  } else if (!_isForeignChange && _wizardRelevantChange) {
                    wizardPage = "items";
                    if (typeof renderWizard === "function") {
                      renderWizard();
                    }
                    console.info("[FS/fs/cart_change] wizard reset to page 1 " +
                                 "(own items-shape change via Firestore)",
                                 FS_WIDGET_VERSION);
                  }
                } catch (_) {}
              }
            }
          }
        } catch (cartErr) {
          // Cart-change handling must NEVER break the session listener.
          // mode/agent_typing/client_typing handling above is more
          // critical — keep those flowing even if cart processing throws.
          console.warn("[FS/fs/cart_change] handler threw:",
            cartErr && cartErr.message);
        }
      }, function (err) {
        console.warn("[FlowerSugar/fs] session listener:", err && err.code);
      });

      // 2) Messages subcollection — new, modified, removed.
      //
      // The `where('created', '>', last_known_ts)` filter narrows the
      // initial snapshot to messages strictly NEWER than what /history
      // already returned. Messages with the same `created` value get
      // re-fired by Firestore on every snapshot cycle, but the seen-
      // set dedup handles those.
      //
      // last_known_ts is in epoch milliseconds (v2.52.0 /history
      // contract). Firestore stores `created` as a Timestamp; the
      // server-side filter accepts a Date (or a Timestamp). Construct
      // a Date from the epoch ms to keep types simple.
      if (unsubMsgs) unsubMsgs();
      var msgsCol = _fb.collection(fbDb, SESSIONS_COLLECTION, SESSION_ID, "messages");
      var msgsQuery;
      if (lastKnownTs > 0) {
        msgsQuery = _fb.query(
          msgsCol,
          _fb.where("created", ">", new Date(lastKnownTs)),
          _fb.orderBy("created", "asc")
        );
      } else {
        // No /history anchor (e.g. /history failed): listen to all
        // messages and let the seen-set do the dedup.
        msgsQuery = _fb.query(msgsCol, _fb.orderBy("created", "asc"));
      }

      unsubMsgs = _fb.onSnapshot(msgsQuery, function (snap) {
        try {
          var _changes = snap.docChanges().map(function (ch, i) {
            var _data = ch.doc.data() || {};
            var _ts = _data.created;
            return {
              i: i,
              type: ch.type,
              id: ch.doc.id,
              role: _data.role,
              created: (_ts && _ts.toDate) ? _ts.toDate().toISOString() : (_ts || "NULL"),
              known: !!seenIds[ch.doc.id],
              live: liveMode,
              inFlight: inFlightCount,
            };
          });
          // console.info("[FlowerSugar/fs] snapshot",
                       // "size=" + snap.size, "changes=" + _changes.length,
                       // "lastKnownTs=" + lastKnownTs, _changes);
        } catch (_) {}

        snap.docChanges().forEach(function (ch) {
          var m  = ch.doc.data() || {};
          var id = ch.doc.id;
          // If a POST is in flight, queue the change for later.
          // Already-seen ids are still routed through the handler so
          // they get dedup'd consistently.
          if (inFlightCount > 0) {
            // v2.53.4 diag: log every deferred change. If a bot
            // message vanishes after POST returns, check whether
            // (a) it was queued here, AND (b) flushDefer ran AFTER
            // the response's addBubble registered the assistant_id —
            // in which case dedup correctly skipped the listener
            // fire. If it was queued but never flushed, the defer
            // timeout / flush logic is broken.
            // console.info("[FS/listener] DEFER (POST in-flight)",
              // "id=" + id, "type=" + ch.type, "role=" + m.role,
              // "text_len=" + (m.text || "").length,
              // "in_flight=" + inFlightCount,
              // "queue_size=" + (deferQueue.length + 1));
            deferQueue.push({ id: id, m: m, type: ch.type });
            scheduleDeferTimeout();
          } else {
            handleChange(id, m, ch.type);
          }
        });
      }, function (err) {
        console.warn("[FlowerSugar/fs] messages listener:", err && err.code);
      });
    }

    // ------------------------------------------------------------------
    // Handle one snapshot change. Dedups via seenIds, applies hide/
    // un-hide for `modified`, removes for `removed`.
    // ------------------------------------------------------------------
    function handleChange(id, m, type) {
      var meta = m.meta || {};

      if (type === "added") {
        if (seenIds[id]) {
          // v2.53.4 diag: this is the dedup hit. If a bot message
          // doesn't appear, check whether the POST response
          // registered the assistant_message_id BEFORE this fired —
          // in which case the listener correctly skips, but the .then
          // branch should have rendered. If the .then rendered the
          // bubble already, this is correct. If not, double-skip bug.
          // console.info("[FS/listener] handleChange added — DEDUP SKIP",
            // "id=" + id, "role=" + m.role,
            // "text_len=" + (m.text || "").length);
          return;
        }
        if (meta.hidden) {
          // console.info("[FS/listener] handleChange added — BORN_HIDDEN skip",
            // "id=" + id);
          // v2.55.30 — was: seenIds[id] = true. Now distinguished
          // from POST-registration via HIDDEN_SENTINEL so a later
          // un-hide modified event re-renders, while a POST-registered
          // id (set to plain `true` by registerSeenId) does NOT.
          seenIds[id] = HIDDEN_SENTINEL;
          return;
        }
        // v2.55.11 — cross-tab form completion signal.
        //
        // Tab A submits or cancels a form. Server persists a user
        // message with meta.form_id (placeholder text `[form_submitted:…]`
        // or `[form_cancelled:…]`). Tab B's listener fires for that
        // message AND passes dedup (it didn't make the POST).
        //
        // Take the form_id and remove any form bubble with that id
        // from THIS tab's DOM. removeFormBubble calls
        // _unregisterActiveForm, which decrements activeForms.size,
        // which re-derives the input lock state via
        // _updateInputLockState. Net effect: Tab B's input unlocks.
        //
        // Why on the user message and not the assistant reply: the
        // user message is appended FIRST in the server flow (before
        // the pipeline runs), so this gives Tab B the earliest possible
        // signal. Querying by data-form-id attribute also makes this
        // a no-op when Tab B doesn't have the form bubble on screen
        // (rare, but possible — e.g. Tab B opened after Tab A had
        // already submitted; listener would still see the user msg).
        if (m.role === "user" && meta.form_id) {
          try {
            var staleBubble = document.querySelector(
              ".fs-chatbot-form-bubble[data-form-id=\"" + meta.form_id + "\"]"
            );
            if (staleBubble) {
              // console.info(
                // "[FS/listener] cross-tab form completion — closing form",
                // "form_id=" + meta.form_id,
                // "msg_id=" + id
              // );
              removeFormBubble(staleBubble);
            }
          } catch (e) {
            console.warn(
              "[FS/listener] form-close failed:",
              e && e.message
            );
          }
        }
        // console.info("[FS/listener] handleChange added — RENDER",
          // "id=" + id, "role=" + m.role,
          // "text_len=" + (m.text || "").length);
        var node = renderMessage(m);
        seenIds[id] = node || true;
        // v2.55.45 — unread indicator. A message that renders here came
        // from the live listener (not our own POST echo — those are caught
        // by the seenIds dedup above) and is genuinely new. Count it as
        // unread only when it's INCOMING (agent/assistant, not the
        // customer's own message echoed cross-tab) and the panel is closed.
        // _incrementUnread itself no-ops when the panel is open.
        try {
          if (node && m.role && m.role !== "user") {
            _incrementUnread();
          }
        } catch (_) {}
      } else if (type === "modified") {
        // console.info("[FS/listener] handleChange modified",
          // "id=" + id, "hidden=" + !!meta.hidden,
          // "seen=" + (seenIds[id] ? "yes" : "no"));
        if (meta.hidden && seenIds[id] && seenIds[id].remove) {
          // un-render
          seenIds[id].remove();
          // v2.55.30 — was: seenIds[id] = true. Now HIDDEN_SENTINEL
          // so the subsequent un-hide re-render branch can identify
          // this as "listener-managed hide" (eligible for re-render)
          // vs "POST-registered, never rendered by listener" (NOT
          // eligible — would create a duplicate of the bubble that
          // already exists from the POST .then path).
          seenIds[id] = HIDDEN_SENTINEL;
        } else if (!meta.hidden && seenIds[id] === HIDDEN_SENTINEL) {
          // re-render after un-hide. v2.55.30 — was: === true. Now
          // strictly checks HIDDEN_SENTINEL so POST-registered ids
          // (seenIds[id] === true) don't match this branch. Critical
          // for form_submit: server writes the user message twice
          // (placeholder, then resolved text). The first write's
          // POST response registers the id as `true`; the second
          // write fires modified with meta.hidden=false. Without
          // this stricter predicate, modified re-rendered, creating
          // the duplicate bubble shown in the v2.55.30 production
          // trace.
          var n = renderMessage(m);
          if (n) seenIds[id] = n;
        }
      } else if (type === "removed") {
        // console.info("[FS/listener] handleChange removed",
          // "id=" + id, "seen=" + (seenIds[id] ? "yes" : "no"));
        if (seenIds[id] && seenIds[id].remove) {
          seenIds[id].remove();
        }
        // v2.55.30 — was: seenIds[id] = true. Removed messages aren't
        // re-rendered by any current code path (a re-added message
        // would fire type="added", not type="modified", so the un-hide
        // branch is moot). But using HIDDEN_SENTINEL keeps the state
        // model consistent: "listener knows about this id, no DOM
        // node currently."
        seenIds[id] = HIDDEN_SENTINEL;
      }
    }

    // ------------------------------------------------------------------
    // Render a Firestore message as a bubble via the widget's addBubble.
    // ------------------------------------------------------------------
    function renderMessage(m) {
      var role = m.role === "user" ? "user" : "bot";
      var meta = m.meta || {};
      var created = (m.created && m.created.toDate)
        ? m.created.toDate().toISOString()
        : (m.created || null);
      var opts = { buttons: meta.buttons, ts: created };
      if (RENDER_HISTORICAL_STRUCTURED) {
        opts.products            = meta.products;
        opts.photos              = meta.photos;
        opts.delivery_quote      = meta.delivery_quote;
        opts.order_details_card      = meta.order_details_card;
        opts.bank_details        = meta.bank_details;
        opts.payment_expiry_note = meta.payment_expiry_note;
        opts.draft_order_number  = meta.draft_order_number;
        // v2.55.10: pass through the embedded form spec so that
        //   (a) a non-focused tab whose listener fires for a new
        //       form-bearing assistant message renders the form
        //       (not just the text bubble), AND
        //   (b) /history reload on any tab re-renders past form
        //       bubbles for messages still within the 60-day
        //       expires_at TTL window.
        //
        // The form spec is persisted server-side on the message doc
        // (v2/main.py and v2/server.py _handle_chat) alongside the
        // existing meta.has_form flag — see the matching server-side
        // change for the rationale.
        //
        // When meta.form is absent (non-form message, OR message
        // written before v2.55.10), opts.form is undefined and
        // addBubble's `if (opts.form)` branch is silently skipped —
        // same behavior as before this change.
        opts.form                = meta.form;
      }
      return addBubble(role, m.text || "", opts);
    }

    // ------------------------------------------------------------------
    // Agent typing indicator. Distinct from the widget's transient
    // showTyping (which fires during the bot's own thinking).
    // ------------------------------------------------------------------
    function setAgentTyping(on) {
      if (on) {
        if (agentTypingNode) return;
        var wrap = document.createElement("div");
        wrap.className = "fs-chatbot-msg fs-chatbot-bot";
        var t = document.createElement("div");
        t.className = "fs-chatbot-bubble fs-chatbot-typing";
        t.innerHTML = "<span></span><span></span><span></span>";
        wrap.appendChild(t);
        $messages.appendChild(wrap);
        agentTypingNode = wrap;
        scrollToBottom(false);
      } else if (agentTypingNode) {
        if (agentTypingNode.parentNode) {
          agentTypingNode.parentNode.removeChild(agentTypingNode);
        }
        agentTypingNode = null;
      }
    }

    // ------------------------------------------------------------------
    // POST-in-flight defer mechanism.
    // ------------------------------------------------------------------
    function beginInFlight() {
      inFlightCount += 1;
      // console.info("[FS/listener] beginInFlight",
        // "in_flight=" + inFlightCount);
      scheduleDeferTimeout();
    }
    function endInFlight() {
      if (inFlightCount > 0) inFlightCount -= 1;
      // console.info("[FS/listener] endInFlight",
        // "in_flight=" + inFlightCount,
        // "queue_size=" + deferQueue.length);
      if (inFlightCount === 0) {
        clearDeferTimeout();
        flushDefer();
      }
    }
    function scheduleDeferTimeout() {
      if (deferTimeoutHandle) return;
      deferTimeoutHandle = setTimeout(function () {
        // v2.55.18 — Hard timeout. Flush whatever's queued so the UI
        // doesn't appear frozen. CRITICALLY, do NOT zero inFlightCount:
        // the POST is still pending. Previously (v2.53.0 through
        // v2.55.17) this callback zeroed inFlightCount, which caused
        // subsequent listener events to render DIRECTLY (bypassing
        // DEFER) — and when .then eventually returned, its
        // unconditional addBubble created a duplicate assistant
        // bubble. By leaving inFlightCount intact:
        //   - Subsequent listener events go back into DEFER (queue).
        //   - When .then eventually arrives, endInFlight drains the
        //     queue, by which time registerSeenId has populated
        //     seenIds and handleChange will correctly dedup.
        // If POST is genuinely hung past the timeout, the queue just
        // accumulates until fetch fails (.catch's finally runs
        // endInFlight). The earlier "zero inFlightCount" path was a
        // false safety net — it didn't actually recover from hung
        // POSTs; it just created the duplicate bug.
        console.warn("[FlowerSugar/fs] defer timeout — flushing " +
                     deferQueue.length + " queued change(s) " +
                     "(in_flight stays " + inFlightCount + ")");
        deferTimeoutHandle = null;
        flushDefer();
      }, DEFER_TIMEOUT_MS);
    }
    function clearDeferTimeout() {
      if (deferTimeoutHandle) {
        clearTimeout(deferTimeoutHandle);
        deferTimeoutHandle = null;
      }
    }
    function flushDefer() {
      var batch = deferQueue.slice();
      deferQueue.length = 0;
      // v2.53.4 diag: log batch size + ids about to flush. If batch
      // contains an assistant message that was already rendered by
      // the POST .then branch, dedup should kick in via seenIds.
      if (batch.length > 0) {
        var _ids = batch.map(function (e) {
          return e.id + "(" + e.type + "/" + (e.m && e.m.role) + ")";
        }).join(",");
        // console.info("[FS/listener] flushDefer",
          // "batch_size=" + batch.length,
          // "ids=" + _ids);
      }
      // Sort by created timestamp so the rendered order is correct
      // even if Firestore fired the changes out of order during the
      // defer window.
      batch.sort(function (a, b) {
        var ac = (a.m && a.m.created && a.m.created.toMillis)
          ? a.m.created.toMillis() : 0;
        var bc = (b.m && b.m.created && b.m.created.toMillis)
          ? b.m.created.toMillis() : 0;
        return ac - bc;
      });
      batch.forEach(function (entry) {
        handleChange(entry.id, entry.m, entry.type);
      });
    }

    // ------------------------------------------------------------------
    // Public API consumed by the widget IIFE.
    // ------------------------------------------------------------------
    return {
      boot: function () { init(); },
      // v2.55.42 — apply a custom token received in any backend response
      // (/chat or /cart/shopify_sync). The single entry point for opening
      // the persistent connection; always adopts the latest token.
      applyToken: function (tokenBody) { return applyToken(tokenBody); },
      // True once a token has been applied and the listeners are live.
      hasToken: function () { return hasToken; },
      registerSeenId: function (id, node) {
        if (!id) return;
        // If a node is provided, use it (allows hide/delete to remove
        // the actual DOM element). Otherwise mark as seen with `true`.
        if (node) {
          seenIds[id] = node;
        } else if (!seenIds[id]) {
          seenIds[id] = true;
        }
      },
      // v2.55.18 — accessor for "is this id mapped to an actual rendered
      // DOM node?" Returns false when the id is missing OR when its
      // entry is just `true` (registered-as-seen but not rendered).
      // Used by the /chat .then path to skip its own unconditional
      // addBubble when the listener has already painted the assistant
      // bubble (can happen when defer timeout fired and flushed the
      // queue before .then arrived; see v2.55.18 CHANGELOG for the
      // race window).
      //
      // Distinct from "is in seenIds at all" because registerSeenId
      // can mark an id as `true` (pre-emptive) WITHOUT having a node
      // — in that case, .then's addBubble should still render because
      // no DOM bubble exists yet.
      hasRenderedNode: function (id) {
        if (!id) return false;
        var entry = seenIds[id];
        // v2.55.30 — also exclude HIDDEN_SENTINEL: the listener
        // knows about the id but no DOM node currently exists for
        // it (either born hidden or un-rendered after a hide).
        // Both states should return false for "is there a node?"
        // semantically equivalent to `true`-registered.
        if (entry === true || entry === HIDDEN_SENTINEL) return false;
        // true (registered but not rendered) → false; node → true
        return !!(entry && entry !== true);
      },
      // v2.55.4: clear the entire seen-ids map. Called after a session
      // merge swaps SESSION_ID to a different live session: the new
      // session has a fresh set of message ids, and we need to forget
      // the old session's ids so the next /history reload (and the
      // listener's initial snapshot) re-register them cleanly.
      resetSeenIds: function () {
        seenIds = {};
      },
      setLastKnownTs: function (ts) {
        if (typeof ts === "number" && ts > lastKnownTs) {
          lastKnownTs = ts;
        }
      },
      beginInFlight: beginInFlight,
      endInFlight:   endInFlight,
      // v2.53.3: client-typing write helper. Used by FS_TYPING to push
      // the current tab's typing state to the session doc, where other
      // tabs (via their session-doc listener) and the agent dashboard
      // read it. `signal` is either an object {tab_id, page_url} or
      // null. The serverTimestamp for last_heartbeat is added here so
      // FS_TYPING doesn't need direct access to the SDK.
      //
      // Returns a Promise that resolves on success, rejects on error.
      // The caller should swallow errors (typing-signal failures must
      // not break the chat experience).
      writeClientTyping: function (signal) {
        // v2.55.42 — require an ACTIVE token, not just SDK readiness. Before
        // the first message earns a token we are not signed in: a direct
        // Firestore write would fail (and must not birth an empty session
        // doc). Typing only matters once a conversation exists anyway.
        if (!hasToken || !fbReady || !fbDb || !_fb) {
          return Promise.reject(new Error("firestore not connected"));
        }
        var sessionRef = _fb.doc(fbDb, SESSIONS_COLLECTION, SESSION_ID);
        if (signal === null) {
          // Clear the field. Use deleteField() so the field is
          // removed from the doc, not just set to null. Either works
          // for listener semantics, but deleteField is cleaner.
          return _fb.setDoc(
            sessionRef,
            { client_typing: _fb.deleteField() },
            { merge: true },
          );
        }
        return _fb.setDoc(
          sessionRef,
          {
            client_typing: {
              tab_id:         signal.tab_id,
              page_url:       signal.page_url || "",
              last_heartbeat: _fb.serverTimestamp(),
            },
          },
          { merge: true },
        );
      },
      // For tests + debugging only.
      _state: function () {
        return {
          fbReady:       fbReady,
          liveMode:      liveMode,
          inFlightCount: inFlightCount,
          deferred:      deferQueue.length,
          seenCount:     Object.keys(seenIds).length,
          lastKnownTs:   lastKnownTs,
        };
      },
      detach: function () {
        if (unsubSession) { unsubSession(); unsubSession = null; }
        if (unsubMsgs)    { unsubMsgs();    unsubMsgs    = null; }
        if (refreshTimer) { clearTimeout(refreshTimer); refreshTimer = null; }
      },
    };
  })();

  // ---------------------------------------------------------------------
  // ---------------------------------------------------------------------
  // v2.53.3 — Typing-signal module (FS_TYPING)
  // ---------------------------------------------------------------------
  // Sends "customer is typing" signals via Firestore so OTHER tabs of
  // the same session and the agent dashboard can react. Other tabs
  // disable their input boxes when they observe a typing signal from
  // a FOREIGN tab_id (the active typer's own tab is unaffected).
  //
  // Lifecycle of one typing burst:
  //   1. First keystroke after idle → writeClientTyping(signal) fires
  //      IMMEDIATELY. isTyping becomes true.
  //   2. Subsequent keystrokes (while isTyping) → no write. The stop
  //      timer is reset (so 5 more seconds before auto-clear).
  //   3. Heartbeat (every HEARTBEAT_MS): writeClientTyping refreshes
  //      last_heartbeat so other tabs see the signal as fresh.
  //   4. Stop conditions:
  //        - STOP_TIMER_MS of no keystrokes → writeClientTyping(null).
  //        - Customer hits send → writeClientTyping(null) immediately.
  //        - beforeunload → best-effort writeClientTyping(null).
  //
  // Foreign-tab observation:
  //   - Session-doc listener (in FS_FIRESTORE) calls
  //     onSessionDocSnapshot(client_typing) on every snapshot.
  //   - We check: tab_id != MY_TAB_ID AND heartbeat is fresh
  //     (< STALE_MS old) → foreign tab is typing.
  //   - _updateInputLockState picks up the foreign-typing flag and
  //     disables $input + $send.
  //
  // Why direct Firestore write rather than POST to bot-server:
  //   - Latency. ~200ms Firestore round-trip vs ~400ms HTTP. Typing
  //     UX benefits from snappy lockout.
  //   - Firestore rules will be updated (v2.53.3 deploy step) to
  //     allow widget writes to ONLY the `client_typing` field — see
  //     deploy notes.
  // ---------------------------------------------------------------------
  var FS_TYPING = (function () {
    "use strict";

    // ------------------------------------------------------------------
    // Tunables (all in milliseconds).
    // ------------------------------------------------------------------
    // Heartbeat: refresh client_typing.last_heartbeat every 3s while
    // typing. Other tabs' staleness check is 10s, so this gives 3
    // chances for a heartbeat to arrive before the signal goes stale.
    var HEARTBEAT_MS = 3000;
    // Stop timer: after this much time with no keystrokes, write null.
    var STOP_TIMER_MS = 5000;
    // Stale threshold: a typing signal whose last_heartbeat is older
    // than this is treated as stale (typer's tab probably died). The
    // staleness check is the safety net for dead tabs.
    var STALE_MS = 10000;
    // Foreign-typing periodic check: every this many ms, re-evaluate
    // the freshness of the current foreign-typing signal even without
    // a new Firestore snapshot — so a stale signal eventually unlocks
    // the input even if Firestore doesn't fire (e.g. the foreign tab
    // simply died without writing null).
    var FRESHNESS_CHECK_MS = 2000;

    // ------------------------------------------------------------------
    // State.
    // ------------------------------------------------------------------
    var isTyping     = false;       // am I currently typing?
    var heartbeatTimer = null;
    var stopTimer    = null;
    var foreignTyping = null;       // { tab_id, page_url, lastHeartbeatMs } | null
    var freshnessChecker = null;    // setInterval handle

    // ------------------------------------------------------------------
    // Outgoing — I'm typing
    // ------------------------------------------------------------------
    function onKeystroke() {
      // Skip if the customer's input is empty (they just deleted
      // everything) — no signal needed. Treat as stop.
      if (!$input || !$input.value) {
        if (isTyping) stop();
        return;
      }
      if (!isTyping) {
        start();
      } else {
        // Already typing — just reset the stop timer.
        resetStopTimer();
      }
    }

    function start() {
      isTyping = true;
      _writeSignal();   // fire & forget
      // Heartbeat refresh.
      if (heartbeatTimer) clearInterval(heartbeatTimer);
      heartbeatTimer = setInterval(_writeSignal, HEARTBEAT_MS);
      resetStopTimer();
    }

    function stop() {
      if (!isTyping) return;
      isTyping = false;
      if (heartbeatTimer) { clearInterval(heartbeatTimer); heartbeatTimer = null; }
      if (stopTimer)      { clearTimeout(stopTimer);       stopTimer      = null; }
      _writeClearSignal();   // fire & forget
    }

    function resetStopTimer() {
      if (stopTimer) clearTimeout(stopTimer);
      stopTimer = setTimeout(function () {
        // Customer hasn't typed for STOP_TIMER_MS. Auto-clear.
        stop();
      }, STOP_TIMER_MS);
    }

    function _writeSignal() {
      try {
        FS_FIRESTORE.writeClientTyping({
          tab_id:   TAB_ID,
          page_url: location.href,
        }).catch(function (e) {
          // Silent failure — typing signal is best-effort.
          if (console && console.debug) {
            // console.debug("[FlowerSugar/typing] write failed:", e && e.message);
          }
        });
      } catch (_) {}
    }

    function _writeClearSignal() {
      try {
        FS_FIRESTORE.writeClientTyping(null).catch(function () {});
      } catch (_) {}
    }

    // ------------------------------------------------------------------
    // Incoming — someone else is typing (or stopped)
    // ------------------------------------------------------------------
    function onSessionDocSnapshot(clientTypingField) {
      // Field is { tab_id, page_url, last_heartbeat: Timestamp } | null.
      if (!clientTypingField || typeof clientTypingField !== "object") {
        // Cleared.
        foreignTyping = null;
        _updateInputLockState();
        return;
      }
      var tab = clientTypingField.tab_id;
      if (tab === TAB_ID) {
        // My own echo — ignore.
        foreignTyping = null;
        _updateInputLockState();
        return;
      }
      // Foreign tab. Extract heartbeat as epoch ms.
      var hbMs = 0;
      var hb = clientTypingField.last_heartbeat;
      if (hb && hb.toMillis) {
        hbMs = hb.toMillis();
      } else if (hb && hb.seconds != null) {
        hbMs = hb.seconds * 1000 + (hb.nanoseconds || 0) / 1e6;
      } else if (typeof hb === "number") {
        hbMs = hb;
      }
      foreignTyping = {
        tab_id:           tab,
        page_url:         clientTypingField.page_url || "",
        lastHeartbeatMs:  hbMs,
      };
      _updateInputLockState();
      // Start periodic freshness re-check so stale signals expire even
      // without further snapshots from Firestore.
      _ensureFreshnessChecker();
    }

    function isForeignTypingActive() {
      if (!foreignTyping) return false;
      if (!foreignTyping.lastHeartbeatMs) {
        // Some snapshots fire BEFORE serverTimestamp resolves (the
        // writing tab sees its own pre-server-timestamp value). Treat
        // missing heartbeat as fresh — the next snapshot will carry
        // the resolved timestamp.
        return true;
      }
      return (Date.now() - foreignTyping.lastHeartbeatMs) < STALE_MS;
    }

    function _ensureFreshnessChecker() {
      if (freshnessChecker) return;
      freshnessChecker = setInterval(function () {
        if (!foreignTyping) {
          clearInterval(freshnessChecker);
          freshnessChecker = null;
          return;
        }
        if (!isForeignTypingActive()) {
          // Stale — treat as if cleared.
          foreignTyping = null;
          _updateInputLockState();
          clearInterval(freshnessChecker);
          freshnessChecker = null;
        }
      }, FRESHNESS_CHECK_MS);
    }

    // ------------------------------------------------------------------
    // beforeunload — best-effort cleanup.
    // ------------------------------------------------------------------
    function _attachUnloadCleanup() {
      var done = false;
      function clean() {
        if (done) return;
        done = true;
        if (isTyping) _writeClearSignal();
      }
      window.addEventListener("pagehide", clean);
      window.addEventListener("beforeunload", clean);
    }
    _attachUnloadCleanup();

    // ------------------------------------------------------------------
    // Public API consumed by the widget IIFE.
    // ------------------------------------------------------------------
    return {
      onKeystroke:           onKeystroke,
      onSend:                stop,
      onSessionDocSnapshot:  onSessionDocSnapshot,
      isForeignTypingActive: isForeignTypingActive,
      foreignTyperTabId:     function () {
        return foreignTyping ? foreignTyping.tab_id : null;
      },
      // For tests + debugging only.
      _state: function () {
        return {
          isTyping:      isTyping,
          foreignTyping: foreignTyping,
          stale:         !isForeignTypingActive() && !!foreignTyping,
        };
      },
    };
  })();

  // ---------------------------------------------------------------------
  // v2.55.0 — FS_PHONE: phone capture UI for cross-device chat continuity
  // ---------------------------------------------------------------------
  // Owns:
  //   - Turn counter (counts BOT-reply turns to time the soft prompt)
  //   - Inline soft-prompt bubble at turn 5 (one-time per session)
  //   - Settings drawer (gear button → menu with capture + unlink)
  //   - Phone entry modal (validate, normalize-preview, submit)
  //   - POST /customer/phone/capture / /unlink
  //   - Linked-phone indicator in header subtitle
  //
  // State persistence:
  //   - sessionStorage for per-tab transient flags (promptShown, promptDismissed).
  //   - The session doc's linked_phone field (loaded via /history) is the
  //     server-side source of truth for "is this device linked". The
  //     widget reads it via setLinkedPhoneFromHistory() during /history.
  //
  // Phase 1 (this version): capture works end-to-end. Phase 2 (recovery
  // via OTP) is out of scope; the widget has no UI for it yet.
  // ---------------------------------------------------------------------
  var FS_PHONE = (function () {
    "use strict";

    // ------------------------------------------------------------------
    // State.
    // ------------------------------------------------------------------
    // Turn counter persisted across reloads (sessionStorage). Survives
    // a refresh, dies with the tab. The prompt should fire AT turn 5
    // even if the customer refreshes mid-conversation.
    var TURN_KEY            = "fsPhoneTurnCount";
    var PROMPT_SHOWN_KEY    = "fsPhonePromptShown";
    var PROMPT_DISMISSED_KEY = "fsPhonePromptDismissed";
    var PROMPT_TRIGGER_TURN = 5;

    var linkedPhoneMasked = null;   // "+6012•••6789" when linked, else null
    var phoneModalContext = "capture";  // "capture" (default) — Phase 2 will add "recover"

    function _getTurnCount() {
      try {
        return parseInt(sessionStorage.getItem(TURN_KEY), 10) || 0;
      } catch (_) {
        return 0;
      }
    }
    function _setTurnCount(n) {
      try { sessionStorage.setItem(TURN_KEY, String(n)); } catch (_) {}
    }
    function _isPromptShown() {
      try { return sessionStorage.getItem(PROMPT_SHOWN_KEY) === "1"; }
      catch (_) { return false; }
    }
    function _markPromptShown() {
      try { sessionStorage.setItem(PROMPT_SHOWN_KEY, "1"); } catch (_) {}
    }
    function _isPromptDismissed() {
      try { return sessionStorage.getItem(PROMPT_DISMISSED_KEY) === "1"; }
      catch (_) { return false; }
    }
    function _markPromptDismissed() {
      try { sessionStorage.setItem(PROMPT_DISMISSED_KEY, "1"); } catch (_) {}
    }

    // ------------------------------------------------------------------
    // Turn tracking — increment on each substantive bot reply.
    // Wired in addBubble (role==="bot" with non-empty text).
    // ------------------------------------------------------------------
    function onBotTurn() {
      // Already linked? Don't waste cycles.
      if (linkedPhoneMasked) return;
      // Already shown the prompt OR explicitly dismissed? Don't re-trigger.
      if (_isPromptShown() || _isPromptDismissed()) return;

      var n = _getTurnCount() + 1;
      _setTurnCount(n);

      if (n >= PROMPT_TRIGGER_TURN) {
        _showInlinePrompt();
      }
    }

    // ------------------------------------------------------------------
    // Inline soft prompt — rendered as a styled bubble in the chat stream
    // ------------------------------------------------------------------
    function _showInlinePrompt() {
      if (_isPromptShown()) return;
      _markPromptShown();

      var wrap = document.createElement("div");
      wrap.className = "fs-chatbot-phone-prompt";
      wrap.setAttribute("role", "note");
      wrap.innerHTML =
        '<div class="fs-chatbot-phone-prompt-title">' +
        '  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '    <rect x="5" y="2" width="14" height="20" rx="2"/>' +
        '    <line x1="12" y1="18" x2="12.01" y2="18"/>' +
        '  </svg>' +
        '  Save your chat across devices' +
        '</div>' +
        '<div class="fs-chatbot-phone-prompt-body">' +
        '  Add your phone number and you can pick up this conversation ' +
        '  on any of your devices.' +
        '</div>' +
        '<div class="fs-chatbot-phone-prompt-actions">' +
        '  <button class="fs-chatbot-phone-prompt-btn fs-chatbot-phone-prompt-btn-secondary" data-act="dismiss">Not now</button>' +
        '  <button class="fs-chatbot-phone-prompt-btn fs-chatbot-phone-prompt-btn-primary" data-act="open">Save my number</button>' +
        '</div>';

      wrap.addEventListener("click", function (e) {
        var btn = e.target.closest("button[data-act]");
        if (!btn) return;
        if (btn.dataset.act === "open") {
          openPhoneModal("capture");
        } else if (btn.dataset.act === "dismiss") {
          _markPromptDismissed();
          wrap.style.transition = "opacity 200ms";
          wrap.style.opacity = "0";
          setTimeout(function () { wrap.remove(); }, 220);
        }
      });

      $messages.appendChild(wrap);
      $messages.scrollTop = $messages.scrollHeight;
    }

    // ------------------------------------------------------------------
    // Settings drawer
    // ------------------------------------------------------------------
    function _toggleSettings(forceState) {
      if (!$settingsDrawer) return;
      var isOpen = $settingsDrawer.classList.contains("fs-chatbot-settings-open");
      var nextOpen = typeof forceState === "boolean" ? forceState : !isOpen;
      if (nextOpen) {
        // v2.55.6: when already linked, hide "Save my number" entirely
        // (no more update-by-recapture path — customers who want to
        // change phones must "Clear History" first, then re-capture).
        // Label is fixed to "Save my number" since we never show an
        // "update" variant.
        if ($settingsSavePhoneLabel) {
          $settingsSavePhoneLabel.textContent = "Save my number";
        }
        if ($settingsSavePhone) {
          $settingsSavePhone.style.display = linkedPhoneMasked ? "none" : "";
        }
        // v2.55.3: hide "Continue previous chat" when session is
        // already linked. Recovery is for fresh devices that don't
        // know they're the same customer yet — once linked, there's
        // nothing to recover.
        if ($settingsRecover) {
          $settingsRecover.style.display = linkedPhoneMasked ? "none" : "";
        }
        // v2.55.6: Clear History is ALWAYS visible — works whether
        // linked or not. Just resets the device.
        if ($settingsClearHistory) {
          $settingsClearHistory.style.display = "";
        }
        $settingsDrawer.classList.add("fs-chatbot-settings-open");
      } else {
        $settingsDrawer.classList.remove("fs-chatbot-settings-open");
      }
    }

    function _closeSettingsOnOutsideClick(e) {
      if (!$settingsDrawer || !$settingsDrawer.classList.contains("fs-chatbot-settings-open")) return;
      if ($settingsDrawer.contains(e.target)) return;
      if ($menu && $menu.contains(e.target)) return;
      _toggleSettings(false);
    }

    if ($menu) {
      $menu.addEventListener("click", function (e) {
        e.stopPropagation();
        _toggleSettings();
      });
    }
    if ($settingsSavePhone) {
      $settingsSavePhone.addEventListener("click", function () {
        _toggleSettings(false);
        openPhoneModal("capture");
      });
    }
    // v2.55.6: Clear History — confirmation, then archive call,
    // then DOM wipe + session id swap. The confirmation is a
    // native window.confirm for portability; could be upgraded
    // to a custom modal later if branded look is desired.
    if ($settingsClearHistory) {
      $settingsClearHistory.addEventListener("click", function () {
        _toggleSettings(false);
        var ok = window.confirm(
          "Clear chat history?\n\n" +
          "All chat history and cart from this device will be removed. " +
          "This cannot be undone."
        );
        if (!ok) return;
        _clearHistory();
      });
    }
    document.addEventListener("click", _closeSettingsOnOutsideClick);

    // ------------------------------------------------------------------
    // Phone entry modal
    // ------------------------------------------------------------------
    // v2.55.3 — modal now has THREE views; context controls which one
    // is shown:
    //   "capture"          — Save my number flow (default)
    //   "recover_phone"    — Enter phone to start recovery
    //   "recover_code"     — Enter the OTP code after seeing WhatsApp link
    //
    // _showView switches visibility of the three view divs and resets
    // any error state from previous activations.
    var _currentOtpRequestId = null;   // set in step recover_phone → recover_code

    function _showView(name) {
      var views = {
        "capture":       $phoneViewCapture,
        "recover_phone": $phoneViewRecPhone,
        "recover_code":  $phoneViewRecCode,
      };
      for (var k in views) {
        if (Object.prototype.hasOwnProperty.call(views, k) && views[k]) {
          views[k].style.display = (k === name) ? "" : "none";
        }
      }
    }

    function openPhoneModal(context) {
      phoneModalContext = context || "capture";
      if (!$phoneModal) return;

      // Clear inputs and errors on every open so a previous failed
      // attempt doesn't leave stale state.
      if ($phoneInput)         $phoneInput.value = "";
      if ($phoneRecoverInput)  $phoneRecoverInput.value = "";
      if ($phoneCodeInput)     $phoneCodeInput.value = "";
      if ($phoneError)         $phoneError.textContent = "";
      if ($phoneRecoverError)  $phoneRecoverError.textContent = "";
      if ($phoneCodeError)     $phoneCodeError.textContent = "";
      if ($phoneInput)         $phoneInput.classList.remove("fs-chatbot-phone-input-error");
      if ($phoneRecoverInput)  $phoneRecoverInput.classList.remove("fs-chatbot-phone-input-error");
      if ($phoneCodeInput)     $phoneCodeInput.classList.remove("fs-chatbot-phone-input-error");

      if (phoneModalContext === "recover_phone") {
        _showView("recover_phone");
      } else if (phoneModalContext === "recover_code") {
        _showView("recover_code");
      } else {
        _showView("capture");
        if ($phoneModalTitle) {
          $phoneModalTitle.textContent = linkedPhoneMasked
            ? "Update your saved number" : "Save your chat across devices";
        }
      }

      $phoneModal.classList.add("fs-chatbot-phone-modal-open");

      // Defer focus to the right input for the active view. iOS needs
      // the timeout so the keyboard pops up reliably.
      setTimeout(function () {
        try {
          if (phoneModalContext === "recover_phone" && $phoneRecoverInput) {
            $phoneRecoverInput.focus();
          } else if (phoneModalContext === "recover_code" && $phoneCodeInput) {
            $phoneCodeInput.focus();
          } else if ($phoneInput) {
            $phoneInput.focus();
          }
        } catch (_) {}
      }, 100);
    }

    function _closePhoneModal() {
      if (!$phoneModal) return;
      $phoneModal.classList.remove("fs-chatbot-phone-modal-open");
      _currentOtpRequestId = null;
    }

    function _validatePhoneLocal(raw) {
      // Local pre-validation: stricter than the server's just to give
      // the customer instant feedback. The server's normalize_phone
      // is the source of truth and will reject any edge case we miss.
      var trimmed = (raw || "").trim();
      if (!trimmed) return "Phone number is required.";
      // Must have at least 8 digits total.
      var digits = trimmed.replace(/\D/g, "");
      if (digits.length < 8) {
        return "Phone number is too short.";
      }
      if (digits.length > 15) {
        return "Phone number is too long.";
      }
      return null;
    }

    function _submitPhoneCapture() {
      if (!$phoneInput) return;
      var raw = ($phoneInput.value || "").trim();
      var err = _validatePhoneLocal(raw);
      if (err) {
        if ($phoneError) $phoneError.textContent = err;
        $phoneInput.classList.add("fs-chatbot-phone-input-error");
        return;
      }
      if ($phoneError) $phoneError.textContent = "";
      $phoneInput.classList.remove("fs-chatbot-phone-input-error");
      $phoneSave.disabled = true;
      $phoneSave.textContent = "Saving…";

      api("/customer/phone/capture", {
        widget_key:   WIDGET_KEY,
        session_id:   SESSION_ID,
        phone_number: raw,
        source:       "chat_prompt",
        language:     null,
      })
        .then(function (res) {
          if (res.status === 200 && res.body && res.body.status === "success") {
            linkedPhoneMasked = res.body.masked;
            _updateHeaderSub();
            _closePhoneModal();
            // Acknowledge with a system message in the chat stream
            // so the customer has a visible confirmation.
            try {
              addBubble("bot",
                "Your number " + res.body.masked + " is saved. You can " +
                "continue this chat on another device by entering this " +
                "number there.");
            } catch (_) {}
            return;
          }
          // Server validation failure surfaces here.
          var reason = (res.body && res.body.reason)
            || (res.body && res.body.error)
            || "Could not save phone. Please try again.";
          if ($phoneError) $phoneError.textContent = reason;
          $phoneInput.classList.add("fs-chatbot-phone-input-error");
        })
        .catch(function (e) {
          if ($phoneError) {
            $phoneError.textContent = "Network error. Please try again.";
          }
          console.warn("[FS/phone] capture failed:", e && e.message);
        })
        .finally(function () {
          $phoneSave.disabled = false;
          $phoneSave.textContent = "Save";
        });
    }

    function _unlinkPhone() {
      if (!confirm("Unlink your phone from this device? Your chat history will stay on the server, but this device will no longer be linked.")) {
        return;
      }
      api("/customer/phone/unlink", {
        widget_key: WIDGET_KEY,
        session_id: SESSION_ID,
      }).then(function (res) {
        if (res.status === 200) {
          linkedPhoneMasked = null;
          _updateHeaderSub();
          try {
            addBubble("bot", "Your phone has been unlinked from this device.");
          } catch (_) {}
        }
      }).catch(function () {});
    }

    // v2.55.6 — Clear History
    //
    // Customer just confirmed they want to wipe. POST to the server's
    // /customer/clear_history endpoint, which:
    //   - archives this session (and cascades to all linked devices
    //     if there's a phone link)
    //   - returns a new session_id to use
    //
    // Widget then:
    //   - swaps cookie + SESSION_ID to the new id
    //   - clears the message DOM stream
    //   - clears the in-memory linked-phone state and refreshes header
    //   - clears the Firestore listener's seen-id dedup map
    //   - calls /history (which returns empty for the new id) →
    //     loadHistory's renders the welcome state
    function _clearHistory() {
      api("/customer/clear_history", {
        widget_key: WIDGET_KEY,
        session_id: SESSION_ID,
      }).then(function (res) {
        if (res.status !== 200 || !res.body || res.body.status !== "success") {
          // Best-effort failure handling: show a transient bot bubble
          // so the customer doesn't think the click was lost.
          try {
            addBubble("bot",
              "Sorry, we couldn't clear your history right now. " +
              "Please try again in a moment.");
          } catch (_) {}
          return;
        }
        var newSid = res.body.new_session_id;
        if (!newSid || typeof newSid !== "string") {
          try {
            addBubble("bot",
              "Sorry, something went wrong clearing your history.");
          } catch (_) {}
          return;
        }
        // Apply the new session id (same plumbing as the v2.55.4
        // redirect path — see _maybeApplyRedirect for the cookie write).
        var previous = SESSION_ID;
        SESSION_ID = newSid;
        setCookie(COOKIE_NAME, newSid, 365);
        try {
          // console.info(
            // "[FlowerSugar/clear_history] session", previous, "→", newSid,
            // "cascaded=" + (res.body.cascaded ? "yes" : "no"),
            // "archived_count=" + ((res.body.archived_session_ids || []).length)
          // );
        } catch (_) {}
        // Wipe the message stream.
        while ($messages && $messages.firstChild) {
          $messages.removeChild($messages.firstChild);
        }
        // v2.55.180 — wiping the stream removed any open form's DOM node, but
        // the input-lock registry (activeForms) still holds it, so the composer
        // would stay disabled in the fresh session. Release the lock explicitly:
        // clear the active-form set, drop any in-flight send flag, and re-derive
        // the lock state so the customer can type right away.
        try { activeForms.clear(); } catch (_) {}
        isSending = false;
        try { _updateInputLockState(); } catch (_) {}
        // Clear linked-phone state (the new session is unlinked).
        try { FS_PHONE.setLinkedFromHistory(null); } catch (_) {}
        // Forget the old session's message ids.
        try { FS_FIRESTORE.resetSeenIds(); } catch (_) {}
        // Reload /history against the new (empty) session — this also
        // re-boots the Firestore listener on the new session.
        loadHistory();
      }).catch(function () {
        try {
          addBubble("bot",
            "Sorry, we couldn't clear your history right now. " +
            "Please check your connection and try again.");
        } catch (_) {}
      });
    }

    // ------------------------------------------------------------------
    // v2.55.3 — Recovery flow (cross-device chat continuity)
    //
    // Three-step UX:
    //   1. Customer taps "Continue previous chat" → recover_phone view
    //   2. Enters phone → POST /customer/phone/recover_request
    //      Server creates OTP doc, returns whatsapp_url + otp_request_id
    //   3. Widget shows WhatsApp link → recover_code view
    //      Customer taps link, messages Flower Sugar, agent replies
    //      with the 6-digit code
    //   4. Customer types code → POST /customer/phone/recover_verify
    //      Server checks code → links session → success
    //   5. Widget refreshes /history to reflect the new link state
    // ------------------------------------------------------------------
    function _submitRecoverRequest() {
      if (!$phoneRecoverInput) return;
      var raw = ($phoneRecoverInput.value || "").trim();
      var err = _validatePhoneLocal(raw);
      if (err) {
        if ($phoneRecoverError) $phoneRecoverError.textContent = err;
        $phoneRecoverInput.classList.add("fs-chatbot-phone-input-error");
        return;
      }
      if ($phoneRecoverError) $phoneRecoverError.textContent = "";
      $phoneRecoverInput.classList.remove("fs-chatbot-phone-input-error");
      $phoneRecoverRequest.disabled = true;
      $phoneRecoverRequest.textContent = "Requesting…";

      api("/customer/phone/recover_request", {
        widget_key:   WIDGET_KEY,
        session_id:   SESSION_ID,
        phone_number: raw,
      })
        .then(function (res) {
          if (res.status === 503) {
            if ($phoneRecoverError) {
              $phoneRecoverError.textContent =
                "Recovery is temporarily unavailable. Please try again later.";
            }
            return;
          }
          if (res.status === 501) {
            if ($phoneRecoverError) {
              $phoneRecoverError.textContent =
                "This delivery method isn't available yet.";
            }
            return;
          }
          if (res.status === 200 && res.body && res.body.status === "success") {
            // Got an OTP request id + WhatsApp link. Move to code-entry step.
            _currentOtpRequestId = res.body.otp_request_id;
            if ($phoneRecoverWaLink && res.body.whatsapp_url) {
              $phoneRecoverWaLink.href = res.body.whatsapp_url;
            }
            if ($phoneRecoverWaSub && res.body.whatsapp_number) {
              $phoneRecoverWaSub.textContent =
                "Tap the button below to message us on WhatsApp (" +
                res.body.whatsapp_number +
                "). An agent will reply with your 6-digit code.";
            }
            openPhoneModal("recover_code");
            return;
          }
          // Generic error
          var reason = (res.body && res.body.reason)
            || (res.body && res.body.error)
            || "Could not request code. Please try again.";
          if ($phoneRecoverError) $phoneRecoverError.textContent = reason;
        })
        .catch(function (e) {
          if ($phoneRecoverError) {
            $phoneRecoverError.textContent = "Network error. Please try again.";
          }
          console.warn("[FS/phone] recover_request failed:", e && e.message);
        })
        .finally(function () {
          $phoneRecoverRequest.disabled = false;
          $phoneRecoverRequest.textContent = "Request code";
        });
    }

    function _submitRecoverVerify() {
      if (!$phoneCodeInput || !_currentOtpRequestId) return;
      var code = ($phoneCodeInput.value || "").trim();
      // Local format check (server enforces too; this is for instant UX)
      if (!/^\d{6}$/.test(code)) {
        if ($phoneCodeError) {
          $phoneCodeError.textContent = "Please enter the 6-digit code.";
        }
        $phoneCodeInput.classList.add("fs-chatbot-phone-input-error");
        return;
      }
      if ($phoneCodeError) $phoneCodeError.textContent = "";
      $phoneCodeInput.classList.remove("fs-chatbot-phone-input-error");
      $phoneCodeVerify.disabled = true;
      $phoneCodeVerify.textContent = "Verifying…";

      api("/customer/phone/recover_verify", {
        widget_key:     WIDGET_KEY,
        session_id:     SESSION_ID,
        otp_request_id: _currentOtpRequestId,
        code:           code,
      })
        .then(function (res) {
          if (res.status === 200 && res.body && res.body.status === "success") {
            // Successful link.
            linkedPhoneMasked = res.body.masked;
            _updateHeaderSub();
            _closePhoneModal();

            // v2.55.4: after merge, render the live session's
            // unified history. api() has already applied the redirect
            // (if any) — SESSION_ID is now the live session.
            //
            // The merge may have done one of three things:
            //   1. No-op: current session WAS the live one (or
            //      single-session phone). Just confirm the link.
            //   2. Merge from other sessions: live session = current,
            //      but other sessions' messages got copied in. The
            //      widget should reload to show them.
            //   3. Redirect: current session was NOT the live one;
            //      cookie + SESSION_ID switched. Widget must clear
            //      its current display and re-render from the live
            //      session.
            //
            // In ALL three cases the safest thing is to wipe the
            // current message stream and re-fetch /history. The
            // server is the source of truth for what messages exist
            // post-merge.
            try {
              var redirected = !!res.body.redirected_to_session_id;
              var mergedFromN = res.body.merged_from_n_sessions || 0;
              var copiedN = res.body.messages_copied || 0;

              // Wipe rendered messages (DOM) but only if there's
              // something to refresh from. The /history reload
              // re-populates.
              if (redirected || mergedFromN > 0) {
                while ($messages && $messages.firstChild) {
                  $messages.removeChild($messages.firstChild);
                }
                // Drop the in-memory dedup set for the listener so
                // the reloaded history can re-register fresh ids.
                try { FS_FIRESTORE.resetSeenIds(); } catch (_) {}

                // Friendly toast bubble: only emit when something
                // actually changed for the customer.
                var toast;
                if (redirected) {
                  toast = "Welcome back. Your previous chat is loading…";
                } else {
                  toast = "Linked to " + res.body.masked + ". Loading your previous messages…";
                }
                addBubble("bot", toast);

                // Re-fetch /history against the new SESSION_ID.
                loadHistory();
              } else {
                // No-op merge — just confirm the link to the customer.
                addBubble("bot",
                  "Linked to " + res.body.masked + "."
                );
              }
            } catch (e) {
              console.warn("[FS/verify] post-merge reload failed:", e && e.message);
              // Last-ditch: leave the conversation as-is plus a
              // simple confirmation.
              try {
                addBubble("bot", "Linked to " + res.body.masked + ".");
              } catch (_) {}
            }
            return;
          }
          // Map common errors to friendly text
          var errCode = (res.body && res.body.error) || "unknown_error";
          var msg;
          if (errCode === "otp_wrong_code") {
            var rem = res.body.remaining_attempts;
            msg = "Incorrect code." + (typeof rem === "number"
              ? " " + rem + " attempt" + (rem === 1 ? "" : "s") + " left."
              : "");
          } else if (errCode === "otp_max_attempts") {
            msg = "Too many wrong attempts. Please request a new code.";
            _currentOtpRequestId = null;
          } else if (errCode === "otp_expired") {
            msg = "This code has expired. Please request a new one.";
            _currentOtpRequestId = null;
          } else if (errCode === "otp_consumed") {
            msg = "This code has already been used.";
            _currentOtpRequestId = null;
          } else if (errCode === "otp_not_found") {
            msg = "Code request was not found. Please request a new one.";
            _currentOtpRequestId = null;
          } else if (errCode === "session_mismatch") {
            msg = "This code can only be verified from the device that requested it.";
          } else {
            msg = (res.body && res.body.reason) || "Could not verify code. Please try again.";
          }
          if ($phoneCodeError) $phoneCodeError.textContent = msg;
          $phoneCodeInput.classList.add("fs-chatbot-phone-input-error");
        })
        .catch(function (e) {
          if ($phoneCodeError) {
            $phoneCodeError.textContent = "Network error. Please try again.";
          }
          console.warn("[FS/phone] recover_verify failed:", e && e.message);
        })
        .finally(function () {
          $phoneCodeVerify.disabled = false;
          $phoneCodeVerify.textContent = "Verify";
        });
    }

    // Wire recovery menu item + buttons
    if ($settingsRecover) {
      $settingsRecover.addEventListener("click", function () {
        _toggleSettings(false);
        openPhoneModal("recover_phone");
      });
    }
    if ($phoneRecoverRequest) {
      $phoneRecoverRequest.addEventListener("click", _submitRecoverRequest);
    }
    if ($phoneRecoverCancel) {
      $phoneRecoverCancel.addEventListener("click", _closePhoneModal);
    }
    if ($phoneCodeVerify) {
      $phoneCodeVerify.addEventListener("click", _submitRecoverVerify);
    }
    if ($phoneCodeCancel) {
      $phoneCodeCancel.addEventListener("click", _closePhoneModal);
    }
    if ($phoneRecoverInput) {
      $phoneRecoverInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          _submitRecoverRequest();
        }
      });
      $phoneRecoverInput.addEventListener("input", function () {
        $phoneRecoverInput.classList.remove("fs-chatbot-phone-input-error");
        if ($phoneRecoverError) $phoneRecoverError.textContent = "";
      });
    }
    if ($phoneCodeInput) {
      $phoneCodeInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          _submitRecoverVerify();
        }
      });
      $phoneCodeInput.addEventListener("input", function () {
        $phoneCodeInput.classList.remove("fs-chatbot-phone-input-error");
        if ($phoneCodeError) $phoneCodeError.textContent = "";
      });
    }

    if ($phoneSave) {
      $phoneSave.addEventListener("click", _submitPhoneCapture);
    }
    if ($phoneCancel) {
      $phoneCancel.addEventListener("click", _closePhoneModal);
    }
    if ($phoneInput) {
      // Submit on Enter for snappier UX
      $phoneInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          _submitPhoneCapture();
        }
      });
      // Clear error state on input
      $phoneInput.addEventListener("input", function () {
        $phoneInput.classList.remove("fs-chatbot-phone-input-error");
        if ($phoneError) $phoneError.textContent = "";
      });
    }

    // ------------------------------------------------------------------
    // Header subtitle — show linked phone (masked) when set
    // ------------------------------------------------------------------
    function _updateHeaderSub() {
      if (!$headerSub) return;
      if (linkedPhoneMasked) {
        $headerSub.innerHTML =
          '<span class="fs-chatbot-linked-phone">' +
          '  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '    <rect x="3" y="11" width="18" height="11" rx="2"/>' +
          '    <path d="M7 11V7a5 5 0 0110 0v4"/>' +
          '  </svg>' +
          '  Saved as ' + linkedPhoneMasked +
          '</span>';
      } else {
        $headerSub.innerHTML =
          '<span class="fs-chatbot-pulse"></span> Usually replies instantly';
      }
    }

    // ------------------------------------------------------------------
    // Public API consumed by the widget IIFE.
    // ------------------------------------------------------------------
    return {
      onBotTurn:      onBotTurn,
      openPhoneModal: openPhoneModal,
      // Called by /history response handling: lets the server tell
      // the widget "you're linked to phone X" so the UI reflects it
      // even on a fresh tab.
      setLinkedFromHistory: function (linkedPhoneE164) {
        // /history returns the session doc's linked_phone (full E.164)
        // or null. Server returns masked? — we should ASK server for
        // masked. Phase 1 just stores the raw and masks client-side.
        if (typeof linkedPhoneE164 === "string" && linkedPhoneE164.startsWith("+")) {
          linkedPhoneMasked = _maskPhoneLocally(linkedPhoneE164);
        } else {
          linkedPhoneMasked = null;
        }
        _updateHeaderSub();
      },
      isLinked: function () { return !!linkedPhoneMasked; },
      // For tests / debug
      _state: function () {
        return {
          linkedPhoneMasked: linkedPhoneMasked,
          turnCount:         _getTurnCount(),
          promptShown:       _isPromptShown(),
          promptDismissed:   _isPromptDismissed(),
        };
      },
    };

    // Local masking — mirrors v2/phone_norm.py mask_phone() so the
    // server doesn't need to send masked + full forms separately for
    // the linked-phone indicator. Only invoked on already-validated
    // E.164 from the server.
    function _maskPhoneLocally(e164) {
      if (!e164 || !e164.startsWith("+")) return "";
      var digits = e164.slice(1);
      if (digits.length < 8) return e164;
      // +<cc:2><sub:2>•••<last4>
      return e164.slice(0, 5) + "•••" + e164.slice(-4);
    }
  })();
  // ---------------------------------------------------------------------
  // v2.55.19 — FS_SHOPIFY_CART
  //
  // Inbound sync: read the Shopify storefront's cart and reconcile with
  // the widget's view. Gated on `window.FS_SHOPIFY_CART_SYNC === true`
  // (the host page sets this when running on a Shopify storefront).
  //
  // Scope (v2.55.19, Phase 1 — read-only):
  //   * On boot, fetch /cart.js to get the storefront cart.
  //   * Compare against widget's current cart (this.fullCart, server-
  //     driven) on the four key fields: product_id, variant_id,
  //     quantity, "Delivery Date" line-item property.
  //   * Conflict resolution per spec:
  //       - both empty → noop
  //       - shopify filled, widget empty → adopt Shopify
  //       - shopify empty, widget filled → "fill empty" (DEFERRED; needs
  //         outbound /cart/add.js; logged, no-op in v2.55.19)
  //       - both filled, mismatch → adopt Shopify (Shopify wins)
  //       - both filled, match → noop
  //   * Subscribe to `cart:updated` DOM event. On external change,
  //     adopt Shopify cart AND reset wizard to page 1 (if open).
  //   * Show a sync indicator during boot-read.
  //
  // Out of scope (v2.55.20+):
  //   * Outbound writes: widget cart edits don't push to /cart.js.
  //   * Server-side cart reconciliation: bot reads its own session
  //     cart for now; informing the bot of Shopify state is the next
  //     ship (likely via a new endpoint or augmented /chat body).
  //
  // Cart-level attributes (balloon_wording, message card, recipient/
  // sender) are NOT synced — they live as Shopify cart-level
  // attributes on the storefront side and as widget-local state here,
  // but no bridge exists in v2.55.19. The Delivery Date is the only
  // line-item property bridged.
  //
  // Loop protection (for Phase 2 outbound): pendingWriteFingerprint
  // is a placeholder hook; Phase 1 never sets it, so all cart:updated
  // events are treated as external.
  // ---------------------------------------------------------------------
  var FS_SHOPIFY_CART = (function () {
    var lastShopifyFingerprint = null;
    var pendingWriteFingerprint = null;  // for v2.55.20+ outbound
    var listenerAttached        = false;

    // v2.55.43 — empty-first-sync guard. Tracks whether this session has
    // ever synced a NON-EMPTY cart to the server. An empty Shopify cart
    // fires on every page load / after Clear History; POSTing it when we've
    // never had items just births an empty server session and wastes a
    // round-trip. We skip the empty sync UNTIL the first non-empty one;
    // after that, an empty sync is a genuine "cart emptied" event and is
    // sent so the server clears it. (The backend has the authoritative
    // gate too; this is the client-side reduction of needless calls.)
    var _hasSyncedNonEmpty      = false;
    var bootDone                = false;
    var shopifyCart             = null;   // last-known parsed Shopify cart

    // v2.55.20+hotfix10 — multi-gate guards against the quantity-doubling
    // race (see the "2 units" incident). Two independent pushToShopify
    // invocations could overlap: a stale empty Firestore snapshot drove a
    // REMOVE, and before its /cart.js re-fetch settled, the corrected
    // snapshot drove an ADD-back. The interleaved writes landed on
    // Shopify as a net +1, doubling the line quantity.
    //
    //   _pushInFlight        — true while a pushToShopify (including its
    //                          terminal /cart.js re-fetch + re-adopt) is
    //                          running. Serializes pushes (Gate 2).
    //   _coalescedPush       — the most recent push request that arrived
    //                          while one was in flight; run once after the
    //                          current push settles (latest-wins coalesce).
    //   _lastPushedFingerprint — fingerprint of the last target we
    //                          successfully wrote; lets us skip a
    //                          redundant re-trigger for the same target
    //                          (Gate 3).
    var _pushInFlight          = false;
    var _coalescedPush         = null;   // { items, deliveryDate } | null
    var _lastPushedFingerprint = null;

    // v2.55.20+hotfix7 — Streamline cart-drawer auto-open suppression.
    //
    // The Streamline theme's listener for `ajaxProduct:added` calls
    // drawer.open() — designed for product-page add-to-cart UX so the
    // customer sees their addition land in the drawer. But our widget
    // dispatches `ajaxProduct:added` (hotfix3 onwards) to trigger the
    // theme's UI refresh after agent/wizard cart edits, where the
    // drawer popping open is wrong UX (the customer is in chat, not
    // shopping).
    //
    // Solution: attach a CAPTURE-PHASE listener on `window` that fires
    // BEFORE any document-level listener regardless of registration
    // order. The capture path is window → document → target; our
    // listener intercepts at window, checks for our `source: "fs_widget"`
    // marker on the event detail, and calls stopImmediatePropagation()
    // so the theme's drawer-opening listener never sees the event.
    //
    // Legitimate `ajaxProduct:added` events from elsewhere (e.g., a
    // future native product-page add-to-cart) won't carry our marker
    // and pass through normally — the drawer behavior for those flows
    // is preserved.
    //
    // We attach in the IIFE so the listener is in place before any
    // dispatch can occur, even if dispatch races with theme.js's own
    // setup. Idempotent guard prevents double-attach across hot
    // re-evaluations.
    var _drawerSuppressionAttached = false;
    (function _attachDrawerSuppression() {
      if (_drawerSuppressionAttached) return;
      if (typeof window === "undefined" || !window.addEventListener) return;
      _drawerSuppressionAttached = true;
      try {
        window.addEventListener("ajaxProduct:added", function (e) {
          if (e && e.detail && e.detail.source === "fs_widget") {
            try { e.stopImmediatePropagation(); } catch (_) {}
            // console.info("[FS/shopify_cart/outbound] suppressed " +
            //              "ajaxProduct:added drawer-open (own echo)",
            //              (typeof FS_WIDGET_VERSION !== "undefined"
            //               ? FS_WIDGET_VERSION : "?"));
          }
        }, /*useCapture=*/ true);
        // console.info("[FS/shopify_cart/outbound] drawer-open suppression " +
        //              "attached (window capture-phase ajaxProduct:added)",
        //              (typeof FS_WIDGET_VERSION !== "undefined"
        //               ? FS_WIDGET_VERSION : "?"));
      } catch (attachErr) {
        // Defensive — if listener registration fails for any reason
        // (e.g., document not ready), the drawer will still open but
        // nothing else breaks. The next sync still works.
        // console.warn("[FS/shopify_cart/outbound] drawer suppression " +
        //              "attach failed:", attachErr && attachErr.message);
        _drawerSuppressionAttached = false;
      }
    })();
    // v2.55.19 hotfix2 — authoritative copy of the items the module
    // last adopted from Shopify. Separate from fullCart.items because
    // any of setFullCart / updateFullCartFromResponse / wizard handlers
    // can mutate fullCart.items at any time. Keeping our own copy lets
    // setFullCart/updateFullCartFromResponse defer to Shopify's view
    // as the source of truth (per spec).
    //   null  = not yet adopted (Shopify hasn't booted / fetch failed)
    //   []    = adopted-and-empty (Shopify cart is empty)
    //   [...] = adopted-with-items
    var adoptedItems = null;
    // v2.55.19 hotfix4 — also track the Shopify-derived delivery_date
    // separately so setFullCart / updateFullCartFromResponse can
    // preserve it the same way they preserve items. Without this,
    // a setFullCart from /cart/state's empty server cart would
    // Object.assign({}, serverCart, { items: shopifyItems }) and
    // the server's null delivery_date would overwrite the Shopify
    // date we just adopted.
    //   null   = no adoption yet, OR adopted-but-Shopify-had-no-date
    //   "..."  = the date from the LAST Shopify line item (ISO if
    //            conversion worked; raw Shopify string as fallback)
    var adoptedDeliveryDate = null;

    // v2.55.20+hotfix2 — pre-boot divergence queue.
    //
    // The race: between page load (FS_FIRESTORE attaches the session-doc
    // listener) and boot completion (FS_SHOPIFY_CART finishes /cart.js
    // and adoption), the agent can edit the cart from the dashboard.
    // The listener fires with the new server cart, but hasAdoptedItems()
    // is still false (we haven't seen Shopify yet), so the divergence-
    // push branch silently skips. Result: agent's edit hits Firestore
    // and reaches the widget, but never propagates to Shopify.
    //
    // The fix: when the listener fires before adoption, it stores the
    // divergent server cart here via _setPendingDivergence. After boot
    // completes and adoptedItems is set, the boot success path checks
    // this queue, computes the diff against the now-known Shopify state,
    // and pushes if non-empty.
    //
    //   null      = no pending divergence
    //   { items } = server cart received before boot resolution
    var pendingDivergenceCart = null;

    function isEnabled() {
      var v = window.FS_SHOPIFY_CART_SYNC === true;
      // Note: the noisy form (logging on every call) is intentional —
      // when the bug is "widget cart not filled with Shopify items",
      // the first thing to verify is whether the gating constant was
      // actually set. Logging at every check makes this trivial to
      // verify from the production console.
      // console.debug("[FS/shopify_cart] isEnabled() check",
      //   "window.FS_SHOPIFY_CART_SYNC=" +
      //   JSON.stringify(window.FS_SHOPIFY_CART_SYNC),
      //   "result=" + v);
      return v;
    }

    // ─────────────────────────────────────────────────────────────
    // Helpers
    // ─────────────────────────────────────────────────────────────

    // Shopify line item → minimal widget-side shape. We deliberately
    // keep only the fields we sync: variant_id, product_id, quantity,
    // "Delivery Date" property. Other Shopify line fields (price,
    // line_price, image, etc.) are NOT preserved here — the widget's
    // fullCart (server-driven) carries those.
    function _normalizeShopifyItem(it) {
      if (!it) return null;
      var props = it.properties || {};
      var deliveryDateRaw = props["Delivery Date"] || null;
      // v2.55.19 hotfix6 — Shopify /cart.js returns `price` (unit) and
      // `line_price` (total for line) as integers in the storefront's
      // smallest currency unit (cents for MYR/USD/etc.). The widget's
      // existing cart panel reads `price_cents` (see ~line 2892), so
      // we align names here for free downstream compatibility.
      // Discounts: per spec we ignore Shopify automatic discounts —
      // but Shopify's `price` field already reflects the post-discount
      // displayed price, which IS what we want to show. We take it
      // as-is. `original_price` (pre-discount) is not used.
      var unitCents = (typeof it.price === "number") ? it.price
                    : (typeof it.final_price === "number") ? it.final_price
                    : 0;
      var lineCents = (typeof it.line_price === "number") ? it.line_price
                    : (typeof it.final_line_price === "number") ? it.final_line_price
                    : unitCents * (Number(it.quantity) || 0);

      // v2.55.19 hotfix7 — diagnostic: log what fields Shopify actually
      // returned for this line. If price extraction is yielding 0, the
      // raw dump tells us whether (a) Shopify didn't send a price at all,
      // (b) it's in an unexpected field name, or (c) it's a string
      // instead of a number. Includes the version constant so we can
      // confirm which widget build emitted this line.
      // console.info("[FS/shopify_cart/normalize]", FS_WIDGET_VERSION,
      //   "raw_fields=" + Object.keys(it || {}).join(","),
      //   "price=" + JSON.stringify(it.price),
      //   "price_type=" + typeof it.price,
      //   "final_price=" + JSON.stringify(it.final_price),
      //   "line_price=" + JSON.stringify(it.line_price),
      //   "final_line_price=" + JSON.stringify(it.final_line_price),
      //   "extracted_unitCents=" + unitCents,
      //   "extracted_lineCents=" + lineCents,
      //   "quantity=" + it.quantity,
      //   "variant_id=" + (it.id || it.variant_id));

      return {
        variant_id:        String(it.id || it.variant_id || ""),
        product_id:        String(it.product_id || ""),
        product_title:     it.product_title || "",
        variant_title:     it.variant_title || "",
        quantity:          Number(it.quantity) || 0,
        delivery_date:     deliveryDateRaw,
        price_cents:       unitCents,
        line_price_cents:  lineCents,
        // v2.55.20 — Shopify's line `key` is the stable identifier
        // for /cart/change.js calls. Variant_id alone is ambiguous
        // when the same variant appears with different properties
        // (e.g., same flower, different delivery dates).
        shopify_line_key:  it.key || null,
        // Preserve unknown line-item properties for Phase 2's read-merge-
        // write pattern (don't strip other props the website set).
        properties_other:  _stripDeliveryDate(props),
      };
    }

    function _stripDeliveryDate(props) {
      if (!props) return {};
      var out = {};
      for (var k in props) {
        if (k !== "Delivery Date" && Object.prototype.hasOwnProperty.call(props, k)) {
          out[k] = props[k];
        }
      }
      return out;
    }

    // ─────────────────────────────────────────────────────────────
    // v2.55.20+hotfix3 — Storefront theme cart-UI refresh
    //
    // After a successful outbound write, Shopify's cart cookie is up to
    // date but the THEME'S OWN UI (cart drawer, mini-cart icon, /cart
    // page subtotal) is still showing the old state. Themes refresh
    // their cart UI in response to specific DOM events that their OWN
    // code dispatches when their OWN code mutates the cart — our raw
    // /cart/change.js POST bypasses that, so the theme never gets the
    // signal.
    //
    // Different themes listen for different events. Streamline (v6.0.1
    // on this storefront) dispatches "ajaxProduct:added" after its add-
    // to-cart calls; Dawn uses "cart:updated"; some older themes use
    // "cart:refresh", "cart:build", or section-rendering API responses.
    // To cover all conventions, we dispatch a small set of common events
    // — themes that don't recognize an event just ignore it.
    //
    // Defense-in-depth: we ALSO update the most common visible DOM
    // elements directly (cart bubble count, subtotal display, body
    // class for cart-has-items). Even if the theme doesn't react to
    // any of the dispatched events, the customer-visible state still
    // matches what's in Shopify.
    // ─────────────────────────────────────────────────────────────

    // Format cents to a money string. Reads the theme's moneyFormat if
    // available (e.g., "RM{{ amount_no_decimals }}" on this storefront),
    // falls back to plain RM<int>.
    function _formatMoneyForTheme(cents) {
      var c = Number(cents) || 0;
      try {
        var theme = window.theme;
        var fmt = theme && theme.settings && theme.settings.moneyFormat;
        if (typeof fmt === "string" && fmt) {
          var amount        = (c / 100).toFixed(2);
          var amountNoDec   = String(Math.round(c / 100));
          var amountComma   = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return fmt
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,           amountNoDec)
            .replace(/\{\{\s*amount\s*\}\}/g,                       amount)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,  amountComma);
        }
      } catch (_) { /* fall through */ }
      return "RM" + Math.round(c / 100);
    }

    // Compute total quantity across all items (Shopify's cart.item_count
    // is sometimes absent on partial cart responses; falling back to a
    // manual sum is more reliable).
    function _cartItemCount(cart) {
      if (!cart) return 0;
      if (typeof cart.item_count === "number") return cart.item_count;
      var items = cart.items || [];
      var n = 0;
      for (var i = 0; i < items.length; i++) {
        n += Number(items[i] && items[i].quantity) || 0;
      }
      return n;
    }

    // Directly update visible DOM elements that themes use to display
    // the cart. This is theme-agnostic — we update every selector that
    // matches conventions across major Shopify themes (Streamline, Dawn,
    // Debut, Brooklyn, Venture, etc.).
    function _refreshStorefrontCartUI(newCart) {
      var itemCount  = _cartItemCount(newCart);
      var totalCents = Number(newCart && newCart.total_price) || 0;
      var moneyStr   = _formatMoneyForTheme(totalCents);

      var bubbleN     = 0;
      var subtotalN   = 0;
      var visToggleN  = 0;

      // v2.55.21 — safe-write guard. NEVER overwrite a node that holds
      // child elements: some themes (Streamline) put cart DATA ATTRIBUTES
      // (data-cart-subtotal, data-count) on the ITEMS CONTAINER — the very
      // <div class="cart__items"> that holds the item rows. A blanket
      // textContent write on such a node wipes every item row and replaces
      // them with a stray money string (the exact corruption seen on the
      // passive drawer). We only write textContent to LEAF nodes (no
      // element children); data attributes are updated via setAttribute.
      function _setLeafText(node, text) {
        if (!node) return false;
        // childElementCount > 0 → it's a container; skip (don't clobber).
        if (node.childElementCount && node.childElementCount > 0) return false;
        node.textContent = text;
        return true;
      }

      try {
        // 1) Cart bubble item count. These are dedicated leaf <span>/count
        //    nodes — safe to write. (No container collision here.)
        var bubbleSel = ".cart-link__bubble-num, " +
                        "[data-cart-count], " +
                        "[data-cart-item-count], " +
                        ".cart-count-bubble span[aria-hidden='true'], " +
                        ".header__cart-count, " +
                        ".site-header__cart-count, " +
                        ".js-cart-count";
        var bubbleNodes = document.querySelectorAll(bubbleSel);
        for (var i = 0; i < bubbleNodes.length; i++) {
          if (_setLeafText(bubbleNodes[i], String(itemCount))) bubbleN++;
        }

        // 2) Bubble visibility class — Streamline hides the bubble entirely
        //    when count is 0 by removing .cart-link__bubble--visible.
        var bubbleContainers = document.querySelectorAll(".cart-link__bubble");
        for (var j = 0; j < bubbleContainers.length; j++) {
          if (itemCount > 0) {
            bubbleContainers[j].classList.add("cart-link__bubble--visible");
          } else {
            bubbleContainers[j].classList.remove("cart-link__bubble--visible");
          }
          visToggleN++;
        }

        // 3) Subtotal display — LEAF money nodes only. v2.55.21:
        //    [data-cart-subtotal] REMOVED from this selector — in
        //    Streamline that attribute is on the items CONTAINER
        //    (<div class="cart__items" data-cart-subtotal=...>), not a
        //    money display, and writing to it destroyed the cart rows.
        //    [data-subtotal] is the footer's dedicated money <div> (leaf),
        //    so it's safe — but the _setLeafText guard protects it anyway.
        var subtotalSel = "[data-subtotal], " +
                          ".cart__subtotal-amount, " +
                          ".cart__subtotal-price, " +
                          ".cart-subtotal__price, " +
                          ".totals__subtotal-value";
        var subtotalNodes = document.querySelectorAll(subtotalSel);
        for (var k = 0; k < subtotalNodes.length; k++) {
          if (_setLeafText(subtotalNodes[k], moneyStr)) subtotalN++;
        }

        // 3b) Update the items-container DATA ATTRIBUTES (not textContent)
        //     so theme code / CSS that reads them stays consistent. This
        //     is the correct way to touch the container — attributes, not
        //     content.
        var containerNodes = document.querySelectorAll(
          ".cart__items[data-cart-subtotal], .cart__items[data-count]");
        for (var c = 0; c < containerNodes.length; c++) {
          try {
            containerNodes[c].setAttribute("data-cart-subtotal", String(totalCents));
            containerNodes[c].setAttribute("data-count", String(itemCount));
          } catch (_) {}
        }

        // 4) Body class — Streamline uses "cart-has-items" / "cart-is-empty"
        //    to switch the layout (e.g., padding-bottom for fixed cart bar).
        if (document.body) {
          if (itemCount > 0) {
            document.body.classList.add("cart-has-items");
            document.body.classList.remove("cart-is-empty");
          } else {
            document.body.classList.remove("cart-has-items");
            document.body.classList.add("cart-is-empty");
          }
        }

        // console.info("[FS/shopify_cart/outbound] storefront UI refreshed",
        //   FS_WIDGET_VERSION,
        //   "item_count=" + itemCount,
        //   "total_cents=" + totalCents,
        //   "money_str=" + moneyStr,
        //   "bubble_updates=" + bubbleN,
        //   "subtotal_updates=" + subtotalN,
        //   "bubble_class_toggles=" + visToggleN);
      } catch (uiErr) {
        console.warn("[FS/shopify_cart/outbound] storefront UI refresh failed:",
          FS_WIDGET_VERSION, uiErr && uiErr.message);
      }
    }

    // Dispatch the set of cart-change events common across major Shopify
    // themes. Themes that don't recognize an event ignore it; themes that
    // do recognize one will trigger their own full cart re-render (cart
    // drawer items list, /cart page sections, etc.).
    function _dispatchThemeCartEvents(newCart) {
      // Each entry: {name, detail}. Detail shape varies by event because
      // different themes look for different keys (`cart` vs `product`).
      var events = [
        { name: "cart:updated",
          detail: { cart: newCart, source: "fs_widget" } },
        // Streamline + many older themes — dispatched on add-to-cart. We
        // pass the full cart as `product` because Streamline's listener
        // uses it to update the drawer's item list. `addToCartBtn: null`
        // tells the theme this wasn't a button click.
        { name: "ajaxProduct:added",
          detail: { product: newCart, addToCartBtn: null, source: "fs_widget" } },
        // Generic refresh signal — some themes listen for this.
        { name: "cart:refresh",
          detail: { cart: newCart, source: "fs_widget" } },
        // PubSub-style — used by some Shopify 2.0 themes.
        { name: "cart:build",
          detail: { cart: newCart, source: "fs_widget" } },
        // Theme-prefixed convention — some custom themes use this.
        { name: "theme:cart:updated",
          detail: { cart: newCart, source: "fs_widget" } },
      ];
      var dispatched = 0;
      for (var i = 0; i < events.length; i++) {
        try {
          var e = events[i];
          document.dispatchEvent(new CustomEvent(e.name, {
            detail:     e.detail,
            bubbles:    true,
            cancelable: false,
          }));
          dispatched++;
        } catch (evtErr) {
          // Individual event dispatch failure shouldn't block the others.
        }
      }
      // console.info("[FS/shopify_cart/outbound] dispatched cart events for theme",
      //   FS_WIDGET_VERSION,
      //   "events_dispatched=" + dispatched + "/" + events.length);
    }

    function _notifyThemeOfCartChange(newCart) {
      // Step 1: dispatch events the theme might listen for.
      // Our own cart:updated listener will receive these too, but the
      // pendingWriteFingerprint loop-protection (set at the top of
      // _pushToShopify) suppresses our own echo.
      _dispatchThemeCartEvents(newCart);
      // Step 2: directly update visible DOM elements (header bubble +
      // subtotal). Leaf-safe — never clobbers the items container.
      _refreshStorefrontCartUI(newCart);
      // Step 3: trigger the THEME's own cart-drawer rebuild.
      //
      // This store's theme (Streamline / Archetype) has NO 'cart:updated'
      // listener, and its drawer does NOT re-fetch on open — so neither
      // the events in Step 1 nor opening the drawer will rebuild the
      // drawer's item rows. The theme DOES listen for 'cart:build', which
      // re-fetches /cart?view=ajax and rebuilds .cart__items, the subtotal
      // and the count using the theme's own templates (without opening the
      // drawer). Dispatching it keeps the storefront drawer correct using
      // the theme's machinery instead of us hand-rendering its markup.
      // 'cart:build' is not an event our widget listens to, so it does not
      // re-enter our sync pipeline, and the theme's buildCart() does not
      // dispatch 'cart:updated' back to us.
      try {
        document.dispatchEvent(new CustomEvent("cart:build"));
      } catch (_) { /* defensive — drawer still updated via Steps 1–2 */ }
    }

    // v2.55.20 — Read window.FS_CART_STATE_ON_PAGE_LOAD if the theme
    // injected it. Returns the parsed cart object (matching /cart.js
    // response shape) or null if absent/malformed.
    //
    // Expected theme injection in the storefront's theme.liquid:
    //   <script>
    //     window.FS_CART_STATE_ON_PAGE_LOAD = {{ cart | json }};
    //   </script>
    //
    // Liquid renders the cart as a JSON object directly, but for safety
    // we also accept a JSON string (in case the theme stringifies it).
    function _readLiquidConstant() {
      var raw = window.FS_CART_STATE_ON_PAGE_LOAD;
      if (raw === undefined || raw === null) return null;
      if (typeof raw === "string") {
        try {
          raw = JSON.parse(raw);
        } catch (e) {
          console.warn("[FS/shopify_cart] window.FS_CART_STATE_ON_PAGE_LOAD " +
                       "is a non-JSON string — falling back to /cart.js:",
                       e && e.message);
          return null;
        }
      }
      if (typeof raw !== "object") {
        console.warn("[FS/shopify_cart] window.FS_CART_STATE_ON_PAGE_LOAD " +
                     "is not an object (type=" + typeof raw + ") — " +
                     "falling back to /cart.js");
        return null;
      }
      if (!Array.isArray(raw.items)) {
        console.warn("[FS/shopify_cart] window.FS_CART_STATE_ON_PAGE_LOAD " +
                     "lacks an items array — falling back to /cart.js");
        return null;
      }
      return raw;
    }

    // Stable fingerprint over the synced-fields tuple. Used for:
    //   (a) detecting whether Shopify cart matches widget cart
    //   (b) future loop-protection on outbound writes (Phase 2)
    function _fingerprint(items) {
      if (!items || !items.length) return "";
      return items
        .map(function (it) {
          return it.variant_id + "|" + (it.delivery_date || "") + "|" + it.quantity;
        })
        .slice()
        .sort()
        .join(",");
    }

    // Widget's fullCart.items shape → same tuple shape for comparison.
    // The widget cart's date is stored as ISO ("2026-06-11"); convert
    // to the Shopify display form "Jan 01, 2000" before comparing.
    function _normalizeWidgetItem(it) {
      if (!it) return null;
      var deliveryDateIso    = it.delivery_date || null;
      var deliveryDateShopify = deliveryDateIso ? _isoToShopifyDate(deliveryDateIso) : null;
      return {
        variant_id:    String(it.variant_id || ""),
        product_id:    String(it.product_id || ""),
        quantity:      Number(it.quantity) || 0,
        delivery_date: deliveryDateShopify,
      };
    }

    // ISO "2026-01-15" → "Jan 15, 2026" (Shopify Delivery Date form).
    function _isoToShopifyDate(iso) {
      if (!iso) return null;
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
      if (!m) return null;
      var months = ["Jan","Feb","Mar","Apr","May","Jun",
                    "Jul","Aug","Sep","Oct","Nov","Dec"];
      var monthIdx = parseInt(m[2], 10) - 1;
      if (monthIdx < 0 || monthIdx > 11) return null;
      return months[monthIdx] + " " + m[3] + ", " + m[1];
    }

    // Shopify "Jan 15, 2026" → ISO "2026-01-15".
    function _shopifyDateToIso(s) {
      if (!s) return null;
      var m = /^([A-Za-z]{3})\s+(\d{2}),\s+(\d{4})$/.exec(s);
      if (!m) return null;
      var monthMap = {
        Jan: "01", Feb: "02", Mar: "03", Apr: "04",
        May: "05", Jun: "06", Jul: "07", Aug: "08",
        Sep: "09", Oct: "10", Nov: "11", Dec: "12",
      };
      var monthNum = monthMap[m[1]];
      if (!monthNum) return null;
      return m[3] + "-" + monthNum + "-" + m[2];
    }

    // ─────────────────────────────────────────────────────────────
    // Conflict resolution
    // ─────────────────────────────────────────────────────────────

    // Returns one of:
    //   "noop_both_empty"     — neither side has items
    //   "noop_both_match"     — both filled, fingerprints agree
    //   "adopt_shopify_empty_widget"   — Shopify has items, widget empty
    //   "adopt_shopify_overwrite"      — both filled but mismatch
    //   "fill_shopify_from_widget"     — widget has items, Shopify empty
    //                                     (DEFERRED to v2.55.20 outbound)
    function _resolveConflict(shopifyItems, widgetItems) {
      var sEmpty = !shopifyItems || !shopifyItems.length;
      var wEmpty = !widgetItems  || !widgetItems.length;
      if (sEmpty && wEmpty)  return "noop_both_empty";
      if (sEmpty && !wEmpty) return "fill_shopify_from_widget";
      if (!sEmpty && wEmpty) return "adopt_shopify_empty_widget";
      // Both non-empty: compare on the synced tuple.
      var sFp = _fingerprint(shopifyItems);
      var wFp = _fingerprint(widgetItems);
      return (sFp === wFp) ? "noop_both_match" : "adopt_shopify_overwrite";
    }

    // ─────────────────────────────────────────────────────────────
    // Sync indicator UI
    // ─────────────────────────────────────────────────────────────

    function _showSyncIndicator() {
      var el = document.getElementById("fs-shopify-sync-indicator");
      if (!el) {
        el = document.createElement("div");
        el.id = "fs-shopify-sync-indicator";
        el.className = "fs-chatbot-shopify-sync-indicator";
        el.textContent = "Syncing your cart…";
        // Position above the input box. The CSS for this element is
        // expected to come from the host page's stylesheet (the widget
        // already injects fs-chatbot-* CSS at top of file). For
        // robustness we inline minimal styling so it's visible even
        // without CSS.
        el.style.cssText =
          "position: absolute; bottom: 64px; left: 12px; right: 12px;" +
          "padding: 8px 12px; background: #f5f5f5; color: #555;" +
          "font-size: 13px; border-radius: 8px; text-align: center;" +
          "z-index: 100; box-shadow: 0 1px 4px rgba(0,0,0,0.1);";
        var panel = document.querySelector(".fs-chatbot-panel") ||
                    document.body;
        panel.appendChild(el);
      }
      el.style.display = "block";
    }

    function _hideSyncIndicator() {
      var el = document.getElementById("fs-shopify-sync-indicator");
      if (el) el.style.display = "none";
    }

    // ─────────────────────────────────────────────────────────────
    // Wizard guardrail
    // ─────────────────────────────────────────────────────────────

    // Called on any external Shopify cart change. If the wizard is open,
    // snap it back to page 1 — the data underneath the wizard's later
    // pages (delivery option, address) may no longer be valid against
    // the new cart contents.
    function _wizardResetToPage1() {
      // Outer-scope `wizardOpen` and `wizardPage` are widget-private vars;
      // we touch them via the public-but-internal helper available in the
      // outer IIFE scope. Be defensive — wizard code may be absent in
      // some embed configurations.
      try {
        if (typeof wizardOpen === "boolean" && wizardOpen) {
          // Reset to first page; preserve everything else so the customer
          // can re-confirm items quickly.
          wizardPage = "items";
          if (typeof renderWizard === "function") {
            renderWizard();
          }
          // console.info("[FS/shopify_cart] wizard reset to page 1 " +
          //              "(external cart change)");
        }
      } catch (e) {
        console.warn("[FS/shopify_cart] wizard reset failed:", e && e.message);
      }
    }

    // ─────────────────────────────────────────────────────────────
    // Boot
    // ─────────────────────────────────────────────────────────────

    function boot() {
      // console.info("[FS/shopify_cart] boot() called",
      //   "enabled=" + isEnabled(),
      //   "bootDone=" + bootDone,
      //   "fullCart_state=" + (fullCart === null ? "null"
      //                       : !fullCart ? "falsy_other"
      //                       : !fullCart.items ? "no_items_key"
      //                       : "items_n=" + fullCart.items.length));
      if (!isEnabled()) {
        // console.info("[FS/shopify_cart] disabled (window.FS_SHOPIFY_CART_SYNC " +
        //              "!== true) — skipping. Set window.FS_SHOPIFY_CART_SYNC = " +
        //              "true on the host page to enable.");
        return Promise.resolve({ enabled: false });
      }
      if (bootDone) {
        // console.info("[FS/shopify_cart] boot already done — skipping");
        return Promise.resolve({ enabled: true, already_booted: true });
      }
      bootDone = true;   // optimistic guard against re-entry

      // ── Pathway 1, step 0: widget initialization on page load ──
      // Fires once per page load, immediately BEFORE the Shopify cart
      // read (Liquid constant or /cart.js fetch) that kicks off the
      // shopify→widget→Firestore pathway.
      _cartTrace("[P1:init] widget initializing — about to read Shopify cart",
        "enabled=" + isEnabled(),
        "fullCart_state=" + (fullCart === null ? "null"
                            : !fullCart ? "falsy_other"
                            : !fullCart.items ? "no_items_key"
                            : "items_n=" + fullCart.items.length));

      _showSyncIndicator();

      // v2.55.20 — prefer the Liquid-rendered constant if the host page
      // injected one. The constant is `window.FS_CART_STATE_ON_PAGE_LOAD`,
      // expected to be `{{ cart | json }}` from the Shopify theme. This
      // saves the /cart.js round-trip on boot AND eliminates a race
      // window. If the constant is missing or malformed, fall back to
      // the existing fetch path.
      var liquidCart = _readLiquidConstant();
      var loadPromise;
      var loadSource;
      if (liquidCart) {
        loadSource = "liquid_constant";
        // ── Pathway 1, step 0b: cart read source = inlined Liquid constant ──
        _cartTrace("[P1:init] reading Shopify cart from Liquid constant",
          "source=window.FS_CART_STATE_ON_PAGE_LOAD",
          "no_fetch=true");
        // console.info("[FS/shopify_cart] boot — using Liquid constant " +
        //              "(window.FS_CART_STATE_ON_PAGE_LOAD), no fetch needed");
        loadPromise = Promise.resolve(liquidCart);
      } else {
        loadSource = "cart_js_fetch";
        // ── Pathway 1, step 0b: cart read source = /cart.js fetch ──
        _cartTrace("[P1:init] reading Shopify cart via /cart.js fetch",
          "source=/cart.js",
          "reason=liquid_constant_absent");
        // console.info("[FS/shopify_cart] boot — Liquid constant absent, " +
        //              "fetching /cart.js");
        var fetchStartTs = Date.now();
        loadPromise = fetch("/cart.js", { credentials: "same-origin" })
          .then(function (r) {
            // console.info("[FS/shopify_cart] /cart.js response",
            //   "status=" + r.status,
            //   "elapsed_ms=" + (Date.now() - fetchStartTs));
            if (!r.ok) throw new Error("HTTP " + r.status);
            return r.json();
          });
      }

      return loadPromise
        .then(function (rawCart) {
          shopifyCart = rawCart;

          // v2.55.19 hotfix7 — diagnostic: dump the FIRST raw line item
          // from /cart.js so we can see every field Shopify actually
          // returned. Includes the version so any log paste reveals
          // which widget build is running. Truncated to first item to
          // keep the log readable when carts are large.
          var firstRaw = (rawCart && rawCart.items && rawCart.items[0]) || null;
          // console.info("[FS/shopify_cart/raw_cart_js]", FS_WIDGET_VERSION,
          //   "source=" + loadSource,
          //   "total_items=" + ((rawCart && rawCart.items) || []).length,
          //   "cart_total_price=" + (rawCart && rawCart.total_price),
          //   "first_item_all_keys=" + (firstRaw ? Object.keys(firstRaw).join(",") : "(no items)"),
          //   "first_item=", firstRaw);

          var shopifyItems = (rawCart.items || []).map(_normalizeShopifyItem);
          var widgetItems  = (fullCart && fullCart.items)
            ? fullCart.items.map(_normalizeWidgetItem)
            : [];
          var verdict = _resolveConflict(shopifyItems, widgetItems);
          lastShopifyFingerprint = _fingerprint(shopifyItems);

          // Diagnostic: dump per-item summaries so we can compare visually.
          var shopifyItemPreview = shopifyItems.map(function (s) {
            return {
              variant_id:       s.variant_id,
              product_id:       s.product_id,
              quantity:         s.quantity,
              delivery_date:    s.delivery_date,
              price_cents:      s.price_cents,
              line_price_cents: s.line_price_cents,
            };
          });
          var widgetItemPreview = widgetItems.map(function (w) {
            return {
              variant_id:    w.variant_id,
              product_id:    w.product_id,
              quantity:      w.quantity,
              delivery_date: w.delivery_date,
            };
          });
          var shopifyTotalCents = shopifyItems.reduce(function (acc, s) {
            return acc + (s.line_price_cents || 0);
          }, 0);
          // console.info("[FS/shopify_cart] boot resolved", FS_WIDGET_VERSION,
          //   "verdict=" + verdict,
          //   "shopify_n=" + shopifyItems.length,
          //   "widget_n=" + widgetItems.length,
          //   "shopify_fp=" + (lastShopifyFingerprint || "<empty>"),
          //   "shopify_total_cents=" + shopifyTotalCents,
          //   "shopify_items=", shopifyItemPreview,
          //   "widget_items=", widgetItemPreview);

          if (verdict === "adopt_shopify_empty_widget" ||
              verdict === "adopt_shopify_overwrite") {
            _adoptShopifyCart(rawCart, /*external*/ false);
          }
          if (verdict === "fill_shopify_from_widget") {
            // v2.55.20 — Phase 2 outbound now ships. Push the widget's
            // existing items to Shopify so Shopify gains the items the
            // bot built up server-side before the customer reached a
            // Shopify storefront page.
            // console.info("[FS/shopify_cart] fill_shopify_from_widget — " +
            //              "pushing widget items to Shopify",
            //              "widget_n=" + widgetItems.length);
            // Use fullCart.items as the source — they have the full
            // widget shape (product_id, variant_id, delivery_date,
            // properties_other, etc.) needed by pushToShopify.
            var widgetSourceItems = (fullCart && fullCart.items) || [];
            // Ensure adoptedItems is initialized (to []) so pushToShopify
            // doesn't bail out on `not_adopted_yet`.
            if (adoptedItems === null) adoptedItems = [];
            // Fire-and-forget at boot — don't block the boot promise.
            // Errors are logged; the next sync attempt will retry.
            // v2.55.20+hotfix6 — pass cart-level delivery_date as
            // explicit param so alignment uses customer intent, not
            // the Shopify-authority-stale fullCart.delivery_date.
            _pushToShopify(
              widgetSourceItems,
              fullCart && fullCart.delivery_date
            ).then(function (result) {
              // console.info("[FS/shopify_cart] fill_shopify_from_widget done",
              //   "result=", result);
            });
          }

          // v2.55.20+hotfix2 — ALWAYS set adoptedItems after boot, even
          // for noop verdicts. Previously only adopt_* and fill_* verdicts
          // set adoptedItems. For noop_both_empty / noop_both_match,
          // adoptedItems stayed null, which made hasAdoptedItems() return
          // false forever. Downstream divergence-push paths (in
          // setFullCart, updateFullCartFromResponse, the Firestore
          // listener) all gate on hasAdoptedItems() — without adoption
          // recorded, they silently skip and Shopify never gets the
          // agent's edits.
          //
          // The simplest correct behavior: any successful boot read of
          // /cart.js IS an adoption. Record it.
          if (adoptedItems === null) {
            console.info("[FS/shopify_cart] boot — verdict was noop " +
                         "(" + verdict + "), calling _adoptShopifyCart " +
                         "to establish baseline so future divergence " +
                         "pushes work");
            _adoptShopifyCart(rawCart, /*external*/ false);
          }

          // v2.55.20+hotfix2 — process any divergence that the
          // Firestore listener queued while we were booting. The race
          // is: page load → listener attaches → agent edit → listener
          // fires → hasAdoptedItems is still false because boot's
          // /cart.js fetch hasn't resolved → divergence push is
          // skipped. The listener now queues the divergent cart via
          // _setPendingDivergence; here we process it.
          //
          // v2.55.20+hotfix6 — REMOVED the queued-divergence preview
          // gate. Same reasoning as the other call sites: the preview
          // misses cart-level date changes. Always call pushToShopify
          // and let it handle no-op internally.
          if (pendingDivergenceCart) {
            try {
              var queuedCart  = pendingDivergenceCart;
              pendingDivergenceCart = null;
              var queuedItems = (queuedCart && queuedCart.items) || [];
              // console.info("[FS/shopify_cart] processing queued " +
              //              "pre-boot divergence from Firestore " +
              //              "(unconditionally; push handles no-op internally)",
              //              "items_n=" + queuedItems.length,
              //              "queuedCart_delivery_date=" +
              //                ((queuedCart && queuedCart.delivery_date) || "(none)"));
              _pushToShopify(
                queuedItems,
                queuedCart && queuedCart.delivery_date
              );
            } catch (qErr) {
              // console.warn("[FS/shopify_cart] queued divergence processing " +
              //              "failed:", qErr && qErr.message);
            }
          }

          _attachListener();
          _hideSyncIndicator();
          return { enabled: true, verdict: verdict };
        })
        .catch(function (err) {
          // console.error("[FS/shopify_cart] boot failed:",
          //   err && err.message,
          //   "stack=" + (err && err.stack ? err.stack.split("\n")[0] : "n/a"));
          _hideSyncIndicator();
          // Don't lock subsequent retries — clear bootDone so a manual
          // re-trigger (or visibility-change wake) can attempt again.
          bootDone = false;
          return { enabled: true, error: err && err.message };
        });
    }

    // Update widget's fullCart from a Shopify cart. Preserves cart-
    // level fields the widget already has (balloon_wording, etc.) —
    // those are NOT synced from Shopify. Only the items array and
    // delivery_date references are replaced.
    function _adoptShopifyCart(rawCart, isExternal, skipServerSync) {
      var shopifyItems = (rawCart.items || []).map(_normalizeShopifyItem);

      // v2.55.20+hotfix10 — an EXTERNAL adoption (Shopify cart:updated /
      // ajaxProduct:added, or a fresh boot) means the Shopify baseline
      // moved underneath us. Clear the dedupe fingerprint so Gate 3
      // never wrongly skips a genuine external change that happens to
      // match a target we previously wrote. Internal re-adopts (after our
      // own push) keep the fingerprint — the success path sets it.
      if (isExternal) {
        _lastPushedFingerprint = null;
      }

      // ── Pathway 1, step 2: transforming Shopify lines → widget items ──
      _cartTrace("[P1:shopify→widget] _adoptShopifyCart start",
        "external=" + !!isExternal,
        "incoming_shopify_n=" + shopifyItems.length,
        "fullCart_was_null=" + (fullCart === null));

      // Build new fullCart.items by transforming Shopify lines into
      // the widget's expected item shape. Note: this DROPS enriched
      // backend fields (has_balloon_wording, includes_message_card,
      // price, image, etc.). Those will be repopulated by the next
      // /chat response from the bot, when the bot's pipeline re-reads
      // the cart and re-enriches.
      //
      // CONSEQUENCE for v2.55.19: between this adoption and the next
      // bot response, the cart panel may render with reduced detail
      // (no balloon-eligibility flags, no images). Acceptable for v1
      // — the next interaction repopulates.
      var newItems = shopifyItems.map(function (s) {
        return {
          variant_id:    s.variant_id,
          product_id:    s.product_id,
          product_name:  s.product_title,
          variant_name:  s.variant_title,
          quantity:      s.quantity,
          delivery_date: s.delivery_date
            ? _shopifyDateToIso(s.delivery_date)
            : null,
          // v2.55.19 hotfix6 — propagate Shopify-driven pricing so
          // the cart panel subtotal (line ~2892 reads price_cents)
          // is correct without waiting for the next /chat enrichment.
          price_cents:      s.price_cents || 0,
          line_price_cents: s.line_price_cents || 0,
          // v2.55.20 — propagate the Shopify line key so outbound
          // writes (_pushToShopify) can address THIS line by id.
          // Also propagate properties_other so the read-merge-write
          // pattern preserves theme/storefront-set properties when
          // we modify a line's quantity or Delivery Date.
          shopify_line_key:  s.shopify_line_key,
          properties_other:  s.properties_other || {},
          // Best-effort placeholders; will be repopulated on next /chat
          has_balloon_wording:   false,
          includes_message_card: false,
        };
      });

      if (!fullCart) fullCart = {};
      fullCart.items = newItems;
      // v2.55.19 hotfix2 — store the authoritative reference so
      // setFullCart / updateFullCartFromResponse can respect Shopify's
      // adoption when they run later. Deep-ish copy via JSON would be
      // overkill — the array reference is enough because we treat it
      // as immutable after this point (re-adoptions allocate fresh).
      adoptedItems = newItems.slice();

      // v2.55.19 hotfix3 — also write the cart-level delivery_date.
      // The cart panel (line ~2899), wizard snapshot (line ~3174),
      // and pickup-flow (line ~4078) all read `fullCart.delivery_date`,
      // NOT the per-item `delivery_date` we already set above. Without
      // this assignment the widget appears to have no cart-level date
      // (or worse, retains a stale server value), even though Shopify
      // told us exactly what date to use.
      //
      // Per spec ("use the date of the last item FOR Widget") the
      // LAST Shopify line item's date wins. Take it AS-IS — even
      // if it represents a past or otherwise-unbookable date. The
      // wizard's page 1 submission is the validation gate.
      //
      // Fallback to the raw Shopify "Jan 01, 2000" string if ISO
      // conversion failed (malformed input). Downstream code expects
      // ISO; raw will be treated as "unparseable" and the cart panel
      // hides the slot, but at least the value survives into the
      // wizard where it can be flagged.
      if (newItems.length > 0) {
        var lastItem    = newItems[newItems.length - 1];
        var lastRaw     = shopifyItems[shopifyItems.length - 1];
        var dateToWrite = lastItem.delivery_date ||
                          (lastRaw && lastRaw.delivery_date) ||
                          null;
        if (dateToWrite) {
          fullCart.delivery_date         = dateToWrite;
          fullCart.current_delivery_date = dateToWrite;
          // v2.55.19 hotfix4 — track separately so the authority
          // mechanism in setFullCart / updateFullCartFromResponse
          // can re-apply this even if a later cart-update writes
          // null over it.
          adoptedDeliveryDate = dateToWrite;
          if (!lastItem.delivery_date && lastRaw && lastRaw.delivery_date) {
            // console.warn("[FS/shopify_cart] last-item Delivery Date " +
            //              "didn't convert to ISO; storing raw Shopify " +
            //              "value — wizard page 1 will validate",
            //              "raw=" + lastRaw.delivery_date);
          }
        } else {
          // Shopify line had no Delivery Date property at all.
          // Leave fullCart.delivery_date untouched (whatever the
          // server view had). Wizard page 1 will flag.
          adoptedDeliveryDate = null;
          // console.info("[FS/shopify_cart] last Shopify item has no " +
          //              "Delivery Date — leaving fullCart.delivery_date " +
          //              "untouched");
        }
      } else {
        // Adopted-and-empty case: no items means no delivery_date
        // authority either.
        adoptedDeliveryDate = null;
      }
      try {
        renderCartPanel();
      } catch (e) {
        console.warn("[FS/shopify_cart] renderCartPanel threw:",
          e && e.message);
      }

      var adoptedTotalCents = newItems.reduce(function (acc, it) {
        return acc + (it.line_price_cents || 0);
      }, 0);
      console.info("[FS/shopify_cart] _adoptShopifyCart done", FS_WIDGET_VERSION,
        "external=" + !!isExternal,
        "items_n=" + newItems.length,
        "delivery_date=" + (fullCart.delivery_date || "null"),
        "current_delivery_date=" + (fullCart.current_delivery_date || "null"),
        "adoptedDeliveryDate=" + (adoptedDeliveryDate || "null"),
        "adopted_total_cents=" + adoptedTotalCents,
        "fullCart_keys=" + Object.keys(fullCart || {}).join(","),
        "item_prices=", newItems.map(function (it) {
          return {
            variant_id:       it.variant_id,
            quantity:         it.quantity,
            price_cents:      it.price_cents,
            line_price_cents: it.line_price_cents,
          };
        }));

      // v2.55.19 hotfix5 — push the adoption to Firestore via the
      // bot server so the live agent dashboard can see what's in
      // the customer's cart. Fire-and-forget; widget state is
      // already correct locally regardless of server outcome.

      // ── Pathway 1, step 3: widget cart assembled → hand to Firestore ──
      _cartTrace("[P1:shopify→widget] widget cart built, dispatching to Firestore",
        "external=" + !!isExternal,
        "widget_items_n=" + newItems.length,
        "widget_delivery_date=" + (adoptedDeliveryDate || "null"),
        "adopted_total_cents=" + adoptedTotalCents,
        "widget_items=", newItems.map(function (it) {
          return {
            variant_id:    it.variant_id,
            product_name:  it.product_name,
            quantity:      it.quantity,
            delivery_date: it.delivery_date,
            price_cents:   it.price_cents,
          };
        }));

      // v2.55.21 — skipServerSync: for a LOCAL-ONLY re-adopt (cross-tab UI
      // catch-up on the NO-OP path), we must NOT write back to Firestore.
      // On that path the live Shopify cart already equals the Firestore
      // target (the diff was empty — that's why it's a NO-OP), so syncing
      // is redundant AND re-fires the _fs/cart_change listener, which
      // re-enters pushToShopify. With two tabs each doing this against a
      // momentarily different live read, Firestore oscillates and never
      // converges — an infinite loop. Re-adopting updates adoptedItems +
      // the rendered panel locally (all we need for the UI); Firestore is
      // left untouched so no echo is produced.
      if (skipServerSync) {
        _cartTrace("[P1:shopify→widget] re-adopt is LOCAL-ONLY — " +
                   "skipping Firestore sync (no echo)",
          "items_n=" + newItems.length);
        return;
      }

      _syncToServer(newItems, adoptedDeliveryDate);
    }

    // ─────────────────────────────────────────────────────────────
    // v2.55.20 — Outbound writes to Shopify
    //
    // Public API: pushToShopify(targetItems, targetDeliveryDate) —
    // reconciles Shopify's
    // adopted cart to match `targetItems`. Computes a diff and fires
    // /cart/add.js (for new items) and /cart/change.js (for quantity
    // changes, property changes, and removals).
    //
    // Diff keying: variant_id + delivery_date (Shopify treats lines
    // with different properties as distinct, so two items of the same
    // variant with different dates are TWO lines).
    //
    // Property preservation: /cart/change.js's `properties` field
    // REPLACES the line's properties wholesale. To preserve unknown
    // theme/storefront-set properties, we read the current line's
    // `properties_other` (captured at adoption time) and merge in
    // the new "Delivery Date" value.
    //
    // Loop protection: before any write, pendingWriteFingerprint is
    // set to the expected post-write state. The cart:updated event
    // that Shopify fires in response will match this and be skipped
    // (so we don't re-process our own writes).
    //
    // Order: removes → changes → adds. This prevents the cart from
    // briefly overflowing Shopify's item limits when both adding and
    // removing in the same batch.
    // ─────────────────────────────────────────────────────────────

    // Item key for diff matching. Shopify lines with different
    // properties are distinct, so (variant_id + delivery_date) is
    // the natural identity. delivery_date is the ISO form on widget
    // items, raw "Jan 01, 2026" on Shopify-derived items — we
    // normalize to ISO for comparison.
    function _diffKeyOf(it) {
      var date = it.delivery_date || "";
      // Convert raw Shopify "Jan 15, 2026" → ISO for stable comparison
      if (date && /^[A-Za-z]{3}\s+\d{2},\s+\d{4}$/.test(date)) {
        date = _shopifyDateToIso(date) || date;
      }
      return (it.variant_id || "") + "|" + date;
    }

    // Compute diff between current Shopify state and target widget state.
    // Returns {adds, changes, removes}.
    function _computeDiff(currentItems, targetItems) {
      var currentMap = {};
      var targetMap  = {};
      for (var i = 0; i < (currentItems || []).length; i++) {
        var c = currentItems[i];
        if (c) currentMap[_diffKeyOf(c)] = c;
      }
      for (var j = 0; j < (targetItems || []).length; j++) {
        var t = targetItems[j];
        if (t) targetMap[_diffKeyOf(t)] = t;
      }
      var adds    = [];
      var changes = [];
      var removes = [];
      for (var tkey in targetMap) {
        if (!Object.prototype.hasOwnProperty.call(targetMap, tkey)) continue;
        var target  = targetMap[tkey];
        var current = currentMap[tkey];
        if (!current) {
          adds.push(target);
        } else {
          var curQty = Number(current.quantity) || 0;
          var tgtQty = Number(target.quantity)  || 0;
          if (curQty !== tgtQty) {
            changes.push({ from: current, to: target });
          }
        }
      }
      for (var ckey in currentMap) {
        if (!Object.prototype.hasOwnProperty.call(currentMap, ckey)) continue;
        if (!targetMap[ckey]) removes.push(currentMap[ckey]);
      }
      return { adds: adds, changes: changes, removes: removes };
    }

    // POST a single add to Shopify. Returns the parsed response promise.
    // Body shape: { items: [{ id, quantity, properties }] }
    function _shopifyAdd(item) {
      var deliveryDateShopify = item.delivery_date
        ? _isoToShopifyDate(item.delivery_date)
        : null;
      var properties = Object.assign({}, item.properties_other || {});
      if (deliveryDateShopify) properties["Delivery Date"] = deliveryDateShopify;
      var body = {
        items: [{
          id:         item.variant_id,
          quantity:   Number(item.quantity) || 1,
          properties: properties,
        }],
      };
      // ── Pathway 2: individual write — add a line to Shopify ──
      _cartTrace("[P2:widget→shopify] POST /cart/add.js",
        "variant_id=" + item.variant_id,
        "qty=" + body.items[0].quantity,
        "delivery_date=" + (deliveryDateShopify || "(none)"));
      console.info("[FS/shopify_cart/outbound] POST /cart/add.js", FS_WIDGET_VERSION,
        "variant_id=" + item.variant_id,
        "qty=" + body.items[0].quantity,
        "Delivery Date=" + (deliveryDateShopify || "(none)"));
      return fetch("/cart/add.js", {
        method:      "POST",
        credentials: "same-origin",
        headers:     { "Content-Type": "application/json" },
        body:        JSON.stringify(body),
      }).then(function (r) {
        if (!r.ok) {
          return r.text().then(function (t) {
            throw new Error("add.js HTTP " + r.status + ": " + (t || "").slice(0, 200));
          });
        }
        return r.json();
      });
    }

    // POST a single change to Shopify. Uses the line `key` if known
    // (most reliable), falls back to variant_id for older adoptions.
    // Body shape: { id, quantity[, properties] }
    function _shopifyChange(line, newQty, newDeliveryDateIso) {
      var id = line.shopify_line_key || line.variant_id;
      if (!id) {
        return Promise.reject(new Error("no shopify_line_key or variant_id"));
      }
      var body = { id: String(id), quantity: Number(newQty) };
      // If date changed, we need to send full properties (Shopify REPLACES
      // the properties dict on change.js — read-merge-write).
      if (newDeliveryDateIso !== undefined && newDeliveryDateIso !== null) {
        var deliveryDateShopify = _isoToShopifyDate(newDeliveryDateIso);
        var props = Object.assign({}, line.properties_other || {});
        if (deliveryDateShopify) props["Delivery Date"] = deliveryDateShopify;
        body.properties = props;
      }
      // ── Pathway 2: individual write — change/remove a Shopify line ──
      _cartTrace("[P2:widget→shopify] POST /cart/change.js",
        "id=" + body.id,
        "qty=" + body.quantity,
        (body.properties ? "with_properties=true" : "qty_only=true"));
      console.info("[FS/shopify_cart/outbound] POST /cart/change.js", FS_WIDGET_VERSION,
        "id=" + body.id,
        "qty=" + body.quantity,
        (body.properties ? "with_properties=true" : "qty_only=true"));
      return fetch("/cart/change.js", {
        method:      "POST",
        credentials: "same-origin",
        headers:     { "Content-Type": "application/json" },
        body:        JSON.stringify(body),
      }).then(function (r) {
        if (!r.ok) {
          return r.text().then(function (t) {
            throw new Error("change.js HTTP " + r.status + ": " + (t || "").slice(0, 200));
          });
        }
        return r.json();
      });
    }

    // Push target items to Shopify. Idempotent: if target matches the
    // currently-adopted Shopify state, this is a no-op.
    //
    // Sequencing: removes → changes → adds. Each batch executed
    // serially (not in parallel) to keep Shopify cart consistent.
    // v2.55.20+hotfix10 — release the in-flight lock and drain any
    // coalesced push. Called on EVERY post-lock exit of _pushToShopify
    // (no-op return, success, failure). Replaying the coalesced request
    // (if any) happens on a fresh microtask so the current call fully
    // unwinds first.
    function _releasePushLockAndDrain() {
      _pushInFlight = false;
      if (_coalescedPush) {
        var next = _coalescedPush;
        _coalescedPush = null;
        _cartTrace("[P2:widget→shopify] draining coalesced push",
          "target_items_n=" + ((next.items || []).length),
          "target_delivery_date=" + (next.deliveryDate || "(none)"));
        Promise.resolve().then(function () {
          try {
            _pushToShopify(next.items, next.deliveryDate);
          } catch (e) {
            console.warn("[FS/shopify_cart/outbound] coalesced push replay failed:",
              FS_WIDGET_VERSION, e && e.message);
          }
        });
      }
    }

    function _pushToShopify(targetItems, targetDeliveryDate) {
      // ── Pathway 2, step 1: widget cart → Shopify push requested ──
      _cartTrace("[P2:widget→shopify] pushToShopify requested",
        "target_items_n=" + ((targetItems || []).length),
        "target_delivery_date=" + (targetDeliveryDate || "(none)"),
        "adopted_items_n=" + ((adoptedItems || []).length),
        "target_items=", (targetItems || []).map(function (it) {
          return {
            variant_id:    it && it.variant_id,
            quantity:      it && it.quantity,
            delivery_date: it && it.delivery_date,
          };
        }));

      // v2.55.20+hotfix6 — comprehensive entry diagnostics. Every
      // unexpected no-op is now traceable to its inputs.
      var _targetSummary = (targetItems || []).map(function (it) {
        return {
          variant_id:    it && it.variant_id,
          quantity:      it && it.quantity,
          delivery_date: it && it.delivery_date,
        };
      });
      var _adoptedSummary = (adoptedItems || []).map(function (it) {
        return {
          variant_id:        it && it.variant_id,
          quantity:          it && it.quantity,
          delivery_date:     it && it.delivery_date,
          shopify_line_key:  it && it.shopify_line_key,
        };
      });
      console.info("[FS/shopify_cart/outbound] pushToShopify ENTRY",
        FS_WIDGET_VERSION,
        "target_items_n=" + ((targetItems || []).length),
        "targetDeliveryDate_param=" + (targetDeliveryDate || "(none)"),
        "fullCart_delivery_date=" + ((fullCart && fullCart.delivery_date) || "(none)"),
        "adoptedItems_n=" + ((adoptedItems || []).length),
        "adoptedDeliveryDate=" + (adoptedDeliveryDate || "(none)"),
        "isEnabled=" + isEnabled(),
        "target_summary=", _targetSummary,
        "adopted_summary=", _adoptedSummary);

      if (!isEnabled()) {
        _cartTrace("[P2:widget→shopify] aborted — widget disabled");
        console.info("[FS/shopify_cart/outbound] pushToShopify gate=disabled");
        return Promise.resolve({ ok: false, reason: "disabled" });
      }
      if (adoptedItems === null) {
        // Haven't adopted yet — can't compute a meaningful diff.
        _cartTrace("[P2:widget→shopify] aborted — not adopted yet (no Shopify baseline)");
        console.warn("[FS/shopify_cart/outbound] pushToShopify gate=not_adopted_yet " +
                     "(call boot() first)");
        return Promise.resolve({ ok: false, reason: "not_adopted_yet" });
      }

      // ── Gate 2 — serialize concurrent pushes (anti-race) ──
      // If a push is already running (writes + terminal /cart.js
      // re-adopt not yet settled), DON'T start a second one — overlapping
      // pushes against the same variant line are what doubled the
      // quantity. Coalesce: remember the latest request and replay it once
      // the in-flight push completes. Latest-wins (a newer trigger
      // supersedes an older queued one).
      if (_pushInFlight) {
        _coalescedPush = { items: targetItems, deliveryDate: targetDeliveryDate };
        _cartTrace("[P2:widget→shopify] GATE — push in flight, coalescing (latest-wins)",
          "queued_target_items_n=" + ((targetItems || []).length),
          "queued_target_delivery_date=" + (targetDeliveryDate || "(none)"));
        console.info("[FS/shopify_cart/outbound] pushToShopify gate=in_flight_coalesced",
          FS_WIDGET_VERSION);
        return Promise.resolve({ ok: true, coalesced: true });
      }

      // ── Gate 3 — dedupe identical target (redundant re-trigger) ──
      // If the incoming target matches the last target we successfully
      // wrote, this is a redundant re-trigger (e.g. the Firestore echo of
      // our own write). Skip it. _lastPushedFingerprint is cleared on any
      // external adoption, so a genuine external change is never skipped.
      var _incomingFp;
      try {
        _incomingFp = _fingerprint((targetItems || []).map(_normalizeWidgetItem));
      } catch (e) { _incomingFp = null; }
      if (_incomingFp !== null && _incomingFp === _lastPushedFingerprint) {
        _cartTrace("[P2:widget→shopify] GATE — target matches last write, deduped",
          "fingerprint=" + _incomingFp);
        console.info("[FS/shopify_cart/outbound] pushToShopify gate=duplicate_target",
          FS_WIDGET_VERSION, "fingerprint=" + _incomingFp);
        return Promise.resolve({ ok: true, deduped: true });
      }

      // Claim the in-flight lock for the remainder of this push.
      _pushInFlight = true;

      // v2.55.21 — LIVE-BASELINE RECONCILIATION.
      //
      // Pre-v2.55.21 the diff was computed against `adoptedItems` — this
      // tab's last-known Shopify state. With multiple tabs open on one
      // Firestore session, a tab that didn't originate a change has a
      // STALE adoptedItems (e.g. empty), so it misclassified an
      // already-present line as "new" and issued an additive /cart/add.js,
      // which Shopify MERGED into the existing line → quantity doubling.
      //
      // Fix: always GET /cart.js first and diff the target against the
      // LIVE Shopify cart (ground truth), not against adoptedItems. A tab
      // can no longer misclassify an existing line as new, because it
      // checks what Shopify actually has right now. This makes the push
      // correct regardless of how many tabs are open or what each adopted.
      //
      // Everything downstream (collapse, change.js/add.js execution,
      // terminal re-adopt) is unchanged — it just diffs against truth.
      // The sync-throw safety net now lives inside the .then; a rejected
      // fetch is handled by the chain's .catch (which releases the lock).
      return fetch("/cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (liveCartJs) {
      var liveItems = ((liveCartJs && liveCartJs.items) || [])
        .map(_normalizeShopifyItem)
        .filter(Boolean);
      _cartTrace("[P2:widget→shopify] live /cart.js baseline fetched",
        "live_items_n=" + liveItems.length,
        "live_summary=", liveItems.map(function (it) {
          return { variant_id: it.variant_id, qty: it.quantity,
                   date: it.delivery_date, key: it.shopify_line_key };
        }));

      // v2.55.20+hotfix6 — resolve cart-level date from EXPLICIT param
      // first, falling back to fullCart.delivery_date.
      //
      // Why the explicit param wins: fullCart.delivery_date is
      // overwritten by setFullCart's Shopify-authority code with
      // adoptedDeliveryDate (the Shopify-side date), which is STALE
      // before this push completes. The customer's NEW intent lives
      // on serverCart.delivery_date at the time the listener fires,
      // and that intent needs to flow through here for the alignment
      // to detect the divergence.
      var cartLevelDate = targetDeliveryDate ||
                          (fullCart && fullCart.delivery_date) ||
                          null;
      var dateSource    = targetDeliveryDate ? "explicit_param"
                         : (fullCart && fullCart.delivery_date) ? "fullCart_fallback"
                         : "none";
      console.info("[FS/shopify_cart/outbound] cart-level date resolved",
        FS_WIDGET_VERSION,
        "cart_level_date=" + (cartLevelDate || "(none)"),
        "source=" + dateSource);

      // v2.55.20+hotfix5 — align target per-item delivery_date with the
      // cart-level delivery_date as the AUTHORITATIVE customer intent.
      // See hotfix5 commentary above for why we touch target only.
      function _alignTargetDateWithCart(it) {
        if (!it)              return it;
        if (!cartLevelDate)   return it;  // no cart-level to align with
        if (it.delivery_date === cartLevelDate) return it;  // already aligned
        return Object.assign({}, it, { delivery_date: cartLevelDate });
      }
      var alignedTarget = (targetItems || []).map(_alignTargetDateWithCart);

      // v2.55.20+hotfix6 — log every item's pre/post alignment state so
      // we can see whether the override actually fired and what date
      // each item is being pushed with.
      var _alignmentDetails = (targetItems || []).map(function (it, i) {
        var was = it && it.delivery_date;
        var now = alignedTarget[i] && alignedTarget[i].delivery_date;
        return {
          variant_id: it && it.variant_id,
          date_before: was || "(empty)",
          date_after:  now || "(empty)",
          changed:     was !== now,
        };
      });
      var alignedN = _alignmentDetails.filter(function (d) { return d.changed; }).length;
      console.info("[FS/shopify_cart/outbound] alignment details",
        FS_WIDGET_VERSION,
        "items_aligned=" + alignedN,
        "alignment=", _alignmentDetails);

      var diff = _computeDiff(liveItems, alignedTarget);
      console.info("[FS/shopify_cart/outbound] raw diff (before collapse)",
        FS_WIDGET_VERSION,
        "adds=" + diff.adds.length,
        "changes=" + diff.changes.length,
        "removes=" + diff.removes.length,
        "adds_detail=", diff.adds.map(function (it) {
          return { variant_id: it.variant_id, qty: it.quantity, date: it.delivery_date };
        }),
        "removes_detail=", diff.removes.map(function (it) {
          return { variant_id: it.variant_id, qty: it.quantity, date: it.delivery_date,
                   key: it.shopify_line_key };
        }),
        "changes_detail=", diff.changes.map(function (ch) {
          return { variant_id: ch.from.variant_id,
                   from_qty: ch.from.quantity, to_qty: ch.to.quantity,
                   from_date: ch.from.delivery_date, to_date: ch.to.delivery_date };
        }));

      // v2.55.20+hotfix5 — collapse same-variant REMOVE+ADD pairs into
      // a single CHANGE (with new properties). See hotfix5 commentary.
      var collapsedChanges = diff.changes.slice();
      var keepRemoves      = [];
      var pendingAdds      = diff.adds.slice();
      for (var ri = 0; ri < diff.removes.length; ri++) {
        var rem = diff.removes[ri];
        var matchAddIdx = -1;
        for (var ai = 0; ai < pendingAdds.length; ai++) {
          if (pendingAdds[ai] && rem &&
              pendingAdds[ai].variant_id === rem.variant_id) {
            matchAddIdx = ai;
            break;
          }
        }
        if (matchAddIdx >= 0) {
          collapsedChanges.push({ from: rem, to: pendingAdds[matchAddIdx] });
          pendingAdds.splice(matchAddIdx, 1);
        } else {
          keepRemoves.push(rem);
        }
      }
      var collapsedN = collapsedChanges.length - diff.changes.length;
      console.info("[FS/shopify_cart/outbound] collapse pass",
        FS_WIDGET_VERSION,
        "pairs_collapsed=" + collapsedN,
        "final_adds=" + pendingAdds.length,
        "final_changes=" + collapsedChanges.length,
        "final_removes=" + keepRemoves.length);
      diff = { adds: pendingAdds, changes: collapsedChanges, removes: keepRemoves };

      // ── Pathway 2, step 2: diff computed (what will be written) ──
      _cartTrace("[P2:widget→shopify] diff computed",
        "adds=" + diff.adds.length,
        "changes=" + diff.changes.length,
        "removes=" + diff.removes.length,
        "cart_level_date=" + (cartLevelDate || "(none)") + " (" + dateSource + ")");

      if (diff.adds.length === 0 &&
          diff.changes.length === 0 &&
          diff.removes.length === 0) {
        _cartTrace("[P2:widget→shopify] NO-OP — Shopify already matches widget cart");
        console.info("[FS/shopify_cart/outbound] pushToShopify NO-OP " +
                     "(target matches Shopify already after alignment + collapse)",
                     FS_WIDGET_VERSION);

        // v2.55.21 — CROSS-TAB UI REFRESH on NO-OP.
        //
        // "No Shopify writes needed" does NOT mean "nothing changed for
        // THIS tab". When another tab changed the cart, this tab's locally
        // ADOPTED items are stale (e.g. adopted=2) while live Shopify and
        // Firestore are ahead (=3). The push correctly computes NO-OP
        // (live already matches the target), but if we return here without
        // re-adopting, adoptedItems stays at 2 — and setFullCart's
        // "Shopify authority" branch keeps overriding the server's 3 items
        // back to the stale 2, so the UI never updates.
        //
        // Fix: compare the LIVE Shopify cart against this tab's current
        // adopted state; if they diverge, re-adopt the live cart so
        // adoptedItems catches up and the panel re-renders with the
        // correct items. Re-adopt is marked external (the change
        // originated elsewhere). This converges: the re-adopted state
        // equals what's already in Firestore, so the resulting listener
        // echo reconciles to a true no-op (adopted==live==target).
        // Compare live Shopify vs this tab's adopted state on a common
        // representation. Both fingerprints use Shopify DISPLAY-format
        // dates: adoptedItems carry ISO dates (so run them through
        // _normalizeWidgetItem, which converts ISO→display), while
        // liveItems already carry display-format dates from
        // _normalizeShopifyItem (so fingerprint them directly). Using
        // _normalizeWidgetItem on liveItems would mis-convert their
        // already-display dates to empty, causing a spurious mismatch.
        var _adoptedFp = null;
        try {
          _adoptedFp = _fingerprint((adoptedItems || []).map(_normalizeWidgetItem));
        } catch (e) { _adoptedFp = null; }
        var _liveFp = null;
        try {
          _liveFp = _fingerprint(liveItems);
        } catch (e) { _liveFp = null; }

        if (_liveFp !== null && _liveFp !== _adoptedFp) {
          _cartTrace("[P2:widget→shopify] NO-OP but live≠adopted — re-adopting " +
                     "live cart so UI catches up (cross-tab update)",
            "adopted_fp=" + _adoptedFp,
            "live_fp=" + _liveFp,
            "live_items_n=" + liveItems.length);
          console.info("[FS/shopify_cart/outbound] NO-OP re-adopt " +
                       "(live diverged from adopted — cross-tab refresh)",
                       FS_WIDGET_VERSION);
          if (_incomingFp !== null) _lastPushedFingerprint = _incomingFp;
          _releasePushLockAndDrain();
          // Re-adopt the authoritative live cart LOCALLY ONLY.
          // external=true → clears the dedupe fingerprint + drives
          // setFullCart with fresh items (panel re-renders).
          // skipServerSync=true → does NOT write Firestore: on this NO-OP
          // path live already equals the Firestore target, so a sync would
          // be redundant and would re-fire _fs/cart_change → re-enter
          // pushToShopify → infinite cross-tab oscillation. Updating
          // adoptedItems + rendering locally is all the UI needs; Firestore
          // already holds the correct state.
          _adoptShopifyCart(liveCartJs, /*external*/ true, /*skipServerSync*/ true);
          // v2.55.21 — also refresh the STOREFRONT theme UI (header cart-
          // count bubble, mini-cart subtotal). _adoptShopifyCart updates
          // the widget's own bar via renderCartPanel, but the theme's
          // cart-icon count is a SEPARATE DOM surface updated only by the
          // storefront refresh — which the NO-OP path otherwise skips.
          // Without this, a passive tab with both the drawer AND the
          // widget closed shows a stale header count after a cross-tab
          // change.
          //
          // Use the DIRECT DOM refresh (_refreshStorefrontCartUI) for the
          // header bubble + footer subtotal — immediate, leaf-safe, and
          // never dispatches events (so no echo into our own cart:updated
          // listener). liveCartJs is the raw /cart.js shape it expects
          // (total_price + items[].quantity).
          _refreshStorefrontCartUI(liveCartJs);

          // v2.55.21 — rebuild the THEME's cart drawer via its OWN machinery.
          //
          // Confirmed from this store's theme.js (Streamline / Archetype):
          //   • There is NO listener on 'cart:updated' — it is only ever
          //     dispatched by the theme, never subscribed. Dispatching it
          //     does nothing to the drawer. (This is why earlier event
          //     dispatches were no-ops and we wrongly fell back to poking
          //     the drawer DOM directly, which corrupted the items list.)
          //   • theme.Drawers.open() does NOT re-fetch the cart; it only
          //     toggles a CSS class. So a closed drawer does NOT self-heal
          //     on open — it shows whatever markup is currently in the DOM.
          //   • theme.CartForm listens for 'cart:build' and responds by
          //     fetching /cart?view=ajax and rebuilding .cart__items (rows),
          //     the subtotal, and the count from Shopify's authoritative
          //     markup — using the THEME's own templates. It does NOT open
          //     the drawer (unlike 'ajaxProduct:added').
          //
          // So the correct, non-destructive way to make the passive tab's
          // drawer match Shopify is to let the theme rebuild itself:
          // dispatch 'cart:build'. We do NOT hand-render any drawer markup.
          // 'cart:build' is not an event our widget listens to, so this
          // does not re-enter our sync pipeline (no echo/loop), and the
          // theme's buildCart() does not dispatch 'cart:updated' back.
          try {
            document.dispatchEvent(new CustomEvent("cart:build"));
            _cartTrace("[P2:widget→shopify] dispatched theme cart:build " +
                       "to rebuild drawer from /cart (cross-tab)");
          } catch (e) {
            console.warn("[FS/shopify_cart/outbound] cart:build dispatch failed:",
              FS_WIDGET_VERSION, e && e.message);
          }
          return { ok: true, no_op: true, readopted: true };
        }

        // Shopify already matches this target AND our adoption is current —
        // record it so an immediate identical re-trigger is deduped by
        // Gate 3, then release + drain.
        if (_incomingFp !== null) _lastPushedFingerprint = _incomingFp;
        _releasePushLockAndDrain();
        return Promise.resolve({ ok: true, no_op: true });
      }

      // Set pendingWriteFingerprint to expected post-write state so
      // the cart:updated echo Shopify fires after our writes is
      // recognized as our own and suppressed.
      var targetNormalized = alignedTarget.map(_normalizeWidgetItem);
      pendingWriteFingerprint = _fingerprint(targetNormalized);

      // ── Pathway 2, step 3: executing writes to Shopify ──
      _cartTrace("[P2:widget→shopify] executing writes",
        "removes=" + diff.removes.length,
        "changes=" + diff.changes.length,
        "adds=" + diff.adds.length,
        "order=removes→changes→adds");

      console.info("[FS/shopify_cart/outbound] pushToShopify EXECUTE",
        FS_WIDGET_VERSION,
        "adds=" + diff.adds.length,
        "changes=" + diff.changes.length,
        "removes=" + diff.removes.length,
        "pendingWriteFingerprint=" + pendingWriteFingerprint);

      // Helper: sequence promise execution (avoid Promise.all to
      // prevent Shopify cart-write contention).
      function _serial(list, fn) {
        return list.reduce(function (acc, item) {
          return acc.then(function () { return fn(item); });
        }, Promise.resolve());
      }

      return _serial(diff.removes, function (line) {
        return _shopifyChange(line, 0, null);
      })
      .then(function () {
        return _serial(diff.changes, function (ch) {
          var newDateIso = (ch.to.delivery_date !== ch.from.delivery_date)
            ? ch.to.delivery_date : null;
          return _shopifyChange(ch.from, Number(ch.to.quantity) || 0, newDateIso);
        });
      })
      .then(function () {
        return _serial(diff.adds, _shopifyAdd);
      })
      .then(function () {
        // Re-fetch /cart.js to get authoritative post-write state.
        console.info("[FS/shopify_cart/outbound] all writes done — " +
                     "re-fetching /cart.js for authoritative state");
        return fetch("/cart.js", { credentials: "same-origin" });
      })
      .then(function (r) { return r.json(); })
      .then(function (newCart) {
        // ── Pathway 2, step 4: all writes done, Shopify confirmed ──
        _cartTrace("[P2:widget→shopify] push complete — Shopify cart updated",
          "shopify_items_n=" + ((newCart && newCart.items) || []).length,
          "adds=" + diff.adds.length,
          "changes=" + diff.changes.length,
          "removes=" + diff.removes.length,
          "note=re-adopting authoritative /cart.js (re-triggers Pathway 1 → Firestore)");

        console.info("[FS/shopify_cart/outbound] pushToShopify complete",
          FS_WIDGET_VERSION,
          "new_items_n=" + ((newCart && newCart.items) || []).length);
        _adoptShopifyCart(newCart, /*external*/ false);

        // v2.55.20+hotfix3 — notify the storefront theme that the cart
        // changed so it refreshes its own UI (cart drawer, mini-cart
        // icon bubble, /cart page subtotal). See _notifyThemeOfCartChange
        // for the full strategy.
        _notifyThemeOfCartChange(newCart);

        // v2.55.20+hotfix10 — record the target we just wrote (for Gate 3
        // dedupe), then release the in-flight lock and drain any push that
        // was coalesced while this one ran. The re-adopt above has already
        // refreshed adoptedItems, so a drained push diffs against the
        // correct, just-written baseline.
        if (_incomingFp !== null) _lastPushedFingerprint = _incomingFp;
        _releasePushLockAndDrain();

        return { ok: true,
                 adds: diff.adds.length,
                 changes: diff.changes.length,
                 removes: diff.removes.length };
      })
      .catch(function (err) {
        // ── Pathway 2, step 4 (failure): Shopify write failed ──
        _cartTrace("[P2:widget→shopify] push FAILED",
          "error=" + (err && err.message));
        console.error("[FS/shopify_cart/outbound] pushToShopify failed:",
          FS_WIDGET_VERSION, err && err.message);
        // Clear loop-protection — if our write failed, the cart:updated
        // we suppressed wasn't ours after all (or there was no echo).
        pendingWriteFingerprint = null;
        // v2.55.20+hotfix10 — release the in-flight lock and drain any
        // coalesced push. Do NOT record _lastPushedFingerprint: the write
        // failed, so a retry of the same target is legitimate.
        _releasePushLockAndDrain();
        return { ok: false, error: err && err.message };
      });
        })  // close the live-/cart.js .then (diff + execute ran inside it)
        .catch(function (outerErr) {
          // Covers: /cart.js fetch failure, or a SYNCHRONOUS throw in the
          // diff-computation code inside the .then above (before the inner
          // execute chain's own .catch could take over). Without this, such
          // a failure would reject the outer promise with no handler and
          // freeze the in-flight lock, blocking ALL future pushes. Release
          // the lock + drain. Don't record _lastPushedFingerprint (nothing
          // was written).
          _cartTrace("[P2:widget→shopify] push FAILED (baseline fetch or sync)",
            "error=" + (outerErr && outerErr.message));
          console.error("[FS/shopify_cart/outbound] pushToShopify baseline/sync " +
            "failure:", FS_WIDGET_VERSION, outerErr && outerErr.message);
          pendingWriteFingerprint = null;
          _releasePushLockAndDrain();
          return { ok: false, error: outerErr && outerErr.message };
        });
    }

    // ─────────────────────────────────────────────────────────────
    // Server-side persistence (Firestore)
    //
    // v2.55.19 hotfix5: POSTs to /cart/shopify_sync. The server
    // replaces session.cart.items + cart.delivery_date with what
    // we send and persists to Firestore. The live agent reads
    // session.cart from the same store, so persistence is the
    // bridge between Shopify and the dashboard.
    //
    // Fire-and-forget: errors are logged but don't affect widget
    // state (the local fullCart already reflects Shopify, which
    // is the source of truth per spec).
    // ─────────────────────────────────────────────────────────────
    function _syncToServer(items, deliveryDate) {
      // v2.55.43 — empty-first-sync guard. If the cart is empty and we have
      // never synced a non-empty cart for this session, there is nothing to
      // persist or clear server-side — skip the POST entirely (avoids
      // birthing an empty session + a wasted round-trip on page load / after
      // Clear History). Once we've synced items at least once, an empty sync
      // is a real "cart emptied" event and IS sent so the server clears it.
      var _itemsN = (items || []).length;
      if (_itemsN === 0 && !_hasSyncedNonEmpty) {
        console.info("[FS/shopify_cart] empty cart + never synced items — "
          + "skipping sync (no empty session)", FS_WIDGET_VERSION);
        return;
      }
      if (_itemsN > 0) _hasSyncedNonEmpty = true;

      var payloadItems = (items || []).map(function (it) {
        return {
          product_id:        it.product_id,
          variant_id:        it.variant_id,
          product_title:     it.product_name,
          variant_title:     it.variant_name,
          quantity:          it.quantity,
          delivery_date:     it.delivery_date,  // ISO YYYY-MM-DD
          // v2.55.19 hotfix6 — propagate pricing to Firestore so the
          // live agent dashboard can see actual order values.
          price_cents:       it.price_cents || 0,
          line_price_cents:  it.line_price_cents || 0,
        };
      });
      var payload = {
        widget_key: WIDGET_KEY,
        session_id: SESSION_ID,
        tab_id:     TAB_ID,
        shopify_cart: {
          items:         payloadItems,
          delivery_date: deliveryDate || null,
        },
      };
      var payloadTotalCents = payloadItems.reduce(function (acc, it) {
        return acc + (it.line_price_cents || 0);
      }, 0);
      console.info("[FS/shopify_cart] sync to server starting", FS_WIDGET_VERSION,
        "items_n=" + payloadItems.length,
        "delivery_date=" + (deliveryDate || "null"),
        "payload_total_cents=" + payloadTotalCents,
        "payload_items=", payloadItems.map(function (it) {
          return {
            variant_id:       it.variant_id,
            quantity:         it.quantity,
            price_cents:      it.price_cents,
            line_price_cents: it.line_price_cents,
          };
        }));
      // ── Pathway 1, step 4: POST widget cart → server → Firestore ──
      _cartTrace("[P1:widget→firestore] POST /cart/shopify_sync",
        "endpoint=/cart/shopify_sync",
        "session_id=" + SESSION_ID,
        "tab_id=" + TAB_ID,
        "payload_items_n=" + payloadItems.length,
        "payload_delivery_date=" + (deliveryDate || "null"),
        "payload_total_cents=" + payloadTotalCents);

      api("/cart/shopify_sync", payload)
        .then(function (res) {
          var ok = res && res.status === 200 &&
                   res.body && res.body.status === "success";
          var serverItemsN = (res && res.body && res.body.cart &&
                              Array.isArray(res.body.cart.items))
                             ? res.body.cart.items.length : null;
          var serverItems = (res && res.body && res.body.cart && res.body.cart.items) || [];
          var serverTotalCents = serverItems.reduce(function (acc, it) {
            return acc + (it.line_price_cents || 0);
          }, 0);

          // ── Pathway 1, step 5: Firestore persistence confirmed ──
          _cartTrace("[P1:widget→firestore] /cart/shopify_sync response (persisted)",
            "ok=" + ok,
            "http_status=" + (res && res.status),
            "server_status=" + (res && res.body && res.body.status),
            "firestore_items_n=" + serverItemsN,
            "firestore_total_cents=" + serverTotalCents);

          console.info("[FS/shopify_cart] sync to server done", FS_WIDGET_VERSION,
            "ok=" + ok,
            "status=" + (res && res.status),
            "server_items_n=" + serverItemsN,
            "server_total_cents=" + serverTotalCents,
            "server_items=", serverItems.map(function (it) {
              return {
                variant_id:       it.variant_id,
                quantity:         it.quantity,
                price_cents:      it.price_cents,
                line_price_cents: it.line_price_cents,
              };
            }));
        })
        .catch(function (err) {
          // ── Pathway 1, step 5 (failure): Firestore persistence failed ──
          _cartTrace("[P1:widget→firestore] /cart/shopify_sync FAILED",
            "error=" + (err && err.message));
          console.warn("[FS/shopify_cart] sync to server failed:", FS_WIDGET_VERSION,
            err && err.message);
        });
    }

    // ─────────────────────────────────────────────────────────────
    // cart:updated listener
    // ─────────────────────────────────────────────────────────────

    function _attachListener() {
      if (listenerAttached) return;
      document.addEventListener("cart:updated", function (evt) {
        var rawCart = evt.detail && evt.detail.cart;
        if (!rawCart) {
          console.warn("[FS/shopify_cart] cart:updated with no detail.cart");
          return;
        }
        var shopifyItems = (rawCart.items || []).map(_normalizeShopifyItem);
        var incomingFp = _fingerprint(shopifyItems);

        // Loop protection for v2.55.20+ (outbound). In v2.55.19,
        // pendingWriteFingerprint is always null → every event is
        // treated as external.
        if (pendingWriteFingerprint &&
            incomingFp === pendingWriteFingerprint) {
          console.info("[FS/shopify_cart] cart:updated — own echo, skipping");
          pendingWriteFingerprint = null;
          return;
        }

        console.info("[FS/shopify_cart] cart:updated — external change",
          "items_n=" + shopifyItems.length,
          "fp=" + incomingFp);

        // ── Pathway 1, step 1: Shopify announced a cart change ──
        _cartTrace("[P1:shopify→widget] cart:updated received (external)",
          "trigger=cart:updated",
          "shopify_items_n=" + shopifyItems.length,
          "incoming_fp=" + incomingFp,
          "shopify_items=", shopifyItems.map(function (s) {
            return {
              variant_id:    s.variant_id,
              quantity:      s.quantity,
              delivery_date: s.delivery_date,
            };
          }));

        shopifyCart = rawCart;
        lastShopifyFingerprint = incomingFp;
        _adoptShopifyCart(rawCart, /*external*/ true);
        _wizardResetToPage1();
      });

      // v2.55.20+hotfix9 — foreign ajaxProduct:added → adopt cart.
      //
      // The Streamline theme (and Streamline-derived themes) dispatch
      // `ajaxProduct:added` after a successful /cart/add.js but DO NOT
      // dispatch `cart:updated` for adds — only for /cart/change.js
      // operations (quantity changes, removals). Without this
      // listener, foreign add-to-cart actions (the cart drawer's
      // "add-on products" swiper, native product-page add buttons,
      // recommendation widgets, etc.) reach Shopify's cart but never
      // propagate to the widget's session — the server-side cart
      // stays stale until the next /cart/change.js fires
      // `cart:updated`.
      //
      // We listen on `document` in the BUBBLE phase. The hotfix7
      // listener attached on `window` in CAPTURE phase calls
      // stopImmediatePropagation() for own-echo events (those
      // carrying detail.source === "fs_widget"), so this listener
      // never sees our own dispatches — they're stopped at window
      // before reaching document. Only foreign events arrive here.
      //
      // Important: the event's detail.product (a jQuery AJAX object
      // for Streamline) carries `.responseJSON` which is just the
      // /cart/add.js response — the items that were just added, NOT
      // the full cart. We fetch /cart.js to get the authoritative
      // cart state before adopting, mirroring how cart:updated
      // hands us the full cart in evt.detail.cart.
      document.addEventListener("ajaxProduct:added", function (evt) {
        // Defense in depth — own-echoes should already be stopped at
        // window capture phase (hotfix7). If hotfix7's listener
        // failed to attach for any reason, fall back to the marker
        // check here.
        if (evt && evt.detail && evt.detail.source === "fs_widget") {
          console.info("[FS/shopify_cart] ajaxProduct:added — own echo at " +
                       "bubble (hotfix7 didn't suppress?), skipping",
                       FS_WIDGET_VERSION);
          return;
        }
        console.info("[FS/shopify_cart] ajaxProduct:added — foreign add, " +
                     "fetching /cart.js for authoritative state",
                     FS_WIDGET_VERSION);
        fetch("/cart.js", { credentials: "same-origin" })
          .then(function (r) {
            if (!r.ok) {
              throw new Error("non-OK status " + r.status);
            }
            return r.json();
          })
          .then(function (rawCart) {
            if (!rawCart || !Array.isArray(rawCart.items)) {
              console.warn("[FS/shopify_cart] ajaxProduct:added — " +
                           "/cart.js returned malformed body");
              return;
            }
            var shopifyItems = rawCart.items.map(_normalizeShopifyItem);
            var incomingFp = _fingerprint(shopifyItems);

            // Loop protection — symmetric to the cart:updated
            // handler. If our own outbound write somehow dispatched
            // ajaxProduct:added without the fs_widget marker (e.g.,
            // a future code path), the fingerprint catches it.
            if (pendingWriteFingerprint &&
                incomingFp === pendingWriteFingerprint) {
              console.info("[FS/shopify_cart] ajaxProduct:added — " +
                           "fp matches own write, skipping",
                           FS_WIDGET_VERSION);
              pendingWriteFingerprint = null;
              return;
            }

            // Sub-fingerprint check: if nothing changed since our
            // last adoption, skip the noisy re-adopt. Adds always
            // change the cart, so this should usually proceed — but
            // if two foreign-add events fire for the same final
            // cart state (e.g., debounced double-click), the second
            // is a no-op.
            if (lastShopifyFingerprint &&
                incomingFp === lastShopifyFingerprint) {
              console.info("[FS/shopify_cart] ajaxProduct:added — " +
                           "fp matches last adopted, skipping (no change)",
                           FS_WIDGET_VERSION);
              return;
            }

            console.info("[FS/shopify_cart] ajaxProduct:added — " +
                         "adopting foreign add",
                         "items_n=" + shopifyItems.length,
                         "fp=" + incomingFp,
                         FS_WIDGET_VERSION);

            // ── Pathway 1, step 1 (alt trigger): foreign add-to-cart ──
            _cartTrace("[P1:shopify→widget] ajaxProduct:added received (foreign)",
              "trigger=ajaxProduct:added",
              "shopify_items_n=" + shopifyItems.length,
              "incoming_fp=" + incomingFp,
              "shopify_items=", shopifyItems.map(function (s) {
                return {
                  variant_id:    s.variant_id,
                  quantity:      s.quantity,
                  delivery_date: s.delivery_date,
                };
              }));

            shopifyCart = rawCart;
            lastShopifyFingerprint = incomingFp;
            _adoptShopifyCart(rawCart, /*external*/ true);
            _wizardResetToPage1();
          })
          .catch(function (err) {
            // Soft fail — the next /cart/change.js will eventually
            // fire cart:updated and force a sync. Adoption gap
            // closes itself, just later than ideal.
            console.warn("[FS/shopify_cart] ajaxProduct:added — " +
                         "/cart.js fetch failed (will retry on next event):",
                         err && err.message);
          });
      });

      listenerAttached = true;
      console.info("[FS/shopify_cart] cart:updated + ajaxProduct:added " +
                   "listeners attached",
                   FS_WIDGET_VERSION);
    }

    // ─────────────────────────────────────────────────────────────
    // Public API
    // ─────────────────────────────────────────────────────────────
    return {
      isEnabled:              isEnabled,
      boot:                   boot,
      getLastShopifyCart:     function () { return shopifyCart; },
      getLastFingerprint:     function () { return lastShopifyFingerprint; },

      // v2.55.19 hotfix2 — authoritative-adoption accessors used by
      // setFullCart and updateFullCartFromResponse to decide whether
      // to defer to Shopify's items. Returns true once the module
      // has adopted at least once (including the "adopted-and-empty"
      // case — Shopify cart was checked, found empty, that's the
      // truth).
      hasAdoptedItems:        function () { return adoptedItems !== null; },
      getAdoptedItems:        function () {
        return adoptedItems === null ? null : adoptedItems.slice();
      },
      // v2.55.20+hotfix10 — total adopted quantity (sum of line
      // quantities). Used by the Firestore listener's Gate 1 to tell a
      // genuinely-empty cart from a stale empty snapshot. Returns 0 when
      // nothing has been adopted yet.
      getAdoptedItemCount:    function () {
        if (!Array.isArray(adoptedItems)) return 0;
        return adoptedItems.reduce(function (n, it) {
          return n + (Number(it && it.quantity) || 0);
        }, 0);
      },
      // v2.55.19 hotfix4 — Shopify-authoritative delivery_date so the
      // authority mechanism in setFullCart / updateFullCartFromResponse
      // can preserve it across server cart writes.
      getAdoptedDeliveryDate: function () { return adoptedDeliveryDate; },

      // v2.55.20 — outbound writes (Phase 2). Push the target items
      // (e.g., from the wizard, /chat response, or fill_shopify_from_widget
      // boot path) to Shopify via /cart/add.js and /cart/change.js.
      // Returns a promise resolving to {ok, adds?, changes?, removes?, error?}.
      // v2.55.36 — PASSIVE-TAB render path (source_action identity model).
      // When a Firestore cart change did NOT originate on this tab (or is
      // this tab's own Shopify→Firestore echo), the tab must NOT push to
      // Shopify and must NOT write Firestore — it only refreshes its own
      // view to match Shopify's truth. We re-adopt from THIS tab's own live
      // /cart.js (authoritative shape) LOCALLY (skipServerSync=true): no
      // push, no Firestore write. For an (S) change Firestore == Shopify so
      // this shows the new cart; for a (W) change Shopify is not yet updated
      // (only the originating tab pushes), so the passive tab correctly
      // keeps showing Shopify's current state until the edit round-trips
      // back as an (S) shopify_cart_sync change. Also rebuilds the theme
      // drawer via cart:build (read-only) and refreshes the header bubble.
      renderFromLiveCart: function () {
        return fetch("/cart.js", { credentials: "same-origin" })
          .then(function (r) { return r.json(); })
          .then(function (liveCartJs) {
            _adoptShopifyCart(liveCartJs, /*external*/ true,
                              /*skipServerSync*/ true);
            try { _refreshStorefrontCartUI(liveCartJs); } catch (_) {}
            try { document.dispatchEvent(new CustomEvent("cart:build")); }
            catch (_) {}
            return { ok: true, rendered: true };
          })
          .catch(function (e) {
            console.warn("[FS/shopify_cart] renderFromLiveCart failed:",
              FS_WIDGET_VERSION, e && e.message);
            return { ok: false, error: e && e.message };
          });
      },

      pushToShopify:          _pushToShopify,

      // v2.55.20+hotfix2 — queue a server cart for divergence processing
      // after boot completes. Called by the Firestore session-doc listener
      // when it fires before FS_SHOPIFY_CART has adopted (race protection).
      _setPendingDivergence: function (cart) {
        pendingDivergenceCart = cart;
        console.info("[FS/shopify_cart] pending divergence queued",
          "items_n=" + ((cart && cart.items) || []).length);
      },

      // Test hooks (also useful for diagnostics)
      _resolveConflict:       _resolveConflict,
      _fingerprint:           _fingerprint,
      _normalizeShopifyItem:  _normalizeShopifyItem,
      _normalizeWidgetItem:   _normalizeWidgetItem,
      _isoToShopifyDate:      _isoToShopifyDate,
      _shopifyDateToIso:      _shopifyDateToIso,
      _readLiquidConstant:    _readLiquidConstant,
      _computeDiff:           _computeDiff,
      _diffKeyOf:             _diffKeyOf,

      // v2.55.20+ outbound hooks (placeholder for next ship)
      _setPendingWriteFingerprint: function (fp) {
        pendingWriteFingerprint = fp;
      },
    };
  })();
  // ---------------------------------------------------------------------
  // The live-agent module is no longer loaded as a separate script. The
  // widget owns the Firestore listener directly (see FS_FIRESTORE
  // module further down). This bridge is kept ONLY so any third-party
  // code that previously read it doesn't break — but no code in this
  // file consumes it any more.
  window.FS_WIDGET_BRIDGE = {
    WIDGET_KEY:                   WIDGET_KEY,
    SESSION_ID:                   SESSION_ID,
    TAB_ID:                       TAB_ID,
    ENDPOINT:                     ENDPOINT,
    LIVE_ENDPOINT:                LIVE_ENDPOINT,
    RENDER_HISTORICAL_STRUCTURED: RENDER_HISTORICAL_STRUCTURED,
    WIDGET_OWNS_LISTENER:         true,   // v2.53.0
    addBubble:      function (role, text, opts) { return addBubble(role, text, opts); },
    scrollToBottom: function (force) { return scrollToBottom(force); },
    messagesEl:     function () { return $messages; },
  };

  // ---------------------------------------------------------------------
  // Boot
  // ---------------------------------------------------------------------
  // v2.55.19 hotfix2 — version marker. If you don't see this exact line
  // in the console on page load, the browser is serving a cached older
  // widget script (try a hard refresh / clear cache). The "hotfix2"
  // suffix increments on each fix so it's easy to confirm deploy.
  // console.info("[FS/boot] flowersugar-widget loaded — " + FS_WIDGET_VERSION);
  warm();
  // Pre-load history quietly so it's ready on open
  loadHistory();
  // v2.55.19 hotfix — serialize cart bootstrap.
  //
  // Previously loadCartState() and FS_SHOPIFY_CART.boot() ran in
  // parallel. Shopify often returned first (Shopify storefronts serve
  // /cart.js fast, server /cart/state goes through Cloud Run + Firestore),
  // so FS_SHOPIFY_CART would adopt the Shopify items into fullCart →
  // renderCartPanel. Then /cart/state's response arrived and
  // setFullCart(server_cart) overwrote fullCart wholesale, wiping the
  // Shopify adoption. UI ended up showing the server's view (often
  // empty, since the server-side cart hadn't been populated yet for
  // a fresh chat), not Shopify's.
  //
  // Fix: chain. loadCartState first; once it resolves (or fails — soft
  // path also calls .then's next handler since the .catch returns
  // undefined), FS_SHOPIFY_CART.boot runs and the comparison happens
  // against a stable fullCart.
  // v2.55.50 — capture ad-click attribution at page load, BEFORE any
  // navigation can strip gclid/fbclid from the URL. Synchronous, cheap,
  // and independent of the lazy Firestore/SDK boot. The captured block is
  // attached to /chat so it persists onto the session server-side.
  try { captureAttribution(); } catch (e) {
    console.warn("[FS/attribution] capture failed:", e && e.message);
  }

  // console.info("[FS/boot] cart bootstrap starting");
  loadCartState()
    .then(function () {
      // console.info("[FS/boot] loadCartState done → booting FS_SHOPIFY_CART");
      try { return FS_SHOPIFY_CART.boot(); } catch (e) {
        console.warn("[FS/shopify_cart] boot threw:", e && e.message);
      }
    })
    .then(function (bootResult) {
      // console.info("[FS/boot] FS_SHOPIFY_CART.boot resolved",
        // "result=", bootResult);
    });
})();